(function ($) {
  var $ = (jQuery = $);
  var dtc_url = "https://dtc.piscifun.com/";
  var dtc_time_out = 3000; //设置超时时间

  $('product-list .product-block[data-product-id="8046859321556"]').hide();
  $('product-list .product-block[data-product-id="8046859256020"]').hide();
  setTimeout(function () {
    $('product-list .product-block[data-product-id="8046859321556"]').hide();
    $('product-list .product-block[data-product-id="8046859256020"]').hide();
  }, 500);

  var setLabelSpan = function (span) {
    var spanstr = $(span).html();
    $(span).css("background", "#ffcb24");
    $(span).css("color", "#000");
    $(span).css("font-size", "14px");
    spanstr = spanstr.replace(" off", "");
    spanstr =
      '<img src="https://cdn.shopify.com/s/files/1/0138/3956/4858/files/Vector_3.png" style="height: 20px; vertical-align: middle; margin-right: 5px;" />-' +
      spanstr;
    console.log(spanstr);
    $(span).html(spanstr);
  };

  if (window.product_label) {
    setLabelSpan(window.product_label);
    setTimeout(function () {
      setLabelSpan(window.product_label);
    }, 100);
  }

  /** run ad **/
  var runAd = function () {
    var url =
      "https://assets-us.welltuo.com/json/c-10-tidewe/ad.json?" +
      (Math.random() + "").substr(2);
    $.ajax({
      url: url,
      success: function (result) {
        console.log(" - ad", result);
        var allSet = null;
        var usSet = null;
        for (var _a_idx in result) {
          if (result[_a_idx].uri === "__ALL__") {
            allSet = result[_a_idx];
          }
          if (result[_a_idx].uri === window.location.pathname) {
            usSet = result[_a_idx];
          }
        }

        console.log(" - allSet", allSet);
        console.log(" - usSet", usSet);
        if (usSet == null) {
          usSet = allSet;
        }

        if (usSet == null) {
          return false;
        }

        if (window.innerWidth > 758) {
          var block = $(".product-list")
            .eq(1)
            .find(".product-block")
            .eq(parseInt(usSet.pc_no) - 1);
          var html =
            '<div class="product-block cc-animate-init -in cc-animate-complete" style="width: 50%;">';
          if (usSet.link) {
            html +=
              '<a href="' +
              usSet.link +
              '" target="_blank" style="display: flex;">';
          }
          html +=
            '<img src="' +
            usSet.image +
            '" style="width: 100%; margin-top: 10px;" />';
          if (usSet.link) {
            html += "</a>";
          }
          if (usSet.link) {
            html += '<a href="' + usSet.link + '" target="_blank">';
          }
          html += '<div class="product-info">';
          html +=
            '<div class="product-block__title" style="color: #4c4c4b;">' +
            usSet.title +
            "</div>";
          if (usSet.link) {
            html += "</a>";
          }
          if (usSet.link && usSet.link_txt) {
            html +=
              '<a style="padding: 0px; color: #4c4c4b; border-bottom: 1px solid #4c4c4b;" href="' +
              usSet.link +
              '">' +
              usSet.link_txt +
              "</a>";
          }
          html += "</div>";
          html += "</div>";
          $(block).after(html);
        } else {
          var block = $(".product-list")
            .eq(1)
            .find(".product-block")
            .eq(parseInt(usSet.mob_no) - 1);
          var html =
            '<div class="product-block cc-animate-init -in cc-animate-complete" style="width: 100%;">';
          if (usSet.link) {
            html +=
              '<a href="' +
              usSet.link +
              '" target="_blank" style="display: flex;">';
          }
          html += '<img src="' + usSet.image + '" />';
          if (usSet.link) {
            html += "</a>";
          }
          if (usSet.link) {
            html += '<a href="' + usSet.link + '" target="_blank">';
          }
          html += '<div class="product-info" style="margin-bottom: 20px;">';
          html +=
            '<div class="product-block__title" style="color: #4c4c4b;">' +
            usSet.title +
            "</div>";
          if (usSet.link) {
            html += "</a>";
          }
          if (usSet.link && usSet.link_txt) {
            html +=
              '<a style="padding: 0px; color: #4c4c4b; border-bottom: 1px solid #4c4c4b;" href="' +
              usSet.link +
              '">' +
              usSet.link_txt +
              "</a>";
          }
          html += "</div>";
          html += "</div>";
          $(block).after(html);
        }
      },
    });
  };
  if (window.location.pathname.substr(0, 12) === "/collections") {
    //runAd();
  }
  /** end ad **/

  // https://cdn.shopify.com/s/files/1/0138/3956/4858/files/foot-bg.jpg
  if (location.pathname == "/") {
    if (window.innerWidth > 720) {
      $("#shopify-section-footer")
        .find(".section-footer__text p")
        .css("color", "#000");

      $("#shopify-section-footer")
        .find(".container")
        .eq(1)
        .css("margin-top", "20vw");
      $("#shopify-section-footer")
        .find(".container")
        .eq(1)
        .css("background", "rgb(0 0 0 / 85%)");

      $("#shopify-section-footer .section-footer__row")
        .eq(1)
        .find(".section-footer__row__col")
        .eq(0)
        .remove();
      $("#shopify-section-footer .section-footer__row")
        .eq(1)
        .find(".section-footer__row__col")
        .eq(0)
        .css("display", "flex");
      $("#shopify-section-footer .section-footer__row")
        .eq(1)
        .find(".section-footer__row__col")
        .eq(0)
        .css("font-size", "16px");
      $("#shopify-section-footer .section-footer__row")
        .eq(1)
        .find(".section-footer__row__col")
        .eq(0)
        .find(".copyright")
        .css("padding-top", "12px");
      $("#shopify-section-footer .section-footer__row")
        .eq(1)
        .find(".section-footer__row__col")
        .eq(0)
        .find(".copyright")
        .css("padding-left", "20px");
      $(".section-footer__row-lower").append(
        '<div class="section-footer__row__col"><img src="//www.tidewe.com/cdn/shop/files/logo.png" alt="TideWe" style="height: 50px;"></div>',
      );

      $(".section-footer__row-lower").css("padding-top", "15px");
      $(".section-footer__row-lower").css("padding-bottom", "0");
      $(".section-footer__row-lower").css("max-width", "1480px");
      $(".section-footer__row-lower").css("margin", "0 auto");
      $(".section-footer__row-lower").find("button").css("background", "#fff");
      $(".section-footer__row-lower")
        .find("button")
        .css("border", "1.5px solid #1e1e1e");
      $(".locale-selectors__container").remove();
    } else {
      $("#shopify-section-footer").css("padding-bottom", "40px");
      $("#shopify-section-footer").css("background-size", "cover");
      $("#shopify-section-footer").css("background-repeat", "no-repeat");
      $("#shopify-section-footer").css("background-position", "bottom");
      $("#shopify-section-footer").find(".container").css("border-top", "0px");
      $("#shopify-section-footer")
        .find(".section-footer__text p")
        .css("color", "#000");
      $(".section-footer__row").eq(0).find("h3").css("color", "#000");
      $(".section-footer__row").eq(0).find("a").css("color", "#000");
      $("#shopify-section-footer")
        .find(".container")
        .eq(1)
        .css("background", "rgb(0 0 0 / 85%)");

      $(".section-footer__row-lower").css("padding-top", "15px");
      $(".section-footer__row-lower").css("padding-bottom", "0");
      $("#shopify-section-footer .section-footer__row")
        .eq(1)
        .find(".section-footer__row__col")
        .eq(0)
        .remove();
    }
  }

  setTimeout(function () {
    var flen = $(".option-selector-fieldset").length;
    if (flen > 0) {
      var MAIN_IMAGE = $(".main-image")
        .find(".slide")
        .eq(0)
        .find("img")
        .attr("srcset");
      var MAIN_IMAGE_SRC = $(".main-image")
        .find(".slide")
        .eq(0)
        .find("img")
        .attr("data-src");
      var inFlen = null;
      for (var fidx = 0; fidx < flen; fidx++) {
        var field = $(".option-selector-fieldset")
          .eq(fidx)
          .find(".opposing-items .label")
          .html()
          .toUpperCase();
        if (true) {
          $(".option-selector-fieldset")
            .find(".option-selector__btns label")
            .click(function () {
              field = $(this)
                .parents(".option-selector")
                .find(".opposing-items .label")
                .html()
                .toUpperCase();
              console.log(inFlen, field);
              if (inFlen == null || inFlen == field) {
                var text = $(this).find(".opt-label__text").html();
                text = text.replace(/\s+/g, "");
                // console.log('C_' + text + '-');

                var isF = false;
                var isM = false;

                if (window.innerWidth > 720) {
                  var imglen = $(".main-image").find(".slide").length;
                  for (var idx = 0; idx < imglen; idx++) {
                    var srcset = $(".main-image")
                      .find(".slide")
                      .eq(idx)
                      .find("img")
                      .attr("srcset");
                    if (srcset) {
                      if (srcset.search(field + "_MAIN_" + text + "-") > 0) {
                        isM = true;
                      }
                      if (srcset.search(field + "_" + text + "-") > 0) {
                        isF = true;
                      }
                    } else {
                      var srcset = $(".main-image")
                        .find(".slide")
                        .eq(idx)
                        .find("img")
                        .attr("data-src");
                      if (srcset) {
                        if (srcset.search(field + "_MAIN_" + text + "-") > 0) {
                          isM = true;
                        }
                        if (srcset.search(field + "_" + text + "-") > 0) {
                          isF = true;
                        }
                      }
                    }
                  }
                  console.log(
                    field + "_MAIN_" + text + "-",
                    field + "_" + text + "-",
                  );
                  console.log("f", isF, "m", isM);
                  if (isF) {
                    inFlen = field;
                    for (var idx = 0; idx < imglen; idx++) {
                      var srcset = $(".main-image")
                        .find(".slide")
                        .eq(idx)
                        .find("img")
                        .attr("srcset");
                      // console.log("idx", idx);
                      // console.log(srcset);
                      if (srcset) {
                        if (
                          srcset.search(field + "_" + text + "-") > 0 ||
                          srcset.search("ALLSEE") > 0
                        ) {
                          // $('.main-image').find('.slide').eq(idx).show();
                        } else {
                          if (idx > 0) {
                            // $('.main-image').find('.slide').eq(idx).hide();
                          }
                        }

                        if (srcset.search(field + "_MAIN_" + text + "-") > 0) {
                          isM = true;
                          console.log("110-main-image", srcset);
                          $(".main-image")
                            .find(".slide")
                            .eq(0)
                            .find("img")
                            .attr("srcset", srcset);
                        }
                      } else {
                        var srcset = $(".main-image")
                          .find(".slide")
                          .eq(idx)
                          .find("img")
                          .attr("data-src");
                        if (srcset) {
                          if (
                            srcset.search(field + "_" + text + "-") > 0 ||
                            srcset.search("ALLSEE") > 0
                          ) {
                            // $('.main-image').find('.slide').eq(idx).show();
                          } else {
                            if (idx > 0) {
                              // $('.main-image').find('.slide').eq(idx).hide();
                            }
                          }

                          if (
                            srcset.search(field + "_MAIN_" + text + "-") > 0
                          ) {
                            isM = true;
                            console.log("110-main-image", srcset);
                            var srcsetArr = srcset.split("_{width}x.");
                            if (srcsetArr.length == 2) {
                              var sArr = srcsetArr[1].split("?");
                              var srcsetUrl = srcsetArr[0] + "." + sArr[0];
                              $(".main-image")
                                .find(".slide")
                                .eq(0)
                                .find("img")
                                .attr("srcset", srcsetUrl);
                            }
                          }
                        }
                      }
                    }
                    if (!isM) {
                      if (MAIN_IMAGE) {
                        $(".main-image")
                          .find(".slide")
                          .eq(0)
                          .find("img")
                          .attr("srcset", MAIN_IMAGE);
                      }
                      if (MAIN_IMAGE_SRC) {
                        var srcsetArr = MAIN_IMAGE_SRC.split("_{width}x.");
                        if (srcsetArr.length == 2) {
                          var sArr = srcsetArr[1].split("?");
                          var srcsetUrl = srcsetArr[0] + "." + sArr[0];
                          $(".main-image")
                            .find(".slide")
                            .eq(0)
                            .find("img")
                            .attr("srcset", srcsetUrl);
                        }
                      }
                    }
                  } else {
                    for (var idx = 0; idx < imglen; idx++) {
                      // $('.main-image').find('.slide').eq(idx).show();

                      if (
                        srcset &&
                        srcset.search(field + "_MAIN_" + text + "-") > 0
                      ) {
                        isM = true;
                        console.log("120-main-image", srcset);
                        $(".main-image")
                          .find(".slide")
                          .eq(0)
                          .find("img")
                          .attr("srcset", srcset);
                      }
                    }
                    if (!isM) {
                      console.log("125-main-image", srcset);
                      $(".main-image")
                        .find(".slide")
                        .eq(0)
                        .find("img")
                        .attr("srcset", MAIN_IMAGE);
                    }
                  }
                } else {
                  var imglen = $(".thumbnails").find(".owl-item").length;
                  for (var idx = 0; idx < imglen; idx++) {
                    var srcset = $(".thumbnails")
                      .find(".owl-item")
                      .eq(idx)
                      .find("img")
                      .attr("data-src");
                    // console.log(srcset);
                    if (srcset && srcset.search(field + "_" + text + "-") > 0) {
                      isF = true;
                    } else {
                      var srcset = $(".thumbnails")
                        .find(".owl-item")
                        .eq(idx)
                        .find("img")
                        .attr("srcset");
                      // console.log(srcset);
                      if (
                        srcset &&
                        srcset.search(field + "_" + text + "-") > 0
                      ) {
                        isF = true;
                      }
                    }
                  }
                  console.log(
                    field + "_MAIN_" + text + "-",
                    field + "_" + text + "-",
                  );
                  console.log("f", isF, "m", isM);
                  if (isF) {
                    inFlen = field;
                    for (var idx = 0; idx < imglen; idx++) {
                      var srcset = $(".thumbnails")
                        .find(".owl-item")
                        .eq(idx)
                        .find("img")
                        .attr("data-src");
                      if (
                        srcset &&
                        (srcset.search(field + "_" + text + "-") > 0 ||
                          srcset.search("ALLSEE") > 0)
                      ) {
                        console.log("show", srcset);
                        // $('.thumbnails').find('.owl-item').eq(idx).show();
                      } else {
                        srcset = $(".thumbnails")
                          .find(".owl-item")
                          .eq(idx)
                          .find("img")
                          .attr("srcset");
                        if (
                          srcset &&
                          (srcset.search(field + "_" + text + "-") > 0 ||
                            srcset.search("ALLSEE") > 0)
                        ) {
                          console.log("show", srcset);
                          // $('.thumbnails').find('.owl-item').eq(idx).show();
                        } else {
                          console.log("hide", srcset);
                          // $('.thumbnails').find('.owl-item').eq(idx).hide();
                        }
                      }

                      if (
                        srcset &&
                        srcset.search(field + "_MAIN_" + text + "-") > 0
                      ) {
                        // $('.thumbnails').find('.owl-item').eq(idx).show();
                        // $('.thumbnails').find('.owl-item').eq(idx).find('img').click();
                        // $('.main-image').find('.slide').eq(0).find('img').attr('srcset', srcset);
                      }
                    }
                    // $('.thumbnails .owl-stage').css('transform', 'translate3d(0px, 0px, 0px)');
                  } else {
                    for (var idx = 1; idx < imglen; idx++) {
                      // $('.thumbnails').find('.owl-item').eq(idx).show();

                      if (
                        srcset &&
                        srcset.search(field + "_MAIN_" + text + "-") > 0
                      ) {
                        isM = true;
                        console.log("160-main-image", srcset);
                        $(".main-image")
                          .find(".slide")
                          .eq(0)
                          .find("img")
                          .attr("srcset", srcset);
                      }
                    }
                    if (!isM) {
                      // $('.main-image').find('.slide').eq(0).find('img').attr('srcset', MAIN_IMAGE);
                    }
                  }
                }
              }
            });
        }
      }
    }
  }, 500);

  // if ($('form[data-product-id="7728337715412"]').length > 0) {
  //   $('form[data-product-id="7728337715412"]').before("Ship on Aug.15");
  // }

  // if ($(".option-selectors").find('[type="radio"]').length > 0) {
  //   $(".option-selectors").find('[type="radio"]').attr('checked', false);
  //   $('.quantity-submit-row').css("position", "relative");
  //   $('.quantity-submit-row').append("<div class='div-fottor' style='background: #00000000; height: 170px; width: 100%; bottom: 0; position: absolute; z-index: 9; text-align: center; font-size: 14px;'></div>");
  //   $(".option-selectors").find('[type="radio"]').change(function () {
  //     var btns = $('.option-selector__btns');
  //     var isSet = true;
  //     for (var idx = 0; idx < btns.length; idx++) {
  //       if ($(btns[idx]).find('[type="radio"]:checked').length == 0) {
  //         isSet = false;
  //       }
  //     }
  //     if (isSet) {
  //       $('.quantity-submit-row .div-fottor').remove();
  //     }
  //   });
  //   $('.quantity-submit-row').find('.div-fottor').click(function () {
  //     console.log(1);
  //     var btns = $('.option-selector-fieldset');
  //     var isSet = true;
  //     var alertName = '';
  //     for (var idx = 0; idx < btns.length; idx++) {
  //       if ($(btns[idx]).find('[type="radio"]:checked').length == 0) {
  //         isSet = false;
  //         if (alertName != '') {
  //           alertName += ','
  //         }
  //         alertName += $(btns[idx]).find('.label').html();
  //       }
  //     }
  //     var alert = 'Please let me know which ' + alertName + ' do you prefer ^ - ^';
  //     $('.quantity-submit-row').find('.div-fottor').html(alert);
  //   });
  // }

  $(".wt-message-images-list img").click(function () {
    var img = $(this).attr("image");
    $(this)
      .parents(".wt-product-main-box")
      .find(".wt-main-image")
      .attr("src", img);
  });

  $('.wt-page-html a[href=""]').each(function () {
    $(this)
      .after("<span>" + $(this).html() + "</span>")
      .remove();
  });

  var runAnimateTransform = function (item, value, time, func) {
    value--;
    if (value >= 0) {
      item.css({ transform: "rotateY(" + value + "deg)" });
      setTimeout(function () {
        runAnimateTransform(item, value, time, func);
      }, time);
    } else {
      func();
    }
  };

  $(".wt-code-list-pic .featured-collection__nav--btn").click(function () {
    var key = $(this).attr("key");
    if (!$(this).hasClass("active")) {
      $(this)
        .parent()
        .parent()
        .parent()
        .parent()
        .find(".featured-collection__nav--btn")
        .removeClass("active");
      $(this).addClass("active");
      if (key == 1) {
        $(this)
          .parent()
          .parent()
          .parent()
          .parent()
          .find(".wt-code-item")
          .eq(0)
          .css({ left: "100%" });
        $(this)
          .parent()
          .parent()
          .parent()
          .parent()
          .find(".wt-code-item")
          .eq(1)
          .css({ left: "0" });
        $(this)
          .parent()
          .parent()
          .parent()
          .parent()
          .find(".wt-code-item")
          .eq(0)
          .animate({ left: "0" }, 500);
        $(this)
          .parent()
          .parent()
          .parent()
          .parent()
          .find(".wt-code-item")
          .eq(1)
          .animate({ left: "-100%" }, 500);
      } else {
        $(this)
          .parent()
          .parent()
          .parent()
          .parent()
          .find(".wt-code-item")
          .eq(1)
          .css({ left: "100%" });
        $(this)
          .parent()
          .parent()
          .parent()
          .parent()
          .find(".wt-code-item")
          .eq(0)
          .css({ left: "0" });
        $(this)
          .parent()
          .parent()
          .parent()
          .parent()
          .find(".wt-code-item")
          .eq(1)
          .animate({ left: "0" }, 500);
        $(this)
          .parent()
          .parent()
          .parent()
          .parent()
          .find(".wt-code-item")
          .eq(0)
          .animate({ left: "-100%" }, 500);
      }
    }
  });

  $(".wt-code-list-pic .wt-code-item").click(function () {
    var _img = $(this).find("img");
    var _boxBgColor = _img.attr("box-bg-color");
    var _boxTxtColor = _img.attr("box-txt-color");
    var _color = _img.attr("txt-color");
    var _title = _img.attr("product-title");
    var _desc = _img.attr("product-desc");
    var _btnTxt = _img.attr("btn-txt");
    var _btnLink = _img.attr("btn-link");
    var _btnBgColor = _img.attr("btn-bg-color");
    var _btnTxtColor = _img.attr("btn-txt-color");

    var html =
      '<div class="wt-code-p-a wt-code-product-click-box" style="width: 100%; height: 100%; background: ' +
      _boxBgColor +
      "; color: " +
      _boxTxtColor +
      '; top: 0; left: 0; padding: 20% 10%; vertical-align: middle; display: inline-grid;">';
    if (_title) {
      html +=
        '<div class="wt-code-box-title wt-code-click-box-item" style="font-size: 22px; color: #ddd;">' +
        _title +
        "</div>";
    }
    if (_desc) {
      html +=
        '<div class="wt-code-box-desc wt-code-click-box-item" style="font-size: 18px; color: #ddd;">' +
        _desc +
        "</div>";
    }
    if (_btnTxt && _btnLink) {
      html +=
        '<div class="wt-code-box-btn wt-code-click-box-item"><a href="' +
        _btnLink +
        '" style="background: ' +
        _btnBgColor +
        "; color: " +
        _btnTxtColor +
        '; padding: 10px;">' +
        _btnTxt +
        "</a></div>";
    }
    html += "</div>";
    $(this).parent().append(html);
    var box = $(this).parent();
    box.find(".wt-code-click-box-item").css({ opacity: 0, marginTop: "20px" });
    box.find(".wt-code-product-click-box").css({ transform: "rotateY(90deg)" });
    runAnimateTransform(
      box.find(".wt-code-product-click-box"),
      90,
      5,
      function () {
        box
          .find(".wt-code-box-title")
          .animate({ opacity: 1, marginTop: "0" }, 500);
        setTimeout(function () {
          box
            .find(".wt-code-box-desc")
            .animate({ opacity: 1, marginTop: "0" }, 500);
        }, 400);
        setTimeout(function () {
          box
            .find(".wt-code-box-btn")
            .animate({ opacity: 1, marginTop: "0" }, 500);
        }, 800);
      },
    );
    box.find(".wt-code-product-click-box").click(function () {
      $(this).remove();
    });
  });

  $(".wt-code-product-hover-show img").hover(
    function () {
      var _idx = $(this).parent().attr("idx") == 1 ? 2 : 1;
      var _boxBgColor = $(this).attr("box-bg-color");
      var _boxTxtColor = $(this).attr("box-txt-color");
      var _color = $(this).attr("txt-color");
      var _title = $(this).attr("product-title");
      var _desc = $(this).attr("product-desc");
      var _btnTxt = $(this).attr("btn-txt");
      var _btnLink = $(this).attr("btn-link");
      var _btnBgColor = $(this).attr("btn-bg-color");
      var _btnTxtColor = $(this).attr("btn-txt-color");

      var box = $(this).parent().parent();
      if (
        box
          .find('.wt-code-product-hover-show[idx="' + _idx + '"]')
          .find(".wt-code-product-hover-box").length === 0
      ) {
        var html =
          '<div class="wt-code-p-a wt-code-product-hover-box" style="width: 100%; height: 100%; background: ' +
          _boxBgColor +
          "; color: " +
          _boxTxtColor +
          '; top: 0; left: 0; padding: 20% 10%; vertical-align: middle; display: inline-grid;">';
        if (_title) {
          html +=
            '<div class="wt-code-box-title wt-code-hover-box-item" style="font-size: 22px; color: #ddd;">' +
            _title +
            "</div>";
        }
        if (_desc) {
          html +=
            '<div class="wt-code-box-desc wt-code-hover-box-item" style="font-size: 18px; color: #ddd;">' +
            _desc +
            "</div>";
        }
        if (_btnTxt && _btnLink) {
          html +=
            '<div class="wt-code-box-btn wt-code-hover-box-item"><a href="' +
            _btnLink +
            '" style="background: ' +
            _btnBgColor +
            "; color: " +
            _btnTxtColor +
            '; padding: 10px;">' +
            _btnTxt +
            "</a></div>";
        }
        html += "</div>";
        box
          .find('.wt-code-product-hover-show[idx="' + _idx + '"]')
          .append(html);
        box
          .find(
            '.wt-code-product-hover-show[idx="' +
              _idx +
              '"] .wt-code-hover-box-item',
          )
          .css({ opacity: 0, marginTop: "20px" });
        box
          .find(
            '.wt-code-product-hover-show[idx="' +
              _idx +
              '"] .wt-code-box-title',
          )
          .animate({ opacity: 1, marginTop: "0" }, 1000);
        setTimeout(function () {
          box
            .find(
              '.wt-code-product-hover-show[idx="' +
                _idx +
                '"] .wt-code-box-desc',
            )
            .animate({ opacity: 1, marginTop: "0" }, 1000);
        }, 800);
        setTimeout(function () {
          box
            .find(
              '.wt-code-product-hover-show[idx="' +
                _idx +
                '"] .wt-code-box-btn',
            )
            .animate({ opacity: 1, marginTop: "0" }, 1000);
        }, 1500);
        box
          .find('.wt-code-product-hover-show[idx="' + _idx + '"]')
          .find(".wt-code-product-hover-box")
          .hover(
            function () {
              $(this).show();
            },
            function () {
              $(this).hide();
            },
          );
      } else {
        box
          .find('.wt-code-product-hover-show[idx="' + _idx + '"]')
          .find(".wt-code-product-hover-box")
          .show();
        box
          .find(
            '.wt-code-product-hover-show[idx="' +
              _idx +
              '"] .wt-code-hover-box-item',
          )
          .css({ opacity: 0, marginTop: "20px" });
        box
          .find(
            '.wt-code-product-hover-show[idx="' +
              _idx +
              '"] .wt-code-box-title',
          )
          .animate({ opacity: 1, marginTop: "0" }, 1000);
        setTimeout(function () {
          box
            .find(
              '.wt-code-product-hover-show[idx="' +
                _idx +
                '"] .wt-code-box-desc',
            )
            .animate({ opacity: 1, marginTop: "0" }, 1000);
        }, 800);
        setTimeout(function () {
          box
            .find(
              '.wt-code-product-hover-show[idx="' +
                _idx +
                '"] .wt-code-box-btn',
            )
            .animate({ opacity: 1, marginTop: "0" }, 1000);
        }, 1500);
      }
    },
    function () {
      $(".wt-code-product-hover-box").hide();
    },
  );

  var runMessageItemRoll = function (list, idx) {
    if ($(list).find(".wt-message-box").length > idx + 1) {
      $(list)
        .find(".wt-message-box")
        .css({ zIndex: 8, top: "0", left: "-100%" });
      $(list)
        .find(".wt-message-box")
        .eq(idx)
        .css({ zIndex: 9, top: "0", left: "0" });
      $(list)
        .find(".wt-message-box")
        .eq(idx + 1)
        .css({ zIndex: 10, top: "0", left: "100%" });
      $(list)
        .find(".wt-message-box")
        .eq(idx)
        .animate({ zIndex: 9, top: "0", left: "-100%" }, 3000);
      $(list)
        .find(".wt-message-box")
        .eq(idx + 1)
        .animate({ top: "0", left: "0" }, 3000, function () {
          setTimeout(function () {
            runMessageItemRoll(list, idx + 1);
          }, 2000);
        });
    } else {
      $(list)
        .find(".wt-message-box")
        .css({ zIndex: 8, top: "0", left: "-100%" });
      $(list)
        .find(".wt-message-box")
        .eq(idx)
        .css({ zIndex: 9, top: "0", left: "0" });
      $(list)
        .find(".wt-message-box")
        .eq(0)
        .css({ zIndex: 10, top: "0", left: "100%" });
      $(list)
        .find(".wt-message-box")
        .eq(idx)
        .animate({ zIndex: 9, top: "0", left: "-100%" }, 3000);
      $(list)
        .find(".wt-message-box")
        .eq(0)
        .animate({ top: "0", left: "0" }, 3000, function () {
          setTimeout(function () {
            runMessageItemRoll(list, 0);
          });
        });
    }
  };

  $(".wt-message-box-list").each(function () {
    runMessageItemRoll(this, 0);
  });

  $(".wt-code-show-pc .comment-drop-item").click(function () {
    $(".wt-code-show-pc .comment-drop-item").removeClass(
      "comment-drop-item-active",
    );
    $(this).addClass("comment-drop-item-active");
    var number = parseInt($(this).attr("number"));
    $(".comment-drop-item")
      .eq(0)
      .parent()
      .parent()
      .find(".comment-list-div-pc")
      .animate({ marginLeft: "-" + number * 50 + "%" }, 500);
  });

  $(".wt-code-show-moble .comment-drop-item").click(function () {
    $(".wt-code-show-moble .comment-drop-item").removeClass(
      "comment-drop-item-active",
    );
    $(this).addClass("comment-drop-item-active");
    var number = parseInt($(this).attr("number"));
    $(".comment-drop-item")
      .eq(0)
      .parent()
      .parent()
      .find(".comment-list-div-mobile")
      .animate({ marginLeft: "-" + number * 100 + "%" }, 500);
  });

  var _touch = 0;
  var _s_x = 0;
  var _action = "";
  var commentList = document.getElementsByClassName("comment-list");
  if ($("body").width() < 758 && commentList.length > 0) {
    for (var idx = 0; idx < commentList.length; idx++) {
      commentList[idx].addEventListener("touchstart", function (e) {
        console.log("touchstart");
        _s_x = e.targetTouches[0].pageX;
      });

      commentList[idx].addEventListener("touchmove", function (e) {
        console.log("touchmove");
        if (_s_x > e.targetTouches[0].pageX) {
          var _x = _s_x - e.targetTouches[0].pageX;
          _action = "left";
        } else {
          var _x = _s_x - e.targetTouches[0].pageX;
          _action = "right";
        }
      });

      commentList[idx].addEventListener("touchend", function (e) {
        var active = $(".wt-code-show-moble").find(".comment-drop-item-active");
        console.log("touchend", _action);
        if (_action == "left") {
          var number = parseInt(active.attr("number"));
          if (
            number < $(".wt-code-show-moble").find(".comment-drop-item").length
          ) {
            $(".wt-code-show-moble")
              .find('.comment-drop-item[number="' + (number + 1) + '"]')
              .click();
          }
        } else {
          var number = parseInt(active.attr("number"));
          if (number > 0) {
            $(".wt-code-show-moble")
              .find('.comment-drop-item[number="' + (number - 1) + '"]')
              .click();
          }
        }
      });
    }
  }
  // --- shopify-countdown --- //

  var runCountdown = function (div, endTimeStr) {
    var nowTime = new Date();
    var endTime = new Date(endTimeStr);
    var lefttime = endTime.getTime() - nowTime.getTime();
    var html = "";
    if (lefttime < 0) {
      html += '<span class="countdown-time-number">0</span>';
      html += '<span class="countdown-time-number">0</span>';
      html += ":";
      html += '<span class="countdown-time-number">0</span>';
      html += '<span class="countdown-time-number">0</span>';
      html += ":";
      html += '<span class="countdown-time-number">0</span>';
      html += '<span class="countdown-time-number">0</span>';
      html += ":";
      html += '<span class="countdown-time-number">0</span>';
      html += '<span class="countdown-time-number">0</span>';
    } else {
      var leftd = Math.floor(lefttime / (1000 * 60 * 60 * 24));
      var lefth = Math.floor((lefttime / (1000 * 60 * 60)) % 24);
      var leftm = Math.floor((lefttime / (1000 * 60)) % 60);
      var lefts = Math.floor((lefttime / 1000) % 60);
      if (leftd < 10) {
        html += '<span class="countdown-time-number">0</span>';
        html += '<span class="countdown-time-number">' + leftd + "</span>";
      } else {
        html +=
          '<span class="countdown-time-number">' + (leftd + "")[0] + "</span>";
        html +=
          '<span class="countdown-time-number">' + (leftd + "")[1] + "</span>";
      }
      html += ":";
      if (lefth < 10) {
        html += '<span class="countdown-time-number">0</span>';
        html += '<span class="countdown-time-number">' + lefth + "</span>";
      } else {
        html +=
          '<span class="countdown-time-number">' + (lefth + "")[0] + "</span>";
        html +=
          '<span class="countdown-time-number">' + (lefth + "")[1] + "</span>";
      }
      html += ":";
      if (leftm < 10) {
        html += '<span class="countdown-time-number">0</span>';
        html += '<span class="countdown-time-number">' + leftm + "</span>";
      } else {
        html +=
          '<span class="countdown-time-number">' + (leftm + "")[0] + "</span>";
        html +=
          '<span class="countdown-time-number">' + (leftm + "")[1] + "</span>";
      }
      html += ":";
      if (lefts < 10) {
        html += '<span class="countdown-time-number">0</span>';
        html += '<span class="countdown-time-number">' + lefts + "</span>";
      } else {
        html +=
          '<span class="countdown-time-number">' + (lefts + "")[0] + "</span>";
        html +=
          '<span class="countdown-time-number">' + (lefts + "")[1] + "</span>";
      }
    }
    div.html(html);
    setTimeout(function () {
      runCountdown(div, endTimeStr);
    }, 1000);
  };

  var runCountdownContainer = function () {
    $(".countdown-container").each(function () {
      if (window.innerWidth > 758) {
        // $(this).find(".hometitle").css("text-align", "left");
        $(this).find(".collection-slider").css("position", "relative");
        if (window.location.pathname == "/pages/homepage") {
          $(this)
            .find(".collection-slider")
            .append(
              '<div class="countdown-div" style="top: 0; right: 50px; color: #fff;"> Ends in:  <div class="countdown-time"></div></div>',
            );
        } else {
          // $(this)
          //   .find(".collection-slider")
          //   .append(
          //     '<div class="countdown-div" style="top: 0; right: 50px;"> Ends in:  <div class="countdown-time"></div></div>'
          //   );
          $(this)
            .find(".collection-slider .flash-sale-header-new")
            .append(
              '<div class="flash-sale-header-new-countdown"><div class="flash-sale-text">END IN</div><div class="countdown-time"></div></div>',
            );
        }
      } else {
        if (window.location.pathname == "/pages/homepage") {
          $(this)
            .find(".featured-collection-layout-mobile .view-all")
            .insertAfter(
              $(this).find(
                ".featured-collection-layout-mobile .collection-listing",
              ),
            );
          $(this).find(".page-header").css("position", "relative");
          $(this).css("position", "relative");
          $(this).find(".collection-listing").css("margin-top", "80px");
          $(this).append(
            '<div class="countdown-div" style="color: #fff;"> Ends in:  <div class="countdown-time"></div></div>',
          );
        } else {
          $(this).find(".page-header").css("position", "relative");
          $(this).css("position", "relative");
          //$(this).find(".collection-listing").css("margin-top", "80px");
          $(this)
            .find(
              ".collection-slider-row .flash-sale-header-new .flash-sale-header-new-countdown",
            )
            .html(
              '<div class="flash-sale-text">END IN</div><div class="countdown-time"></div>',
            );
        }
        if (
          ($(this).find(".featured-collection-layout-mobile").length > 0 &&
            $(this).find(".featured-collection-layout-mobile .view-all")
              .length == 0) ||
          ($(this).find(".featured-collection-layout-mobile").length == 0 &&
            $(this).find(".view-all").length == 0)
        ) {
          $(this).find(".countdown-div").css("top", "50px");
        }
      }
      if (window.location.pathname == "/pages/homepage") {
        runCountdown($(this).find(".countdown-time"), $(this).attr("end_time"));
      } else {
        runFlashSaleCountdown(
          $(this).find(".countdown-time"),
          $(this).attr("end_time"),
        );
      }

      var labelList = $(this).find(
        ".product-block .product-label-container-new .product-label-new--sale",
      );
      for (var idx = 0; idx < labelList.length; idx++) {
        var spanstr = labelList.eq(idx).html();
        var sale_amount = labelList.eq(idx).attr("data-amount"); //labelList.eq(idx).find(".sale_amount").html();
        labelList.eq(idx).css("background", "#E3CDB1");
        labelList.eq(idx).css("font-size", "12px");
        labelList.eq(idx).css("display", "flex");
        labelList.eq(idx).css("justify-content", "center");
        labelList.eq(idx).css("align-items", "center");
        if (window.innerWidth > 758) {
          labelList.eq(idx).css("width", "62px");
        } else {
          labelList.eq(idx).css("width", "55px");
        }
        spanstr =
          '<svg style="width: 12px;height: 12px;" xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none"><path d="M2 6.70312L3.68421 0H7.78947L6.10526 3.96094H10L2.21053 13L4.84211 6.70312H2Z" fill="black"/></svg>' +
          "<span>-" +
          sale_amount +
          "</span>";
        labelList.eq(idx).html(spanstr);
      }
      if (window.location.pathname != "/pages/homepage") {
        //$(this).find(".product-block__title").css("color", "#000");
        //$(this).find(".product-block__title").css("font-weight", "500");
        $(this).find(".product-price").css("color", "#000");
      }
    });

    $(".countdown-span-time").each(function () {
      const endTimeStr = $(this).attr("end_time");
      var nowTime = new Date();
      var endTime = new Date(endTimeStr);
      var lefttime = endTime.getTime() - nowTime.getTime();
      var container = $(this).closest(".lightly-spaced-row")[0];
      if (endTime && lefttime > 0) {
        if (container) {
          container.style.display = "block";
        }
        runProductDetailsCountdown($(this), endTimeStr, 2);
      } else {
        if (container) {
          container.style.display = "none";
        }
      }
    });
  };

  // 商品详情
  var runProductDetailsCountdown = function (div, endTimeStr, uesType) {
    var nowTime = new Date();
    var endTime = new Date(endTimeStr);
    var lefttime = endTime.getTime() - nowTime.getTime();
    var html = "";
    if (lefttime < 0) {
      html += '<span class="countdown-time-number !mr-1">0 Days</span>';
      html += '<span class="countdown-time-number">0</span>';
      html += '<span class="countdown-time-number">0</span>';
      html += ":";
      html += '<span class="countdown-time-number">0</span>';
      html += '<span class="countdown-time-number">0</span>';
      html += ":";
      html += '<span class="countdown-time-number">0</span>';
      html += '<span class="countdown-time-number">0</span>';
      div.html(html);
      if (uesType == 1) {
        // 商品详情早鸟价
        var container = div.closest("[data-end-time]")[0] || div.parent()[0];
        if (container) {
          container.style.display = "none";
        }
      } else if (uesType == 2) {
        // 商品详情FlashSale-兼容旧倒计时
        var container = div.closest(".lightly-spaced-row")[0];
        if (container) {
          container.style.display = "none";
        }
      }
      return;
    } else {
      var leftd = Math.floor(lefttime / (1000 * 60 * 60 * 24));
      var lefth = Math.floor((lefttime / (1000 * 60 * 60)) % 24);
      var leftm = Math.floor((lefttime / (1000 * 60)) % 60);
      var lefts = Math.floor((lefttime / 1000) % 60);
      html +=
        '<span class="countdown-time-number !mr-1">' + leftd + " Days</span>";
      if (lefth < 10) {
        html += '<span class="countdown-time-number">0</span>';
        html += '<span class="countdown-time-number">' + lefth + "</span>";
        html += ":";
      } else {
        html +=
          '<span class="countdown-time-number">' + (lefth + "")[0] + "</span>";
        html +=
          '<span class="countdown-time-number">' + (lefth + "")[1] + "</span>";
        html += ":";
      }
      if (leftm < 10) {
        html += '<span class="countdown-time-number">0</span>';
        html += '<span class="countdown-time-number">' + leftm + "</span>";
        html += ":";
      } else {
        html +=
          '<span class="countdown-time-number">' + (leftm + "")[0] + "</span>";
        html +=
          '<span class="countdown-time-number">' + (leftm + "")[1] + "</span>";
        html += ":";
      }
      if (lefts < 10) {
        html += '<span class="countdown-time-number">0</span>';
        html += '<span class="countdown-time-number">' + lefts + "</span>";
      } else {
        html +=
          '<span class="countdown-time-number">' + (lefts + "")[0] + "</span>";
        html +=
          '<span class="countdown-time-number">' + (lefts + "")[1] + "</span>";
      }
    }
    div.html(html);
    setTimeout(function () {
      runProductDetailsCountdown(div, endTimeStr, uesType);
    }, 1000);
  };

  // 首页FlashSale倒计时
  var runFlashSaleCountdown = function (div, endTimeStr) {
    var nowTime = new Date();
    var endTime = new Date(endTimeStr);
    var lefttime = endTime.getTime() - nowTime.getTime();
    var html = "";
    if (lefttime < 0) {
      html += '<span class="countdown-time-number">0</span>';
      html += '<span class="countdown-time-days">Days</span>';
      html += '<span class="countdown-time-number">00</span>';
      html += ":";
      html += '<span class="countdown-time-number">00</span>';
      html += ":";
      html += '<span class="countdown-time-number">00</span>';
    } else {
      var leftd = Math.floor(lefttime / (1000 * 60 * 60 * 24));
      var lefth = Math.floor((lefttime / (1000 * 60 * 60)) % 24);
      var leftm = Math.floor((lefttime / (1000 * 60)) % 60);
      var lefts = Math.floor((lefttime / 1000) % 60);
      if (leftd < 10) {
        html += '<span class="countdown-time-number">' + leftd + "</span>";
        html += '<span class="countdown-time-days">Days</span>';
      } else {
        html +=
          '<span class="countdown-time-number">' +
          (leftd + "")[0] +
          (leftd + "")[1] +
          "</span>";
      }
      if (lefth < 10) {
        html += '<span class="countdown-time-number">0' + lefth + "</span>";
      } else {
        html +=
          '<span class="countdown-time-number">' +
          (lefth + "")[0] +
          (lefth + "")[1] +
          "</span>";
      }
      html += ":";
      if (leftm < 10) {
        html += '<span class="countdown-time-number">0' + leftm + "</span>";
      } else {
        html +=
          '<span class="countdown-time-number">' +
          (leftm + "")[0] +
          (leftm + "")[1] +
          "</span>";
      }
      html += ":";
      if (lefts < 10) {
        html += '<span class="countdown-time-number">0' + lefts + "</span>";
      } else {
        html +=
          '<span class="countdown-time-number">' +
          (lefts + "")[0] +
          (lefts + "")[1] +
          "</span>";
      }
    }
    div.html(html);
    setTimeout(function () {
      runFlashSaleCountdown(div, endTimeStr);
    }, 1000);
  };

  var runProductDetailsEndIn = function () {
    var url =
      dtc_url +
      "api/activity/flashSale?shop_id=3&activity_site=us&current=" +
      (Math.random() + "").substr(2);
    $.ajax({
      url: url,
      timeout: dtc_time_out, // 设置超时时间为 3 秒
      success: function (result) {
        if (result.end_in && result.collection_id) {
          var collectionsAttr = $(".flash-div").attr("data-collections"); // 获取data-collections属性值
          if (collectionsAttr) {
            var collectionsArray = collectionsAttr.split(",");
            var collectionIdToCheck = result.collection_id.toString();
            var isCollectionIdExists =
              collectionsArray.includes(collectionIdToCheck); // 检查集合ID是否存在

            if (isCollectionIdExists) {
              $(".countdown-span-time").attr("end_time", result.end_in);
              $(".flash-div").show();
              runCountdownContainer();
            }
          }
        }
      },
    });
  };
  if (window.location.pathname.includes("/products/")) {
    runProductDetailsEndIn();
  } else {
    runCountdownContainer();
  }
  // --- shopify-countdown --- //

  // ----- //
  if (window.location.pathname.substr(0, "/en-ca".length) == "/en-ca") {
    setTimeout(function () {
      for (var idx = 0; idx < $(".navigation__tier-1").length; idx++) {
        $(".navigation__tier-1")
          .eq(idx)
          .find("li")
          .eq(0)
          .before(
            '<li class="navigation__item"><a href="/en-ca/collections/ca-hunting-blind-rangefinder" class="navigation__link">FOR CA CUSTOMER</a></li>',
          );
      }
    }, 200);
  }
  $(".rbrFastBundlePage").remove();

  $('.product-block[data-product-id="7877457543380"]').remove();

  $('.product-block[data-product-id="7864134893780"]').remove();
  $('.product-block[data-product-id="7864145543380"]').remove();
  $('.product-block[data-product-id="7864156815572"]').remove();
  $('.product-block[data-product-id="7864152883412"]').remove();
  // $('.product-block[data-product-id="7864154161364"]').remove();
  $('.product-block[data-product-id="7864153800916"]').remove();
  // $('.product-block[data-product-id="8617297117396"]').remove();

  if (
    window.location.pathname.substr(0, "/collections/all".length) !=
      "/collections/all" &&
    window.location.pathname.substr(0, "/collections/search-blind".length) !=
      "/collections/search-blind"
  ) {
    // $('.product-block[data-product-id="7877456068820"]').remove();
  }

  if (
    window.location.pathname ==
    "/products/tidewe-hunting-blind-see-through-with-carrying-bag-2-3-person-pop-up-ground-blinds-270-degree-hunting-tent"
  ) {
    // $('.product-info-block').eq(0).remove();
  }

  // if (
  //   window.location.pathname.substr(0, "/collections/all".length) !=
  //   "/collections/all"
  // ) {
  //   $('.product-block[data-product-id="7728337715412"]').remove();
  // }

  if (
    window.location.pathname.substr(
      0,
      "/products/hunting-blind-270-see-through-with-silent-magnetic-door-sliding-windows-2-3-person-pop-up-ground-blind-with-carrying-bag-portable-durable-hunting-tent-for-deer-turkey-huntingcamouflage"
        .length,
    ) ==
    "/products/hunting-blind-270-see-through-with-silent-magnetic-door-sliding-windows-2-3-person-pop-up-ground-blind-with-carrying-bag-portable-durable-hunting-tent-for-deer-turkey-huntingcamouflage"
  ) {
    $(".product-label-list").remove();
    setTimeout(function () {
      $(".product-label-list").remove();
    }, 200);
    setTimeout(function () {
      $(".product-label-list").remove();
    }, 500);
    setTimeout(function () {
      $(".product-label-list").remove();
    }, 1000);
    setTimeout(function () {
      $(".product-label-list").remove();
    }, 1500);
  }

  if (window.location.pathname.substr(0, "/search".length) == "/search") {
    $('.product-block[data-product-id="7880397422804"]').remove();
    setTimeout(function () {
      $('.product-block[data-product-id="7880397422804"]').remove();
    }, 200);
    setTimeout(function () {
      $('.product-block[data-product-id="7880397422804"]').remove();
    }, 500);
    setTimeout(function () {
      $('.product-block[data-product-id="7880397422804"]').remove();
    }, 1000);
    setTimeout(function () {
      $('.product-block[data-product-id="7880397422804"]').remove();
    }, 1500);

    $('.product-block[data-product-id="7864134893780"]').remove();
    $('.product-block[data-product-id="7864145543380"]').remove();
    $('.product-block[data-product-id="7864156815572"]').remove();
    $('.product-block[data-product-id="7864152883412"]').remove();
    // $('.product-block[data-product-id="7864154161364"]').remove();
    $('.product-block[data-product-id="7864153800916"]').remove();
    setTimeout(function () {
      $('.product-block[data-product-id="7864134893780"]').remove();
      $('.product-block[data-product-id="7864145543380"]').remove();
      $('.product-block[data-product-id="7864156815572"]').remove();
      $('.product-block[data-product-id="7864152883412"]').remove();
      // $('.product-block[data-product-id="7864154161364"]').remove();
      $('.product-block[data-product-id="7864153800916"]').remove();
    }, 500);
  }

  if (
    window.location.pathname.substr(
      0,
      "/en-ca/collections/ca-hunting-blind-rangefinder".length,
    ) != "/en-ca/collections/ca-hunting-blind-rangefinder"
  ) {
    $('.product-block[data-product-id="7823569420500"]').remove();
    $('.product-block[data-product-id="7823557198036"]').remove();
    $('.product-block[data-product-id="7795060408532"]').remove();
    $('.product-block[data-product-id="7433854353620"]').remove();
  }

  if (
    window.location.pathname.substr(
      0,
      "/collections/ca-hunting-blind-rangefinder".length,
    ) != "/collections/ca-hunting-blind-rangefinder" &&
    window.location.pathname.substr(
      0,
      "/en-ca/collections/ca-hunting-blind-rangefinder".length,
    ) != "/en-ca/collections/ca-hunting-blind-rangefinder"
  ) {
    $('.product-block[data-product-id="7821652852948"]').remove();
    $('.product-block[data-product-id="7821653999828"]').remove();
    $('.product-block[data-product-id="7821653311700"]').remove();
    $('.product-block[data-product-id="7821655179476"]').remove();
    $('.product-block[data-product-id="7821652394196"]').remove();
    $('.product-block[data-product-id="7821651312852"]').remove();
  }

  function runMoveDescriptors() {
    console.log($(".price-descriptors").length);
  }

  if (window.location.pathname.substr(0, "/products/".length) == "/products/") {
    runMoveDescriptors();
  }

  function setReviewsTr() {
    if (
      $("#opinew-reviews-product-page-code").find(".opw-table").length === 1
    ) {
      $("#opinew-reviews-product-page-code")
        .find(".opw-table")
        .find("tr")
        .eq(2)
        .find(".opw-progress-meter")
        .css("width", 0);
      $("#opinew-reviews-product-page-code")
        .find(".opw-table")
        .find("tr")
        .eq(3)
        .find(".opw-progress-meter")
        .css("width", 0);
      $("#opinew-reviews-product-page-code")
        .find(".opw-table")
        .find("tr")
        .eq(4)
        .find(".opw-progress-meter")
        .css("width", 0);
      $("#opinew-reviews-product-page-code")
        .find(".opw-table")
        .find("tr")
        .eq(2)
        .find("td")
        .eq(2)
        .find(".opw-inline-block")
        .html("(0)");
      $("#opinew-reviews-product-page-code")
        .find(".opw-table")
        .find("tr")
        .eq(3)
        .find("td")
        .eq(2)
        .find(".opw-inline-block")
        .html("(0)");
      $("#opinew-reviews-product-page-code")
        .find(".opw-table")
        .find("tr")
        .eq(4)
        .find("td")
        .eq(2)
        .find(".opw-inline-block")
        .html("(0)");
      $(".opw-progress").eq(0).click();
      setTimeout(function () {
        $("#opinew-reviews-product-page-code")
          .find(".opw-table")
          .find("tr")
          .eq(2)
          .find(".opw-progress-meter")
          .css("width", 0);
        $("#opinew-reviews-product-page-code")
          .find(".opw-table")
          .find("tr")
          .eq(3)
          .find(".opw-progress-meter")
          .css("width", 0);
        $("#opinew-reviews-product-page-code")
          .find(".opw-table")
          .find("tr")
          .eq(4)
          .find(".opw-progress-meter")
          .css("width", 0);
        $("#opinew-reviews-product-page-code")
          .find(".opw-table")
          .find("tr")
          .eq(2)
          .find("td")
          .eq(2)
          .find(".opw-inline-block")
          .html("(0)");
        $("#opinew-reviews-product-page-code")
          .find(".opw-table")
          .find("tr")
          .eq(3)
          .find("td")
          .eq(2)
          .find(".opw-inline-block")
          .html("(0)");
        $("#opinew-reviews-product-page-code")
          .find(".opw-table")
          .find("tr")
          .eq(4)
          .find("td")
          .eq(2)
          .find(".opw-inline-block")
          .html("(0)");
      }, 200);
    } else {
      setTimeout(function () {
        setReviewsTr();
      }, 200);
    }
  }

  setReviewsTr();

  var cc = {
    sections: [],
  };

  theme.cartNoteMonitor = {
    load: function load($notes) {
      $notes.on(
        "change.themeCartNoteMonitor paste.themeCartNoteMonitor keyup.themeCartNoteMonitor",
        function () {
          theme.cartNoteMonitor.postUpdate($(this).val());
        },
      );
    },

    unload: function unload($notes) {
      $notes.off(".themeCartNoteMonitor");
    },

    updateThrottleTimeoutId: -1,
    updateThrottleInterval: 500,

    postUpdate: function postUpdate(val) {
      clearTimeout(theme.cartNoteMonitor.updateThrottleTimeoutId);
      theme.cartNoteMonitor.updateThrottleTimeoutId = setTimeout(function () {
        $.post(
          theme.routes.cart_url + "/update.js",
          {
            note: val,
          },
          function (data) {},
          "json",
        );
      }, theme.cartNoteMonitor.updateThrottleInterval);
    },
  };

  theme.Shopify = {
    formatMoney: function formatMoney(t, r) {
      function e(t, r) {
        return void 0 === t ? r : t;
      }
      function a(t, r, a, o) {
        if (
          ((r = e(r, 2)),
          (a = e(a, ",")),
          (o = e(o, ".")),
          isNaN(t) || null == t)
        )
          return 0;
        t = (t / 100).toFixed(r);
        var n = t.split(".");
        return (
          n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) +
          (n[1] ? o + n[1] : "")
        );
      }
      "string" == typeof t && (t = t.replace(".", ""));
      var o = "",
        n = /\{\{\s*(\w+)\s*\}\}/,
        i = r || this.money_format;
      switch (i.match(n)[1]) {
        case "amount":
          o = a(t, 2);
          break;
        case "amount_no_decimals":
          o = a(t, 0);
          break;
        case "amount_with_comma_separator":
          o = a(t, 2, ".", ",");
          break;
        case "amount_with_space_separator":
          o = a(t, 2, " ", ",");
          break;
        case "amount_with_period_and_space_separator":
          o = a(t, 2, " ", ".");
          break;
        case "amount_no_decimals_with_comma_separator":
          o = a(t, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          o = a(t, 0, " ", "");
          break;
        case "amount_with_apostrophe_separator":
          o = a(t, 2, "'", ".");
          break;
        case "amount_with_decimal_separator":
          o = a(t, 2, ".", ".");
      }

      return i.replace(n, o);
    },
    formatImage: function formatImage(originalImageUrl, format) {
      return originalImageUrl
        ? originalImageUrl.replace(/^(.*)\.([^\.]*)$/g, "$1_" + format + ".$2")
        : "";
    },
    Image: {
      imageSize: function imageSize(t) {
        var e = t.match(
          /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/,
        );
        return null !== e ? e[1] : null;
      },
      getSizedImageUrl: function getSizedImageUrl(t, e) {
        if (null == e) return t;
        if ("master" == e) return this.removeProtocol(t);
        var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (null != o) {
          var i = t.split(o[0]),
            r = o[0];
          return this.removeProtocol(i[0] + "_" + e + r);
        }
        return null;
      },
      removeProtocol: function removeProtocol(t) {
        return t.replace(/http(s)?:/, "");
      },
    },
  };

  theme.Disclosure = (function () {
    var selectors = {
      disclosureList: "[data-disclosure-list]",
      disclosureToggle: "[data-disclosure-toggle]",
      disclosureInput: "[data-disclosure-input]",
      disclosureOptions: "[data-disclosure-option]",
    };

    var classes = {
      listVisible: "disclosure-list--visible",
    };

    function Disclosure($disclosure) {
      this.$container = $disclosure;
      this.cache = {};
      this._cacheSelectors();
      this._connectOptions();
      this._connectToggle();
      this._onFocusOut();
    }

    Disclosure.prototype = $.extend({}, Disclosure.prototype, {
      _cacheSelectors: function _cacheSelectors() {
        this.cache = {
          $disclosureList: this.$container.find(selectors.disclosureList),
          $disclosureToggle: this.$container.find(selectors.disclosureToggle),
          $disclosureInput: this.$container.find(selectors.disclosureInput),
          $disclosureOptions: this.$container.find(selectors.disclosureOptions),
        };
      },

      _connectToggle: function _connectToggle() {
        this.cache.$disclosureToggle.on(
          "click",
          function (evt) {
            var ariaExpanded =
              $(evt.currentTarget).attr("aria-expanded") === "true";
            $(evt.currentTarget).attr("aria-expanded", !ariaExpanded);

            this.cache.$disclosureList.toggleClass(classes.listVisible);
          }.bind(this),
        );
      },

      _connectOptions: function _connectOptions() {
        this.cache.$disclosureOptions.on(
          "click",
          function (evt) {
            evt.preventDefault();
            this._submitForm($(evt.currentTarget).data("value"));
          }.bind(this),
        );
      },

      _onFocusOut: function _onFocusOut() {
        this.cache.$disclosureToggle.on(
          "focusout",
          function (evt) {
            var disclosureLostFocus =
              this.$container.has(evt.relatedTarget).length === 0;

            if (disclosureLostFocus) {
              this._hideList();
            }
          }.bind(this),
        );

        this.cache.$disclosureList.on(
          "focusout",
          function (evt) {
            var childInFocus =
              $(evt.currentTarget).has(evt.relatedTarget).length > 0;
            var isVisible = this.cache.$disclosureList.hasClass(
              classes.listVisible,
            );

            if (isVisible && !childInFocus) {
              this._hideList();
            }
          }.bind(this),
        );

        this.$container.on(
          "keyup",
          function (evt) {
            if (evt.which !== 27) return; // escape
            this._hideList();
            this.cache.$disclosureToggle.focus();
          }.bind(this),
        );

        this.bodyOnClick = function (evt) {
          var isOption = this.$container.has(evt.target).length > 0;
          var isVisible = this.cache.$disclosureList.hasClass(
            classes.listVisible,
          );

          if (isVisible && !isOption) {
            this._hideList();
          }
        }.bind(this);

        $("body").on("click", this.bodyOnClick);
      },

      _submitForm: function _submitForm(value) {
        this.cache.$disclosureInput.val(value);
        this.$container.parents("form").submit();
      },

      _hideList: function _hideList() {
        this.cache.$disclosureList.removeClass(classes.listVisible);
        this.cache.$disclosureToggle.attr("aria-expanded", false);
      },

      unload: function unload() {
        $("body").off("click", this.bodyOnClick);
        this.cache.$disclosureOptions.off();
        this.cache.$disclosureToggle.off();
        this.cache.$disclosureList.off();
        this.$container.off();
      },
    });

    return Disclosure;
  })();
  (function () {
    function throttle(callback, threshold) {
      var debounceTimeoutId = -1;
      var tick = false;

      return function () {
        clearTimeout(debounceTimeoutId);
        debounceTimeoutId = setTimeout(callback, threshold);

        if (!tick) {
          callback.call();
          tick = true;
          setTimeout(function () {
            tick = false;
          }, threshold);
        }
      };
    }

    function showSlickCart() {
      var $element = $("#add-to-cart-3d");
      if (!$element.offset()) return;
      if ($element.text() !== theme?.strings?.products_product_add_to_cart)
        return;
      var elementTop = $element.offset().top;
      var viewportTop = $(window).scrollTop();
      if (elementTop >= viewportTop) {
        $(".product-column-float-pc").css({
          transform: "translate(0, 100%)",
        });
        $(".product-column-float-mobile-show").css({
          transform: "translate(0, 100%)",
        });
      } else {
        $(".product-column-float-pc").css({
          transform: "translate(0, 0)",
        });
        $(".product-column-float-mobile-show").css({
          transform: "translate(0, 0)",
        });
      }
    }

    var scrollEvent = document.createEvent("Event");
    scrollEvent.initEvent("throttled-scroll", true, true);

    window.addEventListener(
      "scroll",
      throttle(function () {
        window.dispatchEvent(scrollEvent);
        showSlickCart();
      }, 200),
    );
  })();
  // Source: https://davidwalsh.name/javascript-debounce-function
  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  theme.debounce = function (func) {
    var wait =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 700;
    var immediate = arguments.length > 2 ? arguments[2] : undefined;
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function later() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };
  // requires: throttled-scroll, debouncedresize

  /*
    Define a section by creating a new function object and registering it with the section handler.
    The section handler manages:
      Instantiation for all sections on the current page
      Theme editor lifecycle events
      Deferred initialisation
      Event cleanup
  
    There are two ways to register a section.
    In a theme:
      theme.Sections.register('slideshow', theme.SlideshowSection);
      theme.Sections.register('header', theme.HeaderSection, { deferredLoad: false });
      theme.Sections.register('background-video', theme.VideoManager, { deferredLoadViewportExcess: 800 });
  
    As a component:
      cc.sections.push({ name: 'faq', section: theme.Faq });
  
    Assign any of these to receive Shopify section lifecycle events:
      this.onSectionLoad
      this.afterSectionLoadCallback
      this.onSectionSelect
      this.onSectionDeselect
      this.onBlockSelect
      this.onBlockDeselect
      this.onSectionUnload
      this.afterSectionUnloadCallback
      this.onSectionReorder
  
    If you add any events using the manager's registerEventListener,
    e.g. this.registerEventListener(element, 'click', this.functions.handleClick.bind(this)),
    these will be automatically cleaned up after onSectionUnload.
   */

  theme.Sections = new (function () {
    var _ = this;

    _._instances = [];
    _._deferredSectionTargets = [];
    _._sections = [];
    _._deferredLoadViewportExcess = 300; // load defferred sections within this many px of viewport
    _._deferredWatcherRunning = false;

    _.init = function () {
      $(document)
        .on("shopify:section:load", function (e) {
          // load a new section
          var target = _._themeSectionTargetFromShopifySectionTarget(e.target);
          if (target) {
            _.sectionLoad(target);
          }
        })
        .on("shopify:section:unload", function (e) {
          // unload existing section
          var target = _._themeSectionTargetFromShopifySectionTarget(e.target);
          if (target) {
            _.sectionUnload(target);
          }
        })
        .on("shopify:section:reorder", function (e) {
          // unload existing section
          var target = _._themeSectionTargetFromShopifySectionTarget(e.target);
          if (target) {
            _.sectionReorder(target);
          }
        });
      $(window).on(
        "throttled-scroll.themeSectionDeferredLoader debouncedresize.themeSectionDeferredLoader",
        _._processDeferredSections,
      );
      _._deferredWatcherRunning = true;
    };

    // register a type of section
    _.register = function (type, section, options) {
      _._sections.push({
        type: type,
        section: section,
        afterSectionLoadCallback: options ? options.afterLoad : null,
        afterSectionUnloadCallback: options ? options.afterUnload : null,
      });

      // load now
      $('[data-section-type="' + type + '"]').each(function () {
        if (
          Shopify.designMode ||
          (options && options.deferredLoad === false) ||
          !_._deferredWatcherRunning
        ) {
          _.sectionLoad(this);
        } else {
          _.sectionDeferredLoad(this, options);
        }
      });
    };

    // prepare a section to load later
    _.sectionDeferredLoad = function (target, options) {
      _._deferredSectionTargets.push({
        target: target,
        deferredLoadViewportExcess:
          options && options.deferredLoadViewportExcess
            ? options.deferredLoadViewportExcess
            : _._deferredLoadViewportExcess,
      });

      _._processDeferredSections(true);
    };

    // load deferred sections if in/near viewport
    _._processDeferredSections = function (firstRunCheck) {
      if (_._deferredSectionTargets.length) {
        var viewportTop = $(window).scrollTop(),
          viewportBottom = viewportTop + $(window).height(),
          loopStart =
            firstRunCheck === true ? _._deferredSectionTargets.length - 1 : 0;
        for (var i = loopStart; i < _._deferredSectionTargets.length; i++) {
          var target = _._deferredSectionTargets[i].target,
            viewportExcess =
              _._deferredSectionTargets[i].deferredLoadViewportExcess,
            sectionTop = $(target).offset().top - viewportExcess,
            doLoad = sectionTop > viewportTop && sectionTop < viewportBottom;
          if (!doLoad) {
            var sectionBottom =
              sectionTop + $(target).outerHeight() + viewportExcess * 2;
            doLoad =
              sectionBottom > viewportTop && sectionBottom < viewportBottom;
          }
          if (
            doLoad ||
            (sectionTop < viewportTop && sectionBottom > viewportBottom)
          ) {
            // in viewport, load
            _.sectionLoad(target);
            // remove from deferred queue and resume checks
            _._deferredSectionTargets.splice(i, 1);
            i--;
          }
        }
      }

      // remove event if no more deferred targets left, if not on first run
      if (firstRunCheck !== true && _._deferredSectionTargets.length === 0) {
        _._deferredWatcherRunning = false;
        $(window).off(".themeSectionDeferredLoader");
      }
    };

    // load in a section
    _.sectionLoad = function (target) {
      var target = target,
        sectionObj = _._sectionForTarget(target),
        section = false;

      if (sectionObj.section) {
        section = sectionObj.section;
      } else {
        section = sectionObj;
      }

      if (section !== false) {
        var instance = {
          target: target,
          section: section,
          $shopifySectionContainer: $(target).closest(".shopify-section"),
          thisContext: {
            functions: section.functions,
            registeredEventListeners: [],
          },
        };

        instance.thisContext.registerEventListener =
          _._registerEventListener.bind(instance.thisContext);
        _._instances.push(instance);

        //Initialise any components
        if ($(target).data("components")) {
          //Init each component
          var components = $(target).data("components").split(",");
          components.forEach((component) => {
            $(document).trigger("cc:component:load", [component, target]);
          });
        }

        _._callSectionWith(
          section,
          "onSectionLoad",
          target,
          instance.thisContext,
        );
        _._callSectionWith(
          section,
          "afterSectionLoadCallback",
          target,
          instance.thisContext,
        );

        // attach additional UI events if defined
        if (section.onSectionSelect) {
          instance.$shopifySectionContainer.on(
            "shopify:section:select",
            function (e) {
              _._callSectionWith(
                section,
                "onSectionSelect",
                e.target,
                instance.thisContext,
              );
            },
          );
        }
        if (section.onSectionDeselect) {
          instance.$shopifySectionContainer.on(
            "shopify:section:deselect",
            function (e) {
              _._callSectionWith(
                section,
                "onSectionDeselect",
                e.target,
                instance.thisContext,
              );
            },
          );
        }
        if (section.onBlockSelect) {
          $(target).on("shopify:block:select", function (e) {
            _._callSectionWith(
              section,
              "onBlockSelect",
              e.target,
              instance.thisContext,
            );
          });
        }
        if (section.onBlockDeselect) {
          $(target).on("shopify:block:deselect", function (e) {
            _._callSectionWith(
              section,
              "onBlockDeselect",
              e.target,
              instance.thisContext,
            );
          });
        }
      }
    };

    // unload a section
    _.sectionUnload = function (target) {
      var sectionObj = _._sectionForTarget(target);
      var instanceIndex = -1;
      for (var i = 0; i < _._instances.length; i++) {
        if (_._instances[i].target == target) {
          instanceIndex = i;
        }
      }
      if (instanceIndex > -1) {
        var instance = _._instances[instanceIndex];
        // remove events and call unload, if loaded
        $(target).off("shopify:block:select shopify:block:deselect");
        instance.$shopifySectionContainer.off(
          "shopify:section:select shopify:section:deselect",
        );
        _._callSectionWith(
          instance.section,
          "onSectionUnload",
          target,
          instance.thisContext,
        );
        _._unloadRegisteredEventListeners(
          instance.thisContext.registeredEventListeners,
        );
        _._callSectionWith(
          sectionObj,
          "afterSectionUnloadCallback",
          target,
          instance.thisContext,
        );
        _._instances.splice(instanceIndex);

        //Destroy any components
        if ($(target).data("components")) {
          //Init each component
          var components = $(target).data("components").split(",");
          components.forEach((component) => {
            $(document).trigger("cc:component:unload", [component, target]);
          });
        }
      } else {
        // check if it was a deferred section
        for (var i = 0; i < _._deferredSectionTargets.length; i++) {
          if (_._deferredSectionTargets[i].target == target) {
            _._deferredSectionTargets[i].splice(i, 1);
            break;
          }
        }
      }
    };

    _.sectionReorder = function (target) {
      var instanceIndex = -1;
      for (var i = 0; i < _._instances.length; i++) {
        if (_._instances[i].target == target) {
          instanceIndex = i;
        }
      }
      if (instanceIndex > -1) {
        var instance = _._instances[instanceIndex];
        _._callSectionWith(
          instance.section,
          "onSectionReorder",
          target,
          instance.thisContext,
        );
      }
    };

    // Helpers
    _._registerEventListener = function (element, eventType, callback) {
      element.addEventListener(eventType, callback);
      this.registeredEventListeners.push({
        element,
        eventType,
        callback,
      });
    };

    _._unloadRegisteredEventListeners = function (registeredEventListeners) {
      registeredEventListeners.forEach((rel) => {
        rel.element.removeEventListener(rel.eventType, rel.callback);
      });
    };

    _._callSectionWith = function (section, method, container, thisContext) {
      if (typeof section[method] === "function") {
        try {
          if (thisContext) {
            section[method].bind(thisContext)(container);
          } else {
            section[method](container);
          }
        } catch (ex) {
          var sectionType = container.dataset["sectionType"];
          console.warn(
            "Theme warning: '"
              .concat(method, "' failed for section '")
              .concat(sectionType, "'"),
          );
          console.debug(container, ex);
        }
      }
    };

    _._themeSectionTargetFromShopifySectionTarget = function (target) {
      var $target = $("[data-section-type]:first", target);
      if ($target.length > 0) {
        return $target[0];
      } else {
        return false;
      }
    };

    _._sectionForTarget = function (target) {
      var type = $(target).attr("data-section-type");
      for (var i = 0; i < _._sections.length; i++) {
        if (_._sections[i].type == type) {
          return _._sections[i];
        }
      }
      return false;
    };

    _._sectionAlreadyRegistered = function (type) {
      for (var i = 0; i < _._sections.length; i++) {
        if (_._sections[i].type == type) {
          return true;
        }
      }
      return false;
    };
  })();
  // Loading third party scripts
  theme.scriptsLoaded = {};
  theme.loadScriptOnce = function (src, callback, beforeRun, sync) {
    if (typeof theme.scriptsLoaded[src] === "undefined") {
      theme.scriptsLoaded[src] = [];
      var tag = document.createElement("script");
      tag.src = src;

      if (sync || beforeRun) {
        tag.async = false;
      }

      if (beforeRun) {
        beforeRun();
      }

      if (typeof callback === "function") {
        theme.scriptsLoaded[src].push(callback);
        if (tag.readyState) {
          // IE, incl. IE9
          tag.onreadystatechange = function () {
            if (tag.readyState == "loaded" || tag.readyState == "complete") {
              tag.onreadystatechange = null;
              for (var i = 0; i < theme.scriptsLoaded[this].length; i++) {
                theme.scriptsLoaded[this][i]();
              }
              theme.scriptsLoaded[this] = true;
            }
          }.bind(src);
        } else {
          tag.onload = function () {
            // Other browsers
            for (var i = 0; i < theme.scriptsLoaded[this].length; i++) {
              theme.scriptsLoaded[this][i]();
            }
            theme.scriptsLoaded[this] = true;
          }.bind(src);
        }
      }

      var firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      return true;
    } else if (
      typeof theme.scriptsLoaded[src] === "object" &&
      typeof callback === "function"
    ) {
      theme.scriptsLoaded[src].push(callback);
    } else {
      if (typeof callback === "function") {
        callback();
      }
      return false;
    }
  };

  theme.loadStyleOnce = function (src) {
    var srcWithoutProtocol = src.replace(/^https?:/, "");
    if (
      !document.querySelector(
        'link[href="' + encodeURI(srcWithoutProtocol) + '"]',
      )
    ) {
      var tag = document.createElement("link");
      tag.href = srcWithoutProtocol;
      tag.rel = "stylesheet";
      tag.type = "text/css";
      var firstTag = document.getElementsByTagName("link")[0];
      firstTag.parentNode.insertBefore(tag, firstTag);
    }
  }; /// Show a short-lived text popup above an element
  theme.showQuickPopup = function (message, $origin) {
    var $popup = $('<div class="simple-popup"/>');
    var offs = $origin.offset();
    $popup.html(message).css({ left: offs.left, top: offs.top }).hide();
    $("body").append($popup);
    $popup.css({
      marginTop: -$popup.outerHeight() - 10,
      marginLeft: -($popup.outerWidth() - $origin.outerWidth()) / 2,
    });
    $popup
      .fadeIn(200)
      .delay(3500)
      .fadeOut(400, function () {
        $(this).remove();
      });
  };
  class ccComponent {
    constructor(name) {
      var cssSelector =
        arguments.length > 1 && arguments[1] !== undefined
          ? arguments[1]
          : ".cc-".concat(name);
      var _this = this;
      this.instances = [];

      // Initialise any instance of this component within a section
      $(document).on("cc:component:load", function (event, component, target) {
        if (component === name) {
          $(target)
            .find("".concat(cssSelector, ":not(.cc-initialized)"))
            .each(function () {
              _this.init(this);
            });
        }
      });

      // Destroy any instance of this component within a section
      $(document).on(
        "cc:component:unload",
        function (event, component, target) {
          if (component === name) {
            $(target)
              .find(cssSelector)
              .each(function () {
                _this.destroy(this);
              });
          }
        },
      );

      // Initialise any instance of this component
      $(cssSelector).each(function () {
        _this.init(this);
      });
    }

    init(container) {
      $(container).addClass("cc-initialized");
    }

    destroy(container) {
      $(container).removeClass("cc-initialized");
    }

    registerInstance(container, instance) {
      this.instances.push({
        container,
        instance,
      });
    }

    destroyInstance(container) {
      this.instances = this.instances.filter((item) => {
        if (item.container === container) {
          if (typeof item.instance.destroy === "function") {
            item.instance.destroy();
          }

          return item.container !== container;
        }
      });
    }
  }

  /**
   * Use with template literals to build HTML with correct escaping.
   *
   * Example:
   *
   * const tve = theme.createTemplateVariableEncoder();
   * tve.add('className', className, 'attribute');
   * tve.add('title', title, 'html');
   * tve.add('richText', richText, 'raw');
   * const template = `
   *   <div class="${tve.values.className}">
   *     <h1>${tve.values.title}</h1>
   *     <div class="rte">${tve.values.richText}</div>
   *   </div>
   * `;
   */
  theme.createTemplateVariableEncoder = function () {
    return {
      utilityElement: document.createElement("div"),
      values: {},
      /**
       * Add a new value to sanitise.
       * @param {String} key - key used to retrieve this value
       * @param {String} value - the value to encode and store
       * @param {String} type - possible values: [attribute, html, raw] - the type of encoding to use
       */
      add: function add(key, value, type) {
        switch (type) {
          case "attribute":
            this.utilityElement.innerHTML = "";
            this.utilityElement.setAttribute("util", value);
            this.values[key] =
              this.utilityElement.outerHTML.match(/util="([^"]*)"/)[1];
            break;
          case "html":
            this.utilityElement.innerText = value;
            this.values[key] = this.utilityElement.innerHTML;
            break;
          case "raw":
            this.values[key] = value;
            break;
          default:
            throw "Type '".concat(type, "' not handled");
        }
      },
    };
  };
  theme.suffixIds = function (container, suffix) {
    var refAttrs = ["aria-describedby", "aria-controls"];
    suffix = "-" + suffix;
    container.querySelectorAll("[id]").forEach((el) => {
      var oldId = el.id,
        newId = oldId + suffix;
      el.id = newId;
      refAttrs.forEach((attr) => {
        container
          .querySelectorAll("[".concat(attr, '="').concat(oldId, '"]'))
          .forEach((refEl) => {
            refEl.setAttribute(attr, newId);
          });
      });
    });
  };
  theme.renderUnitPrice = function (
    unit_price,
    unit_price_measurement,
    money_format,
  ) {
    if (unit_price && unit_price_measurement) {
      var unitPriceHtml = '<div class="unit-price">';
      unitPriceHtml += '<span class="unit-price__price theme-money">'.concat(
        theme.Shopify.formatMoney(unit_price, money_format),
        "</span>",
      );
      unitPriceHtml += '<span class="unit-price__separator">'.concat(
        theme.strings.products_product_unit_price_separator,
        "</span>",
      );
      var unit = unit_price_measurement.reference_unit;
      if (unit_price_measurement.reference_value != 1) {
        unit = unit_price_measurement.reference_value + unit;
      }
      unitPriceHtml += '<span class="unit-price__unit">'.concat(
        unit,
        "</span>",
      );
      unitPriceHtml += "</div>";
      return unitPriceHtml;
    } else {
      return "";
    }
  };
  class ccPopup {
    constructor($container, namespace) {
      this.$container = $container;
      this.namespace = namespace;
      this.cssClasses = {
        visible: "cc-popup--visible",
        bodyNoScroll: "cc-popup-no-scroll",
        bodyNoScrollPadRight: "cc-popup-no-scroll-pad-right",
      };
    }

    /**
     * Open popup on timer / local storage - move focus to input ensure you can tab to submit and close
     * Add the cc-popup--visible class
     * Update aria to visible
     */
    open(callback) {
      // Prevent the body from scrolling
      if (this.$container.data("freeze-scroll")) {
        $("body").addClass(this.cssClasses.bodyNoScroll);

        // Add any padding necessary to the body to compensate for the scrollbar that just disappeared
        var scrollDiv = document.createElement("div");
        scrollDiv.className = "popup-scrollbar-measure";
        document.body.appendChild(scrollDiv);
        var scrollbarWidth =
          scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
        if (scrollbarWidth > 0) {
          $("body")
            .css("padding-right", scrollbarWidth + "px")
            .addClass(this.cssClasses.bodyNoScrollPadRight);
        }
      }

      // Add reveal class
      this.$container.addClass(this.cssClasses.visible);

      // Track previously focused element
      this.previouslyActiveElement = document.activeElement;

      // Focus on the close button after the animation in has completed
      setTimeout(() => {
        this.$container.find(".cc-popup-close")[0].focus();
      }, 500);

      // Pressing escape closes the modal
      $(window).on("keydown" + this.namespace, (event) => {
        if (event.keyCode === 27) {
          this.close();
        }
      });

      if (callback) {
        callback();
      }
    }

    /**
     * Close popup on click of close button or background - where does the focus go back to?
     * Remove the cc-popup--visible class
     */
    close(callback) {
      // Remove reveal class
      this.$container.removeClass(this.cssClasses.visible);

      // Revert focus
      if (this.previouslyActiveElement) {
        $(this.previouslyActiveElement).focus();
      }

      // Destroy the escape event listener
      $(window).off("keydown" + this.namespace);

      // Allow the body to scroll and remove any scrollbar-compensating padding
      if (this.$container.data("freeze-scroll")) {
        var transitionDuration = 500;

        var $innerModal = this.$container.find(".cc-popup-modal");
        if ($innerModal.length) {
          transitionDuration = parseFloat(
            getComputedStyle($innerModal[0])["transitionDuration"],
          );
          if (transitionDuration && transitionDuration > 0) {
            transitionDuration *= 1000;
          }
        }

        setTimeout(() => {
          $("body")
            .removeClass(this.cssClasses.bodyNoScroll)
            .removeClass(this.cssClasses.bodyNoScrollPadRight)
            .css("padding-right", "0");
        }, transitionDuration);
      }

      if (callback) {
        callback();
      }
    }
  }
  (() => {
    theme.initAnimateOnScroll = function () {
      if (
        document.body.classList.contains("cc-animate-enabled") &&
        window.innerWidth >= 768
      ) {
        var animationTimeout =
          typeof document.body.dataset.ccAnimateTimeout !== "undefined"
            ? document.body.dataset.ccAnimateTimeout
            : 200;

        if ("IntersectionObserver" in window) {
          var intersectionObserver = new IntersectionObserver(
            (entries, observer) => {
              entries.forEach((entry) => {
                // In view and hasn't been animated yet
                if (
                  entry.isIntersecting &&
                  !entry.target.classList.contains("cc-animate-complete")
                ) {
                  setTimeout(() => {
                    entry.target.classList.add("-in", "cc-animate-complete");
                  }, animationTimeout);

                  setTimeout(() => {
                    //Once the animation is complete (assume 5 seconds), remove the animate attribute to remove all css
                    entry.target.classList.remove("data-cc-animate");
                    entry.target.style.transitionDuration = null;
                    entry.target.style.transitionDelay = null;
                  }, 5000);

                  // Remove observer after animation
                  observer.unobserve(entry.target);
                }
              });
            },
          );

          document
            .querySelectorAll("[data-cc-animate]:not(.cc-animate-init)")
            .forEach((elem) => {
              //Set the animation delay
              if (elem.dataset.ccAnimateDelay) {
                elem.style.transitionDelay = elem.dataset.ccAnimateDelay;
              }

              ///Set the animation duration
              if (elem.dataset.ccAnimateDuration) {
                elem.style.transitionDuration = elem.dataset.ccAnimateDuration;
              }

              //Init the animation
              if (elem.dataset.ccAnimate) {
                elem.classList.add(elem.dataset.ccAnimate);
              }

              elem.classList.add("cc-animate-init");

              //Watch for elem
              intersectionObserver.observe(elem);
            });
        } else {
          //Fallback, load all the animations now
          var elems = document.querySelectorAll(
            "[data-cc-animate]:not(.cc-animate-init)",
          );
          for (var i = 0; i < elems.length; i++) {
            elems[i].classList.add("-in", "cc-animate-complete");
          }
        }
      }
    };

    theme.initAnimateOnScroll();

    document.addEventListener("shopify:section:load", () => {
      setTimeout(theme.initAnimateOnScroll, 100);
    });

    //Reload animations when changing from mobile to desktop
    try {
      window
        .matchMedia("(min-width: 768px)")
        .addEventListener("change", (event) => {
          if (event.matches) {
            setTimeout(theme.initAnimateOnScroll, 100);
          }
        });
    } catch (e) {}
  })();

  class AccordionInstance {
    constructor(container) {
      this.accordion = container;
      this.itemClass = ".cc-accordion-item";
      this.titleClass = ".cc-accordion-item__title";
      this.panelClass = ".cc-accordion-item__panel";
      this.allowMultiOpen = this.accordion.dataset.allowMultiOpen === "true";

      // If multiple open items not allowed, set open item as active (if there is one)
      if (!this.allowMultiOpen) {
        this.activeItem = this.accordion.querySelector(
          "".concat(this.itemClass, "[open]"),
        );
      }

      this.bindEvents();
    }

    /**
     * Adds inline 'height' style to a panel, to trigger open transition
     * @param {HTMLDivElement} panel - The accordion item content panel
     */
    static addPanelHeight(panel) {
      panel.style.height = "".concat(panel.scrollHeight, "px");
    }

    /**
     * Removes inline 'height' style from a panel, to trigger close transition
     * @param {HTMLDivElement} panel - The accordion item content panel
     */
    static removePanelHeight(panel) {
      panel.getAttribute("style"); // Fix Safari bug (doesn't remove attribute without this first!)
      panel.removeAttribute("style");
    }

    /**
     * Opens an accordion item
     * @param {HTMLDetailsElement} item - The accordion item
     * @param {HTMLDivElement} panel - The accordion item content panel
     */
    open(item, panel) {
      panel.style.height = "0";

      // Set item to open. Blocking the default click action and opening it this way prevents a
      // slight delay which causes the panel height to be set to '0' (because item's not open yet)
      item.open = true;

      AccordionInstance.addPanelHeight(panel);

      // Slight delay required before starting transitions
      setTimeout(() => {
        item.classList.add("is-open");
      }, 10);

      if (!this.allowMultiOpen) {
        // If there's an active item and it's not the opened item, close it
        if (this.activeItem && this.activeItem !== item) {
          var activePanel = this.activeItem.querySelector(this.panelClass);
          this.close(this.activeItem, activePanel);
        }

        this.activeItem = item;
      }
    }

    /**
     * Closes an accordion item
     * @param {HTMLDetailsElement} item - The accordion item
     * @param {HTMLDivElement} panel - The accordion item content panel
     */
    close(item, panel) {
      AccordionInstance.addPanelHeight(panel);

      item.classList.remove("is-open");
      item.classList.add("is-closing");

      if (this.activeItem === item) {
        this.activeItem = null;
      }

      // Slight delay required to allow scroll height to be applied before changing to '0'
      setTimeout(() => {
        panel.style.height = "0";
      }, 10);
    }

    /**
     * Handles 'click' event on the accordion
     * @param {Object} e - The event object
     */
    handleClick(e) {
      // Ignore clicks outside a toggle (<summary> element)
      var toggle = e.target.closest(this.titleClass);
      if (!toggle) return;

      // Prevent the default action
      // We'll trigger it manually after open transition initiated or close transition complete
      e.preventDefault();

      var item = toggle.parentNode;
      var panel = toggle.nextElementSibling;

      if (item.open) {
        this.close(item, panel);
      } else {
        this.open(item, panel);
      }
    }

    /**
     * Handles 'transitionend' event in the accordion
     * @param {Object} e - The event object
     */
    handleTransition(e) {
      // Ignore transitions not on a panel element
      if (!e.target.matches(this.panelClass)) return;

      var panel = e.target;
      var item = panel.parentNode;

      if (item.classList.contains("is-closing")) {
        item.classList.remove("is-closing");
        item.open = false;
      }

      AccordionInstance.removePanelHeight(panel);
    }

    bindEvents() {
      // Need to assign the function calls to variables because bind creates a new function,
      // which means the event listeners can't be removed in the usual way
      this.clickHandler = this.handleClick.bind(this);
      this.transitionHandler = this.handleTransition.bind(this);

      this.accordion.addEventListener("click", this.clickHandler);
      this.accordion.addEventListener("transitionend", this.transitionHandler);
    }

    destroy() {
      this.accordion.removeEventListener("click", this.clickHandler);
      this.accordion.removeEventListener(
        "transitionend",
        this.transitionHandler,
      );
    }
  }

  class Accordion extends ccComponent {
    constructor() {
      var name =
        arguments.length > 0 && arguments[0] !== undefined
          ? arguments[0]
          : "accordion";
      var cssSelector =
        arguments.length > 1 && arguments[1] !== undefined
          ? arguments[1]
          : ".cc-".concat(name);
      super(name, cssSelector);
    }

    init(container) {
      super.init(container);
      this.registerInstance(container, new AccordionInstance(container));
    }

    destroy(container) {
      this.destroyInstance(container);
      super.destroy(container);
    }
  }

  new Accordion();
  class CustomSelectInstance {
    constructor(el) {
      this.el = el;
      this.button = el.querySelector(".cc-select__btn");
      this.listbox = el.querySelector(".cc-select__listbox");
      this.options = el.querySelectorAll(".cc-select__option");
      this.selectedOption = el.querySelector('[aria-selected="true"]');
      this.nativeSelect = document.getElementById("".concat(el.id, "-native"));
      this.swatches = "swatch" in this.options[this.options.length - 1].dataset;
      this.focusedClass = "is-focused";
      this.searchString = "";
      this.listboxOpen = false;

      // Set the selected option
      if (!this.selectedOption) {
        this.selectedOption = this.listbox.firstElementChild;
      }

      this.bindEvents();
      this.setButtonWidth();
    }

    bindEvents() {
      this.el.addEventListener("keydown", this.handleKeydown.bind(this));
      this.el.addEventListener(
        "selectOption",
        this.handleSelectOption.bind(this),
      );
      this.button.addEventListener(
        "mousedown",
        this.handleMousedown.bind(this),
      );
    }

    /**
     * Adds event listeners when the options list is visible
     */
    addListboxOpenEvents() {
      this.mouseoverHandler = this.handleMouseover.bind(this);
      this.mouseleaveHandler = this.handleMouseleave.bind(this);
      this.clickHandler = this.handleClick.bind(this);
      this.blurHandler = this.handleBlur.bind(this);

      this.listbox.addEventListener("mouseover", this.mouseoverHandler);
      this.listbox.addEventListener("mouseleave", this.mouseleaveHandler);
      this.listbox.addEventListener("click", this.clickHandler);
      this.listbox.addEventListener("blur", this.blurHandler);
    }

    /**
     * Removes event listeners added when the options list was visible
     */
    removeListboxOpenEvents() {
      this.listbox.removeEventListener("mouseover", this.mouseoverHandler);
      this.listbox.removeEventListener("mouseleave", this.mouseleaveHandler);
      this.listbox.removeEventListener("click", this.clickHandler);
      this.listbox.removeEventListener("blur", this.blurHandler);
    }

    /**
     * Handles a 'keydown' event on the custom select element
     * @param {Object} e - The event object
     */
    handleKeydown(e) {
      if (this.listboxOpen) {
        this.handleKeyboardNav(e);
      } else if (
        e.key === "ArrowUp" ||
        e.key === "ArrowDown" ||
        e.key === " "
      ) {
        e.preventDefault();
        this.showListbox();
      }
    }

    /**
     * Handles a 'mousedown' event on the button element
     * @param {Object} e - The event object
     */
    handleMousedown(e) {
      if (!this.listboxOpen && e.button === 0) {
        this.showListbox();
      }
    }

    /**
     * Handles a 'mouseover' event on the options list
     * @param {Object} e - The event object
     */
    handleMouseover(e) {
      if (e.target.matches("li")) {
        this.focusOption(e.target);
      }
    }

    /**
     * Handles a 'mouseleave' event on the options list
     */
    handleMouseleave() {
      this.focusOption(this.selectedOption);
    }

    /**
     * Handles a 'click' event on the options list
     * @param {Object} e - The event object
     */
    handleClick(e) {
      if (e.target.matches(".js-option")) {
        this.selectOption(e.target);
      }
    }

    /**
     * Handles a 'blur' event on the options list
     */
    handleBlur() {
      if (this.listboxOpen) {
        this.hideListbox();
      }
    }

    /**
     * Handles a 'keydown' event on the options list
     * @param {Object} e - The event object
     */
    handleKeyboardNav(e) {
      var optionToFocus;

      // Disable tabbing if options list is open (as per native select element)
      if (e.key === "Tab") {
        e.preventDefault();
      }

      switch (e.key) {
        // Focus an option
        case "ArrowUp":
        case "ArrowDown":
          e.preventDefault();

          if (e.key === "ArrowUp") {
            optionToFocus = this.focusedOption.previousElementSibling;
          } else {
            optionToFocus = this.focusedOption.nextElementSibling;
          }

          if (
            optionToFocus &&
            !optionToFocus.classList.contains("is-disabled")
          ) {
            this.focusOption(optionToFocus);
          }
          break;

        // Select an option
        case "Enter":
        case " ":
          e.preventDefault();
          this.selectOption(this.focusedOption);
          break;

        // Cancel and close the options list
        case "Escape":
          e.preventDefault();
          this.hideListbox();
          break;

        // Search for an option and focus the first match (if one exists)
        default:
          optionToFocus = this.findOption(e.key);

          if (optionToFocus) {
            this.focusOption(optionToFocus);
          }
          break;
      }
    }

    /**
     * Sets the button width to the same as the longest option, to prevent
     * the button width from changing depending on the option selected
     */
    setButtonWidth() {
      // Get the width of an element without side padding
      var getUnpaddedWidth = (el) => {
        var elStyle = getComputedStyle(el);
        return (
          parseFloat(elStyle.paddingLeft) + parseFloat(elStyle.paddingRight)
        );
      };

      var buttonPadding = getUnpaddedWidth(this.button);
      var optionPadding = getUnpaddedWidth(this.selectedOption);
      var buttonBorder = this.button.offsetWidth - this.button.clientWidth;
      var optionWidth = Math.ceil(
        this.selectedOption.getBoundingClientRect().width,
      );

      this.button.style.width = "".concat(
        optionWidth - optionPadding + buttonPadding + buttonBorder,
        "px",
      );
    }

    /**
     * Shows the options list
     */
    showListbox() {
      this.listbox.hidden = false;
      this.listboxOpen = true;

      this.el.classList.add("is-open");
      this.button.setAttribute("aria-expanded", "true");
      this.listbox.setAttribute("aria-hidden", "false");

      // Slight delay required to prevent blur event being fired immediately
      setTimeout(() => {
        this.focusOption(this.selectedOption);
        this.listbox.focus();

        this.addListboxOpenEvents();
      }, 10);
    }

    /**
     * Hides the options list
     */
    hideListbox() {
      if (!this.listboxOpen) return;

      this.listbox.hidden = true;
      this.listboxOpen = false;

      this.el.classList.remove("is-open");
      this.button.setAttribute("aria-expanded", "false");
      this.listbox.setAttribute("aria-hidden", "true");

      if (this.focusedOption) {
        this.focusedOption.classList.remove(this.focusedClass);
        this.focusedOption = null;
      }

      this.button.focus();
      this.removeListboxOpenEvents();
    }

    /**
     * Finds a matching option from a typed string
     * @param {string} key - The key pressed
     * @returns {?HTMLElement}
     */
    findOption(key) {
      this.searchString += key;

      // If there's a timer already running, clear it
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }

      // Wait 500ms to see if another key is pressed, if not then clear the search string
      this.searchTimer = setTimeout(() => {
        this.searchString = "";
      }, 500);

      // Find an option that contains the search string (if there is one)
      var matchingOption = [...this.options].find((option) => {
        var label = option.innerText.toLowerCase();
        return (
          label.includes(this.searchString) &&
          !option.classList.contains("is-disabled")
        );
      });

      return matchingOption;
    }

    /**
     * Focuses an option
     * @param {HTMLElement} option - The <li> element of the option to focus
     */
    focusOption(option) {
      // Remove focus on currently focused option (if there is one)
      if (this.focusedOption) {
        this.focusedOption.classList.remove(this.focusedClass);
      }

      // Set focus on the option
      this.focusedOption = option;
      this.focusedOption.classList.add(this.focusedClass);

      // If option is out of view, scroll the list
      if (this.listbox.scrollHeight > this.listbox.clientHeight) {
        var scrollBottom = this.listbox.clientHeight + this.listbox.scrollTop;
        var optionBottom = option.offsetTop + option.offsetHeight;

        if (optionBottom > scrollBottom) {
          this.listbox.scrollTop = optionBottom - this.listbox.clientHeight;
        } else if (option.offsetTop < this.listbox.scrollTop) {
          this.listbox.scrollTop = option.offsetTop;
        }
      }
    }

    /**
     * Handles a 'selectOption' event on the custom select element
     * @param {Object} e - The event object (pass value in detail.value)
     */
    handleSelectOption(e) {
      var matchingOption = [...this.options].find(
        (option) => option.dataset.value === e.detail.value,
      );
      if (matchingOption) {
        this.selectOption(matchingOption);
      }
    }

    /**
     * Selects an option
     * @param {HTMLElement} option - The option <li> element
     */
    selectOption(option) {
      if (option !== this.selectedOption) {
        // Switch aria-selected attribute to selected option
        option.setAttribute("aria-selected", "true");
        this.selectedOption.setAttribute("aria-selected", "false");

        // Update swatch colour in the button
        if (this.swatches) {
          if (option.dataset.swatch) {
            this.button.dataset.swatch = option.dataset.swatch;
          } else {
            this.button.removeAttribute("data-swatch");
          }
        }

        // Update the button text and set the option as active
        this.button.firstChild.textContent =
          option.firstElementChild.textContent;
        this.listbox.setAttribute("aria-activedescendant", option.id);
        this.selectedOption = document.getElementById(option.id);

        // If a native select element exists, update its selected value and trigger a 'change' event
        if (this.nativeSelect) {
          this.nativeSelect.value = option.dataset.value;
          this.nativeSelect.dispatchEvent(
            new Event("change", { bubbles: true }),
          );
        } else {
          // Trigger a 'change' event on the custom select element
          var detail = { selectedValue: option.dataset.value };
          this.el.dispatchEvent(
            new CustomEvent("change", { bubbles: true, detail }),
          );
        }
      }

      this.hideListbox();
    }
  }

  class CustomSelect extends ccComponent {
    constructor() {
      var name =
        arguments.length > 0 && arguments[0] !== undefined
          ? arguments[0]
          : "custom-select";
      var cssSelector =
        arguments.length > 1 && arguments[1] !== undefined
          ? arguments[1]
          : ".cc-select";
      super(name, cssSelector);
    }

    init(container) {
      super.init(container);
      this.registerInstance(container, new CustomSelectInstance(container));
    }

    destroy(container) {
      this.destroyInstance(container);
      super.destroy(container);
    }
  }

  new CustomSelect();
  /**
   * Display a modal window on-click. It's a lightbox.
   * To use:
   * Add 'cc-modal' class to a clickable element.
   *
   * Configure with:
   * - data-cc-modal-contentelement - selector for element containing content to show, innerHTML of element is copied into the modal
   * - data-cc-modal-size (optional) - 'small' or 'medium', defaults to 'medium'
   * - data-cc-modal-launch (optional) - 'true' if we want to open the modal immediately
   *
   * Example:
   * <a href="#password-login" class="cc-modal" data-cc-modal-contentelement="#password-login" data-cc-modal-size="small">
   * <div id="password-login" class="js-hidden">
   */
  class ModalInstance {
    constructor(container) {
      this.container = container;
      this.size = container.dataset.ccModalSize || "medium";
      this.contentElement = document.querySelector(
        container.dataset.ccModalContentelement,
      );

      this.container.addEventListener("click", this.handleClick.bind(this));

      if (container.dataset.ccModalLaunch === "true") {
        setTimeout(this.open.bind(this), 10);
      }
    }

    /**
     * Handles 'click' event on the container
     * @param {Object} e - The event object
     */
    handleClick(e) {
      e.preventDefault();
      this.open();
      this.opener = e.target;
    }

    /**
     * Create the modal and add it to the page.
     */
    open() {
      var tve = theme.createTemplateVariableEncoder();
      tve.add("size", this.size, "attribute");
      tve.add("content", this.contentElement.innerHTML, "raw");
      tve.add(
        "button_close_label",
        theme.strings.general_accessibility_labels_close,
        "attribute",
      );
      tve.add("button_close_icon", theme.icons.close, "raw");

      var html =
        '\n      <div class="cc-modal-window cc-modal-window--pre-reveal cc-modal-window--size-'
          .concat(
            tve.values.size,
            '">\n        <div class="cc-modal-window__background"></div>\n        <div class="cc-modal-window__foreground" role="dialog" aria-modal="true">\n          <div class="cc-modal-window__content-container">\n            <button class="cc-modal-window__close" aria-label="',
          )
          .concat(tve.values.button_close_label, '">')
          .concat(
            tve.values.button_close_icon,
            '</button>\n            <div class="cc-modal-window__content">',
          )
          .concat(
            tve.values.content,
            "</div>\n          </div>\n        </div>\n      </div>\n    ",
          );

      var modalElementFragment = document
        .createRange()
        .createContextualFragment(html);
      document.body.appendChild(modalElementFragment);

      document.body.classList.add("cc-modal-visible");
      this.modalElement = document.body.lastElementChild;

      this.modalElement
        .querySelector(".cc-modal-window__background")
        .addEventListener("click", this.close.bind(this));
      this.modalElement
        .querySelector(".cc-modal-window__close")
        .addEventListener("click", this.close.bind(this));

      setTimeout(() => {
        this.modalElement.classList.remove("cc-modal-window--pre-reveal");
        this.modalElement.querySelector(".cc-modal-window__close").focus();
      }, 10);
    }

    close() {
      this.modalElement.classList.add("cc-modal-window--closing");
      if (
        !document.querySelector(
          ".cc-modal-window:not(.cc-modal-window--closing)",
        )
      ) {
        document.body.classList.remove("cc-modal-visible");
      }

      if (this.opener) {
        setTimeout(() => {
          this.opener.focus();
        }, 10);
      }

      // give transitions 5s to do their thing before we tidy up (note: this.modalElement may be reassigned during this timeout)
      setTimeout(
        function () {
          this.remove();
        }.bind(this.modalElement),
        5000,
      );
    }
  }

  class Modal extends ccComponent {
    constructor() {
      var name =
        arguments.length > 0 && arguments[0] !== undefined
          ? arguments[0]
          : "modal";
      var cssSelector =
        arguments.length > 1 && arguments[1] !== undefined
          ? arguments[1]
          : ".cc-".concat(name);
      super(name, cssSelector);
    }

    init(container) {
      super.init(container);
      this.registerInstance(container, new ModalInstance(container));
    }

    destroy(container) {
      this.destroyInstance(container);
      super.destroy(container);
    }
  }

  new Modal();
  class PriceRangeInstance {
    constructor(container) {
      this.container = container;
      this.selectors = {
        inputMin: ".cc-price-range__input--min",
        inputMax: ".cc-price-range__input--max",
        control: ".cc-price-range__control",
        controlMin: ".cc-price-range__control--min",
        controlMax: ".cc-price-range__control--max",
        bar: ".cc-price-range__bar",
        activeBar: ".cc-price-range__bar-active",
      };

      this.controls = {
        min: {
          barControl: container.querySelector(this.selectors.controlMin),
          input: container.querySelector(this.selectors.inputMin),
        },

        max: {
          barControl: container.querySelector(this.selectors.controlMax),
          input: container.querySelector(this.selectors.inputMax),
        },
      };

      this.controls.min.value = parseInt(
        this.controls.min.input.value === ""
          ? this.controls.min.input.placeholder
          : this.controls.min.input.value,
      );
      this.controls.max.value = parseInt(
        this.controls.max.input.value === ""
          ? this.controls.max.input.placeholder
          : this.controls.max.input.value,
      );
      this.valueMin = this.controls.min.input.min;
      this.valueMax = this.controls.min.input.max;
      this.valueRange = this.valueMax - this.valueMin;

      [this.controls.min, this.controls.max].forEach((item) => {
        item.barControl.setAttribute("aria-valuemin", this.valueMin);
        item.barControl.setAttribute("aria-valuemax", this.valueMax);
        item.barControl.setAttribute("tabindex", 0);
      });
      this.controls.min.barControl.setAttribute(
        "aria-valuenow",
        this.controls.min.value,
      );
      this.controls.max.barControl.setAttribute(
        "aria-valuenow",
        this.controls.max.value,
      );

      this.bar = container.querySelector(this.selectors.bar);
      this.activeBar = container.querySelector(this.selectors.activeBar);
      this.inDrag = false;
      this.rtl = document.querySelector("html[dir=rtl]");

      this.bindEvents();
      this.render();
    }

    getPxToValueRatio() {
      var r = this.bar.clientWidth / (this.valueMax - this.valueMin);
      if (this.rtl) {
        return -r;
      } else {
        return r;
      }
    }

    getPcToValueRatio() {
      return 100.0 / (this.valueMax - this.valueMin);
    }

    setActiveControlValue(value) {
      // only accept valid numbers
      if (isNaN(parseInt(value))) return;

      // clamp & default
      if (this.activeControl === this.controls.min) {
        if (value === "") {
          value = this.valueMin;
        }
        value = Math.max(this.valueMin, value);
        value = Math.min(value, this.controls.max.value);
      } else {
        if (value === "") {
          value = this.valueMax;
        }
        value = Math.min(this.valueMax, value);
        value = Math.max(value, this.controls.min.value);
      }

      // round
      this.activeControl.value = Math.round(value);

      // update input
      if (this.activeControl.input.value != this.activeControl.value) {
        if (this.activeControl.value == this.activeControl.input.placeholder) {
          this.activeControl.input.value = "";
        } else {
          this.activeControl.input.value = this.activeControl.value;
        }
        this.activeControl.input.dispatchEvent(
          new CustomEvent("change", {
            bubbles: true,
            cancelable: false,
            detail: { sender: "theme:component:price_range" },
          }),
        );
      }

      // a11y
      this.activeControl.barControl.setAttribute(
        "aria-valuenow",
        this.activeControl.value,
      );
    }

    render() {
      this.drawControl(this.controls.min);
      this.drawControl(this.controls.max);
      this.drawActiveBar();
    }

    drawControl(control) {
      var x = (control.value - this.valueMin) * this.getPcToValueRatio() + "%";
      if (this.rtl) {
        control.barControl.style.right = x;
      } else {
        control.barControl.style.left = x;
      }
    }

    drawActiveBar() {
      var s =
          (this.controls.min.value - this.valueMin) * this.getPcToValueRatio() +
          "%",
        e =
          (this.valueMax - this.controls.max.value) * this.getPcToValueRatio() +
          "%";
      if (this.rtl) {
        this.activeBar.style.left = e;
        this.activeBar.style.right = s;
      } else {
        this.activeBar.style.left = s;
        this.activeBar.style.right = e;
      }
    }

    handleControlTouchStart(e) {
      e.preventDefault();
      this.startDrag(e.target, e.touches[0].clientX);
      this.boundControlTouchMoveEvent = this.handleControlTouchMove.bind(this);
      this.boundControlTouchEndEvent = this.handleControlTouchEnd.bind(this);
      window.addEventListener("touchmove", this.boundControlTouchMoveEvent);
      window.addEventListener("touchend", this.boundControlTouchEndEvent);
    }

    handleControlTouchMove(e) {
      this.moveDrag(e.touches[0].clientX);
    }

    handleControlTouchEnd(e) {
      e.preventDefault();
      window.removeEventListener("touchmove", this.boundControlTouchMoveEvent);
      window.removeEventListener("touchend", this.boundControlTouchEndEvent);
      this.stopDrag();
    }

    handleControlMouseDown(e) {
      e.preventDefault();
      this.startDrag(e.target, e.clientX);
      this.boundControlMouseMoveEvent = this.handleControlMouseMove.bind(this);
      this.boundControlMouseUpEvent = this.handleControlMouseUp.bind(this);
      window.addEventListener("mousemove", this.boundControlMouseMoveEvent);
      window.addEventListener("mouseup", this.boundControlMouseUpEvent);
    }

    handleControlMouseMove(e) {
      this.moveDrag(e.clientX);
    }

    handleControlMouseUp(e) {
      e.preventDefault();
      window.removeEventListener("mousemove", this.boundControlMouseMoveEvent);
      window.removeEventListener("mouseup", this.boundControlMouseUpEvent);
      this.stopDrag();
    }

    startDrag(target, startX) {
      if (this.controls.min.barControl === target) {
        this.activeControl = this.controls.min;
      } else {
        this.activeControl = this.controls.max;
      }
      this.dragStartX = startX;
      this.dragStartValue = this.activeControl.value;
      this.inDrag = true;
    }

    moveDrag(moveX) {
      if (this.inDrag) {
        var value =
          this.dragStartValue +
          (moveX - this.dragStartX) / this.getPxToValueRatio();
        this.setActiveControlValue(value);
        this.render();
      }
    }

    stopDrag() {
      this.inDrag = false;
    }

    handleControlKeyDown(e) {
      if (e.key === "ArrowRight") {
        this.incrementControlFromKeypress(e.target, 10.0);
      } else if (e.key === "ArrowLeft") {
        this.incrementControlFromKeypress(e.target, -10.0);
      }
    }

    incrementControlFromKeypress(control, pxAmount) {
      if (this.controls.min.barControl === control) {
        this.activeControl = this.controls.min;
      } else {
        this.activeControl = this.controls.max;
      }
      this.setActiveControlValue(
        this.activeControl.value + pxAmount / this.getPxToValueRatio(),
      );
      this.render();
    }

    handleInputChange(e) {
      // strip out non numeric values
      e.target.value = e.target.value.replace(/\D/g, "");

      if (!e.detail || e.detail.sender != "theme:component:price_range") {
        if (this.controls.min.input === e.target) {
          this.activeControl = this.controls.min;
        } else {
          this.activeControl = this.controls.max;
        }
        this.setActiveControlValue(e.target.value);
        this.render();
      }
    }

    handleInputKeyup(e) {
      // enforce numeric chars in the input
      setTimeout(
        function () {
          this.value = this.value.replace(/\D/g, "");
        }.bind(e.target),
        10,
      );
    }

    bindEvents() {
      [this.controls.min, this.controls.max].forEach((item) => {
        item.barControl.addEventListener(
          "touchstart",
          this.handleControlTouchStart.bind(this),
        );
        item.barControl.addEventListener(
          "mousedown",
          this.handleControlMouseDown.bind(this),
        );
        item.barControl.addEventListener(
          "keydown",
          this.handleControlKeyDown.bind(this),
        );
        item.input.addEventListener(
          "change",
          this.handleInputChange.bind(this),
        );
        item.input.addEventListener("keyup", this.handleInputKeyup.bind(this));
      });
    }

    destroy() {}
  }

  class PriceRange extends ccComponent {
    constructor() {
      var name =
        arguments.length > 0 && arguments[0] !== undefined
          ? arguments[0]
          : "price-range";
      var cssSelector =
        arguments.length > 1 && arguments[1] !== undefined
          ? arguments[1]
          : ".cc-".concat(name);
      super(name, cssSelector);
    }

    init(container) {
      super.init(container);
      this.registerInstance(container, new PriceRangeInstance(container));
    }

    destroy(container) {
      this.destroyInstance(container);
      super.destroy(container);
    }
  }

  new PriceRange();

  // Manage videos
  theme.VideoManager = new (function () {
    var _ = this;

    _._permitPlayback = function (container) {
      // return !(
      //   $(container).hasClass("video-container--background") &&
      //   $(window).outerWidth() < 768
      // );
      return (
        $(container).hasClass("video-container--background") ||
        $(container).hasClass("video-container")
      );
    };

    // Youtube
    _.youtubeVars = {
      incrementor: 0,
      apiReady: false,
      videoData: {},
      toProcessSelector:
        '.video-container[data-video-type="youtube"]:not(.video--init)',
    };

    _.youtubeApiReady = function () {
      _.youtubeVars.apiReady = true;
      _._loadYoutubeVideos();
    };

    _._loadYoutubeVideos = function (container) {
      if ($(_.youtubeVars.toProcessSelector, container).length) {
        if (_.youtubeVars.apiReady) {
          // play those videos
          $(_.youtubeVars.toProcessSelector, container).each(function () {
            // Don't init background videos on mobile
            if (
              _._permitPlayback($(this)) /* || $(window).outerWidth() < 768 */
            ) {
              $(this).addClass("video--init");
              _.youtubeVars.incrementor++;
              var containerId = "theme-yt-video-" + _.youtubeVars.incrementor;
              $(this).data("video-container-id", containerId);
              var videoElement = $(
                '<div class="video-container__video-element">',
              )
                .attr("id", containerId)
                .appendTo($(".video-container__video", this));
              var autoplay = $(this).data("video-autoplay");
              var loop = $(this).data("video-loop");
              var player = new YT.Player(containerId, {
                height: "360",
                width: "640",
                videoId: $(this).data("video-id"),
                playerVars: {
                  iv_load_policy: 3,
                  modestbranding: 1,
                  autoplay: 0,
                  loop: loop ? 1 : 0,
                  playlist: $(this).data("video-id"),
                  rel: 0,
                  showinfo: 0,
                  origin: window.location.origin,
                },

                events: {
                  onReady: _._onYoutubePlayerReady.bind({
                    autoplay: autoplay,
                    loop: loop,
                    $container: $(this),
                  }),
                  onStateChange: _._onYoutubePlayerStateChange.bind({
                    autoplay: autoplay,
                    loop: loop,
                    $container: $(this),
                  }),
                },
              });

              _.youtubeVars.videoData[containerId] = {
                id: containerId,
                container: this,
                videoElement: videoElement,
                player: player,
              };
            }
          });
        } else {
          // load api
          theme.loadScriptOnce("https://www.youtube.com/iframe_api");
        }
      }
    };

    _._onYoutubePlayerReady = function (event) {
      event.target.setPlaybackQuality("hd1080");
      if (this.autoplay) {
        event.target.mute();
        event.target.playVideo();
      }

      _._initBackgroundVideo(this.$container);
    };

    _._onYoutubePlayerStateChange = function (event) {
      if (event.data == YT.PlayerState.PLAYING) {
        this.$container.addClass("video--play-started");

        if (this.autoplay) {
          event.target.mute();
        }

        if (this.loop) {
          // 4 times a second, check if we're in the final second of the video. If so, loop it for a more seamless loop
          var finalSecond = event.target.getDuration() - 1;
          if (finalSecond > 2) {
            function loopTheVideo() {
              if (event.target.getCurrentTime() > finalSecond) {
                event.target.seekTo(0);
              }
              setTimeout(loopTheVideo, 250);
            }
            loopTheVideo();
          }
        }
      }
    };

    _._unloadYoutubeVideos = function (container) {
      for (var dataKey in _.youtubeVars.videoData) {
        var data = _.youtubeVars.videoData[dataKey];
        if ($(container).find(data.container).length) {
          data.player.destroy();
          delete _.youtubeVars.videoData[dataKey];
          return;
        }
      }
    };

    // Vimeo
    _.vimeoVars = {
      incrementor: 0,
      apiReady: false,
      videoData: {},
      toProcessSelector:
        '.video-container[data-video-type="vimeo"]:not(.video--init)',
    };

    _.vimeoApiReady = function () {
      _.vimeoVars.apiReady = true;
      _._loadVimeoVideos();
    };

    _._loadVimeoVideos = function (container) {
      if ($(_.vimeoVars.toProcessSelector, container).length) {
        if (_.vimeoVars.apiReady) {
          // play those videos

          $(_.vimeoVars.toProcessSelector, container).each(function () {
            // Don't init background videos on mobile
            if (_._permitPlayback($(this))) {
              $(this).addClass("video--init");
              _.vimeoVars.incrementor++;
              var $this = $(this);
              var containerId = "theme-vi-video-" + _.vimeoVars.incrementor;
              $(this).data("video-container-id", containerId);
              var videoElement = $(
                '<div class="video-container__video-element">',
              )
                .attr("id", containerId)
                .appendTo($(".video-container__video", this));
              var autoplay = !!$(this).data("video-autoplay");
              var player = new Vimeo.Player(containerId, {
                url: $(this).data(
                  $(window).width() > 768 ? "video-url" : "mobile-video-url",
                ),
                width: 640,
                loop: $(this).data("video-autoplay"),
                autoplay: autoplay,
                muted:
                  $this.hasClass("video-container--background") || autoplay,
              });

              player.on(
                "playing",
                function () {
                  $(this).addClass("video--play-started");
                }.bind(this),
              );
              player.ready().then(function () {
                if (autoplay) {
                  player.setVolume(0);
                  player.play();
                }
                if (
                  player.element &&
                  player.element.width &&
                  player.element.height
                ) {
                  var ratio =
                    parseInt(player.element.height) /
                    parseInt(player.element.width);
                  $this
                    .find(".video-container__video")
                    .css("padding-bottom", ratio * 100 + "%");
                }
                _._initBackgroundVideo($this);
              });
              _.vimeoVars.videoData[containerId] = {
                id: containerId,
                container: this,
                videoElement: videoElement,
                player: player,
                autoPlay: autoplay,
              };
            }
          });
        } else {
          // load api
          if (window.define) {
            // workaround for third parties using RequireJS
            theme.loadScriptOnce(
              "https://player.vimeo.com/api/player.js",
              function () {
                _.vimeoVars.apiReady = true;
                _._loadVimeoVideos();
                window.define = window.tempDefine;
              },
              function () {
                window.tempDefine = window.define;
                window.define = null;
              },
            );
          } else {
            theme.loadScriptOnce(
              "https://player.vimeo.com/api/player.js",
              function () {
                _.vimeoVars.apiReady = true;
                _._loadVimeoVideos();
              },
            );
          }
        }
      }
    };

    _._unloadVimeoVideos = function (container) {
      for (var dataKey in _.vimeoVars.videoData) {
        var data = _.vimeoVars.videoData[dataKey];
        if ($(container).find(data.container).length) {
          data.player.unload();
          delete _.vimeoVars.videoData[dataKey];
          return;
        }
      }
    };

    // Init third party apis - Youtube and Vimeo
    _._loadThirdPartyApis = function (container) {
      //Don't init youtube or vimeo background videos on mobile
      if (_._permitPlayback($(".video-container", container))) {
        _._loadYoutubeVideos(container);
        _._loadVimeoVideos(container);
      }
    };

    // Mp4
    _.mp4Vars = {
      incrementor: 0,
      videoData: {},
      toProcessSelector:
        '.video-container[data-video-type="mp4"]:not(.video--init)',
    };

    _._loadMp4Videos = function (container) {
      if ($(_.mp4Vars.toProcessSelector, container).length) {
        // play those videos
        $(_.mp4Vars.toProcessSelector, container)
          .addClass("video--init")
          .each(function () {
            _.mp4Vars.incrementor++;
            var $this = $(this);
            var containerId = "theme-mp-video-" + _.mp4Vars.incrementor;
            $(this).data("video-container-id", containerId);
            var videoElement = $('<div class="video-container__video-element">')
              .attr("id", containerId)
              .appendTo($(".video-container__video", this));

            var $video = $("<video playsinline>");
            if ($(this).data("video-loop")) {
              $video.attr("loop", "loop");
            }
            if (!$(this).hasClass("video-container--background")) {
              $video.attr("controls", "controls");
            }
            if ($(this).data("video-autoplay")) {
              $video.attr({ autoplay: "autoplay", muted: "muted" });
              $video[0].muted = true; // required by Chrome - ignores attribute
              $video.one("loadeddata", function () {
                this.play();
              });
            }
            $video.on(
              "playing",
              function () {
                $(this).addClass("video--play-started");
              }.bind(this),
            );
            $video
              .attr(
                "src",
                $(this).data(
                  $(window).width() > 768 ? "video-url" : "mobile-video-url",
                ),
              )
              .appendTo(videoElement);
            _.mp4Vars.videoData[containerId] = {
              element: $video[0],
            };
          });
      }
    };

    _._unloadMp4Videos = function (container) {};

    // background video placement for iframes
    _._initBackgroundVideo = function ($container) {
      if (
        $container.hasClass("video-container--background") &&
        $container.find(".video-container__video iframe").length
      ) {
        function assessBackgroundVideo() {
          var $media = $(".video-container__media", this),
            $container = $media.length ? $media : this,
            cw = $container.width(),
            ch = $container.height(),
            cr = cw / ch,
            $frame = $(".video-container__video iframe", this),
            vr = $frame.attr("width") / $frame.attr("height"),
            $pan = $(".video-container__video", this),
            vCrop = 75; // pushes video outside container to hide controls
          if (cr > vr && ch > 0) {
            var vh = cw / vr + vCrop * 2;
            $pan.css({
              marginTop: (ch - vh) / 2 - vCrop,
              marginInlineStart: "",
              height: vh + vCrop * 2,
              width: "",
            });
          } else if (ch === 0) {
            $pan.css({
              height: cw / vr,
            });
          } else {
            var vw = cw * vr + vCrop * 2 * vr;
            $pan.css({
              marginTop: -vCrop,
              marginInlineStart: (cw - vw) / 2,
              height: ch + vCrop * 2,
              width: vw,
            });
          }
        }
        assessBackgroundVideo.bind($container)();
        $(window).on(
          "debouncedresize." + $container.data("video-container-id"),
          assessBackgroundVideo.bind($container),
        );
      }
    };

    // Compatibility with Sections
    this.onSectionLoad = function (container) {
      // url only - infer type
      $(".video-container[data-video-url]:not([data-video-type])").each(
        function () {
          var url = $(this).data("video-url");
          var mobileUrl = $(this).data("mobile-video-url");
          if (mobileUrl && $(window).width() < 768) {
            url = mobileUrl;
          }

          if (url.indexOf(".mp4") > -1) {
            $(this).attr("data-video-type", "mp4");
          }

          if (url.indexOf("vimeo.com") > -1) {
            $(this).attr("data-video-type", "vimeo");
            $(this).attr("data-video-id", url.split("?")[0].split("/").pop());
          }

          if (url.indexOf("youtu.be") > -1 || url.indexOf("youtube.com") > -1) {
            $(this).attr("data-video-type", "youtube");
            if (url.indexOf("v=") > -1) {
              $(this).attr(
                "data-video-id",
                url.split("v=").pop().split("&")[0],
              );
            } else {
              $(this).attr("data-video-id", url.split("?")[0].split("/").pop());
            }
          }
        },
      );

      _._loadThirdPartyApis(container);
      _._loadMp4Videos(container);

      $(window).on("debouncedresize.video-manager-resize", function () {
        _._loadThirdPartyApis(container);
      });

      // play button
      $(".video-container__play", container).on("click", function (evt) {
        evt.preventDefault();
        var $container = $(this).closest(".video-container");
        // reveal
        $container.addClass("video-container--playing");

        // broadcast a play event on the section container
        $(container).trigger("cc:video:play");

        // play
        var id = $container.data("video-container-id");
        if (id.indexOf("theme-yt-video") === 0) {
          _.youtubeVars.videoData[id].player.playVideo();
        } else if (id.indexOf("theme-vi-video") === 0) {
          _.vimeoVars.videoData[id].player.play();
        } else if (id.indexOf("theme-mp-video") === 0) {
          _.mp4Vars.videoData[id].element.play();
        }
      });

      // modal close button
      $(".video-container__stop", container).on("click", function (evt) {
        evt.preventDefault();
        var $container = $(this).closest(".video-container");
        // hide
        $container.removeClass("video-container--playing");

        // broadcast a stop event on the section container
        $(container).trigger("cc:video:stop");

        // play
        var id = $container.data("video-container-id");
        if (id.indexOf("theme-yt-video") === 0) {
          _.youtubeVars.videoData[id].player.stopVideo();
        } else {
          _.vimeoVars.videoData[id].player.pause();
          _.vimeoVars.videoData[id].player.setCurrentTime(0);
        }
      });
    };

    this.onSectionUnload = function (container) {
      $(".video-container__play, .video-container__stop", container).off(
        "click",
      );
      $(window).off("." + $(".video-container").data("video-container-id"));
      $(window).off("debouncedresize.video-manager-resize");
      _._unloadYoutubeVideos(container);
      _._unloadVimeoVideos(container);
      _._unloadMp4Videos(container);
      $(container).trigger("cc:video:stop");
    };
  })();

  // Youtube API callback
  window.onYouTubeIframeAPIReady = function () {
    theme.VideoManager.youtubeApiReady();
  };

  // Register the section
  cc.sections.push({
    name: "video",
    section: theme.VideoManager,
  });

  theme.MapSection = new (function () {
    var _ = this;
    _.config = {
      zoom: 14,
      styles: {
        default: [],
        silver: [
          { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
          { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
          { elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "#f5f5f5" }],
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [{ color: "#bdbdbd" }],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [{ color: "#eeeeee" }],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{ color: "#757575" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{ color: "#e5e5e5" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9e9e9e" }],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ color: "#ffffff" }],
          },
          {
            featureType: "road.arterial",
            elementType: "labels.text.fill",
            stylers: [{ color: "#757575" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{ color: "#dadada" }],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{ color: "#616161" }],
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9e9e9e" }],
          },
          {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [{ color: "#e5e5e5" }],
          },
          {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [{ color: "#eeeeee" }],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#c9c9c9" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9e9e9e" }],
          },
        ],
        retro: [
          { elementType: "geometry", stylers: [{ color: "#ebe3cd" }] },
          { elementType: "labels.text.fill", stylers: [{ color: "#523735" }] },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "#f5f1e6" }],
          },
          {
            featureType: "administrative",
            elementType: "geometry.stroke",
            stylers: [{ color: "#c9b2a6" }],
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "geometry.stroke",
            stylers: [{ color: "#dcd2be" }],
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [{ color: "#ae9e90" }],
          },
          {
            featureType: "landscape.natural",
            elementType: "geometry",
            stylers: [{ color: "#dfd2ae" }],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [{ color: "#dfd2ae" }],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{ color: "#93817c" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [{ color: "#a5b076" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{ color: "#447530" }],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ color: "#f5f1e6" }],
          },
          {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [{ color: "#fdfcf8" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{ color: "#f8c967" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{ color: "#e9bc62" }],
          },
          {
            featureType: "road.highway.controlled_access",
            elementType: "geometry",
            stylers: [{ color: "#e98d58" }],
          },
          {
            featureType: "road.highway.controlled_access",
            elementType: "geometry.stroke",
            stylers: [{ color: "#db8555" }],
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [{ color: "#806b63" }],
          },
          {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [{ color: "#dfd2ae" }],
          },
          {
            featureType: "transit.line",
            elementType: "labels.text.fill",
            stylers: [{ color: "#8f7d77" }],
          },
          {
            featureType: "transit.line",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#ebe3cd" }],
          },
          {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [{ color: "#dfd2ae" }],
          },
          {
            featureType: "water",
            elementType: "geometry.fill",
            stylers: [{ color: "#b9d3c2" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#92998d" }],
          },
        ],
        dark: [
          { elementType: "geometry", stylers: [{ color: "#212121" }] },
          { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
          { elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "#212121" }],
          },
          {
            featureType: "administrative",
            elementType: "geometry",
            stylers: [{ color: "#757575" }],
          },
          {
            featureType: "administrative.country",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9e9e9e" }],
          },
          {
            featureType: "administrative.land_parcel",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [{ color: "#bdbdbd" }],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{ color: "#757575" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{ color: "#181818" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{ color: "#616161" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#1b1b1b" }],
          },
          {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [{ color: "#2c2c2c" }],
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{ color: "#8a8a8a" }],
          },
          {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [{ color: "#373737" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{ color: "#3c3c3c" }],
          },
          {
            featureType: "road.highway.controlled_access",
            elementType: "geometry",
            stylers: [{ color: "#4e4e4e" }],
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [{ color: "#616161" }],
          },
          {
            featureType: "transit",
            elementType: "labels.text.fill",
            stylers: [{ color: "#757575" }],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#000000" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#3d3d3d" }],
          },
        ],
        night: [
          { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
          { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "#242f3e" }],
          },
          {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [{ color: "#d59563" }],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{ color: "#d59563" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{ color: "#263c3f" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{ color: "#6b9a76" }],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ color: "#38414e" }],
          },
          {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{ color: "#212a37" }],
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9ca5b3" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{ color: "#746855" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{ color: "#1f2835" }],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{ color: "#f3d19c" }],
          },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers: [{ color: "#2f3948" }],
          },
          {
            featureType: "transit.station",
            elementType: "labels.text.fill",
            stylers: [{ color: "#d59563" }],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#17263c" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#515c6d" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#17263c" }],
          },
        ],
        aubergine: [
          { elementType: "geometry", stylers: [{ color: "#1d2c4d" }] },
          { elementType: "labels.text.fill", stylers: [{ color: "#8ec3b9" }] },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "#1a3646" }],
          },
          {
            featureType: "administrative.country",
            elementType: "geometry.stroke",
            stylers: [{ color: "#4b6878" }],
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [{ color: "#64779e" }],
          },
          {
            featureType: "administrative.province",
            elementType: "geometry.stroke",
            stylers: [{ color: "#4b6878" }],
          },
          {
            featureType: "landscape.man_made",
            elementType: "geometry.stroke",
            stylers: [{ color: "#334e87" }],
          },
          {
            featureType: "landscape.natural",
            elementType: "geometry",
            stylers: [{ color: "#023e58" }],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [{ color: "#283d6a" }],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{ color: "#6f9ba5" }],
          },
          {
            featureType: "poi",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#1d2c4d" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [{ color: "#023e58" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{ color: "#3C7680" }],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ color: "#304a7d" }],
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{ color: "#98a5be" }],
          },
          {
            featureType: "road",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#1d2c4d" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{ color: "#2c6675" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{ color: "#255763" }],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{ color: "#b0d5ce" }],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#023e58" }],
          },
          {
            featureType: "transit",
            elementType: "labels.text.fill",
            stylers: [{ color: "#98a5be" }],
          },
          {
            featureType: "transit",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#1d2c4d" }],
          },
          {
            featureType: "transit.line",
            elementType: "geometry.fill",
            stylers: [{ color: "#283d6a" }],
          },
          {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [{ color: "#3a4762" }],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#0e1626" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#4e6d70" }],
          },
        ],
      },
    };

    _.apiStatus = null;

    this.geolocate = function ($map) {
      var deferred = $.Deferred();
      var geocoder = new google.maps.Geocoder();
      var address = $map.data("address-setting");

      geocoder.geocode({ address: address }, function (results, status) {
        if (status !== google.maps.GeocoderStatus.OK) {
          deferred.reject(status);
        }

        deferred.resolve(results);
      });

      return deferred;
    };

    this.createMap = function (container) {
      var $map = $(".map-section__map-container", container);

      return _.geolocate($map)
        .then(
          function (results) {
            var mapOptions = {
              zoom: _.config.zoom,
              styles: _.config.styles[$(container).data("map-style")],
              center: results[0].geometry.location,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true,
              zoomControl: true,
            };

            _.map = new google.maps.Map($map[0], mapOptions);
            _.center = _.map.getCenter();

            var marker = new google.maps.Marker({
              map: _.map,
              position: _.center,
              clickable: false,
            });

            google.maps.event.addDomListener(window, "resize", function () {
              google.maps.event.trigger(_.map, "resize");
              _.map.setCenter(_.center);
            });
          }.bind(this),
        )
        .fail(function () {
          var errorMessage;

          switch (status) {
            case "ZERO_RESULTS":
              errorMessage = theme.strings.addressNoResults;
              break;
            case "OVER_QUERY_LIMIT":
              errorMessage = theme.strings.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.addressError;
              break;
          }

          // Only show error in the theme editor
          if (Shopify.designMode) {
            var $mapContainer = $map.parents(".map-section");

            $mapContainer.addClass("page-width map-section--load-error");
            $mapContainer
              .find(".map-section__wrapper")
              .html(
                '<div class="errors text-center">' + errorMessage + "</div>",
              );
          }
        });
    };

    this.onSectionLoad = function (target) {
      var $container = $(target);
      // Global function called by Google on auth errors
      window.gm_authFailure = function () {
        if (!Shopify.designMode) return;

        $container.addClass("page-width map-section--load-error");
        $container
          .find(".map-section__wrapper")
          .html(
            '<div class="errors text-center">' +
              theme.strings.authError +
              "</div>",
          );
      };

      // create maps
      var key = $container.data("api-key");

      if (typeof key !== "string" || key === "") {
        return;
      }

      // load map
      theme.loadScriptOnce(
        "https://maps.googleapis.com/maps/api/js?key=" + key,
        function () {
          _.createMap($container);
        },
      );
    };

    this.onSectionUnload = function (target) {
      if (
        typeof window.google !== "undefined" &&
        typeof google.maps !== "undefined"
      ) {
        google.maps.event.clearListeners(_.map, "resize");
      }
    };
  })();

  // Register the section
  cc.sections.push({
    name: "map",
    section: theme.MapSection,
  });

  theme.FaqHeader = new (function () {
    this.onSectionLoad = function (container) {
      this.namespace = theme.namespaceFromSection(container);
      this.container = container;

      this.classNames = {
        questionContainerInactive: "faq-search-item-inactive",
        sectionWithIndexStatus: "section-faq-header--with-index",
      };

      this.searchInput = this.container.querySelector(".faq-search__input");
      if (this.searchInput) {
        this.registerEventListener(
          this.searchInput,
          "change",
          this.functions.performSearch.bind(this),
        );
        this.registerEventListener(
          this.searchInput,
          "keyup",
          this.functions.performSearch.bind(this),
        );
        this.registerEventListener(
          this.searchInput,
          "paste",
          this.functions.performSearch.bind(this),
        );
      }

      this.functions.debouncedBuildIndex = theme.debounce(
        this.functions.buildIndex.bind(this),
        50,
      );
      this.registerEventListener(
        document,
        "theme:faq-header-update",
        this.functions.debouncedBuildIndex,
      );
      this.functions.debouncedBuildIndex();

      if (this.container.querySelector(".faq-index")) {
        this.registerEventListener(
          this.container,
          "click",
          this.functions.handleIndexClick.bind(this),
        );
        this.container
          .closest(".section-faq-header")
          .classList.add(this.classNames.sectionWithIndexStatus);
        this.functions.resizeIndex.call(this);
        this.registerEventListener(
          window,
          "resize",
          theme.debounce(this.functions.resizeIndex.bind(this), 250),
        );
      }
    };

    this.onSectionReorder = function (container) {
      this.functions.debouncedBuildIndex();
    };

    this.functions = {
      buildIndex: function buildIndex() {
        var faqHeaderSection = this.container.closest(".section-faq-header"),
          indexContainer = this.container.querySelector(
            ".faq-index__item-container",
          );

        if (indexContainer) {
          indexContainer
            .querySelectorAll(".faq-index-item")
            .forEach((element) => {
              element.parentNode.removeChild(element);
            });
        }

        this.linkedCollapsibleTabs = [];
        this.linkedQuestionContainers = [];
        this.linkedContent = [];

        var currentElement = faqHeaderSection;
        while (
          currentElement.nextElementSibling &&
          currentElement.nextElementSibling.classList.contains(
            "section-collapsible-tabs",
          )
        ) {
          currentElement = currentElement.nextElementSibling;

          // build list of searchable content
          this.linkedCollapsibleTabs.push(currentElement);
          currentElement
            .querySelectorAll(".collapsible-tabs__tab")
            .forEach((element) => this.linkedQuestionContainers.push(element));
          currentElement
            .querySelectorAll(".collapsible-tabs__content")
            .forEach((element) => this.linkedContent.push(element));

          // build index UI
          if (indexContainer) {
            var currentElementHeading = currentElement.querySelector(
              ".collapsible-tabs__heading",
            );
            if (currentElementHeading) {
              var tve = theme.createTemplateVariableEncoder();
              tve.add("title_id", currentElementHeading.id, "attribute");
              tve.add("title", currentElementHeading.innerHTML, "raw");

              var html =
                '\n              <div class="faq-index-item">\n                <a class="faq-index-item__link" href="#'
                  .concat(tve.values.title_id, '">')
                  .concat(tve.values.title, "</a>\n              </div>");

              var htmlFragment = document
                .createRange()
                .createContextualFragment(html);
              indexContainer.appendChild(htmlFragment);
            }
          }
        }

        if (indexContainer) {
          this.functions.resizeIndex.call(this);
        }
      },

      resizeIndex: function resizeIndex() {
        var stickyContainer = this.container.querySelector(
            ".faq-index__sticky-container",
          ),
          faqHeaderSection = this.container.closest(".section-faq-header");

        var currentElement = faqHeaderSection;
        while (
          currentElement.nextElementSibling &&
          currentElement.nextElementSibling.classList.contains(
            "section-collapsible-tabs",
          )
        ) {
          currentElement = currentElement.nextElementSibling;
        }

        var stickyContainerRect = stickyContainer.getBoundingClientRect(),
          currentElementRect = currentElement.getBoundingClientRect();

        stickyContainer.style.height =
          currentElementRect.bottom - stickyContainerRect.top + "px";
      },

      performSearch: function performSearch() {
        // defer to avoid input lag
        setTimeout(() => {
          var splitValue = this.searchInput.value.split(" ");

          // sanitise terms
          var terms = [];
          splitValue.forEach((t) => {
            if (t.length > 0) {
              terms.push(t.toLowerCase());
            }
          });

          // search
          this.linkedQuestionContainers.forEach((element) => {
            if (terms.length) {
              var termFound = false;
              var matchContent = element.textContent.toLowerCase();
              terms.forEach((term) => {
                if (matchContent.indexOf(term) >= 0) {
                  termFound = true;
                }
              });
              if (termFound) {
                element.classList.remove(
                  this.classNames.questionContainerInactive,
                );
              } else {
                element.classList.add(
                  this.classNames.questionContainerInactive,
                );
              }
            } else {
              element.classList.remove(
                this.classNames.questionContainerInactive,
              );
            }
          });

          // hide non-question content if doing a search
          this.linkedContent.forEach((element) => {
            if (terms.length) {
              element.classList.add(this.classNames.questionContainerInactive);
            } else {
              element.classList.remove(
                this.classNames.questionContainerInactive,
              );
            }
          });
        }, 10);
      },

      handleIndexClick: function handleIndexClick(evt) {
        if (evt.target.classList.contains("faq-index-item__link")) {
          evt.preventDefault();
          var id = evt.target.href.split("#")[1];
          var scrollTarget = document.getElementById(id);
          var scrollTargetY =
            scrollTarget.getBoundingClientRect().top + window.pageYOffset - 50;

          // sticky header offset
          var stickyHeight = getComputedStyle(
            document.documentElement,
          ).getPropertyValue("--theme-sticky-header-height");
          if (stickyHeight) {
            scrollTargetY -= parseInt(stickyHeight);
          }

          window.scrollTo({
            top: scrollTargetY,
            behavior: "smooth",
          });
        }
      },
    };
  })();

  // Register section
  cc.sections.push({
    name: "faq-header",
    section: theme.FaqHeader,
    deferredLoad: false,
  });

  theme.CollapsibleTabs = new (function () {
    this.onSectionLoad = function (container) {
      this.functions.notifyFaqHeaderOfChange();
    };

    this.onSectionReorder = function (container) {
      this.functions.notifyFaqHeaderOfChange();
    };

    this.onSectionUnload = function (container) {
      this.functions.notifyFaqHeaderOfChange();
    };

    this.functions = {
      notifyFaqHeaderOfChange: function notifyFaqHeaderOfChange() {
        document.dispatchEvent(
          new CustomEvent("theme:faq-header-update", {
            bubbles: true,
            cancelable: false,
          }),
        );
      },
    };
  })();

  // Register section
  cc.sections.push({
    name: "collapsible-tabs",
    section: theme.CollapsibleTabs,
    deferredLoad: false,
  });

  /**
   * StoreAvailability Section Script
   * ------------------------------------------------------------------------------
   *
   * @namespace StoreAvailability
   */

  theme.StoreAvailability = function (container) {
    var loadingClass = "store-availability-loading";
    var initClass = "store-availability-initialized";
    var storageKey = "cc-location";

    this.onSectionLoad = function (container) {
      this.namespace = theme.namespaceFromSection(container);
      this.$container = $(container);
      this.productId = this.$container.data("store-availability-container");
      this.sectionUrl = this.$container.data("section-url");
      this.$modal;

      this.$container.addClass(initClass);
      this.transitionDurationMS =
        parseFloat(getComputedStyle(container).transitionDuration) * 1000;
      this.removeFixedHeightTimeout = -1;

      // Handle when a variant is selected
      $(window).on(
        "cc-variant-updated".concat(this.namespace).concat(this.productId),
        (e, args) => {
          if (args.product.id === this.productId) {
            this.functions.updateContent.bind(this)(
              args.variant ? args.variant.id : null,
              args.product.title,
              this.$container.data("has-only-default-variant"),
              args.variant && typeof args.variant.available !== "undefined",
            );
          }
        },
      );

      // Handle single variant products
      if (this.$container.data("single-variant-id")) {
        this.functions.updateContent.bind(this)(
          this.$container.data("single-variant-id"),
          this.$container.data("single-variant-product-title"),
          this.$container.data("has-only-default-variant"),
          this.$container.data("single-variant-product-available"),
        );
      }
    };

    this.onSectionUnload = function () {
      $(window).off(
        "cc-variant-updated".concat(this.namespace).concat(this.productId),
      );
      this.$container.off("click");
      if (this.$modal) {
        this.$modal.off("click");
      }
    };

    this.functions = {
      // Returns the users location data (if allowed)
      getUserLocation: function getUserLocation() {
        return new Promise((resolve, reject) => {
          var storedCoords;

          if (sessionStorage[storageKey]) {
            storedCoords = JSON.parse(sessionStorage[storageKey]);
          }

          if (storedCoords) {
            resolve(storedCoords);
          } else {
            if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(
                function (position) {
                  var coords = {
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                  };

                  //Set the localization api
                  fetch("/localization.json", {
                    method: "PUT",
                    headers: {
                      "Content-Type": "application/json",
                    },

                    body: JSON.stringify(coords),
                  });

                  //Write to a session storage
                  sessionStorage[storageKey] = JSON.stringify(coords);

                  resolve(coords);
                },
                function () {
                  resolve(false);
                },
                {
                  maximumAge: 3600000, // 1 hour
                  timeout: 5000,
                },
              );
            } else {
              resolve(false);
            }
          }
        });
      },

      // Requests the available stores and calls the callback
      getAvailableStores: function getAvailableStores(variantId, cb) {
        return $.get(this.sectionUrl.replace("VARIANT_ID", variantId), cb);
      },

      // Haversine Distance
      // The haversine formula is an equation giving great-circle distances between
      // two points on a sphere from their longitudes and latitudes
      calculateDistance: function calculateDistance(
        coords1,
        coords2,
        unitSystem,
      ) {
        var dtor = Math.PI / 180;
        var radius = unitSystem === "metric" ? 6378.14 : 3959;

        var rlat1 = coords1.latitude * dtor;
        var rlong1 = coords1.longitude * dtor;
        var rlat2 = coords2.latitude * dtor;
        var rlong2 = coords2.longitude * dtor;

        var dlon = rlong1 - rlong2;
        var dlat = rlat1 - rlat2;

        var a =
          Math.pow(Math.sin(dlat / 2), 2) +
          Math.cos(rlat1) * Math.cos(rlat2) * Math.pow(Math.sin(dlon / 2), 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return radius * c;
      },

      // Updates the existing modal pickup with locations with distances from the user
      updateLocationDistances: function updateLocationDistances(coords) {
        var unitSystem = this.$modal
          .find("[data-unit-system]")
          .data("unit-system");
        var self = this;

        this.$modal.find('[data-distance="false"]').each(function () {
          var thisCoords = {
            latitude: parseFloat($(this).data("latitude")),
            longitude: parseFloat($(this).data("longitude")),
          };

          if (thisCoords.latitude && thisCoords.longitude) {
            var distance = self.functions
              .calculateDistance(coords, thisCoords, unitSystem)
              .toFixed(1);

            $(this).html(distance);

            //Timeout to trigger animation
            setTimeout(() => {
              $(this)
                .closest(".store-availability-list__location__distance")
                .addClass("-in");
            }, 0);
          }

          $(this).attr("data-distance", "true");
        });
      },

      // Requests the available stores and updates the page with info below Add to Basket, and append the modal to the page
      updateContent: function updateContent(
        variantId,
        productTitle,
        isSingleDefaultVariant,
        isVariantAvailable,
      ) {
        this.$container.off("click", "[data-store-availability-modal-open]");
        this.$container.off(
          "click" + this.namespace,
          ".cc-popup-close, .cc-popup-background",
        );
        $(".store-availabilities-modal").remove();

        if (!isVariantAvailable) {
          //If the variant is Unavailable (not the same as Out of Stock) - hide the store pickup completely
          this.$container.addClass(loadingClass);
          if (this.transitionDurationMS > 0) {
            this.$container.css("height", "0px");
          }
        } else {
          this.$container.addClass(loadingClass);
          if (this.transitionDurationMS > 0) {
            this.$container.css("height", this.$container.outerHeight() + "px");
          }
        }

        if (isVariantAvailable) {
          this.functions.getAvailableStores.call(
            this,
            variantId,
            (response) => {
              if (
                response.trim().length > 0 &&
                !response.includes("NO_PICKUP")
              ) {
                this.$container.html(response);
                this.$container.html(this.$container.children().first().html()); // editor bug workaround

                this.$container
                  .find("[data-store-availability-modal-product-title]")
                  .html(productTitle);

                if (isSingleDefaultVariant) {
                  this.$container
                    .find(".store-availabilities-modal__variant-title")
                    .remove();
                }

                this.$container.find(".cc-popup").appendTo("body");

                this.$modal = $("body").find(".store-availabilities-modal");
                var popup = new ccPopup(this.$modal, this.namespace);

                this.$container.on(
                  "click",
                  "[data-store-availability-modal-open]",
                  () => {
                    popup.open();

                    //When the modal is opened, try and get the users location
                    this.functions.getUserLocation().then((coords) => {
                      if (
                        coords &&
                        this.$modal.find('[data-distance="false"]').length
                      ) {
                        //Re-retrieve the available stores location modal contents
                        this.functions.getAvailableStores.call(
                          this,
                          variantId,
                          (response) => {
                            this.$modal
                              .find(".store-availabilities-list")
                              .html(
                                $(response)
                                  .find(".store-availabilities-list")
                                  .html(),
                              );
                            this.functions.updateLocationDistances.bind(this)(
                              coords,
                            );
                          },
                        );
                      }
                    });

                    return false;
                  },
                );

                this.$modal.on(
                  "click" + this.namespace,
                  ".cc-popup-close, .cc-popup-background",
                  () => {
                    popup.close();
                  },
                );

                this.$container.removeClass(loadingClass);

                if (this.transitionDurationMS > 0) {
                  var newHeight = this.$container
                    .find(".store-availability-container")
                    .outerHeight();
                  this.$container.css(
                    "height",
                    newHeight > 0 ? newHeight + "px" : "",
                  );
                  clearTimeout(this.removeFixedHeightTimeout);
                  this.removeFixedHeightTimeout = setTimeout(() => {
                    this.$container.css("height", "");
                  }, this.transitionDurationMS);
                }
              }
            },
          );
        }
      },
    };

    // Initialise the section when it's instantiated
    this.onSectionLoad(container);
  };

  // Register section
  cc.sections.push({
    name: "store-availability",
    section: theme.StoreAvailability,
  });

  /**
   * Popup Section Script
   * ------------------------------------------------------------------------------
   *
   * @namespace Popup
   */

  theme.Popup = new (function () {
    /**
     * Popup section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */

    var dismissedStorageKey = "cc-theme-popup-dismissed";

    this.onSectionLoad = function (container) {
      this.namespace = theme.namespaceFromSection(container);
      this.$container = $(container);
      this.popup = new ccPopup(this.$container, this.namespace);

      var dismissForDays = this.$container.data("dismiss-for-days"),
        delaySeconds = this.$container.data("delay-seconds"),
        showPopup = true,
        testMode = this.$container.data("test-mode"),
        lastDismissed = window.localStorage.getItem(dismissedStorageKey);

      // Should we show it during this page view?
      // Check when it was last dismissed
      if (lastDismissed) {
        var dismissedDaysAgo =
          (new Date().getTime() - lastDismissed) / (1000 * 60 * 60 * 24);
        if (dismissedDaysAgo < dismissForDays) {
          showPopup = false;
        }
      }

      // Check for error or success messages
      if (this.$container.find(".cc-popup-form__response").length) {
        showPopup = true;
        delaySeconds = 1;

        // If success, set as dismissed
        if (this.$container.find(".cc-popup-form__response--success").length) {
          this.functions.popupSetAsDismissed.call(this);
        }
      }

      // Prevent popup on Shopify robot challenge page
      if (document.querySelector(".shopify-challenge__container")) {
        showPopup = false;
      }

      // Show popup, if appropriate
      if (showPopup || testMode) {
        setTimeout(() => {
          this.popup.open();
        }, delaySeconds * 1000);
      }

      // Click on close button or modal background
      this.$container.on(
        "click" + this.namespace,
        ".cc-popup-close, .cc-popup-background",
        () => {
          this.popup.close(() => {
            this.functions.popupSetAsDismissed.call(this);
          });
        },
      );
    };

    this.onSectionSelect = function () {
      this.popup.open();
    };

    this.functions = {
      /**
       * Use localStorage to set as dismissed
       */
      popupSetAsDismissed: function popupSetAsDismissed() {
        window.localStorage.setItem(dismissedStorageKey, new Date().getTime());
      },
    };

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    this.onSectionUnload = function () {
      this.$container.off(this.namespace);
    };
  })();

  // Register section
  cc.sections.push({
    name: "newsletter-popup",
    section: theme.Popup,
  });

  /*================ General =================*/
  theme.owlCarouselEventList =
    [
      "to",
      "next",
      "prev",
      "destroy",
      "initialized",
      "resized",
      "refreshed",
    ].join(".owl.carousel ") + ".owl.carousel";
  theme.beforeCarouselLoadEventBlockFix = function (carouselEls) {
    $(carouselEls).on(theme.owlCarouselEventList, function (evt) {
      evt.stopPropagation();
    });
  };

  theme.beforeCarouselUnloadEventBlockFix = function (carouselEls) {
    $(carouselEls).off(theme.owlCarouselEventList);
  };

  theme.loadCarousels = function (container) {
    return $(".carousel", container).each(function () {
      var $this = $(this);

      function getTotalProductBlockWidth() {
        var productBlockTotalWidth = 0;
        $this
          .find(
            $this.hasClass("owl-loaded")
              ? ".owl-item:not(.cloned)"
              : ".product-block",
          )
          .each(function () {
            productBlockTotalWidth += $(this).outerWidth(true);
          });
        return productBlockTotalWidth;
      }

      // function to update button states
      function updateButtonStates() {
        var carousel = $this.data("owl.carousel");
        if (!carousel) return;

        var $slider = $this.closest(".collection-slider");
        var $prevBtn = $slider.find(".prev");
        var $nextBtn = $slider.find(".next");

        var current = carousel.current();
        var totalItems = carousel.items().length;
        var visibleItems = carousel.settings.items;
        var isLoop = carousel.settings.loop;

        // Update prev button
        var canGoPrev = isLoop || current > 0;
        $prevBtn.toggleClass("owl-btn-disabled", !canGoPrev);

        // Update next button
        var canGoNext = isLoop || current < totalItems - visibleItems;
        $nextBtn.toggleClass("owl-btn-disabled", !canGoNext);
      }

      // next & prev arrows
      $this
        .closest(".collection-slider")
        .on("click.themeCarousel", ".prev, .next", function (e) {
          e.preventDefault();
          var carousel = $(this)
            .closest(".collection-slider")
            .find(".owl-carousel")
            .data("owl.carousel");
          if ($(this).hasClass("prev")) {
            carousel.prev();
          } else {
            carousel.next();
          }

          // Update button states after navigation
          setTimeout(updateButtonStates, 50);
        });

      // create options
      var carouselOptions, isLooping;
      var fixedMode = !$(this).closest(".container--no-max").length;
      $this.toggleClass("carousel--fixed-grid-mode", fixedMode);
      if (fixedMode) {
        var desktopNumPerRow = parseInt(
          $(this)[0].className.match(/per-row-(.)/)[1],
        );
        carouselOptions = {
          margin: 0,
          loop: false,
          autoWidth: false,
          items: 5,
          slideBy: 4,
          center: false,
          nav: false,
          dots: false,
          responsive: {
            0: {
              items: desktopNumPerRow < 4 ? 1 : 2,
              slideBy: 2,
            },

            480: {
              items: Math.min(2, desktopNumPerRow - 2),
              slideBy: 2,
            },

            767: {
              items: desktopNumPerRow - 1,
              slideBy: 3,
            },

            1000: {
              items: desktopNumPerRow,
              slideBy: 4,
            },
          },
        };
      } else {
        isLooping = getTotalProductBlockWidth() > $this.width();
        carouselOptions = {
          margin: 0,
          loop: isLooping,
          autoWidth: true,
          items: Math.min($this.children().length, 8),
          slideBy: 4,
          center: true,
          nav: false,
          dots: false,
        };
      }

      carouselOptions.rtl = document.querySelector("html[dir=rtl]")
        ? true
        : false;

      // init carousel
      var loadCarousel = function loadCarousel() {
        // remove data-src as not in correct format for Owl to parse
        $this.find("[data-src]").each(function () {
          $(this)
            .attr("data-src-temp", $(this).attr("data-src"))
            .removeAttr("data-src");
        });

        // fix for event propagation in nested owl carousels
        theme.beforeCarouselLoadEventBlockFix($this);

        // run after carousel is initialised
        $this.on("initialized.owl.carousel", function () {
          // restore data-src
          $this.find("[data-src-temp]").each(function () {
            $(this)
              .attr("data-src", $(this).attr("data-src-temp"))
              .removeAttr("data-src-temp");
          });
          // lazysizes on primary images
          $this
            .find(
              '.product-block__image--primary .lazyload--manual, .product-block__image--secondary[data-image-index="1"] .lazyload--manual, .product-block-options__item.lazyload--manual',
            )
            .removeClass("lazyload--manual")
            .addClass("lazyload");
          // ensure clones are processed from scratch
          theme.ProductBlockManager.loadImages(
            $this.closest("[data-section-type]"),
          );
          // recalculate widths, after the above's async calls
          setTimeout(function () {
            $this.data("owl.carousel").invalidate("width");
            $this.trigger("refresh.owl.carousel");
            // Update button states after initialization
            setTimeout(updateButtonStates, 100);
          }, 10);
        });

        // run after carousel is initialised or resized
        $this.on(
          "initialized.owl.carousel resized.owl.carousel",
          function (evt) {
            // only loop if items do not all fit on screen, in non-fixed mode
            if (!fixedMode && evt.type == "resized") {
              var shouldLoop = getTotalProductBlockWidth() > $this.width();
              if (shouldLoop != isLooping) {
                // destroy and rebuild carousel with appropriate loop setting
                carouselOptions.loop = shouldLoop;
                isLooping = shouldLoop;

                // destroy function
                $(evt.target).data("owl.carousel").destroy();

                // build again
                $(evt.target).owlCarousel(carouselOptions);

                // do no more in this callback
                return;
              }
            }

            // layout fixes
            setTimeout(function () {
              // fixes
              var currentWidth = $this.find(".owl-stage").width();
              var stageIsPartiallyOffScreen = currentWidth > $this.width();
              if (stageIsPartiallyOffScreen) {
                // more elements than fit in viewport
                // resize stage to avoid rounding-error wrapping
                var newWidth = 0;
                $this.find(".owl-item").each(function () {
                  newWidth += $(this).outerWidth(true) + 1;
                });
                $this
                  .find(".owl-stage")
                  .css({})
                  .removeClass("owl-stage--items-fit");
              } else {
                // all elements fit inside viewport
                // centre-align using css, if not full
                $this
                  .find(".owl-stage")
                  .addClass("owl-stage--items-fit")
                  .css({});
              }
              // previous/next button visibility
              $this
                .closest(".collection-slider")
                .find(".prev, .next")
                .toggleClass("owl-btn-disabled", !stageIsPartiallyOffScreen);

              // Update button states based on carousel position
              if (stageIsPartiallyOffScreen) {
                updateButtonStates();
              }
            }, 10);
          },
        );

        // Update button states on all carousel events
        $this.on(
          "changed.owl.carousel translated.owl.carousel dragged.owl.carousel to.owl.carousel",
          function (evt) {
            // Update button states after any carousel change
            setTimeout(updateButtonStates, 10);
          },
        );

        // Update button states on navigation events
        $this.on("prev.owl.carousel next.owl.carousel", function (evt) {
          // Update button states immediately after navigation
          setTimeout(updateButtonStates, 10);
        });

        // run when the contents change, for any reason
        theme.carouselInputIncrementer = theme.carouselInputIncrementer || 0;
        $this
          .on("refreshed.owl.carousel", function () {
            // set a11y attrs to avoid clone items giving duplication errors
            $(".owl-item", this).removeAttr("aria-hidden");
            $(".owl-item.cloned", this)
              .attr("aria-hidden", "true")
              .each(function () {
                theme.carouselInputIncrementer++;
                var uniquenessSuffix = "_" + theme.carouselInputIncrementer;
                $(this)
                  .find(
                    "form[id]:not([data-id-altered]), :input[id]:not([data-id-altered])",
                  )
                  .each(function () {
                    $(this).attr("id", $(this).attr("id") + uniquenessSuffix);
                  })
                  .attr("data-id-altered", true);

                $(this)
                  .find("label[for]:not([data-id-altered])")
                  .each(function () {
                    $(this).attr("for", $(this).attr("for") + uniquenessSuffix);
                  })
                  .attr("data-id-altered", true);
              });

            // Update button states after refresh
            setTimeout(updateButtonStates, 50);
          })
          .addClass("owl-carousel")
          .owlCarousel(carouselOptions);
      };
      loadCarousel();
    });
  };

  theme.unloadCarousels = function (container) {
    $(".collection-slider", container).off(".themeCarousel");
    $(".slick-slider", container).slick("unslick");
    theme.beforeCarouselUnloadEventBlockFix($(".owl-carousel", container));
    $(".owl-carousel", container).each(function () {
      $(this).data("owl.carousel").destroy();
    });
  };

  theme.icons = {
    left:
      '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' +
      theme.strings.icon_labels_left +
      '</title><path d="M0 0h24v24H0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>',
    right:
      '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' +
      theme.strings.icon_labels_right +
      '</title><path d="M0 0h24v24H0z" fill="none"/><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg>',
    close:
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><title>' +
      theme.strings.icon_labels_close +
      '</title><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
    chevronLeft:
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left ltr-icon"><title>' +
      theme.strings.icon_labels_left +
      '</title><polyline points="15 18 9 12 15 6"></polyline></svg>',
    chevronRight:
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right ltr-icon"><title>' +
      theme.strings.icon_labels_right +
      '</title><polyline points="9 18 15 12 9 6"></polyline></svg>',
    chevronDown:
      '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' +
      theme.strings.icon_labels_down +
      '</title><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/><path d="M0-.75h24v24H0z" fill="none"/></svg>',
    tick: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>',
    label:
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-tag"><title>Label</title><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7" y2="7"></line></svg>',
  };

  // Get Shopify feature support
  try {
    theme.Shopify.features = JSON.parse(
      document.documentElement.querySelector("#shopify-features").textContent,
    );
  } catch (e) {
    theme.Shopify.features = {};
  }

  theme.namespaceFromSection = function (container) {
    return [
      ".",
      $(container).data("section-type"),
      $(container).data("section-id"),
    ].join("");
  };

  theme.toggleLinkDropdownButton = function (evt) {
    evt.stopPropagation();
    var $btn = $(evt.currentTarget),
      doExpand = $btn.attr("aria-expanded") == "false";
    $btn.attr("aria-expanded", doExpand);
    $btn.css("width", $btn.outerWidth() + "px");
    var newWidth = null,
      $optsBox = $btn.next(),
      isLeftAligned = $btn
        .closest(".link-dropdown")
        .hasClass("link-dropdown--left-aligned");
    if (!isLeftAligned) {
      if (doExpand) {
        newWidth = $optsBox.outerWidth();
        // rtl - could be either side
        if (document.querySelector("html[dir=rtl]")) {
          newWidth += parseInt($optsBox.css("left"));
        } else {
          newWidth += parseInt($optsBox.css("right"));
        }
        newWidth -= parseInt(
          $optsBox
            .find(".link-dropdown__link:first")
            .css("padding-inline-start"),
        );
      } else {
        newWidth =
          parseInt($btn.css("padding-inline-end")) +
          $btn.find(".link-dropdown__button-text").width() +
          1;
      }
      setTimeout(function () {
        $btn.css("width", newWidth + "px");
      }, 10);
    }
  };

  // Enables any images inside a container
  theme.awakenImagesFromSlumber = function ($cont) {
    $cont.find(".lazyload--manual:not(.lazyload)").addClass("lazyload");
  };

  theme.measureTextInsideElement = function (text, element) {
    theme.measureTextInsideElementCanvas =
      theme.measureTextInsideElementCanvas || document.createElement("canvas");
    var context = theme.measureTextInsideElementCanvas.getContext("2d");
    var font = getComputedStyle(element).font;
    context.font = font;
    return context.measureText(text);
  };

  // Use non-breaking space to attempt to avoid orphans
  theme.avoidUnecessaryOrphans = function (element) {
    if (theme.settings.avoid_orphans) {
      var innerTextSplit = element.innerText.split(" ");
      if (
        innerTextSplit.length >= 4 && // 4 or more words
        innerTextSplit[innerTextSplit.length - 1].length +
          innerTextSplit[innerTextSplit.length - 2].length <
          20 // last two words aren't particularly long together
      ) {
        var html = element.innerHTML;
        if (html.indexOf("&nbsp;") < 0) {
          html = html.replace(/<[^>]*?>/g, (match) => {
            return match.replace(/ /g, "ΩΩ");
          });
          var splitHtml = html.split(" "),
            lastItem = splitHtml.pop();

          // ensure length of text will be smaller than container, excluding HTML
          if (
            theme.measureTextInsideElement(
              splitHtml[splitHtml.length - 1].replace(/<[^>]*?>/g, "") +
                " " +
                lastItem.replace(/<[^>]*?>/g, ""),
              element,
            ).width > element.clientWidth
          ) {
            return;
          }

          html = splitHtml.join(" ") + "&nbsp;" + lastItem;
          html = html.replace(/ΩΩ/g, " ");
          element.innerHTML = html;
        }
      }
    }
  };

  theme.stickyHeaderHeight = function () {
    var v = getComputedStyle(document.documentElement).getPropertyValue(
      "--theme-sticky-header-height",
    );
    if (v) {
      return parseInt(v) || 0;
    } else {
      return 0;
    }
  };

  theme.scrollToRevealElement = function (el, ifFullyOutsideViewport) {
    var elTop = el.getBoundingClientRect().top + window.scrollY,
      elBot = elTop + el.offsetHeight,
      inViewTop = window.scrollY,
      inViewBot = window.scrollY + window.innerHeight - 50;

    if (
      (ifFullyOutsideViewport && (elTop >= inViewBot || elBot <= inViewTop)) ||
      (!ifFullyOutsideViewport && (elTop < inViewTop || elBot > inViewBot))
    ) {
      window.scrollTo({
        top: elTop - 100 - theme.stickyHeaderHeight(),
        left: window.screenLeft,
        behavior: "smooth",
      });
    }
  };

  theme.getEmptyOptionSelectors = function ($formContainer) {
    var emptySections = [];

    $formContainer
      .find('[data-selector-type="dropdown"].option-selector')
      .each(function () {
        if (
          !$(this)
            .find('[aria-selected="true"]')
            .filter(function () {
              return this.dataset && this.dataset.value;
            }).length
        ) {
          emptySections.push(this);
        }
      });

    $formContainer
      .find('[data-selector-type="listed"].option-selector')
      .each(function () {
        if (!$(this).find("input:checked").length) {
          emptySections.push(this);
        }
      });

    return emptySections;
  };

  theme.validateProductForm = function ($formContainer) {
    $formContainer
      .find(".option-selector--empty")
      .removeClass("option-selector--empty")
      .find(".label__prefix")
      .remove();

    if (!$formContainer.find(".original-selector").val()) {
      var emptySections = theme.getEmptyOptionSelectors($formContainer);

      if (emptySections.length) {
        emptySections.forEach((el) => {
          el.classList.add("option-selector--empty");
          var labelPrefix = document.createElement("span");
          labelPrefix.innerText = theme.strings.products_product_pick_a + " ";
          labelPrefix.className = "label__prefix";
          el.querySelector(".label").prepend(labelPrefix);
        });

        theme.scrollToRevealElement(emptySections[0]);

        $formContainer.addClass("product-form--validation-started");
      }
      return false;
    } else {
      return true;
    }
  };

  theme.pauseAllMedia = function (params) {
    if (!params || params.videos) {
      document.querySelectorAll(".js-youtube").forEach((video) => {
        video.contentWindow.postMessage(
          '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
          "*",
        );
      });
      document.querySelectorAll(".js-vimeo").forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', "*");
      });
      document.querySelectorAll("video").forEach((video) => video.pause());
    }
    if (!params || params.models) {
      document.querySelectorAll("product-model").forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
      });
    }
  };

  // bg-set snippet in JS
  theme.lazyBGSetWidths = [
    180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1950, 2100, 2260, 2450,
    2700, 3000, 3350, 3750, 4100,
  ];
  theme.loadLazyBGSet = function (container) {
    $("[data-lazy-bgset-src]", container).each(function () {
      var srcset = "",
        masterSrc = $(this).data("lazy-bgset-src"),
        aspectRatio = $(this).data("lazy-bgset-aspect-ratio"),
        masterWidth = $(this).data("lazy-bgset-width"),
        masterHeight = Math.round(masterWidth / aspectRatio);

      for (var i = 0; i < theme.lazyBGSetWidths.length; i++) {
        var thisWidth = theme.lazyBGSetWidths[i];
        if (masterWidth >= thisWidth) {
          srcset += ""
            .concat(theme.Shopify.formatImage(masterSrc, thisWidth + "x"), " ")
            .concat(thisWidth, "w ")
            .concat(Math.round(thisWidth / aspectRatio), "h, ");
        }
      }
      srcset += ""
        .concat(masterSrc, " ")
        .concat(masterWidth, "w ")
        .concat(masterHeight, "h");
      $(this)
        .attr("data-bgset", srcset)
        .removeClass("lazyload--manual")
        .addClass("lazyload");
    });
  };
  /*
   * 判断是否是移动端
   */
  theme.isMobile = function () {
    return window.innerWidth <= 768;
  };
  /*=============== Components ===============*/
  theme.applyAjaxToProductForm = function ($formContainer) {
    $formContainer.find("form.product-purchase-form").each(function () {
      var $form = $(this);
      $form.on("submit", function (evt) {
        const isProductPage = document.querySelector(".section-product-main");
        //埋点添加
        const isFloatPcfForm = $formContainer.data("is-float-pc-form");
        const isFloatMobileForm = $formContainer.data("is-float-mobile-form");
        const isMainForm = $formContainer.data("is-main-form");
        let ptName;
        if (isFloatPcfForm) {
          ptName = "detail-pc-quick-addToCart";
        } else if (isFloatMobileForm) {
          ptName = "detail-m-quick-addToCart";
        } else {
          ptName = theme.isMobile()
            ? "detail-m-main-addToCart"
            : "detail-pc-main-addToCart";
        }
        if (
          (isMainForm || isFloatPcfForm || isFloatMobileForm) &&
          isProductPage
        ) {
          ptengine && ptengine.track(ptName);
        }
        // Validate
        if (!theme.validateProductForm($formContainer)) {
          return false;
        }

        // Ajax-add
        if (
          theme.settings.cart_type === "drawer" &&
          $formContainer.is('[data-ajax-add-to-cart="true"]')
        ) {
          evt.preventDefault();

          var shopifyAjaxAddURL = theme.routes.cart_add_url;

          //Disable add button
          $form
            .find('button[type="submit"]')
            .attr("disabled", "disabled")
            .each(function () {
              $(this).data("previous-value", $(this).val());
            })
            .val(theme.strings.products_product_adding_to_cart);

          theme.removeAddedCartDrawer();
          $(".product-column-float-mobile").fadeOut(500);
          $("body").css("overflow", "auto");

          //Add to cart
          var formData = new FormData($form[0]);
          formData.append("sections", "cart-drawer");
          $.post(
            shopifyAjaxAddURL,
            new URLSearchParams(formData).toString(),
            theme.addedToCartHandler.bind($form),
            "json",
          ).fail(function (data) {
            //Enable add button
            $form
              .find('button[type="submit"]')
              .removeAttr("disabled")
              .each(function () {
                $(this).val($(this).data("previous-value"));
              });

            //Not added, show message
            if (
              typeof data !== "undefined" &&
              typeof data.status !== "undefined"
            ) {
              var jsonRes = $.parseJSON(data.responseText);
              theme.showQuickPopup(
                jsonRes.description,
                $form.find('button[type="submit"]:first'),
              );
            } else {
              //Some unknown error? Disable ajax and add the old-fashioned way.
              $formContainer.attr("ajax-add-to-cart", "false");
              $form.submit();
            }
          });
        }
      });
    });

    if (theme.settings.cart_type === "drawer") {
      $(window)
        .off(".ajaxAddScroll")
        .on("scroll.ajaxAddScroll", function () {
          // Hide notifications on scroll
          theme.removeAddedCartDrawer();
        });
    }
  };

  theme.addedToCartHandler = function (response) {
    // Dispatch change event
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:cartchanged", {
        bubbles: true,
        cancelable: false,
      }),
    );

    //Enable add button
    $(this)
      .find('button[type="submit"]')
      .removeAttr("disabled")
      .each(function () {
        $btn = $(this);
        //Set to 'DONE', alter button style, wait a few secs, revert to normal
        $btn
          .val(theme.strings.products_product_added_to_cart)
          .addClass("inverted");
        window.setTimeout(function () {
          $btn.removeClass("inverted").val($btn.data("previous-value"));
        }, 3000);
      });

    var $cartDrawerContainer = $(response.sections["cart-drawer"]);
    var cartDrawer = $cartDrawerContainer.find(".cart-summary-overlay")[0];
    cartDrawer.classList.add("cart-summary-overlay--off-screen");

    // show only added item
    if (response.key) {
      //判断是单个还是一个集合，加购集合的话，就只展示当前集合的产品，不展示购物车其他的内容
      // 多个的时候用id匹配，key每次会变动，尤其是购物车没有商品的时候是个bug,add.js返回的数据的items的key和cart.js拿到的items数据的key不一致。
      if (Array.isArray(response.key)) {
        const keysToKeep = new Set(response.key);
        const $rowBodies = $cartDrawerContainer.find(
          ".cart-summary-overlay__row-body",
        );
        $rowBodies.each(function (index) {
          const $row = $(this);
          const itemKey = $row.data("item-id");
          if (!keysToKeep.has(itemKey)) {
            $row.remove();
          }
        });

        //获取剩余的
        const $remainingRows = $cartDrawerContainer.find(
          ".cart-summary-overlay__row-body",
        );
        $remainingRows.each(function (index) {
          const $row = $(this);

          //保留最后一行汇总价格
          if (index < $remainingRows.length - 1) {
            $row.find(".cart-summary-overlay__column-subtotal").remove();
          }
        });
      } else {
        $cartDrawerContainer
          .find(
            '.cart-summary-overlay__row-body:not([data-item-key="'.concat(
              response.key,
              '"])',
            ),
          )
          .remove();
      }
    }

    document
      .querySelector(".cart-drawer__close")
      ?.addEventListener("click", function (evt) {
        evt.preventDefault();
        theme.removeAddedCartDrawer();
      });

    $cartDrawerContainer.prependTo("body");
    setTimeout(function () {
      cartDrawer.classList.remove("cart-summary-overlay--off-screen");
    }, 50);

    //ech0
    if (typeof window.aa_freegift !== "undefined") {
      console.log("Update aa_freegift notice when ajax add to cart");
      window.aa_freegift.saveActivityProductAdded();
      var aaFreeGiftElementShow = $("body").attr("data-aafreegiftelementshow");
      $("body").attr("data-aafreegift-force-update-notice", 1);
      aaFreeGiftElementShow = parseInt(aaFreeGiftElementShow);
      window.aa_freegift.notice_render(
        aaFreeGiftElementShow,
        window.aa_freegift.getCart(),
      );
    }
    //ech0
  };

  theme.removeAddedCartDrawer = function () {
    document.querySelectorAll(".cart-summary-overlay").forEach((drawer) => {
      drawer.classList.add("cart-summary-overlay--off-screen");
      var duration =
        parseFloat(getComputedStyle(drawer).transitionDuration) * 1000;
      setTimeout(() => $(drawer.parentElement).remove(), duration);
    });
  };

  theme.removeAjaxFromProductForm = function ($formContainer) {
    $formContainer.find("form.product-purchase-form").off("submit");
  };

  theme.LoadFilterer = function (section) {
    this.$container = section.$container;
    this.namespace = section.namespace;
    this.registerEventListener = section.registerEventListener;

    this.functions = {
      initFiltersEtc: function initFiltersEtc() {
        $(".filter-container", this.$container).addClass(
          "filter-container--mobile-initialised",
        );

        // append query vars onto sort urls (e.g. filters, vendor collection)
        if (location.href.indexOf("?") >= 0) {
          $(
            "#sort-dropdown-options .link-dropdown__link",
            this.$container,
          ).each(function () {
            var queryTerms = location.href.split("?")[1].split("&");
            var newHref = $(this).attr("href");
            queryTerms.forEach((term) => {
              if (term.indexOf("sort_by=") === -1) {
                newHref += "&" + term;
              }
            });
            $(this).attr("href", newHref);
          });
        }

        theme.ProductBlockManager.loadImages(this.$container);
      },

      switchGridLayout: function switchGridLayout(evt) {
        evt.preventDefault();
        if ($(evt.currentTarget).hasClass("layout-switch--one-column")) {
          this.$container
            .find(".product-list")
            .removeClass("product-list--per-row-mob-2")
            .addClass("product-list--per-row-mob-1");
        } else {
          this.$container
            .find(".product-list")
            .removeClass("product-list--per-row-mob-1")
            .addClass("product-list--per-row-mob-2");
        }
        $(evt.currentTarget)
          .addClass("layout-switch--active")
          .siblings()
          .removeClass("layout-switch--active");
      },

      checkStickyScroll: function checkStickyScroll() {
        var utilityBarOffsetY = $(".utility-bar").offset().top;
        if (
          $(window).width() < 768 &&
          this.previousScrollTop > window.scrollY &&
          window.scrollY > utilityBarOffsetY
        ) {
          $("body").addClass("utility-bar-sticky-mobile-copy-reveal");
        } else {
          $("body.utility-bar-sticky-mobile-copy-reveal").removeClass(
            "utility-bar-sticky-mobile-copy-reveal",
          );
        }
        this.previousScrollTop = window.scrollY;
      },

      ajaxLoadLink: function ajaxLoadLink(evt) {
        evt.preventDefault();
        this.functions.ajaxLoadUrl.call(
          this,
          $(evt.currentTarget).attr("href"),
        );
      },

      ajaxLoadForm: function ajaxLoadForm(evt) {
        if (evt.type === "submit") {
          evt.preventDefault();
        }
        var queryVals = [];
        evt.currentTarget.querySelectorAll("input, select").forEach((input) => {
          if (
            ((input.type !== "checkbox" && input.type !== "radio") ||
              input.checked) && // is an active input value
            input.value !== "" // has a value
          ) {
            queryVals.push([input.name, encodeURIComponent(input.value)]);
          }
        });
        // new url
        var newUrl = location.pathname;
        queryVals.forEach((value) => {
          newUrl += "&".concat(value[0], "=").concat(value[1]);
        });
        newUrl = newUrl.replace("&", "?");
        // load
        this.functions.ajaxLoadUrl.call(this, newUrl);
      },

      ajaxPopState: function ajaxPopState(event) {
        this.functions.ajaxLoadUrl.call(this, document.location.href, true);
      },

      ajaxLoadUrl: function ajaxLoadUrl(url, noPushState) {
        if (!noPushState) {
          // update url history
          var fullUrl = url;
          if (fullUrl.slice(0, 1) === "/") {
            fullUrl =
              window.location.protocol + "//" + window.location.host + fullUrl;
          }
          window.history.pushState({ path: fullUrl }, "", fullUrl);
        }

        // start fetching URL
        var refreshContainerSelector = "[data-ajax-container]",
          $ajaxContainers = this.$container.find(refreshContainerSelector);

        // loading state
        $ajaxContainers.addClass("ajax-loading");

        // fetch content
        if (this.currentAjaxLoadUrlFetch) {
          this.currentAjaxLoadUrlFetch.abort();
        }
        this.currentAjaxLoadUrlFetch = $.get(
          url,
          function (data) {
            this.currentAjaxLoadUrlFetch = null;

            // save active element
            if (document.activeElement) {
              this.activeElementId = document.activeElement.id;
            }

            // unload content
            theme.ProductBlockManager.unloadImages(this.$container);

            // replace contents
            var $newAjaxContainers = $("<div>".concat(data, "</div>")).find(
              refreshContainerSelector,
            );
            $newAjaxContainers.each(function (index) {
              $($ajaxContainers[index]).html($(this).html());
            });

            // init js
            this.functions.initFiltersEtc.call(this);

            // init theme components
            var $componentHaver = this.$container.closest("[data-components]");
            if ($componentHaver.length) {
              var components = $componentHaver.data("components").split(",");
              components.forEach(
                function (component) {
                  $(document).trigger("cc:component:load", [
                    component,
                    $componentHaver[0],
                  ]);
                }.bind(this),
              );
            }

            // remove loading state
            $ajaxContainers.removeClass("ajax-loading");

            // init scroll animations
            theme.initAnimateOnScroll();

            // restore active element
            if (this.activeElementId) {
              var el = document.getElementById(this.activeElementId);
              if (el) {
                el.focus();
              }
            }

            // scroll viewport (must be done after any page size changes)
            var scrollToY =
              $("[data-ajax-scroll-to]:first", this.$container).offset().top -
              $(".section-header").height();
            window.scrollTo({
              top: scrollToY,
              behavior: "smooth",
            });
          }.bind(this),
        );
      },
    };

    // ajax filter & sort
    if (this.$container.data("ajax-filtering")) {
      // ajax load on link click
      this.$container.on(
        "click" + this.namespace,
        ".link-dropdown__link, .filter-group__applied-item, .filter-group__clear-link, .pagination a",
        this.functions.ajaxLoadLink.bind(this),
      );
      // ajax load form submission
      this.$container.on(
        "change" + this.namespace + " submit" + this.namespace,
        "#CollectionFilterForm",
        theme.debounce(this.functions.ajaxLoadForm.bind(this), 700),
      );
      // handle back button
      this.registerEventListener(
        window,
        "popstate",
        this.functions.ajaxPopState.bind(this),
      );
    } else {
      this.$container.on(
        "change" + this.namespace,
        "#CollectionFilterForm",
        function () {
          $(this).submit();
        },
      );
    }
    //尺寸和类型筛选处理
    $(document).on("click", ".js-filter-group__checkbox", function (val) {
      const sizeEle = $(".js-filter-group__checkbox.size");
      const sizeItem = $(".js-filter-item-size");
      if ($(this).hasClass("category")) {
        const currAllSize = $(this).data("sizes");
        sizeEle.prop("checked", false);
        $(".js-filter-group__checkbox")
          .parent()
          .removeClass("filter-group__item--active");
        sizeItem.each((index, item) => {
          const size = $(item).data("size");
          if (currAllSize.includes(size)) {
            $(item).removeClass("hide");
          } else {
            $(item).addClass("hide");
          }
        });
      } else {
        if ($(this).parent().hasClass("filter-group__item--active")) {
          $(this).prop("checked", false);
        }
        sizeItem.removeClass("filter-group__item--active");
      }
      const formData = $("#CollectionFilterForm").serialize(); // 获取整个表单的数据并序列化
      const checked = $(this).prop("checked");
      if (checked) {
        $(this).parent().addClass("filter-group__item--active");
      }
      const sectionId = $(this).attr("section-id");
      const currCollectionList = $(`#shopify-section-${sectionId}`).find(
        ".collection-listing",
      );
      const url = `${window.location.origin}${window.location.pathname}?${formData}`;
      const loading = ` <span class="loading">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
                    <radialGradient id="a3" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)"><stop offset="0" stop-color="#000000"></stop><stop offset=".3" stop-color="#000000" stop-opacity=".9"></stop><stop offset=".6" stop-color="#000000" stop-opacity=".6"></stop><stop offset=".8" stop-color="#000000" stop-opacity=".3"></stop><stop offset="1" stop-color="#000000" stop-opacity="0"></stop></radialGradient><circle transform-origin="center" fill="none" stroke="url(#a3)" stroke-width="15" stroke-linecap="round" stroke-dasharray="200 1000" stroke-dashoffset="0" cx="100" cy="100" r="70"><animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="2" values="360;0" keyTimes="0;1" keySplines="0 0 1 1" repeatCount="indefinite"></animateTransform></circle><circle transform-origin="center" fill="none" opacity=".2" stroke="#000000" stroke-width="15" stroke-linecap="round" cx="100" cy="100" r="70"></circle>
                  </svg>
                </span>`;
      currCollectionList.html(loading);
      $.get(`${url}&section_id=${sectionId}`, function (response) {
        const collectionHtml = $(response).find(".collection-listing").html();
        currCollectionList.html(collectionHtml);
        history.replaceState(null, "", url);
      });
    });
    // sort dropdown: open
    this.$container.on(
      "click" + this.namespace,
      ".link-dropdown__button",
      theme.toggleLinkDropdownButton.bind(this),
    );

    // sort dropdown: click anywhere else in page to close
    $(document).on("click" + this.namespace, function () {
      $('.link-dropdown__button[aria-expanded="true"]').trigger("click");
    });

    if (document.querySelector(".utility-bar")) {
      // duplicate utility bar for mobile
      var $utilBarClone = $(".utility-bar")
        .clone()
        .addClass("utility-bar--sticky-mobile-copy")
        .removeAttr("data-ajax-container")
        .insertAfter(".utility-bar");
      // ensure unique ids
      theme.suffixIds($utilBarClone[0], "dupe");

      this.previousScrollTop = window.scrollY;
      $(window).on(
        "throttled-scroll" + this.namespace,
        this.functions.checkStickyScroll.bind(this),
      );

      // filter visibility
      this.$container.on(
        "click" + this.namespace,
        "[data-toggle-filters]",
        function (evt) {
          var isNowVisible = $(".filter-container", this.$container)
            .toggleClass(
              "filter-container--show-filters-desktop filter-container--show-filters-mobile",
            )
            .hasClass("filter-container--show-filters-desktop");
          $(".toggle-btn[data-toggle-filters]", this.$container).toggleClass(
            "toggle-btn--revealed-desktop",
            isNowVisible,
          );
          // handle resized collection grid
          theme.ProductBlockManager.afterImagesResized();
          $(".slick-slider", this.$container).each(function () {
            $(this).slick("setPosition");
          });
          return false;
        }.bind(this),
      );

      // layout switcher
      this.$container.on(
        "click" + this.namespace,
        ".layout-switch",
        this.functions.switchGridLayout.bind(this),
      );
    }

    // init things that may need re-initialising on ajax load
    this.functions.initFiltersEtc.call(this);

    this.destroy = function () {
      theme.ProductBlockManager.unloadImages(this.$container);
      theme.destroyProductGallery(this.$container);
      this.$container.off(this.namespace);
      $(window).off(this.namespace);
      $(document).off(this.namespace);
    }.bind(this);
  };

  theme.buildGalleryViewer = function (config) {
    // create viewer
    var $allContainer = $(
        '<div class="gallery-viewer gallery-viewer--pre-reveal">',
      ),
      $zoomContainer = $(
        '<div class="gallery-viewer__zoom-container">',
      ).appendTo($allContainer),
      $thumbContainer = $('<div class="gallery-viewer__thumbs">').appendTo(
        $allContainer,
      ),
      $controlsContainer = $('<div class="gallery-viewer__controls">').appendTo(
        $allContainer,
      ),
      $close = $(
        '<a class="gallery-viewer__button gallery-viewer__close" href="#">',
      )
        .html(config.close)
        .appendTo($controlsContainer),
      $right = $(
        '<a class="gallery-viewer__button gallery-viewer__prev" href="#">',
      )
        .html(config.prev)
        .appendTo($controlsContainer),
      $left = $(
        '<a class="gallery-viewer__button gallery-viewer__next" href="#">',
      )
        .html(config.next)
        .appendTo($controlsContainer),
      $currentZoomImage = null,
      wheelZoomMultiplier = -0.001,
      pinchZoomMultiplier = 0.003,
      touchPanModifier = 1.0,
      currentTransform = {
        panX: 0,
        panY: 0,
        zoom: 1,
      };

    // add images
    for (var i = 0; i < config.images.length; i++) {
      var img = config.images[i];
      $('<a class="gallery-viewer__thumb" href="#">')
        .data("zoom-url", img.zoomUrl)
        .html(img.thumbTag)
        .appendTo($thumbContainer);
    }

    if (config.images.length === 1) {
      $allContainer.addClass("gallery-viewer--single-image");
    }

    // helper function for panning an image
    var panZoomImageFromCoordinate = function panZoomImageFromCoordinate(
      inputX,
      inputY,
    ) {
      // do nothing if the image fits, pan if not
      var doPanX = $currentZoomImage.width() > $allContainer.width();
      var doPanY = $currentZoomImage.height() > $allContainer.height();
      if (doPanX || doPanY) {
        var midX = $allContainer.width() / 2;
        var midY = $allContainer.height() / 2;

        var offsetFromCentreX = inputX - midX,
          offsetFromCentreY = inputY - midY;

        // the offsetMultipler ensures it can only pan to the edge of the image, no further
        var finalOffsetX = 0;
        var finalOffsetY = 0;
        if (doPanX) {
          var offsetMultiplierX =
            ($currentZoomImage.width() - $allContainer.width()) / 2 / midX;
          finalOffsetX = Math.round(-offsetFromCentreX * offsetMultiplierX);
        }
        if (doPanY) {
          var offsetMultiplierY =
            ($currentZoomImage.height() - $allContainer.height()) / 2 / midY;
          finalOffsetY = Math.round(-offsetFromCentreY * offsetMultiplierY);
        }

        currentTransform.panX = finalOffsetX;
        currentTransform.panY = finalOffsetY;
        alterCurrentPanBy(0, 0); // sanitise
        updateImagePosition();
      }
    };

    var alterCurrentPanBy = function alterCurrentPanBy(x, y) {
      currentTransform.panX += x;
      // limit offset to keep most of image on screen
      var panXMax =
        ($currentZoomImage[0].naturalWidth * currentTransform.zoom -
          $allContainer.width()) /
        2.0;
      panXMax = Math.max(panXMax, 0);
      currentTransform.panX = Math.min(currentTransform.panX, panXMax);
      currentTransform.panX = Math.max(currentTransform.panX, -panXMax);

      currentTransform.panY += y;
      var panYMax =
        ($currentZoomImage[0].naturalHeight * currentTransform.zoom -
          $allContainer.height()) /
        2.0;
      panYMax = Math.max(panYMax, 0);
      currentTransform.panY = Math.min(currentTransform.panY, panYMax);
      currentTransform.panY = Math.max(currentTransform.panY, -panYMax);
      updateImagePosition();
    };

    var setCurrentTransform = function setCurrentTransform(panX, panY, zoom) {
      currentTransform.panX = panX;
      currentTransform.panY = panY;
      currentTransform.zoom = zoom;
      alterCurrentTransformZoomBy(0);
    };

    var alterCurrentTransformZoomBy = function alterCurrentTransformZoomBy(
      delta,
    ) {
      currentTransform.zoom += delta;
      // do not zoom out further than fit
      var maxZoomX = $allContainer.width() / $currentZoomImage[0].naturalWidth,
        maxZoomY = $allContainer.height() / $currentZoomImage[0].naturalHeight;
      currentTransform.zoom = Math.max(
        currentTransform.zoom,
        Math.min(maxZoomX, maxZoomY),
      );

      // do not zoom in further than native size
      currentTransform.zoom = Math.min(currentTransform.zoom, 1.0);

      // reasses pan bounds
      alterCurrentPanBy(0, 0);
      updateImagePosition();
    };

    var updateImagePosition = function updateImagePosition() {
      // $currentZoomImage.css(
      // 'transform', "translate3d(".concat(currentTransform.panX, "px, ").concat(currentTransform.panY, "px, 0) scale(").concat(currentTransform.zoom, ")"));
    };

    // set up events
    // event: select thumbnail - zoom it
    $allContainer.on(
      "click.galleryViewer select.galleryViewer",
      ".gallery-viewer__thumb",
      function (evt) {
        evt.preventDefault();

        // set active
        $(this)
          .addClass("gallery-viewer__thumb--active")
          .siblings(".gallery-viewer__thumb--active")
          .removeClass("gallery-viewer__thumb--active");

        // replace zoom image
        $currentZoomImage = $(
          '<img class="gallery-viewer__zoom-image" alt="" style="visibility: hidden">',
        );
        $currentZoomImage
          .on("load", function () {
            $(this).off("load");
            $(this).css({
              visibility: "",
              // top: $allContainer.height() / 2 - $(this).height() / 2,
              // left: $allContainer.width() / 2 - $(this).width() / 2
            });

            // setCurrentTransform(0, 0, 0); // centre, zoomed out
          })
          .attr("src", $(this).data("zoom-url"));

        $zoomContainer.html($currentZoomImage);
      },
    );

    // event: pan
    var pinchTracking = {
      isTracking: false,
      lastPinchDistance: 0,
    };

    var touchTracking = {
      isTracking: false,
      lastTouchX: 0,
      lastTouchY: 0,
    };

    $allContainer.on("touchend.galleryViewer", function (evt) {
      pinchTracking.isTracking = false;
      touchTracking.isTracking = false;
    });

    $allContainer.on(
      "mousemove.galleryViewer touchmove.galleryViewer",
      function (evt) {
        evt.preventDefault();
        if (evt.type === "touchmove" && evt.touches.length > 0) {
          // pan
          var touch1 = evt.touches[0];
          if (!touchTracking.isTracking) {
            touchTracking.isTracking = true;
            touchTracking.lastTouchX = touch1.clientX;
            touchTracking.lastTouchY = touch1.clientY;
          } else {
            alterCurrentPanBy(
              (touch1.clientX - touchTracking.lastTouchX) * touchPanModifier,
              (touch1.clientY - touchTracking.lastTouchY) * touchPanModifier,
            );

            touchTracking.lastTouchX = touch1.clientX;
            touchTracking.lastTouchY = touch1.clientY;
          }

          if (evt.touches.length === 2) {
            // pinch
            var touch2 = evt.touches[1],
              pinchDistance = Math.sqrt(
                Math.pow(touch1.clientX - touch2.clientX, 2) +
                  Math.pow(touch1.clientY - touch2.clientY, 2),
              );
            if (!pinchTracking.isTracking) {
              pinchTracking.lastPinchDistance = pinchDistance;
              pinchTracking.isTracking = true;
            } else {
              var pinchDelta = pinchDistance - pinchTracking.lastPinchDistance;
              alterCurrentTransformZoomBy(pinchDelta * pinchZoomMultiplier);
              pinchTracking.lastPinchDistance = pinchDistance;
            }
          } else {
            pinchTracking.isTracking = false;
          }
        } else {
          // mousemove
          panZoomImageFromCoordinate(evt.clientX, evt.clientY);
        }
      },
    );

    // event: mousewheel
    $allContainer.on("wheel.galleryViewer", function (evt) {
      evt.preventDefault();
      if (evt.originalEvent.deltaY != 0) {
        alterCurrentTransformZoomBy(
          evt.originalEvent.deltaY * wheelZoomMultiplier,
        );
      }
    });

    // event: prevent pan while swiping thumbnails
    $allContainer.on(
      "touchmove.galleryViewer",
      ".gallery-viewer__thumbs",
      function (evt) {
        evt.stopPropagation();
      },
    );

    // event: next thumbnail
    $allContainer.on(
      "click.galleryViewer",
      ".gallery-viewer__next",
      function (evt) {
        evt.preventDefault();
        var $next = $thumbContainer
          .find(".gallery-viewer__thumb--active")
          .next();
        if ($next.length === 0) {
          $next = $thumbContainer.find(".gallery-viewer__thumb:first");
        }
        $next.trigger("select");
      },
    );

    // event: previous thumbnail
    $allContainer.on(
      "click.galleryViewer",
      ".gallery-viewer__prev",
      function (evt) {
        evt.preventDefault();
        var $prev = $thumbContainer
          .find(".gallery-viewer__thumb--active")
          .prev();
        if ($prev.length === 0) {
          $prev = $thumbContainer.find(".gallery-viewer__thumb:last");
        }
        $prev.trigger("select");
      },
    );

    // event: close (button)
    $allContainer.on(
      "click.galleryViewer",
      ".gallery-viewer__close",
      function (evt) {
        evt.preventDefault();
        theme.galleryViewerFunctions.close();
      },
    );

    // event: close (esc key)
    document.addEventListener(
      "keyup",
      theme.galleryViewerFunctions.onDocumentKeyup,
    );

    // event: zoom
    $allContainer.on(
      "click.galleryViewer",
      ".gallery-viewer__zoom-container",
      function (evt) {
        evt.preventDefault();
        if (currentTransform.zoom == 1.0) {
          currentTransform.zoom = 0;
          alterCurrentTransformZoomBy(0);
        } else {
          currentTransform.zoom = 1;
          alterCurrentTransformZoomBy(0);
          panZoomImageFromCoordinate(evt.clientX, evt.clientY);
        }
      },
    );

    // initialise

    // - clear any remnants of failed previous closure
    $("html").removeClass("gallery-viewer-open");
    $(".gallery-viewer").remove();

    // - insert into page
    $("html").addClass("gallery-viewer-open");
    $allContainer.appendTo("body");

    // - select first thumbnail
    var currentIndex = 0;
    if (config.currentImage) {
      config.images.forEach((img, index) => {
        if (config.currentImage === img.zoomUrl) {
          currentIndex = index;
        }
      });
    }
    $thumbContainer
      .find(".gallery-viewer__thumb:eq(" + currentIndex + ")")
      .trigger("select")
      .focus();

    // - reveal
    setTimeout(function () {
      $allContainer.removeClass("gallery-viewer--pre-reveal");
    }, 10);
  };

  theme.galleryViewerFunctions = {
    close: function close() {
      var $galleryViewer = $(".gallery-viewer");

      // destroy events
      $galleryViewer.off(".galleryViewer");
      document.removeEventListener(
        "keyup",
        theme.galleryViewerFunctions.onDocumentKeyup,
      );

      // begin exit transition
      $galleryViewer.addClass("gallery-viewer--transition-out");

      // remove after transition
      var transitionDelay = $galleryViewer.css("transition-duration");
      transitionDelay =
        transitionDelay.indexOf("ms") > -1
          ? parseFloat(transitionDelay)
          : parseFloat(transitionDelay) * 1000;
      setTimeout(function () {
        $galleryViewer.remove();
        $("html").removeClass("gallery-viewer-open");
      }, transitionDelay);
    },

    onDocumentKeyup: function onDocumentKeyup(evt) {
      switch (evt.key) {
        case "Escape":
          theme.galleryViewerFunctions.close();
          break;
        case "ArrowLeft":
          $(".gallery-viewer__prev").trigger("click");
          break;
        case "ArrowRight":
          $(".gallery-viewer__next").trigger("click");
          break;
      }
    },
  };

  theme.Navigation = {
    init: function init(options) {
      if (options.nav.length == 0) {
        return;
      }

      var $nav = options.nav,
        navHoverDelay = 250,
        $navLastOpenDropdown = $(),
        navOpenTimeoutId = -1;

      /// Mobile nav

      // create it
      var $mobileDrawer = $(options.mobileNavHtml);

      // add announcement bar items
      var $mobileDrawerFooter = $(
        '<div class="mobile-navigation-drawer__footer">',
      ).appendTo($mobileDrawer);
      $mobileDrawerFooter.append(
        $(".announcement-bar .inline-menu").clone().removeClass("desktop-only"),
      );
      $mobileDrawerFooter.append(
        $(".announcement-bar .header-disclosures")
          .clone()
          .removeClass("desktop-only"),
      );
      $mobileDrawerFooter.append(
        $(".announcement-bar .social-links")
          .clone()
          .removeClass("desktop-only"),
      );

      // insert into page
      $mobileDrawer.insertAfter($("#shopify-section-header"));

      // event: open second tier
      $mobileDrawer.on(
        "click",
        ".navigation__tier-1 > .navigation__item > .navigation__children-toggle",
        function (evt) {
          evt.preventDefault();

          // set text in header
          $(this)
            .parent()
            .addClass("navigation__item--open")
            .closest(".mobile-navigation-drawer")
            .addClass("mobile-navigation-drawer--child-open")
            .find(".mobile-nav-title")
            .text($(this).siblings(".navigation__link").text());

          // position under header
          $(this)
            .siblings(".navigation__tier-2-container")
            .css({
              top:
                Math.ceil($(".navigation__mobile-header:last").height() + 1) +
                "px",
            });

          // scroll container
          this.closest(".mobile-navigation-drawer").scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
        },
      );

      if ($mobileDrawer.data("mobile-expand-with-entire-link")) {
        $mobileDrawer.on(
          "click",
          ".navigation__item--with-children > .navigation__link",
          function (evt) {
            evt.preventDefault();
            $(this).siblings(".navigation__children-toggle").trigger("click");
          },
        );
      }

      // event: close second tier
      $mobileDrawer.on("click", ".mobile-nav-back", function (evt) {
        evt.preventDefault();
        $(this)
          .closest(".mobile-navigation-drawer")
          .removeClass("mobile-navigation-drawer--child-open")
          .find(".navigation__tier-1 > .navigation__item--open")
          .removeClass("navigation__item--open");
      });

      // event: toggle third tier
      $mobileDrawer.on(
        "click",
        ".navigation__tier-2 > .navigation__item > .navigation__children-toggle",
        function (evt) {
          evt.preventDefault();
          var doOpen = !$(this).parent().hasClass("navigation__item--open");
          if (doOpen) {
            $(this).parent().addClass("navigation__item--open");
            var $childContainer = $(this).siblings(
              ".navigation__tier-3-container",
            );
            $childContainer.css(
              "height",
              $childContainer.children().outerHeight(),
            );
          } else {
            $(this).parent().removeClass("navigation__item--open");
            $(this).siblings(".navigation__tier-3-container").css("height", "");
          }
        },
      );

      /// Desktop nav

      // reveal images
      $nav
        .find(".lazyload--manual")
        .removeClass("lazyload--manual")
        .addClass("lazyload");

      // hover events
      $nav.on(
        "mouseenter mouseleave",
        ".navigation__tier-1 > .navigation__item--with-children",
        function (evt, data) {
          var $dropdownContainer = $(this);
          // delay on hover-out
          if (evt.type == "mouseenter") {
            clearTimeout(navOpenTimeoutId);
            clearTimeout($dropdownContainer.data("navCloseTimeoutId"));
            var $openSiblings = $dropdownContainer.siblings(
              ".navigation__item--show-children",
            );

            // close all menus but last opened
            $openSiblings
              .not($navLastOpenDropdown)
              .removeClass("navigation__item--show-children");
            $navLastOpenDropdown = $dropdownContainer;

            // show after a delay, based on first-open or not
            var timeoutDelay = $openSiblings.length == 0 ? 0 : navHoverDelay;

            // open it
            var newNavOpenTimeoutId = setTimeout(function () {
              $dropdownContainer
                .addClass("navigation__item--show-children")
                .siblings(".navigation__item--show-children")
                .removeClass("navigation__item--show-children");
              $dropdownContainer
                .closest(".section-header")
                .addClass("section-header--nav-open");
            }, timeoutDelay);

            navOpenTimeoutId = newNavOpenTimeoutId;
            $dropdownContainer.data("navOpenTimeoutId", newNavOpenTimeoutId);
          } else {
            // cancel opening, close after delay, and clear transforms
            clearTimeout($dropdownContainer.data("navOpenTimeoutId"));
            $dropdownContainer.data(
              "navCloseTimeoutId",
              setTimeout(function () {
                $dropdownContainer.removeClass(
                  "navigation__item--show-children",
                );
                $dropdownContainer
                  .closest(".section-header")
                  .removeClass("section-header--nav-open");
              }, navHoverDelay),
            );
          }
          // a11y
          $dropdownContainer
            .children("[aria-expanded]")
            .attr("aria-expanded", evt.type == "mouseenter");
        },
      );

      // touch events on desktop
      var touchHandler = function touchHandler(evt) {
        if ($(window).width() > 767) {
          if (evt.type == "touchstart") {
            $(this).data("touchstartedAt", evt.timeStamp);
          } else if (evt.type == "touchend") {
            // down & up in under a second - presume tap
            if (evt.timeStamp - $(this).data("touchstartedAt") < 1000) {
              $(this).data("touchOpenTriggeredAt", evt.timeStamp);
              if (
                $(this).parent().hasClass("navigation__item--show-children")
              ) {
                // trigger close
                $(this).parent().trigger("mouseleave");
              } else {
                // trigger close on any open items
                $(".navigation:first .navigation__item--show-children").trigger(
                  "mouseleave",
                );
                // trigger open
                $(this).parent().trigger("mouseenter");
              }
              // prevent fake click
              return false;
            }
          } else if (evt.type == "click") {
            // if touch open was triggered very recently, prevent click event
            if (
              $(this).data("touchOpenTriggeredAt") &&
              evt.timeStamp - $(this).data("touchOpenTriggeredAt") < 1000
            ) {
              return false;
            }
          }
        }
      };
      $nav.on(
        "touchstart touchend click",
        ".navigation__tier-1 > .navigation__item--with-children > .navigation__link",
        touchHandler,
      );

      // hit return on dropdown toggle
      var keydownHandler = function keydownHandler(evt) {
        if (evt.which == 13) {
          var $parent = $(this).parent();
          $parent.trigger(
            $parent.hasClass("navigation__item--show-children")
              ? "mouseleave"
              : "mouseenter",
          );
          return false;
        }
      };
      $nav.on(
        "keydown",
        ".navigation__tier-1 > .navigation__item--with-children > .navigation__children-toggle",
        keydownHandler,
      );

      // proxy for desktop nav interaction events
      if (options.proxyTier1Nav) {
        // reposition small menu
        $(options.proxyTier1Nav).on(
          "mouseenter",
          ".navigation__item--with-small-menu",
          function (evt) {
            var $dropdown = $(
              $(".navigation__tier-1 > .navigation__item", $nav)[
                $(this).index()
              ],
            ).find(".navigation__tier-2-container");
            if (document.querySelector("html[dir=rtl]")) {
              $dropdown.css(
                "right",
                $dropdown[0].offsetParent.clientWidth -
                  ($(this).offset().left + this.clientWidth),
              );
            } else {
              $dropdown.css("left", $(this).offset().left);
            }
          },
        );

        // transfer all events to main menu
        $(options.proxyTier1Nav)
          .on(
            "mouseenter mouseleave",
            ".navigation__tier-1 > .navigation__item--with-children",
            function (evt) {
              $(
                $(".navigation__tier-1 > .navigation__item", $nav)[
                  $(this).index()
                ],
              ).trigger(evt.type);
            },
          )
          .on(
            "touchstart touchend click",
            ".navigation__tier-1 > .navigation__item--with-children > .navigation__link",
            function (evt) {
              var response = touchHandler.call(
                $(
                  $(".navigation__tier-1 > .navigation__item", $nav)[
                    $(this).parent().index()
                  ],
                ).children(".navigation__link")[0],
                evt,
              );

              if (response === false) {
                return false;
              }
            },
          )
          .on(
            "keydown",
            ".navigation__tier-1 > .navigation__item--with-children > .navigation__children-toggle",
            function (evt) {
              if (evt.which == 13) {
                keydownHandler.call(
                  $(
                    $(".navigation__tier-1 > .navigation__item", $nav)[
                      $(this).parent().index()
                    ],
                  ).children(".navigation__children-toggle")[0],
                  evt,
                );

                return false;
              }
            },
          );
      }

      // click #-link, open child nav
      $nav.on(
        "click",
        '.navigation__link[href="#"][aria-haspopup="true"]',
        function () {
          $(this).siblings(".navigation__children-toggle").trigger("click");
          return false;
        },
      );

      // transparent header hover
      $nav[0].addEventListener("mouseenter", theme.Navigation.onNavHover);
      $nav[0].addEventListener("mouseleave", theme.Navigation.onNavHover);
      if (options.proxyTier1Nav.length) {
        options.proxyTier1Nav[0].addEventListener(
          "mouseenter",
          theme.Navigation.onNavHover,
        );
        options.proxyTier1Nav[0].addEventListener(
          "mouseleave",
          theme.Navigation.onNavHover,
        );
      }
    },

    onNavHover: function onNavHover(evt) {
      $(evt.target)
        .closest(".section-header")
        .toggleClass("section-header--nav-hover", evt.type === "mouseenter");
    },

    destroy: function destroy($nav, $proxyTier1Nav) {
      $nav
        .add($proxyTier1Nav)
        .off("click mouseenter mouseleave touchstart touchend keydown");
      theme.ProductBlockManager.unloadImages(
        $(".mobile-navigation-drawer .product-list"),
      );
      $(".mobile-navigation-drawer").off("click").remove();
    },
  };

  // Process product block layout
  theme.ProductBlockManager = new (function () {
    var _ = this;

    _.isDesktop = function () {
      return $(window).width() >= 768;
    };

    _.loadImages = function (container) {
      var container = container;
      if (typeof container === "undefined") {
        container = $("body");
      }

      // lazy bg-set - faster in JS
      theme.loadLazyBGSet(container);

      if (_.isDesktop()) {
        // preload hover images after short delay
        setTimeout(() => {
          $(
            ".product-block__image--show-on-hover.product-block__image--inactivated",
            container,
          ).each(function () {
            _.lazyloadImage($(this));
            lazySizes.loader.unveil($(this).find(".lazyload")[0]);
          });
        }, 250);
        // preload first carousel image after a delay
        setTimeout(() => {
          $(
            ".product-block__image--show-on-hover + .product-block__image--inactivated",
            container,
          ).each(function () {
            _.lazyloadImage($(this));
          });
        }, 1000);
      }

      _.monitorImagePagination(container);
      _.monitorSwatchSelection(container);
      _.afterImagesResized(container);
    };

    _.unloadImages = function (container) {
      $(container).off(".productBlockManager");
    };

    // get image at index, safely wraps index
    _.getImageAt = function ($images, index) {
      // positive modulo, like it should be, JS does not do *maths* correctly
      return $images[
        ((index % $images.length) + $images.length) % $images.length
      ];
    };

    _.lazyloadImage = function ($image, onLoadCB) {
      var $toLoad = $image.filter(".product-block__image--inactivated");
      if ($toLoad.length) {
        if (onLoadCB) {
          $toLoad.on("lazyloaded.themeBlockManager", (evt) => {
            if (evt.target === $toLoad.find(".lazyloaded")[0]) {
              onLoadCB();
            }
            $(this).off("lazyloaded.themeBlockManager");
          });
        }
        $toLoad.removeClass("product-block__image--inactivated");
      } else if (onLoadCB) {
        onLoadCB();
      }
    };

    _.incrementActiveImage = function ($images, increment) {
      var index = Math.max(
        $images.filter(".product-block__image--active:first").index(),
        0,
      );
      _.setActiveImage($images, index + increment);
    };

    _.setActiveImage = function ($images, index) {
      var $newActive = $(_.getImageAt($images, index));

      _.lazyloadImage($newActive, () => {
        // set new active image visibility
        $newActive.addClass("product-block__image--active");
        $newActive.siblings().removeClass("product-block__image--active");
        // set new hover image
        var $hoverImage = $(_.getImageAt($images, index + 1)).addClass(
          "product-block__image--show-on-hover",
        );
        $hoverImage
          .siblings()
          .removeClass("product-block__image--show-on-hover");
        _.lazyloadImage($hoverImage);
      });

      // dots
      var $dots = $images
        .closest(".image-cont")
        .find(".product-block__image-dot");
      $dots
        .removeClass("product-block__image-dot--active")
        .eq($newActive.index())
        .addClass("product-block__image-dot--active");
    };

    _.monitorImagePagination = function (container) {
      if ($(".image-cont--with-secondary-image", container).length) {
        // next/prev button selection
        $(container).on(
          "click.productBlockManager",
          ".image-page-button",
          function (evt) {
            var $images = $(this)
              .closest(".product-block")
              .find(".product-block__image");
            _.incrementActiveImage(
              $images,
              $(evt.currentTarget).hasClass("image-page-button--next") ? 1 : -1,
            );
            // preload the rest
            $images.each(function () {
              _.lazyloadImage($(this));
            });
            return false;
          },
        );

        // swipe (when not in a carousel)
        if (
          $(".image-cont--with-secondary-image:first", container).closest(
            ".carousel, .product-list--scrollarea",
          ).length === 0
        ) {
          // preload all images after swipe
          $(container).on("imageSwiped", ".product-block", function () {
            if ($(".product-block__image--inactivated", this).length) {
              setTimeout(
                function () {
                  $(this)
                    .find(".product-block__image")
                    .each(function () {
                      _.lazyloadImage($(this));
                    });
                }.bind(this),
                500,
              );
            }
          });

          $(container).on(
            "touchstart.productBlockManager",
            ".image-cont--with-secondary-image",
            function (evt) {
              theme.productBlockTouchTracking = true;
              theme.productBlockTouchStartX = evt.touches[0].clientX;
              theme.productBlockTouchStartY = evt.touches[0].clientY;
              // preload next image on touchstart
              var nextImage = evt.currentTarget.querySelector(
                ".product-block__image--active + .product-block__image--inactivated",
              );
              if (nextImage) {
                _.lazyloadImage($(nextImage));
              }
            },
          );

          $(container).on(
            "touchmove.productBlockManager",
            ".image-cont--with-secondary-image",
            function (evt) {
              if (theme.productBlockTouchTracking) {
                if (
                  Math.abs(
                    evt.touches[0].clientY - theme.productBlockTouchStartY,
                  ) < 30
                ) {
                  var deltaX =
                    evt.touches[0].clientX - theme.productBlockTouchStartX;
                  if (deltaX > 25) {
                    var $images = $(this)
                      .closest(".product-block")
                      .trigger("imageSwiped")
                      .find(".product-block__image");
                    _.incrementActiveImage($images, -1);
                    theme.productBlockTouchTracking = false;
                  } else if (deltaX < -25) {
                    var $images = $(this)
                      .closest(".product-block")
                      .trigger("imageSwiped")
                      .find(".product-block__image");
                    _.incrementActiveImage($images, 1);
                    theme.productBlockTouchTracking = false;
                  }
                }
              }
            },
          );
          $(container).on(
            "touchend.productBlockManager",
            ".image-cont--with-secondary-image",
            function (evt) {
              theme.productBlockTouchTracking = false;
            },
          );
        }
      }
    };

    _.monitorSwatchSelection = function (container) {
      if ($("[data-media].product-block-options__item", container).length) {
        $(container).on(
          "mouseenter.productBlockManager click.productBlockManager",
          "[data-media].product-block-options__item",
          function () {
            var $block = $(this).closest(".product-block");
            var $images = $block.find(".product-block__image");
            var index = $images
              .filter(
                '[data-media-id="' +
                  $(this).data("media") +
                  '"].product-block__image',
              )
              .index();
            _.setActiveImage($images, index);
            // include in URL
            var optionName = encodeURIComponent(
                $(this).closest(".product-block-options").data("option-name"),
              ),
              optionValue = encodeURIComponent($(this).data("option-item"));
            $block[0]
              .querySelectorAll(".product-link, .quickbuy-toggle")
              .forEach((el) => {
                var url = new URL(el.href);
                var params = new URLSearchParams(url.search);
                params.set(optionName, optionValue);
                el.href = "".concat(url.pathname, "?").concat(params);
                el.rel = "nofollow";
              });
          },
        );
      }
    };

    _.afterImagesResized = function (container) {
      var container = container;
      if (typeof container === "undefined") {
        container = $("body");
      }

      _.alignProductBlockHeights(container);
    };

    _.alignProductBlockHeights = function (container) {
      var container = container;
      if (typeof container === "undefined") {
        container = $("body");
      }

      // All product blocks must be the same height, for quick-buy alignment
      $(".collection-listing .product-list", container).each(function () {
        if (
          $(window).width() >= 768 ||
          $(this).closest(".carousel").length > 0
        ) {
          var tallest = 0;
          $(this)
            .find(".product-block .block-inner .block-inner-inner")
            .each(function () {
              if ($(this).height() > tallest) tallest = $(this).height();
            });
          $(this)
            .find(".product-block .block-inner")
            .css("min-height", tallest);
        } else {
          $(this).find(".product-block .block-inner").css("min-height", "");
        }
      });
    };
  })();

  // container must be an element higher up the tree than the gallery
  theme.initProductGallery = function (container) {
    var $gallery = $(".gallery", container);
    if ($gallery.hasClass("gallery-initialised")) {
      return;
    }

    $gallery.addClass("gallery-initialised");

    /// Variant grouping
    if (
      $gallery.data("variant-image-grouping") &&
      $gallery.data("variant-image-grouping-option-index") !== ""
    ) {
      var productData = theme.OptionManager.getProductData(
          $gallery.closest(".product-detail").find(".product-form"),
        ),
        groupingOptionIndex = $gallery.data(
          "variant-image-grouping-option-index",
        );
      // build map of grouping options and featured media
      var optionNameMediaMap = {};
      productData.media.forEach((media) => {
        productData.variants.forEach((variant) => {
          if (variant.featured_media && variant.featured_media.id == media.id) {
            if (!optionNameMediaMap[variant.options[groupingOptionIndex]]) {
              optionNameMediaMap[variant.options[groupingOptionIndex]] =
                media.id;
            }
          }
        });
      });
      // set option name on each image
      var currentMediaOptionName = "";
      $gallery.find(".slide").each(function (index, item) {
        for (var optionName in optionNameMediaMap) {
          if ($(item).data("media-id") == optionNameMediaMap[optionName]) {
            currentMediaOptionName = optionName;
          }
        }
        $(item).attr("data-variant-image-group", currentMediaOptionName);
      });
      currentMediaOptionName = "";
      $gallery.find(".thumbnail").each(function (index, item) {
        for (var optionName in optionNameMediaMap) {
          if ($(item).data("media-id") == optionNameMediaMap[optionName]) {
            currentMediaOptionName = optionName;
          }
        }
        $(item).attr("data-variant-image-group", currentMediaOptionName);
      });
    }

    /// Init main image slideshow
    var $slideshow = $(".product-slideshow", container);
    if ($slideshow.length) {
      var slickConfig = {
        autoplay: false,
        fade: false,
        infinite: false,
        useTransform: true,
        dots: false,
        arrows: false,
        waitForAnimate: false,
        appendArrows: $slideshow
          .siblings(".slideshow-controls")
          .find(".slideshow-controls__arrows"),
        prevArrow:
          '<button type="button" class="slick-product-prev" aria-label="' +
          theme.strings.previous +
          '">' +
          theme.icons.chevronLeft +
          "</button>",
        nextArrow:
          '<button type="button" class="slick-product-next" aria-label="' +
          theme.strings.next +
          '">' +
          theme.icons.chevronRight +
          "</button>",
        mobileFirst: true,
        rtl: document.querySelector("html[dir=rtl]") ? true : false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              fade: true,
              arrows: true,
            },
          },
        ],
      };

      $slideshow
        .on("init", function (evt, slick) {
          $(".lazyload--manual", this)
            .removeClass("lazyload--manual")
            .addClass("lazyload");
        })
        .on("beforeChange", function (evt, slick, current, next) {
          var mediaId = $(slick.$slides[next]).data("media-id");
          $(
            $(this)
              .closest(".gallery")
              .find(
                '.thumbnails:not(.hidden) .thumbnail[data-media-id="' +
                  mediaId +
                  '"]',
              ),
          ).trigger("selectFromSlick");
        });

      if (
        $slideshow.closest(
          ".gallery--layout-carousel-beside, .gallery--layout-carousel-under",
        ).length
      ) {
        // carousel layout - slideshow all the time
        $slideshow.slick(slickConfig);
      } else {
        // collage layout - slideshow on mobile only
        var enforceMobileSlideshow = function enforceMobileSlideshow() {
          if ($(window).width() < 768) {
            $slideshow.not(".slick-slider").each(function () {
              // remove desktop collage filter classes
              $(this)
                .find(".slide--inactive-option")
                .removeClass("slide--inactive-option");
              // init slideshow
              $(this).slick(slickConfig);
              // trigger variant select
              $(this)
                .closest(".product-detail")
                .find(".original-selector")
                .trigger("change");
            });
          } else {
            $slideshow.filter(".slick-slider").each(function () {
              $(this).slick("slickUnfilter").slick("unslick");
              // trigger variant select
              $(this)
                .closest(".product-detail")
                .find(".original-selector")
                .trigger("change");
            });
          }
        };
        enforceMobileSlideshow();
        $(window).on("debouncedresize.productGallery", enforceMobileSlideshow);
      }

      // media initialisation
      theme.ProductMedia.init($gallery, {
        onPlyrInit: function onPlyrInit(playerObj) {
          if ($slideshow.hasClass("slick-slider")) {
            theme.productGallerySlideshowTabFix(
              $slideshow.slick("getSlick").$slides,
              $slideshow.slick("getSlick").currentSlide,
            );
          }
        },
        onYoutubeInit: function onYoutubeInit(playerObj) {
          if ($slideshow.hasClass("slick-slider")) {
            theme.productGallerySlideshowTabFix(
              $slideshow.slick("getSlick").$slides,
              $slideshow.slick("getSlick").currentSlide,
            );
          }
        },
        onModelViewerInit: function onModelViewerInit(element) {
          if ($slideshow.hasClass("slick-slider")) {
            theme.productGallerySlideshowTabFix(
              $slideshow.slick("getSlick").$slides,
              $slideshow.slick("getSlick").currentSlide,
            );
          }
        },
        onVideoVisible: function onVideoVisible(e) {
          if ($(window).width() >= 768) {
            $(e.target)
              .closest(".slick-slider")
              .slick("slickSetOption", "swipe", false);
          }
        },
        onVideoHidden: function onVideoHidden(e) {
          if ($(window).width() >= 768) {
            $(e.target)
              .closest(".slick-slider")
              .slick("slickSetOption", "swipe", true);
          }
        },
        onPlyrPlay: function onPlyrPlay(e) {
          $(e.target)
            .closest(".slick-slider")
            .slick("slickSetOption", "swipe", false);
        },
        onPlyrPause: function onPlyrPause(e) {
          $(e.target)
            .closest(".slick-slider")
            .slick("slickSetOption", "swipe", true);
        },
        onModelViewerPlay: function onModelViewerPlay(e) {
          // prevent swiping
          $(e.target)
            .closest(".slick-slider")
            .slick("slickSetOption", "swipe", false);
          // prevent left/right key control
          $(e.target)
            .closest(".slick-slider")
            .slick("slickSetOption", "accessibility", false);
        },
        onModelViewerPause: function onModelViewerPause(e) {
          $(e.target)
            .closest(".slick-slider")
            .slick("slickSetOption", "swipe", true);
          $(e.target)
            .closest(".slick-slider")
            .slick("slickSetOption", "accessibility", true);
        },
      });

      // fix tabindex for first slide
      if ($slideshow.hasClass("slick-slider")) {
        theme.productGallerySlideshowTabFix(
          $slideshow.slick("getSlick").$slides,
          $slideshow.slick("getSlick").currentSlide,
        );
      }

      $slideshow.on("afterChange", function (evt, slick, current) {
        // notify media of visibility
        $(".product-media--activated")
          .removeClass("product-media--activated")
          .trigger("mediaHidden");
        $(".product-media", slick.$slides[current])
          .addClass("product-media--activated")
          .trigger("mediaVisible");
        // fix tabbing
        theme.productGallerySlideshowTabFix(slick.$slides, current);
        // resize quickbuy
        $(this).closest(".quickbuy-container").trigger("changedsize");
      });

      // if in quickbuy, trigger resize after slideshow change
      if ($(container).closest(".collection-listing").length > 0) {
        $slideshow.on("afterChange", function () {
          $(this).closest(".quickbuy-container").trigger("changedsize");
        });
      }
    }

    var $thumbnails = $(".thumbnails:not(.hidden)", container);
    if ($thumbnails.length) {
      var carouselVisibleItemCount = 6,
        isCarousel = false;

      /// Screen-width based initialisation of thumbnail carousels
      var assessCarousel = function assessCarousel() {
        if ($thumbnails.parent().css("display") == "flex") {
          // thumbnail container is in column beside main image - destroy carousel
          if (isCarousel) {
            isCarousel = false;

            theme.beforeCarouselUnloadEventBlockFix($thumbnails);
            $thumbnails
              .removeClass("owl-carousel")
              .data("owl.carousel")
              .destroy();

            // trigger variant image grouping
            $gallery
              .closest(".product-detail")
              .find(".original-selector")
              .trigger("change");
          }
        } else {
          // thumbnails underneath - init carousel
          if (!isCarousel) {
            isCarousel = true;

            // fix for event propagation in nested owl carousels
            theme.beforeCarouselLoadEventBlockFix($thumbnails);

            // reset any image grouping modifications
            $thumbnails.find(".thumbnail").show();
            $gallery
              .find(".hidden-thumbnails")
              .children()
              .appendTo($thumbnails);

            $thumbnails
              .addClass("owl-carousel")
              .on("initialized.owl.carousel", function () {
                $(".lazyload--manual", this)
                  .removeClass("lazyload--manual")
                  .addClass("lazyload");
              })
              .owlCarousel({
                items: carouselVisibleItemCount,
                dots: false,
                margin: 7,
                rtl: document.querySelector("html[dir=rtl]") ? true : false,
              });

            // trigger variant image grouping
            $gallery
              .closest(".product-detail")
              .find(".original-selector")
              .trigger("change");
          }
        }
      };

      $(window).on("debouncedresize.productGallery", assessCarousel);
      assessCarousel();
      $(container).data("assessCarouselCallback", assessCarousel);

      /// Thumbnail click - in carousel
      // Events:
      // click: click on a thumbnail
      // select: selection via variant image
      // selectFromSlick: change of main image
      //
      // 'selectFromSlick' is treated as the 'primary' driver of state change, select/click to just update the main image slideshow,
      // and an after-transition callback updates the thumbnail
      $(".gallery", container).on(
        "click select selectFromSlick",
        ".thumbnails.owl-carousel .thumbnail",
        function (e) {
          e.preventDefault();
          var $carouselItem = $(this).parent();
          if (e.type != "selectFromSlick") {
            // from click or variant image? change main image
            var mediaId = $(this).data("media-id");
            var _$slideshow = $(this)
              .closest(".gallery")
              .find(".slideshow.slick-slider");
            if (_$slideshow) {
              var index = _$slideshow
                .find('.slide[data-media-id="' + mediaId + '"]')
                .index(); // current index including filters
              // same index? manual trigger of next event
              var slick = _$slideshow.slick("getSlick");
              if (slick.currentSlide === index) {
                // current slide active, manually trigger from-slick thumb selection (req. for index changes during filtering)
                $(this).trigger("selectFromSlick");
              } else {
                // change slide
                _$slideshow.slick("slickGoTo", index);
              }
            }
          } else {
            // change to active state comes from the main slideshow change event
            // show the highlight
            $(this)
              .addClass("selected")
              .parent()
              .siblings()
              .find("a")
              .removeClass("selected");

            // adjust thumbnail carousel if not on-screen
            var shelfStart = $carouselItem
              .parent()
              .children(".active:first")
              .index();
            var shelfEnd = shelfStart + carouselVisibleItemCount - 1;
            var currentIndex = $carouselItem.index();

            if (currentIndex < shelfStart) {
              // selected is to left of shelf - move carousel right to show
              $carouselItem
                .closest(".owl-carousel")
                .trigger("to.owl.carousel", currentIndex);
            } else if (currentIndex > shelfEnd) {
              // selected is to right of shelf - move carousel left to show
              $carouselItem
                .closest(".owl-carousel")
                .trigger(
                  "to.owl.carousel",
                  Math.max(0, currentIndex - carouselVisibleItemCount + 1),
                );
            }
          }
        },
      );

      /// Thumbnail click - beside
      // Uses same event structure as the events above ^
      $(".gallery", container).on(
        "click select selectFromSlick",
        " .thumbnails:not(.owl-carousel) .thumbnail",
        function (e) {
          e.preventDefault();
          if (e.type != "selectFromSlick") {
            // from click or variant image? change main image
            var index = 0;
            var mediaId = $(this).data("media-id");
            $(this)
              .parent()
              .children(":visible")
              .each(function (iter) {
                index = iter;
                if ($(this).data("media-id") == mediaId) {
                  return false;
                }
              });
            // same index? manual trigger of next event
            var _$slideshow2 = $(this).closest(".gallery").find(".slideshow");
            var slick = _$slideshow2.slick("getSlick");
            if (slick.currentSlide === index) {
              // current slide active, manually trigger from-slick thumb selection (req. for index changes during filtering)
              $(this).trigger("selectFromSlick");
            } else {
              // change slide
              _$slideshow2.slick("slickGoTo", index);
            }
          } else {
            // change to active state comes from the main slideshow change event
            $(this)
              .addClass("selected")
              .siblings(".selected")
              .removeClass("selected");
          }
        },
      );
    }
  };

  theme.initProductData = {};
  theme.preViewData = [];
  // 初始化产品轮播图
  theme.initProductSlick = function (container) {
    // 渲染轮播图
    $(container).find(".slider-for").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      // asNavFor: ".slider-nav",
      infinite: false,
      speed: 300,
      autoplay: false,
    });

    // 绑定点击事件
    initSlickClick();

    // 绑定缩略图事件
    initThumbnails();

    // 绑定滑动事件
    $(container)
      .find(".slider-for")
      .off("beforeChange")
      .on("beforeChange", function (event, slick, currentSlide, nextIndex) {
        showThumbnailsActive(nextIndex);
        if (nextIndex > currentSlide) {
          moveCarousel("next", nextIndex);
        } else {
          moveCarousel("prev", nextIndex);
        }

        currentSlide = nextIndex;
      });

    // 保存一份当前产品的数据
    if (container) {
      Object.keys(theme.productData).map((key) => {
        if (theme.productData?.[key]) {
          theme.initProductData = theme.productData[key];
        }
      });
    }

    // 关闭预览
    $("#swiper-overlay-close").on("click", function () {
      theme.pauseAllMedia();
      $("#swiper-overlay").fadeOut();
      var smileUiContainer = $("#smile-ui-container");
      if (smileUiContainer) {
        smileUiContainer.css("display", "block");
      }
      $("body").css("overflow", ""); // 恢复页面滚动
    });
    // 详情页商品图的 video gallery parameters tabs click 转换
    const $videoGalleryTabs = $(container).find('[role="video-gallery-tabs"]');
    const tabTypeMap = {
      video: ["video", "external_video"],
      parameters_image: ["parameters_image"],
      image: ["image"],
    };
    const optionalTabs = ["video", "parameters_image"];
    const visibleOptionalTabs = optionalTabs.filter((tab) => {
      return tabTypeMap[tab].some((type) => {
        return (
          $(container).find('[data-video-gallery-type="' + type + '"]').length >
          0
        );
      });
    });

    optionalTabs.forEach((tab) => {
      $videoGalleryTabs
        .find('[data-tab="' + tab + '"]')
        .toggleClass("hidden", !visibleOptionalTabs.includes(tab));
    });
    $videoGalleryTabs.toggleClass("hidden", visibleOptionalTabs.length === 0);

    $(container)
      .find('[role="video-gallery-tabs"]')
      .on("click", "span", function () {
        const $currentTab = $(this);
        const $tabContainer = $currentTab.closest(
          '[role="video-gallery-tabs"]',
        );
        const tab = $(this).data("tab");
        const targetTypes = tabTypeMap[tab];
        if (!targetTypes) return;

        const $slider = $(container).find(".slider-for");
        const $targetItem = $slider
          .find("[data-video-gallery-type]")
          .filter(function () {
            const type = ($(this).data("video-gallery-type") || "").toString();
            return targetTypes.includes(type);
          })
          .first();
        if (!$targetItem.length) return;
        $tabContainer.find("span").removeClass("bg-[#092F18] text-white");
        $currentTab.addClass("bg-[#092F18] text-white");
        const index = $targetItem.closest(".slick-slide").index();
        if (index > -1) {
          $slider.slick("slickGoTo", index);
          $(container)
            .find(".carousel-thumbnails")
            .find(".green-line")
            .each(function (i) {
              if (i === index) {
                $(this).addClass("slider-nav-line-active");
              } else {
                $(this).removeClass("slider-nav-line-active");
              }
            });
        }
      });
  };
  theme.hiddenProductsSlick = function (filterFn, id) {
    if (typeof filterFn !== "function") return;

    let filterProductData = [];
    var initProductData = {};
    Object.keys(theme.productData).map((key) => {
      if (theme.productData?.[key]) {
        const media = [];
        theme.productData[key].media.forEach((item) => {
          const alt = item.alt?.toLocaleLowerCase().trim() ?? "";
          if (alt.includes("v,main") || alt.includes("v, main")) {
            media.push(item);
          }
        });
        theme.productData[key].media.forEach((item) => {
          const alt = item.alt?.toLocaleLowerCase().trim() ?? "";
          if (!alt.includes("v,main") && !alt.includes("v, main")) {
            media.push(item);
          }
        });
        theme.productData[key].media = media;
        initProductData = theme.productData[key];
      }
    });
    if (id && theme.productData[id]) {
      initProductData = theme.productData[id];
    }
    if (initProductData.media.length > 0) {
      filterProductData = initProductData.media.filter(filterFn);
      theme.preViewData = filterProductData;
      // 清除之前的过滤
      $(".slider-for").first().slick("slickUnfilter");

      // 过滤符合条件的项
      $(".slider-for")
        .first()
        .slick("slickFilter", function () {
          // 如果 filterProductData 是一个数组，使用数组的 some 方法来检查
          return filterProductData.some(
            (ele) => $(this).data("media-id") == ele.id,
          );
        });

      $(".slider-for").first().slick("slickGoTo", 0);

      // 重置轮播图的点击索引
      initSlickClick();

      $(".carousel-thumbnails")
        .empty()
        .removeClass()
        .addClass("carousel-thumbnails");

      const $carouselNav = $(".carousel-thumbnails");
      $.each(filterProductData, function (index, item) {
        let videoGalleryType = item.media_type;
        if (
          videoGalleryType === "image" &&
          item.alt?.toLocaleLowerCase().includes("is_parameters")
        ) {
          videoGalleryType = "parameters_image";
        }

        const $newDiv = $(
          "<div data-video-gallery-type='" + videoGalleryType + "'></div",
        ).html(
          '<img src="' +
            item.preview_image.src +
            '&width=150" alt="' +
            item.alt +
            '"><div class="green-line"></div>',
        );
        $carouselNav.append($newDiv);
      });

      initThumbnails();
      // initPreThumbnails(0);
    }
  };

  theme.destroyProductGallery = function (container) {
    $(window).off(".productGallery");
    var $gallery = $(".gallery", container).off("click select selectFromSlick");
    theme.ProductMedia.destroy($gallery);
    $(".slick-slider", container)
      .slick("unslick")
      .off("init beforeChange afterChange");
    $(".owl-carousel", container).each(function () {
      theme.beforeCarouselUnloadEventBlockFix(this);
      $(this).data("owl.carousel").destroy();
    });
  };

  /* Product Media
   *
   * Load and destroy:
   * theme.ProductMedia.init(galleryContainer, {
   *   onModelViewerPlay: function(e){
   *     $(e.target).closest('.slick-slider').slick('slickSetOption', 'swipe', false);
   *   },
   *   onModelViewerPause: function(e){
   *     $(e.target).closest('.slick-slider').slick('slickSetOption', 'swipe', true);
   *   },
   *   onPlyrPlay: function(e){
   *     $(e.target).closest('.slick-slider').slick('slickSetOption', 'swipe', false);
   *   },
   *   onPlyrPause: function(e){
   *     $(e.target).closest('.slick-slider').slick('slickSetOption', 'swipe', true);
   *   },
   * });
   *
   * theme.ProductMedia.destroy(galleryContainer);
   *
   * Trigger mediaVisible and mediaHidden events based on UI
   * $slickSlideshow.on('afterChange', function(evt, slick, current){
   *   $('.product-media--activated').removeClass('product-media--activated').trigger('mediaHidden');
   *   $('.product-media', slick.$slides[current]).addClass('product-media--activated').trigger('mediaVisible');
   * });
   */
  theme.ProductMedia = new (function () {
    var _ = this;

    _._setupShopifyXr = function () {
      if (!window.ShopifyXR) {
        document.addEventListener(
          "shopify_xr_initialized",
          _._setupShopifyXr.bind(this),
        );
        return;
      }

      window.ShopifyXR.addModels(JSON.parse($(this).html()));
      window.ShopifyXR.setupXRElements();
    };

    this.init = function (container, callbacks) {
      var callbacks = callbacks || {},
        _container = container;

      // set up video media elements with a controller
      $(container)
        .find(".product-media--video")
        .each(function (index) {
          var poster = this.querySelector(".product-media__poster");
          $(".product-media__video-play-btn", poster).on("click", function () {
            $(this).closest(".product-media--video").data("player").play();
          });

          var playerObj = { container: this, poster: poster };
          playerObj.play = function () {
            // init
            var template = this.container.querySelector("template");
            if (template) {
              this.container.appendChild(template.content);
              this.container.removeChild(template);
              this.container.style.paddingBottom =
                100 /
                  this.container
                    .querySelector("video, iframe")
                    .getAttribute("aspect-ratio") +
                "%";
              $(this.container).closest(".slick-slider").slick("refresh");
            }

            // hide poster
            this.poster.classList.add("product-media__poster--hide");

            // play
            this.container.querySelectorAll(".js-youtube").forEach((video) => {
              video.contentWindow.postMessage(
                '{"event":"command","func":"' + "playVideo" + '","args":""}',
                "*",
              );
            });
            this.container.querySelectorAll(".js-vimeo").forEach((video) => {
              video.contentWindow.postMessage('{"method":"play"}', "*");
            });
            this.container
              .querySelectorAll("video")
              .forEach((video) => video.play());
          }.bind(playerObj);

          playerObj.pause = function () {
            theme.pauseAllMedia();
          };

          $(this)
            .data("player", playerObj)
            .addClass("product-media--video-loaded");
        });

      // when any media appears
      $(container).on(
        "mediaVisible",
        ".product-media--video-loaded, .product-media--model-loaded",
        function () {
          // autoplay all media on larger screens
          if ($(window).width() >= 768) {
            $(this).data("player").play();
          }
          // update view-in-space
          if ($(this).hasClass("product-media--model")) {
            $(".view-in-space", _container).attr(
              "data-shopify-model3d-id",
              $(this).data("model-id"),
            );
          }
        },
      );

      // when any media is hidden
      $(container).on(
        "mediaHidden",
        ".product-media--video-loaded, .product-media--model-loaded",
        function () {
          // pause all media
          $(this).data("player").pause();
        },
      );

      // necessary callbacks
      if (callbacks.onVideoVisible) {
        $(container).on(
          "mediaVisible",
          ".product-media--video-loaded",
          callbacks.onVideoVisible,
        );
      }

      if (callbacks.onVideoHidden) {
        $(container).on(
          "mediaHidden",
          ".product-media--video-loaded",
          callbacks.onVideoHidden,
        );
      }

      $("model-viewer", container).each(function () {
        if (callbacks.onModelViewerPlay) {
          $(this).on(
            "shopify_model_viewer_ui_toggle_play",
            callbacks.onModelViewerPlay,
          );
        }
        if (callbacks.onModelViewerPause) {
          $(this).on(
            "shopify_model_viewer_ui_toggle_pause",
            callbacks.onModelViewerPause,
          );
        }
      });

      // set up a 3d model when it first appears
      $(container).on(
        "mediaVisible mediaVisibleInitial",
        ".product-media--model:not(.product-media--model-loaded)",
        function (e) {
          var element = $(this).find("model-viewer")[0],
            autoplay = e.type != "mediaVisibleInitial";
          // load viewer
          theme.loadStyleOnce(
            "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css",
          );
          window.Shopify.loadFeatures([
            {
              name: "model-viewer-ui",
              version: "1.0",
              onLoad: function () {
                $(this).data("player", new Shopify.ModelViewerUI(element));
                // set class and re-trigger visible event now loaded
                $(this).addClass("product-media--model-loaded");
                if (callbacks.onModelViewerInit) {
                  callbacks.onModelViewerInit(element);
                }
                if (autoplay) {
                  $(this).trigger("mediaVisible");
                }
              }.bind(this),
            },
          ]);
        },
      );

      // load AR viewer
      if ($(".model-json", container).length) {
        window.Shopify.loadFeatures([
          {
            name: "shopify-xr",
            version: "1.0",
            onLoad: _._setupShopifyXr.bind($(".model-json", container)),
          },
        ]);
      }

      // pause video when a 3d model is launched in AR
      $(document).on("shopify_xr_launch", function () {
        theme.pauseAllMedia({ videos: true });
      });

      // 3d model in first place - start in paused mode
      setTimeout(
        function () {
          $(".product-slideshow.slick-slider .product-media:first", this)
            .filter(".product-media--model")
            .trigger("mediaVisibleInitial");
          $(
            ".product-slideshow:not(.slick-slider) .product-media--model",
            this,
          ).trigger("mediaVisibleInitial");
        }.bind(container),
        50,
      );
    };

    this.destroy = function (container) {
      $(document).off("shopify_xr_launch");
      $(container).off("mediaVisible mediaVisibleInitial mediaHidden");
      $(".product-media--model-loaded", container).each(function () {
        $(this).data("player").destroy();
      });
      $(".product-media--video video", container).off("playing pause ended");
      $("model-viewer", container).off(
        "shopify_model_viewer_ui_toggle_play shopify_model_viewer_ui_toggle_pause",
      );
    };
  })();

  theme.productGallerySlideshowTabFix = function (slides, current) {
    // tabindex everything to prevent tabbing into hidden slides
    $(slides[current])
      .find("a, input, button, select, iframe, video, model-viewer, [tabindex]")
      .each(function () {
        if (
          typeof $(this).data("theme-slideshow-original-tabindex") !==
          "undefined"
        ) {
          if ($(this).data("theme-slideshow-original-tabindex") === false) {
            $(this).removeAttr("tabindex");
          } else {
            $(this).attr(
              "tabindex",
              $(this).data("theme-slideshow-original-tabindex"),
            );
          }
        } else {
          $(this).removeAttr("tabindex");
        }
      });
    $(slides)
      .not(slides[current])
      .find("a, input, button, select, iframe, video, model-viewer, [tabindex]")
      .each(function () {
        if (
          typeof $(this).data("theme-slideshow-original-tabindex") ===
          "undefined"
        ) {
          $(this).data(
            "theme-slideshow-original-tabindex",
            typeof $(this).attr("tabindex") !== "undefined"
              ? $(this).attr("tabindex")
              : false,
          );

          $(this).attr("tabindex", "-1");
        }
      });
  };

  theme.ActiveFreeDiscount = new (function () {
    var _ = this;

    _.container = null;

    _.discountData = {};

    _.filterids = [];

    _.filterCollection = "";

    _.getDiscountData = function () {
      var pathname = window.location.pathname.replace(/\/+/g, "/");
      if (
        pathname.startsWith("/cart") ||
        pathname.startsWith("/collections/")
      ) {
        $.ajax({
          url: `https://dtc.piscifun.com/activity/full_discount/3.json?v=${Date.now()}`,
          success: function (res) {
            _.discountData = res;
            if (!_.discountData?.full_discount) {
              return;
            }

            let fullDiscountArray = Object.keys(_.discountData.full_discount)
              .filter(
                (level) => _.discountData.full_discount[level]?.discount_code,
              )
              .map((level) => {
                return {
                  ..._.discountData.full_discount[level],
                  level: level,
                };
              });

            // 按照 level1 和 level2 排序
            fullDiscountArray.sort((a, b) => a.level.localeCompare(b.level));
            // 重写 full_discount 为排序后的数组
            _.discountData.full_discount = fullDiscountArray;
            _.initDiscount();
            _.reShowDiscount();
          },
        });
      }
    };

    _.initDiscount = function () {
      var now = Math.round(Date.now() / 1000);
      var data = _.discountData;
      // 通过活动时间判断
      if (now <= data.activity_end_time && data.full_discount) {
        var full_discount = data.full_discount;
        for (let index = 0; index < full_discount.length; index++) {
          let { level, discount_code, discount_money, full_money } =
            full_discount[index];
          $(_.container).find(`.active-free-discount-codes .${level}`).show();
          $(_.container)
            .find(`.${level} .discount-copy`)
            .attr("data-discount-code", discount_code);
          $(_.container).find(`.${level}-discount-code`).text(discount_code);
          $(_.container).find(`.${level}-discount-money`).text(discount_money);
          $(_.container).find(`.${level}-full-money`).text(full_money);
        }

        $(_.container).find(".active-free-discount-bar").show();
      }
    };

    _.copySvg = function (type) {
      if (type === "copied") {
        return `<svg class="!size-5" t="1764154077646" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8136" width="14" height="14" fill="#ffffff">
        <path d="M639.786667 208.938667A42.666667 42.666667 0 0 0 597.333333 170.666667H213.333333a42.666667 42.666667 0 0 0-42.666666 42.666666v384a42.666667 42.666667 0 0 0 42.666666 42.666667v85.333333a128 128 0 0 1-128-128V213.333333a128 128 0 0 1 128-128h384a128 128 0 0 1 128 128 42.666667 42.666667 0 0 1-85.12 4.394667l-0.426666-8.789333z" fill="#ffffff" p-id="8137"></path>
        <path d="M256 341.333333a85.333333 85.333333 0 0 1 85.333333-85.333333h469.333334a128 128 0 0 1 128 128v341.333333a213.333333 213.333333 0 0 1-213.333334 213.333334H384a128 128 0 0 1-128-128V341.333333z m85.333333 469.333334a42.666667 42.666667 0 0 0 42.666667 42.666666h341.333333a128 128 0 0 0 128-128V384a42.666667 42.666667 0 0 0-42.666666-42.666667H341.333333v469.333334z" fill="#ffffff" p-id="8138"></path>
        <path d="M692.906667 484.266667a42.666667 42.666667 0 1 1 64.853333 55.466666l-145.92 170.666667a42.666667 42.666667 0 0 1-59.221333 5.461333l-3.285334-2.944-67.413333-66.986666-2.944-3.2a42.666667 42.666667 0 0 1 59.861333-60.245334l3.242667 2.944 34.816 34.56 116.053333-135.68z" fill="#ffffff" p-id="8139"></path></svg>`;
      } else if (type === "copy") {
        return `<svg class="!size-5" t="1764153994997" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6595" width="14" height="14" fill="#ffffff">
        <path d="M96.1 575.7a32.2 32.1 0 1 0 64.4 0 32.2 32.1 0 1 0-64.4 0Z" fill="#ffffff" p-id="6596"></path>
        <path d="M742.1 450.7l-269.5-2.1c-14.3-0.1-26 13.8-26 31s11.7 31.3 26 31.4l269.5 2.1c14.3 0.1 26-13.8 26-31s-11.7-31.3-26-31.4zM742.1 577.7l-269.5-2.1c-14.3-0.1-26 13.8-26 31s11.7 31.3 26 31.4l269.5 2.1c14.3 0.2 26-13.8 26-31s-11.7-31.3-26-31.4z" fill="#ffffff" p-id="6597"></path>
        <path d="M736.1 63.9H417c-70.4 0-128 57.6-128 128h-64.9c-70.4 0-128 57.6-128 128v128c-0.1 17.7 14.4 32 32.2 32 17.8 0 32.2-14.4 32.2-32.1V320c0-35.2 28.8-64 64-64H289v447.8c0 70.4 57.6 128 128 128h255.1c-0.1 35.2-28.8 63.8-64 63.8H224.5c-35.2 0-64-28.8-64-64V703.5c0-17.7-14.4-32.1-32.2-32.1-17.8 0-32.3 14.4-32.3 32.1v128.3c0 70.4 57.6 128 128 128h384.1c70.4 0 128-57.6 128-128h65c70.4 0 128-57.6 128-128V255.9l-193-192z m0.1 63.4l127.7 128.3H800c-35.2 0-64-28.8-64-64v-64.3h0.2z m64 641H416.1c-35.2 0-64-28.8-64-64v-513c0-35.2 28.8-64 64-64H671V191c0 70.4 57.6 128 128 128h65.2v385.3c0 35.2-28.8 64-64 64z" fill="#ffffff" p-id="6598"></path>
        </svg>`;
      }
    };

    _.reShowDiscount = function () {
      $.ajax({
        url: "/cart.js",
        success: function (res) {
          var cartData = JSON.parse(res);
          // var totalPrice = (cartData.total_price || 0) / 100
          var totalPrice =
            cartData.items
              .filter((item) => !_.filterids.includes(`${item.product_id}`))
              .reduce((sum, item) => sum + item.line_price, 0) / 100;
          console.log("totalPrice ===> ", totalPrice);
          var fullDiscount = _.discountData.full_discount;
          var full_discount = _.discountData.full_discount;
          for (let index = 0; index < full_discount.length; index++) {
            let { level, discount_code, discount_money, full_money } =
              full_discount[index];

            if ((index === 0) & (totalPrice < full_money)) {
              var moreSpend = (full_money - totalPrice).toFixed(2);
              $(_.container)
                .find(".discount-notice")
                .text(`Spend $${moreSpend} more to save $${discount_money}!`);
              break;
            }
            if (index === full_discount.length - 1 && totalPrice > full_money) {
              $(_.container)
                .find(".discount-notice")
                .html(
                  `<div class="flex flex-row text-sm">
                    <div>
                      Congratulations! You've unlocked $${discount_money} off! <strong>CODE: ${discount_code}</strong>
                    </div>
                    <div class="copy-icon ml-0.5 cursor-pointer" data-discount-code="${discount_code}">
                    ${_.copySvg("copy")}
                    </div>
                  </div>`,
                );
              break;
            }
            if (index < full_discount.length - 1) {
              let nextlevel = full_discount[index + 1];
              if (
                full_money <= totalPrice &&
                totalPrice < nextlevel.full_money
              ) {
                var moreSpend = (nextlevel.full_money - totalPrice).toFixed(2);
                $(_.container)
                  .find(".discount-notice")
                  .html(
                    `<div class="flex flex-col md:flex-row items-start md:items-center text-sm">
                      <div class="flex items-start md:items-center">
                        <span>$${discount_money} OFF UNLOCKED! <strong>CODE: ${discount_code}</strong></span> 
                        <span class="copy-icon mx-0.5 cursor-pointer" data-discount-code="${discount_code}">
                        ${_.copySvg("copy")}
                        </span>
                      </div>
                      <div class="ml-0.5">Spend $${moreSpend} more to save $${
                        nextlevel.discount_money
                      }!</div>
                    </div>`,
                  );
                break;
              }
            }
          }
        },
      });
    };

    this.onSectionLoad = function (container) {
      _.filterids = $(container)
        .data("filter-ids")
        ?.split(",")
        ?.filter(Boolean);
      _.filterCollection = $(container).data("filter-collection");
      var pathname = window.location.pathname.replace(/\/+/g, "/");

      if (
        pathname.startsWith("/collections/") &&
        pathname !== `/collections/${_.filterCollection}`
      ) {
        var target = $(
          '[data-section-type="collection-template"] > .container .filters-adjacent',
        );
        if (target.find(".active-free-discount").length > 0) {
          target.find(".active-free-discount").remove();
        }
        target.first().prepend($(container));
        _.container = $(
          '[data-section-type="collection-template"] > .container [data-section-type="active-free-discount"]',
        );
      } else if (pathname.startsWith("/cart")) {
        if (
          $("#sca_fg_cart .container").find(".active-free-discount").length > 0
        ) {
          $("#sca_fg_cart .container").find(".active-free-discount").remove();
        }
        $("#sca_fg_cart .page-header").after($(container));
        _.container = $(
          '#sca_fg_cart [data-section-type="active-free-discount"]',
        );
      } else {
        return;
      }
      _.getDiscountData();

      $(document).on(
        "click",
        ".active-free-discount-codes [data-discount-code]",
        function (evt) {
          var text = $(this).attr("data-discount-code");
          var that = this;
          navigator.clipboard.writeText(text).then(function () {
            $(that).text("COPIED");
          });
        },
      );

      $(document).on(
        "click",
        ".cc-modal-window__content .discount-content-close",
        function () {
          $(".cc-modal-window__close").click();
        },
      );

      $(document).on("click", ".active-free-discount .copy-icon", function () {
        var text = $(this).attr("data-discount-code");
        var that = this;
        navigator.clipboard
          .writeText(text)
          .then(function () {
            $(that).html(_.copySvg("copied"));
            window.toast("Copied");
          })
          .catch(function () {
            window.toast("Failed to copy");
          });
      });

      $(document).on("theme:cartchanged", function (data) {
        _.reShowDiscount();
      });
    };

    this.onSectionUnload = function (container) {};
  })();

  theme.CartTieredDiscounts = new (function () {
    var _ = this;

    _.container = null;

    _.filterids = [];

    _.onSectionLoad = function (container) {
      _.filterids = $(container)
        .data("filter-ids")
        ?.split(",")
        ?.filter(Boolean)
        ?.map(Number);

      _.replaceDiscount(container);
      _.renderDiscount();

      $(document).on("theme:cartchanged", function (data) {
        _.container.data(
          "cart-count",
          _.calculateItemCOunt(data.originalEvent.detail),
        );
        _.renderDiscount();
      });

      $(document).on(
        "click",
        ".cart-tiered-discounts [data-discount-code]",
        function (evt) {
          var text = $(this).attr("data-discount-code");
          var that = this;
          navigator.clipboard.writeText(text).then(function () {
            $(that).css({ "pointer-events": "none" }).text("COPIED");
            let t = setTimeout(function () {
              $(that).css({ "pointer-events": "all" }).text("COPY");
              clearTimeout(t);
            }, 2000);
          });
        },
      );
    };

    _.onSectionUnload = function (container) {};

    _.replaceDiscount = function (container) {
      var pathname = window.location.pathname.replace(/\/+/g, "/");
      if (_.container) {
        _.container.remove();
      }
      if (pathname.startsWith("/cart")) {
        $("#sca_fg_cart .cart-active-free-discount_container").append(
          $(container),
        );
        _.container = $(
          '#sca_fg_cart [data-section-type="cart-tiered-discounts"]',
        );
      }
    };

    _.calculateItemCOunt = function (cart) {
      let item_count = 0;
      for (let index = 0; index < cart.items.length; index++) {
        const item = cart.items[index];
        if (!_.filterids.includes(item.product_id)) {
          item_count += item.quantity;
        }
      }
      return item_count;
    };

    _.renderDiscount = function () {
      if (_.container) {
        let first_count = +_.container
          .find(".discount-notice")
          .last()
          .data("count");

        let item_count = +_.container.data("cart-count");

        // if (item_count === 0) {
        //   _.container
        //     .find(".active-free-discount-bar")
        //     .css({ display: "none" });
        //   return;
        // }

        if (item_count >= first_count) {
          _.container
            .find(".active-free-discount-bar")
            .css({ display: "flex" });
        } else {
          _.container
            .find(".active-free-discount-bar")
            .css({ display: "none" });
        }
        _.container.find(".discount-notice").hide();
        let last_count = 0;
        _.container.find(".discount-notice").each(function (index) {
          let count = $(this).data("count");
          if (item_count >= count) {
            $(this).show();
            $(this)
              .find(".count")
              .text(last_count - item_count);
            return false;
          }
          last_count = count;
        });
      }
    };
  })();

  theme.FacetedFilters = new (function () {
    var _ = this;

    // 配置常量
    const FILTER_TRACKING_CONFIG = {
      // 需要埋点的集合页面
      collectionPages: [
        "/collections/holiday-sale2",
        "/collections/all",
        "/collections/ALL",
        "/collections/hunting-blind",
        "/collections/waders",
        "/collections/hunting-clothes",
      ],
      // 埋点事件名称
      eventName: "collection_filter_click",
      // 埋点传输方式
      transport: "beacon",
    };

    // 检查当前页面是否需要埋点
    function shouldTrackFilter() {
      const currentUrl = window.location.href;
      return FILTER_TRACKING_CONFIG.collectionPages.some((page) =>
        currentUrl.includes(page),
      );
    }

    // 获取集合名称
    function getCollectionName() {
      return window.location.href.split("?")[0];
    }

    // 发送埋点数据
    function sendFilterTracking(filterKey, filterValue) {
      if (!window.ptengine) return;

      window.ptengine.track(
        FILTER_TRACKING_CONFIG.eventName,
        {
          collection_name: getCollectionName(),
          filter_key: filterKey,
          filter_value: filterValue,
        },
        { transport: FILTER_TRACKING_CONFIG.transport },
      );
    }

    // 处理过滤器点击事件
    function handleFilterClick(event) {
      // 检查是否需要埋点
      if (!shouldTrackFilter()) return;

      const item = event.target.closest(".filter-group__item");
      if (!item) return;

      const checkbox = item.querySelector(".filter-group__checkbox");
      if (
        !checkbox ||
        event.target.classList.contains("filter-group__checkbox")
      )
        return;

      const filterKey = checkbox.getAttribute("data-filter-key");
      if (!filterKey) return;

      // 记录点击前的状态
      const wasChecked = checkbox.checked;

      // 如果复选框已经是选中状态，不需要处理
      if (wasChecked) return;

      // 防止事件重复触发
      if (event._filterTrackingProcessed) return;
      event._filterTrackingProcessed = true;

      setTimeout(() => {
        if (checkbox.checked && !wasChecked) {
          sendFilterTracking(filterKey, checkbox.value);
        }
      }, 0);
    }

    // 事件监听器管理
    let isEventBound = false;

    function bindEvents() {
      if (isEventBound) return;

      document.addEventListener("click", handleFilterClick);
      isEventBound = true;

      console.log("Filter click events bound to document");
    }

    function unbindEvents() {
      if (!isEventBound) return;

      document.removeEventListener("click", handleFilterClick);
      isEventBound = false;

      console.log("Filter click events unbound from document");
    }

    // 公共方法
    _.onSectionLoad = function (container) {
      bindEvents();
    };

    _.onSectionUnload = function (container) {
      unbindEvents();
    };

    // 初始化
    function init() {
      // 绑定初始事件
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", function () {
          bindEvents();
        });
      } else {
        bindEvents();
      }
    }

    // 启动初始化
    init();
  })();

  // 统一的 linkfirstoid 参数重新排序商品方法
  theme.handleLinkFirstOidSorting = function (container, productListSelectors) {
    if (!container) {
      return;
    }
    var selectors = productListSelectors;
    var urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has("linkfirstoid")) {
      return;
    }
    if (Array.from(urlParams.keys()).length !== 1) {
      return;
    }
    var linkFirstOid = urlParams.get("linkfirstoid");
    if (!linkFirstOid || linkFirstOid.trim() === "") {
      return;
    }
    var $productList = $(container).find(selectors);
    if (!$productList || $productList.length === 0) {
      return;
    }
    var $productBlocks = $productList.find(".product-block");
    if ($productBlocks.length === 0) {
      return;
    }
    var targetProductIds = linkFirstOid
      .split(",")
      .map(function (id) {
        return id.trim();
      })
      .filter(function (id) {
        return id.length > 0;
      });

    if (targetProductIds.length === 0) {
      return;
    }
    var $anchor = $productList.children().first();
    targetProductIds.forEach(function (productId) {
      var $matchedBlocks = $productBlocks.filter(
        '[data-product-id="' + productId + '"]',
      );
      if ($matchedBlocks.length > 0) {
        $matchedBlocks.each(function () {
          $(this).insertBefore($anchor);
          $anchor = $(this).next();
        });
      }
    });
  };

  // Manage option dropdowns
  theme.productData = {};
  theme.OptionManager = new (function () {
    var _ = this;

    _._getVariantOptionElement = function (variant, $container) {
      return $container.find(
        'select[name="id"] option[value="' + (variant ? variant.id : "") + '"]',
      );
    };

    _.selectors = {
      container: ".product-detail",
      gallery: ".gallery",
      priceArea: ".price-area",
      variantIdInputs: '[name="id"]',
      purchaseForm: ".product-purchase-form",
      primaryVariantIdInput: '.product-purchase-form [name="id"]',
      submitButton: '.product-purchase-form button[type="submit"]',
      multiOption: ".option-selectors",
      customOption: ".custom-option",
      installmentsFormSuffix: "-installments",
    };

    _.strings = {
      buttonDefault: theme.strings.products_product_add_to_cart,
      buttonNoStock: theme.strings.products_variant_no_stock,
      buttonNoVariant: theme.strings.products_variant_non_existent,
    };

    _.getProductData = function ($form) {
      try {
        var productId = $form.data("product-id");
        var data = null;
        var productJsonEl = document.getElementById("ProductJson-" + productId);
        if (!productJsonEl) {
          throw new Error(
            "Cant not found document.getElementById('ProductJson-" +
              productId +
              "')",
          );
        }
        if (!theme.productData[productId] && productJsonEl) {
          theme.productData[productId] = JSON.parse(productJsonEl.innerHTML);
        }
        data = theme.productData[productId];
        if (!data) {
          throw new Error(
            "Product data missing (id: " + $form.data("product-id") + ")",
          );
        }
      } catch (error) {
        console.warn("getProductData error: ", error);
      }
      return data;
    };

    ((_.getBaseUnit = function (variant) {
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }),
      (_.addVariantUrlToHistory = function (variant) {
        if (variant) {
          var newurl =
            window.location.protocol +
            "//" +
            window.location.host +
            window.location.pathname +
            "?variant=" +
            variant.id;
          window.history.replaceState({ path: newurl }, "", newurl);
        }
      }));

    _.updateSku = function (variant, $container) {
      $container.find(".sku .sku__value").html(variant ? variant.sku : "");
      $container
        .find(".sku")
        .toggleClass("sku--no-sku", !variant || !variant.sku);
    };

    _.updateBarcode = function (variant, $container) {
      $container
        .find(".barcode .barcode__value")
        .html(variant ? variant.barcode : "");
      $container
        .find(".barcode")
        .toggleClass("barcode--no-barcode", !variant || !variant.barcode);
    };

    _.updateTransferNotice = function (variant, $container) {
      var transferData = _._getVariantOptionElement(variant, $container).data(
        "inventory-transfer",
      );
      if (transferData) {
        $container
          .find(".product-inventory-transfer")
          .removeClass("product-inventory-transfer--none")
          .html(transferData);
      } else {
        $container
          .find(".product-inventory-transfer")
          .addClass("product-inventory-transfer--none")
          .empty();
      }
    };

    _.updateVariantDeterminedVisibilityAreas = function (variant, $container) {
      $container.find(".variant-visibility-area").each(function () {
        $(this).children(":not(script)").remove();
        // 测试爬虫价格逻辑，暂时注释，后期可能恢复
        // if (variant) {
        //   $(this).append(
        //     $(this)
        //       .children('script[data-variant-id="' + variant.id + '"]')
        //       .html()
        //   );
        // } else {
        //   $(this).append($(this).children('script[data-variant-id=""]').html());
        // }

        // 初始化渲染爬虫价格，再通过js动态获取真实的价格
        let $scriptContent = $(this)
          .children('script[data-variant-id=""]')
          .html();
        if (variant) {
          $scriptContent = $(this)
            .children('script[data-variant-id="' + variant.id + '"]')
            .html();
        }
        let $tempDiv = $("<div>").html($scriptContent);
        const currPriceEle = $tempDiv.find(".current-price");
        let newPrice = currPriceEle.data("price");
        if (newPrice) {
          currPriceEle.html(newPrice);
        }
        $(this).append($tempDiv.html());
      });
    };

    _.updatePreSales = function (variant, $container) {
      $container.find(".variant-visibility-area-pre-sales").each(function () {
        $(this).children(":not(script)").remove();
        $(".pre-order-btn").hide();
        // $("#dynamic-payment-div").show();
        $(".button[data-buy-now]")?.show();
        if (variant) {
          try {
            jsonData = JSON.parse(
              $(this)
                .children('script[data-variant-id="' + variant.id + '"]')
                .html(),
            );
            if (jsonData.is_pre_sales == 1) {
              console.log("---inside---");
              $(this).append(
                "<div class='pre-sales-remark'>" + jsonData.remark + "</div>",
              );
              if (variant.available) {
                $(".pre-order-btn").show();
                $(".button[data-buy-now]")?.hide();
              }

              $("#dynamic-payment-div").hide();
              $(".button[data-buy-now]")?.hide();
            } else {
              console.log("---outside---");
              $(this).append(
                $(this).children('script[data-variant-id=""]').html(),
              );
            }
          } catch (error) {
            console.log("---error---");
            $(this).append(
              $(this).children('script[data-variant-id=""]').html(),
            );
          }
        } else {
          $(this).append($(this).children('script[data-variant-id=""]').html());
        }
      });
    };

    _.updateBackorder = function (variant, $container) {
      var $backorder = $container.find(".backorder");
      if ($backorder.length) {
        if (variant && variant.available) {
          if (
            variant.inventory_management &&
            _._getVariantOptionElement(variant, $container).data("stock") ==
              "out"
          ) {
            var productData = _.getProductData(
              $backorder.closest(".product-form"),
            );
            $backorder
              .find(".backorder__variant")
              .html(
                productData.title +
                  (variant.title.indexOf("Default") >= 0
                    ? ""
                    : " - " + variant.title),
              );
            $backorder.show();
          } else {
            $backorder.hide();
          }
        } else {
          $backorder.hide();
        }
      }
    };

    _._updateButtonText = function ($button, string, variant) {
      $button.each(function () {
        var newVal;
        newVal = _.strings["button" + string];
        if (newVal !== false) {
          if ($(this).is("input")) {
            $(this).val(newVal);
          } else {
            $(this).html(newVal);
          }
        }
      });
    };

    _.updateButtons = function (variant, $container) {
      var $button = $container.find(_.selectors.submitButton);
      var $buyNowButton = $container.find(".js-product-buy-now");

      if (variant) {
        $button.removeAttr("disabled");
        if (variant.available == true) {
          _._updateButtonText($button, "Default", variant);
          $buyNowButton?.show();
        } else {
          _._updateButtonText($button, "NoStock", variant);
          $buyNowButton?.hide();
        }
      } else {
        if (theme.getEmptyOptionSelectors($container).length) {
          $button.removeAttr("disabled");
          _._updateButtonText($button, "Default", variant);
          $buyNowButton?.show();
        } else {
          $button.attr("disabled", "disabled");
          _._updateButtonText($button, "NoVariant", variant);
          $buyNowButton?.hide();
        }
      }
    };

    _.updateContainerStatusClasses = function (variant, $container) {
      $container.toggleClass("variant-status--not-selected", !variant);
      $container.toggleClass(
        "variant-status--unavailable",
        variant && !variant.available,
      );
      $container.toggleClass(
        "variant-status--backorder",
        variant &&
          variant.available &&
          variant.inventory_management &&
          _._getVariantOptionElement(variant, $container).data("stock") ==
            "out",
      );
      $container.toggleClass(
        "variant-status--on-sale",
        variant &&
          variant.available &&
          variant.compare_at_price > variant.price,
      );
    };

    _.initProductOptions = function ($productForm) {
      if ($productForm.hasClass("theme-init")) return;
      var productData = _.getProductData($productForm);
      $productForm.addClass("theme-init");

      // init option selectors
      $productForm
        .find(_.selectors.multiOption)
        .on("change.themeProductOptions", function () {
          var selectedOptions = [];
          $(this)
            .find(".option-selector")
            .each(function () {
              if ($(this).data("selector-type") === "listed") {
                selectedOptions.push($(this).find(".js-option:checked").val());
              } else {
                selectedOptions.push(
                  $(this)
                    .find('.js-option[aria-selected="true"]')
                    .data("value"),
                );
              }
            });

          // find variant
          var variant = false;
          for (var i = 0; i < productData.variants.length; i++) {
            var v = productData.variants[i];
            var matchCount = 0;
            for (var j = 0; j < selectedOptions.length; j++) {
              if (v.options[j] == selectedOptions[j]) {
                matchCount++;
              }
            }
            if (matchCount == selectedOptions.length) {
              variant = v;
              break;
            }
          }

          $(".product-label-new--sale").hide();
          $(".all_variants_label_html").hide();

          // trigger change
          $productForm
            .find(_.selectors.variantIdInputs)
            .val(variant ? variant.id : "");

          // a jQuery event may not be picked up by all listeners
          $productForm.find(_.selectors.variantIdInputs).each(function () {
            this.dispatchEvent(
              new CustomEvent("change", {
                bubbles: true,
                cancelable: false,
                detail: { variant: variant, selectedOptions: selectedOptions },
              }),
            );
          });
        });

      // init custom options (mirror in purchase form for Buy Now button)
      $productForm
        .find(_.selectors.customOption)
        .each(function () {
          var $input = $(this).find("input:first, textarea, select");
          $('<input type="hidden">')
            .attr({
              name: $input.attr("name"),
              value: $input.val(),
            })
            .appendTo($productForm.find(_.selectors.purchaseForm));
        })
        .on("change.themeProductOptions", function () {
          var $radios = $(this).find('input[type="radio"]'),
            $checkbox = $(this).find('input[type="checkbox"]');
          if ($radios.length) {
            // radio buttons
            $productForm
              .find(_.selectors.purchaseForm + " input")
              .filter(function () {
                return this.name === $radios[0].name;
              })
              .val($radios.filter(":checked").val())
              .trigger("change");
          } else if ($checkbox.length) {
            // checkbox
            var val = null;
            if ($checkbox.is(":checked")) {
              val = $checkbox.val();
            } else {
              val = $checkbox.siblings('[type="hidden"]').val();
            }
            $productForm
              .find(_.selectors.purchaseForm + " input")
              .filter(function () {
                return this.name === $checkbox[0].name;
              })
              .val(val)
              .trigger("change");
          } else {
            // other inputs
            var $input = $(this).find("select, input, textarea");
            $productForm
              .find(_.selectors.purchaseForm + " input")
              .filter(function () {
                return this.name === $input.attr("name");
              })
              .val($input.val())
              .trigger("change");
          }
        });

      // init variant ids
      $productForm.find(_.selectors.primaryVariantIdInput).each(function () {
        // change state for original dropdown
        $(this).on(
          "change.themeProductOptions firstrun.themeProductOptions",
          function (e) {
            if ($(this).is("input[type=radio]:not(:checked)")) {
              return; // handle radios - only update for checked
            }
            // If variant is passed in, use that. Even if 'false'. If nothing is passed, find from input value.
            var variant = e.detail ? e.detail.variant : null;
            if (!variant && variant !== false) {
              for (var i = 0; i < productData.variants.length; i++) {
                if (productData.variants[i].id == $(this).val()) {
                  variant = productData.variants[i];
                }
              }
            }
            var $container = $(this).closest(_.selectors.container);

            // string overrides
            var $addToCart = $container
              .find(_.selectors.submitButton)
              .filter("[data-add-to-cart-text]");
            if ($addToCart.length) {
              _.strings.buttonDefault = $addToCart.data("add-to-cart-text");
            }

            // update buttons
            _.updateButtons(variant, $container);

            // emit an event to broadcast the variant update
            $(window).trigger("cc-variant-updated", {
              variant: variant,
              product: productData,
            });

            // variant images
            if (variant && variant.featured_media) {
              // variant passed
              $container
                .find(_.selectors.gallery)
                .trigger("variantImageSelected", [
                  variant,
                  e.type === "firstrun",
                ]);
            } else if (e.detail && e.detail.selectedOptions) {
              // if some options selected, find the first matching variant for image
              var matchesRequired = e.detail.selectedOptions.filter(
                (o) => o.length > 0,
              ).length;
              if (matchesRequired > 0) {
                for (var i = 0; i < productData.variants.length; i++) {
                  var v = productData.variants[i];
                  var matchCount = 0;
                  for (var j = 0; j < e.detail.selectedOptions.length; j++) {
                    if (v.options[j] == e.detail.selectedOptions[j]) {
                      matchCount++;
                    }
                  }
                  if (matchCount == matchesRequired && v.featured_media) {
                    $container
                      .find(_.selectors.gallery)
                      .trigger("variantImageSelected", [
                        v,
                        e.type === "firstrun",
                      ]);
                    break;
                  }
                }
              }
            }

            // extra details
            _.updateBarcode(variant, $container);
            _.updateSku(variant, $container);
            _.updateTransferNotice(variant, $container);
            _.updateVariantDeterminedVisibilityAreas(variant, $container);
            _.updateBackorder(variant, $container);
            _.updateContainerStatusClasses(variant, $container);
            _.updatePreSales(variant, $container);

            // variant urls
            if (
              $productForm.data("enable-history-state") &&
              e.type == "change"
            ) {
              _.addVariantUrlToHistory(variant);
            }

            // allow other things to hook on
            $productForm.trigger("variantChanged", [variant, productData]);
          },
        );

        // first-run
        $(this).trigger("firstrun");
      });

      // ajax
      theme.applyAjaxToProductForm($productForm);

      // apply URL params
      var searchParams = new URLSearchParams(location.search);
      var _loop = function _loop(key) {
        $productForm
          .find(".option-selector")
          .filter(function () {
            return this.querySelector(".label").firstChild.textContent === key;
          })
          .each(function () {
            var value = searchParams.get(key);
            if (this.dataset.selectorType == "dropdown") {
              this.querySelector(".cc-select").dispatchEvent(
                new CustomEvent("selectOption", { detail: { value: value } }),
              );
            } else {
              this.querySelectorAll(".opt-label__text").forEach((el) => {
                if (el.innerText == value) {
                  var input = document.getElementById(
                    el.parentElement.getAttribute("for"),
                  );
                  if (input) {
                    input.checked = true;
                    input.dispatchEvent(
                      new CustomEvent("change", {
                        bubbles: true,
                        cancelable: false,
                      }),
                    );
                  }
                }
              });
            }
          });
      };
      for (var key of searchParams.keys()) {
        _loop(key);
      }
    };

    _.unloadProductOptions = function ($productForm) {
      $productForm.removeClass("theme-init").each(function () {
        $(this).trigger("unloading").off(".themeProductOptions");
        $(this).find(_.selectors.multiOption).off(".themeProductOptions");
        $(this).find(_.selectors.customOption).off(".themeProductOptions");
        theme.removeAjaxFromProductForm($productForm);
      });
    };
  })();

  theme.loadQuickbuy = function () {
    // utility function for quickbuy (closes all quickbuys in passed blocks, in a collection grid)
    function contractDetail($blocks, speed) {
      if ($blocks.length > 0) {
        $blocks.removeClass("expanded");
        $blocks
          .find(".quickbuy-container")
          .stop()
          .animate({ height: 0 }, speed, function () {
            $(this).find(".inner").empty();
          });
        $blocks.stop().each(function () {
          $(this).animate({ paddingBottom: 0 }, speed);
        });
      }
    }

    // handle components
    function loadComponents(componentContainer) {
      $(componentContainer)
        .closest("[data-components]")
        .each(function () {
          $(this)
            .data("components")
            .split(",")
            .forEach((component) => {
              $(document).trigger("cc:component:load", [
                component,
                componentContainer,
              ]);
            });
        });
      $(componentContainer)
        .find(".cc-accordion")
        .on("transitionend.qbLoadComponents", function () {
          $(this).closest(".quickbuy-container").trigger("changedsize");
        });

      $(document).trigger("cc:component:load", [
        "custom-select",
        ".quickbuy-container",
      ]);
    }

    function unloadComponents(componentContainer) {
      $(componentContainer).find(".cc-accordion").off(".qbLoadComponents");
      $(componentContainer)
        .closest("[data-components]")
        .each(function () {
          $(this)
            .data("components")
            .split(",")
            .forEach((component) => {
              $(document).trigger("cc:component:unload", [
                component,
                componentContainer,
              ]);
            });
        });
    }

    // quick buy - managing slide-down quickbuy in both grids and carousels
    var droppyDownAnimSpeed = 500;
    $(document).on(
      "click",
      ".product-list .product-block:not(.collection-block):not(.main-search-result) .quickbuy-toggle, .featured-collection_embla__container .product-block:not(.collection-block):not(.main-search-result) .quickbuy-toggle",
      function () {
        var pageWidth = $(window).width(),
          productUrl = $(this).attr("href");

        //Only show dropdown if screen is large enough for it to be useful
        if (pageWidth > 767) {
          // cancel current request if one exists
          if (theme.currentQuickbuyRequest) {
            theme.currentQuickbuyRequest.abort();
          }

          var $block = $(this).closest(".product-block"),
            $detailCont = null,
            $quickbuyCont = null,
            $slider = $(this).closest(".collection-slider"),
            $sliderRow = null;

          // do different things if it's inside a slideshow
          if ($slider.length > 0) {
            $sliderRow = $slider.closest(".collection-slider-row");
            // slider without detail
            if ($sliderRow.find(".quickbuy-container").length === 0) {
              return;
            }
            $quickbuyCont = $sliderRow.find(".quickbuy-container");
          } else {
            $quickbuyCont = $block.find(".quickbuy-container");
          }
          $detailCont = $quickbuyCont.find(".inner");

          // toggle active class on block
          if ($block.toggleClass("expanded").hasClass("expanded")) {
            // expanding
            if ($slider.length > 0) {
              // if another block is expanded, remove its expanded class
              var noneExpanded =
                $slider
                  .find(".product-block.expanded")
                  .not($block)
                  .removeClass("expanded").length === 0;

              // if expanding from empty, set initial detail container height to 0
              if (noneExpanded) {
                $quickbuyCont.height(0);
              } else {
                // unload existing quickbuy
                $(".product-form", $quickbuyCont).trigger(
                  "unload-product-form",
                );
                $(".gallery", $quickbuyCont).off(this.namespace);
                $(".slideshow", $quickbuyCont).slick("unslick");
                // unload components
                unloadComponents($quickbuyCont);
              }

              // what to adjust when details change size
              $quickbuyCont.off("changedsize").on("changedsize", function () {
                $quickbuyCont.stop().animate(
                  {
                    height: $detailCont.outerHeight(),
                  },
                  droppyDownAnimSpeed,
                );
              });
            } else {
              // close expanded siblings
              var $expandedSiblings = $block.siblings(".expanded");

              $expandedSiblings.each(function () {
                contractDetail($(this), 0);

                // unload existing quickbuy
                $(".product-form", this).trigger("unload-product-form");
                theme.destroyProductGallery(this);
                // unload components
                unloadComponents(this);
              });

              // what do adjust when details change size
              $quickbuyCont.off("changedsize").on("changedsize", function () {
                // check expanded class in case it's mid close transition
                if ($block.hasClass("expanded")) {
                  var targetHeight = $detailCont.outerHeight();
                  // slide down instantly if a neighbour is expanded
                  var speed =
                    $expandedSiblings.length > 0 ? 0 : droppyDownAnimSpeed;
                  $block.stop().animate(
                    {
                      paddingBottom: targetHeight + 20,
                    },
                    speed,
                  ); // extra for gap underneath
                  $quickbuyCont.stop().animate({ height: targetHeight }, speed);
                }
              });
            }

            // add spinner
            $detailCont.html('<div class="loading-spinner"></div>');
            $quickbuyCont.trigger("changedsize");

            // load in content
            var url = $(this).attr("href");
            theme.currentQuickbuyRequest = $.get(url, function (response) {
              var $newDetail = $("<div>" + response + "</div>").find(
                ".quickbuy-content",
              );
              // convert to quickbuy content
              $newDetail.find(".more").attr("href", productUrl);
              $newDetail
                .find(".detail .title")
                .wrapInner($("<a>").attr("href", productUrl));
              $newDetail
                .find(".show-gallery")
                .removeClass("show-gallery")
                .attr("href", productUrl);
              $newDetail.find(".detail .title a").attr("style", "color: #000");
              $newDetail.find(".not-in-quickbuy").remove();
              $newDetail
                .find(".only-in-quickbuy")
                .removeClass("only-in-quickbuy");
              $newDetail
                .find(".sticky-content-container")
                .removeClass("sticky-content-container");
              $newDetail.find(".store-availability-container").remove();
              $newDetail
                .find('[data-enable-history-state="true"]')
                .attr("data-enable-history-state", "false");
              $newDetail.find(".gallery").remove();
              var $gallery = $("<div>" + response + "</div>").find(
                ".quickbuy-content-mobile .gallery",
              );
              $gallery.find(".swiper-container").css("display", "block");
              $gallery.find(".slider-for").css("height", "auto");
              $newDetail.find(".product-column-right").before($gallery);
              theme.initProductSlick($gallery);
              theme.initProductGallery($gallery);
              // $newDetail.find(".thumbnails").remove();
              // $newDetail
              //   .find(".gallery .thumbnails")
              //   .removeClass("mobile-only");
              // [
              //   "gallery--layout-carousel-beside",
              //   "gallery--layout-columns-1",
              //   "gallery--layout-columns-2",
              //   "gallery--layout-collage-1",
              //   "gallery--layout-collage-2",
              // ].forEach((cl) => {
              //   $newDetail
              //     .find("." + cl)
              //     .removeClass(cl)
              //     .addClass("gallery--layout-carousel-under");
              // });

              // resize after images load, if present
              // $newDetail.find(".rte img").on("load", function () {
              //   $quickbuyCont.trigger("changedsize");
              //   $(this).off("load");
              // });

              $detailCont.html($newDetail);
              // the order of these is important:
              // theme.initProductGallery($quickbuyCont); // 1
              $quickbuyCont
                .find(".product-form")
                .attr("data-is-quick-buy-form", "true")
                .trigger("load-product-form") // 2
                .on("variantChanged", function () {
                  $quickbuyCont.trigger("changedsize"); // (5)
                });
              loadComponents($quickbuyCont); // 3
              theme.initAnimateOnScroll(); // 4
              $quickbuyCont.trigger("changedsize"); // 5
            }).always(function () {
              theme.currentQuickbuyRequest = false;
              // document
              //   .querySelector(".thumbnails")
              //   .addEventListener("click", (e) => {
              //     try {
              //       const isProductPage = document.querySelector(
              //         ".section-product-main"
              //       );
              //       if (!isProductPage) {
              //         setTimeout(() => {
              //           document
              //             .querySelectorAll(".slick-track .slide")
              //             .forEach((item) => {
              //               item.style.display = "block";
              //             });
              //         }, 1000);
              //       }
              //     } catch (error) {
              //       console.warn("thumbnails click error: ", error);
              //     }
              //   });
            });

            // enable close button
            $quickbuyCont.find(".close-detail").removeAttr("tabindex");

            // scroll to appropriate position
            // qb: top of quick buy
            // bl: top of product block
            var scrollMode = "qb";
            var scrollOffset = -120;

            if ($(".section-header").css("position") == "sticky") {
              scrollOffset -= $(".section-header").height();
            }

            if (scrollMode == "qb") {
              $("html:not(:animated),body:not(:animated)").animate(
                { scrollTop: $quickbuyCont.offset().top + scrollOffset },
                500,
              );
            } else {
              if ($slider.length > 0) {
                // simple for slider
                $("html:not(:animated),body:not(:animated)").animate(
                  { scrollTop: $block.offset().top },
                  500,
                );
              } else {
                // need to use top of block when no quickbuys are visible
                saveCollectionPageData();
                var offsetTop =
                  typeof $block.data("offsetTop") != "undefined"
                    ? $block.data("offsetTop")
                    : $block.offset().top;
                $("html:not(:animated),body:not(:animated)").animate(
                  { scrollTop: offsetTop + scrollOffset },
                  500,
                );
              }
            }
          } else {
            // close
            unloadComponents($quickbuyCont);
            if ($slider.length > 0) {
              // collapse detail container
              $quickbuyCont
                .stop()
                .animate({ height: 0 }, droppyDownAnimSpeed, function () {
                  // remove details
                  $detailCont.empty();
                });
            } else {
              contractDetail($block, droppyDownAnimSpeed);
            }

            // scroll to top of closing block
            var scrollUpOffset = -140;
            $("html:not(:animated),body:not(:animated)").animate(
              { scrollTop: $block.offset().top + scrollUpOffset },
              500,
            );

            // disable close button
            $quickbuyCont.find(".close-detail").attr("tabindex", "-1");
          }

          return false;
        }
      },
    );

    //Close button event
    $(document).on("click", ".quickbuy-container .close-detail", function () {
      var $slider = $(this).closest(".collection-slider-row");
      if ($slider.length) {
        $slider
          .find(".product-block.expanded .quickbuy-toggle:first")
          .trigger("click");
      } else {
        $(this)
          .closest(".product-block")
          .find(".quickbuy-toggle:first")
          .trigger("click");
      }
      return false;
    });

    //You also need to know where to scroll to
    function saveCollectionPageData() {
      $(".collection-listing").each(function () {
        var $blocks = $(this).find(".product-block");
        if ($blocks.length <= 1) return true; // Skip for empty colls
        var row = 0;
        var currTop = 0;
        //Heights are fixed. Check two in case somebody has expanded one...
        var blockHeight = Math.min(
          $blocks.first().outerHeight(),
          $($blocks[1]).outerHeight(),
        );
        var blockPageOffset = $blocks.first().offset().top;
        $blocks.each(function (index) {
          var currOffsetTop = $(this).offset().top;
          if (index == 0) {
            currTop = currOffsetTop;
          } else {
            if (currOffsetTop > currTop) {
              row++;
              currTop = currOffsetTop;
            }
          }
          $(this).data({
            offsetTop: blockPageOffset + row * blockHeight,
          });
        });
      });
    }
  };

  // 首页商品列表-移动端-悬浮购物车
  theme.loadMobileQuickbuy = new (function () {
    this.onSectionLoad = function (container) {
      console.log("[featured-collection][mobile-quickbuy] bind start", {
        container,
      });
      $(container).on(
        "click",
        ".featured-collection-mobile_embla .image-add-to-cart-button",
        function (evt) {
          console.log(
            "[featured-collection][mobile-quickbuy] click image-add-to-cart-button",
            { evtTarget: evt.target, currentTarget: evt.currentTarget },
          );
          var $block = $(this).closest(".product-block");
          var $quickbuyCont = $(container).find(
            ".featured-collection-product-mobile",
          );
          if ($quickbuyCont.length === 0) {
            $quickbuyCont = $(container).next(
              ".featured-collection-product-mobile",
            );
          }
          const productUrl = $(this).data("href");
          const pageWidth = $(window).width();
          console.log(
            "[featured-collection][mobile-quickbuy] resolved context",
            {
              blockLength: $block.length,
              quickbuyContainerLength: $quickbuyCont.length,
              productUrl,
              pageWidth,
            },
          );
          if (pageWidth < 767) {
            // toggle active class on block
            if ($block.toggleClass("expanded").hasClass("expanded")) {
              console.log(
                "[featured-collection][mobile-quickbuy] expanded=true, request start",
                { productUrl },
              );
              // load in content
              theme.currentMobileQuickbuyRequest = $.get(
                productUrl,
                function (response) {
                  console.log(
                    "[featured-collection][mobile-quickbuy] request success",
                    {
                      responseLength: response ? response.length : 0,
                      quickbuyContainerLength: $quickbuyCont.length,
                    },
                  );
                  // 塞入浮动购物车
                  var $newDetail = $("<div>" + response + "</div>")
                    .find(".quickbuy-content-mobile")
                    .html();
                  console.log(
                    "[featured-collection][mobile-quickbuy] parsed quickbuy-content-mobile",
                    { hasHtml: !!$newDetail },
                  );
                  $quickbuyCont.html($newDetail);
                  $($quickbuyCont.find(".product-column-float-mobile")).fadeIn(
                    500,
                  );
                  $("body").css("overflow", "hidden");
                  theme.initProductSlick($quickbuyCont);
                  theme.initProductGallery($quickbuyCont);
                  $quickbuyCont
                    .find(".product-form")
                    .attr("data-is-quick-buy-form", "true")
                    .trigger("load-product-form") // 2
                    .on("variantChanged", function () {
                      $quickbuyCont.trigger("changedsize"); // (5)
                    });
                  $(
                    $quickbuyCont.find(
                      ".product-column-float-mobile .product-form",
                    ),
                  ).trigger("load-product-form");

                  theme.ProductBlockManager.loadImages($quickbuyCont);
                  theme.OptionManager.getProductData(
                    $quickbuyCont.find(".product-form"),
                  );
                },
              )
                .fail(function (xhr, status, error) {
                  console.error(
                    "[featured-collection][mobile-quickbuy] request failed",
                    { status, error, xhrStatus: xhr && xhr.status },
                  );
                })
                .always(function () {
                  console.log(
                    "[featured-collection][mobile-quickbuy] request complete",
                  );
                  theme.currentMobileQuickbuyRequest = false;
                });
            } else {
              console.log(
                "[featured-collection][mobile-quickbuy] expanded=false, skip request",
              );
            }
          } else {
            console.log(
              "[featured-collection][mobile-quickbuy] ignored on non-mobile width",
            );
          }
        },
      );

      $(".featured-collection-product-mobile").on(
        "click",
        ".product-column-float-mobile .close-detail",
        function (event) {
          event.preventDefault();
          $(".product-column-float-mobile").fadeOut(500);
          $("body").css("overflow", "auto");
        },
      );

      $(".featured-collection-product-mobile").on(
        "click",
        ".overlay",
        function () {
          $(".product-column-float-mobile").fadeOut(500);
          $("body").css("overflow", "auto");
        },
      );
    };

    this.onSectionUnload = function (container) {
      $(".product-form", container).trigger("unload-product-form");
    };
  })();
  // 移动端加购弹窗
  theme.globalMobileQuickbuyModal = function (selector, targetContainer) {
    // 设置默认值
    selector = selector || ".product-list .product-block__add-to-cart-button";
    const $quickbuyCont = $(targetContainer) || $("body");
    $(document).on("click", selector, function (e) {
      e.preventDefault();
      var $button = $(this);
      var href = $button.data("href");

      if (href) {
        // 先移除已存在的浮动窗口
        $quickbuyCont.find(".product-column-float-mobile").remove();

        theme.currentMobileQuickbuyRequest = $.get(href, function (response) {
          // 塞入浮动购物车
          var $newDetail = $("<div>" + response + "</div>")
            .find(".quickbuy-content-mobile")
            .html();
          $quickbuyCont.html($newDetail);
          $($quickbuyCont.find(".product-column-float-mobile")).fadeIn(500);
          $("body").css("overflow", "hidden");
          theme.initProductSlick($quickbuyCont);
          theme.initProductGallery($quickbuyCont);
          $quickbuyCont
            .find(".product-form")
            .attr("data-is-quick-buy-form", "true")
            .trigger("load-product-form") // 2
            .on("variantChanged", function () {
              $quickbuyCont.trigger("changedsize"); // (5)
            });
          $(
            $quickbuyCont.find(".product-column-float-mobile .product-form"),
          ).trigger("load-product-form");

          theme.ProductBlockManager.loadImages($quickbuyCont);
          theme.OptionManager.getProductData(
            $quickbuyCont.find(".product-form"),
          );
        }).always(function () {
          theme.currentMobileQuickbuyRequest = false;
        });
      }
    });
    $quickbuyCont.on(
      "click",
      ".product-column-float-mobile .close-detail",
      function (event) {
        event.preventDefault();
        $(".product-column-float-mobile").fadeOut(500);
        $("body").css("overflow", "auto");
      },
    );

    $quickbuyCont.on("click", ".overlay", function () {
      $(".product-column-float-mobile").fadeOut(500);
      $("body").css("overflow", "auto");
    });
  };

  // 商品列表-移动端-悬浮购物车
  theme.loadCollectionTemplateListMobile = new (function () {
    this.onSectionLoad = function (container) {
      $(container).on(
        "click",
        ".filters-adjacent-mobile .image-add-to-cart-button",
        function (evt) {
          var $block = $(this).closest(".product-block");
          var $quickbuyCont = $(container).next(
            ".collection-template-list-mobile",
          );
          const productUrl = $(this).data("href");
          const pageWidth = $(window).width();
          if (pageWidth < 767) {
            // toggle active class on block
            if ($block.toggleClass("expanded").hasClass("expanded")) {
              // load in content
              theme.currentMobileQuickbuyRequest = $.get(
                productUrl,
                function (response) {
                  // 塞入浮动购物车
                  var $newDetail = $("<div>" + response + "</div>")
                    .find(".quickbuy-content-mobile")
                    .html();
                  $quickbuyCont.html($newDetail);

                  $(".product-column-float-mobile").fadeIn(500);
                  $("body").css("overflow", "hidden");
                  theme.initProductSlick($quickbuyCont);
                  theme.initProductGallery($quickbuyCont);
                  $quickbuyCont
                    .find(".product-form")
                    .attr("data-is-quick-buy-form", "true")
                    .trigger("load-product-form") // 2
                    .on("variantChanged", function () {
                      $quickbuyCont.trigger("changedsize"); // (5)
                    });
                  $(".product-column-float-mobile .product-form").trigger(
                    "load-product-form",
                  );

                  theme.ProductBlockManager.loadImages($quickbuyCont);
                  theme.OptionManager.getProductData(
                    $quickbuyCont.find(".product-form"),
                  );
                },
              ).always(function () {
                theme.currentMobileQuickbuyRequest = false;
              });
            }
          }
        },
      );

      $(".collection-template-list-mobile").on(
        "click",
        ".product-column-float-mobile .close-detail",
        function (event) {
          event.preventDefault();
          $(".product-column-float-mobile").fadeOut(500);
          $("body").css("overflow", "auto");
          $(".product-block.expanded").removeClass("expanded");
        },
      );

      $(".collection-template-list-mobile").on(
        "click",
        ".overlay",
        function () {
          $(".product-column-float-mobile").fadeOut(500);
          $("body").css("overflow", "auto");
          $(".product-block.expanded").removeClass("expanded");
        },
      );
    };

    this.onSectionUnload = function (container) {
      $(".product-form", container).trigger("unload-product-form");
    };
  })();

  theme.utils = {
    getMatchAll: function (alt_str, public_title) {
      const datas = alt_str.replace("{", "").replace("}", "").split("?");
      let flag = true;
      for (let i = 0; i < datas.length; i++) {
        const str = datas[i].trim().toLowerCase();
        const result = public_title?.find((item) => item.trim() === str);
        if (!result) flag = false;
      }
      return flag;
    },
    getSkuImageFillterByAlt: function (variant, product) {
      let result = [];
      for (let i = 0; i < product.media.length; i++) {
        let is_show = false;
        const media = product.media[i];
        const public_title = variant.public_title
          ?.trim()
          ?.toLowerCase()
          .split(" / ");

        let main_next_value = null;
        let is_main_image = false;

        if (media.alt) {
          const image_alt_text = media.alt.trim().toLowerCase().split(",");
          if (image_alt_text.length === 1) {
            is_show = true;
            for (const v of product.variants) {
              const variant_title = v.title.trim().toLowerCase().split(" / ");
              for (const alt of image_alt_text) {
                if (variant_title.includes(alt.trim())) is_show = false;
              }
            }
          }
          for (let j = 0; j < image_alt_text.length; j++) {
            const alt_str = image_alt_text[j].trim().toLowerCase();
            if (alt_str === "main") {
              if (image_alt_text[j + 1])
                main_next_value = image_alt_text[j + 1].trim().toLowerCase();
              is_main_image = true;
            }
            if (
              alt_str !== "main" &&
              alt_str.includes("{") &&
              alt_str.includes("}") &&
              !is_show
            ) {
              is_show = theme.utils.getMatchAll(alt_str, public_title);
            } else {
              if (
                alt_str !== "main" &&
                !is_show &&
                (alt_str === "all" || public_title?.includes(alt_str))
              ) {
                is_show = true;
              }
            }
          }
        } else {
          if (!media.alt) is_show = true; // 不配置alt就直接显示
        }

        if (is_main_image) {
          if (main_next_value === "all") {
            is_show = true;
          } else {
            if (
              !!main_next_value &&
              main_next_value?.includes("{") &&
              main_next_value?.includes("}") &&
              !is_show
            ) {
              is_show = theme.utils.getMatchAll(main_next_value, public_title);
            } else {
              if (!is_show)
                is_show = main_next_value
                  ? public_title?.includes(main_next_value)
                  : true;
            }
          }
        }
        if (is_show) result.push(media);
      }
      return result;
    },
  };

  $(function () {
    $(document).on("click", ".sharing a", function (e) {
      var $parent = $(this).parent();
      if ($parent.hasClass("twitter")) {
        e.preventDefault();
        var url = $(this).attr("href");
        var width = 575,
          height = 450,
          left = ($(window).width() - width) / 2,
          top = ($(window).height() - height) / 2,
          opts =
            "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0" +
            ",width=" +
            width +
            ",height=" +
            height +
            ",top=" +
            top +
            ",left=" +
            left;
        window.open(url, "Twitter", opts);
      } else if ($parent.hasClass("facebook")) {
        e.preventDefault();
        var url = $(this).attr("href");
        var width = 626,
          height = 256,
          left = ($(window).width() - width) / 2,
          top = ($(window).height() - height) / 2,
          opts =
            "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0" +
            ",width=" +
            width +
            ",height=" +
            height +
            ",top=" +
            top +
            ",left=" +
            left;
        window.open(url, "Facebook", opts);
      } else if ($parent.hasClass("pinterest")) {
        e.preventDefault();
        var url = $(this).attr("href");
        var width = 700,
          height = 550,
          left = ($(window).width() - width) / 2,
          top = ($(window).height() - height) / 2,
          opts =
            "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0" +
            ",width=" +
            width +
            ",height=" +
            height +
            ",top=" +
            top +
            ",left=" +
            left;
        window.open(url, "Pinterest", opts);
      } else if ($parent.hasClass("google")) {
        e.preventDefault();
        var url = $(this).attr("href");
        var width = 550,
          height = 450,
          left = ($(window).width() - width) / 2,
          top = ($(window).height() - height) / 2,
          opts =
            "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0" +
            ",width=" +
            width +
            ",height=" +
            height +
            ",top=" +
            top +
            ",left=" +
            left;
        window.open(url, "Google+", opts);
      }
    });
  });

  /*================ Sections ================*/
  theme.AnnouncementBarSection = new (function () {
    this.onSectionLoad = function (container) {
      this.container = container;
      $(".disclosure", container).each(function () {
        $(this).data("disclosure", new theme.Disclosure($(this)));
      });

      $(container).on("click", "[data-pt-tag]", function (e) {
        var ptTag = $(this).data("pt-tag");
        console.log("click", ptTag);
        if (ptTag) {
          ptengine && ptengine.track(ptTag);
        }
      });

      this.announcements = container.querySelectorAll(".announcement");
      document
        .getElementById("announcement_L7xAi4")
        .addEventListener("click", function () {
          ptengine && ptengine.track("giveaway-announcement");
        });
      if (this.announcements.length > 1) {
        this.currentAnnouncement = 0;
        container
          .querySelector(".announcement-bar__middle")
          .addEventListener(
            "focusin",
            this.functions.pauseAnnouncements.bind(this),
          );
        container
          .querySelector(".announcement-bar__middle")
          .addEventListener(
            "focusout",
            this.functions.playAnnouncements.bind(this),
          );
        container
          .querySelector(".announcement-button--previous")
          .addEventListener(
            "click",
            this.functions.previousAnnouncement.bind(this),
          );
        container
          .querySelector(".announcement-button--next")
          .addEventListener(
            "click",
            this.functions.nextAnnouncement.bind(this),
          );
        this.observer = new IntersectionObserver(
          this.functions.handleIntersect.bind(this),
        );
        this.observer.observe(this.container);
      }
    };

    this.functions = {
      handleIntersect: function handleIntersect(entries) {
        entries.forEach((entry) => {
          if (entry.target == this.container) {
            if (entry.isIntersecting) {
              this.functions.playAnnouncements.call(this);
            } else {
              this.functions.pauseAnnouncements.call(this);
            }
          }
        });
      },

      playAnnouncements: function playAnnouncements() {
        this.announcementInterval = setInterval(() => {
          this.functions.setCurrentAnnouncement.call(
            this,
            this.currentAnnouncement + 1,
          );
        }, 5000);
      },

      pauseAnnouncements: function pauseAnnouncements() {
        if (this.announcementInterval) {
          clearInterval(this.announcementInterval);
        }
      },

      setCurrentAnnouncement: function setCurrentAnnouncement(newIndex) {
        if (newIndex < 0) {
          newIndex += this.announcements.length;
        }
        this.currentAnnouncement = newIndex % this.announcements.length;
        this.announcements.forEach((el, index) => {
          if (index !== this.currentAnnouncement) {
            el.classList.add("announcement--inactive");
          } else {
            el.classList.remove("announcement--inactive");
          }
        });
      },

      previousAnnouncement: function previousAnnouncement() {
        this.functions.setCurrentAnnouncement.call(
          this,
          this.currentAnnouncement - 1,
        );
      },

      nextAnnouncement: function nextAnnouncement() {
        this.functions.setCurrentAnnouncement.call(
          this,
          this.currentAnnouncement + 1,
        );
      },
    };

    this.onSectionUnload = function (container) {
      clearInterval(this.announcementInterval);

      $(".disclosure", container).each(function () {
        $(this).data("disclosure").unload();
      });

      if (this.observer) {
        this.observer.disconnect();
      }
    };

    this.onBlockSelect = function (block) {
      var index = Array.prototype.indexOf.call(
        block.parentElement.children,
        block,
      );
      this.functions.pauseAnnouncements.call(this);
      this.functions.setCurrentAnnouncement.call(this, index);
    };

    this.onBlockDeselect = function (block) {
      this.functions.playAnnouncements.call(this);
    };
  })();

  theme.BlogTemplateSection = new (function () {
    this.onSectionLoad = function (container) {
      this.namespace = theme.namespaceFromSection(container);
      this.$container = $(container);

      // filter dropdown
      this.$container.on(
        "click" + this.namespace,
        ".link-dropdown__button",
        theme.toggleLinkDropdownButton.bind(this),
      );

      // click anywhere else in page to close
      $(document).on("click" + this.namespace, function () {
        $('.link-dropdown__button[aria-expanded="true"]').trigger("click");
      });
    };

    this.onSectionUnload = function (container) {
      this.$container.off(this.namespace);
      $(document).off(this.namespace);
    };
  })();

  theme.CartTemplateSection = new (function () {
    this.onSectionLoad = function (container) {
      this.$container = $(container);

      // listen to cart changes
      $(document).on(
        "theme:cartchanged.cartTemplateSection",
        this.functions.refreshCartDependentContent.bind(this),
      );

      // terms and conditions checkbox
      if ($("#cartform input#terms", container).length > 0) {
        $(document).on(
          "click.cartTemplateSection",
          '#cartform [name="checkout"], .additional-checkout-buttons input, a[href*="/checkout"]',
          function () {
            if ($("#cartform input#terms:checked").length == 0) {
              alert(theme.strings.cart_terms_confirmation);
              return false;
            }
          },
        );
      }

      if ($(container).data("ajax-update")) {
        $(container).on(
          "keyup.cartTemplateSection change.cartTemplateSection changeFromButton.cartTemplateSection",
          ".cart-item__quantity-input",
          function (evt) {
            if (this.replacingContent) {
              return;
            }
            if (
              $(evt.currentTarget).data("initial-value") &&
              $(evt.currentTarget).data("initial-value") ==
                $(evt.currentTarget).val()
            ) {
              return;
            }
            if (
              $(evt.currentTarget).val().length == 0 ||
              $(evt.currentTarget).val() == "0"
            ) {
              return;
            }

            // focus on -/+ button or input, depending on source of event
            var toFocusId;
            if (evt.type === "changeFromButton") {
              toFocusId = $(evt.data).attr("id");
            } else {
              toFocusId = $(evt.currentTarget).attr("id");
            }

            this.functions.updateCart.call(
              this,
              {
                line: $(evt.currentTarget).data("line"),
                quantity: $(evt.currentTarget).val(),
              },
              function () {
                // after update, set focus
                $("#" + toFocusId).focus();
              },
            );
          }.bind(this),
        );

        $(container).on(
          "click.cartTemplateSection",
          ".quantity-down, .quantity-up",
          function (evt) {
            var $input = $(this).closest(".quantity").find("input"),
              step = $input.attr("step") ? parseInt($input.attr("step")) : 1;
            if ($(this).hasClass("quantity-down")) {
              $input
                .val(parseInt($input.val()) - step)
                .trigger("changeFromButton", { data: this });
            } else {
              $input
                .val(parseInt($input.val()) + step)
                .trigger("changeFromButton", { data: this });
            }
            return false;
          },
        );
      }

      theme.cartNoteMonitor.load($('.checkout-note [name="note"]', container));

      $(container).on(
        "click.cartTemplateSection",
        "button[data-toggle-shipping]",
        function () {
          $("#shipping-calculator").toggle();
          var alt = $(this).data("toggle-html");
          $(this).data("toggle-html", $(this).html());
          $(this).html(alt);
          return false;
        },
      );
    };

    this.functions = {
      refreshCartDependentContent: function refreshCartDependentContent() {
        if (this.cartRefreshXhr) {
          this.cartRefreshXhr.abort();
        }
        // fetch new html for the page
        this.cartRefreshXhr = $.ajax({
          type: "GET",
          url: theme.routes.cart_url,
          success: function (data) {
            var toReplace = [
              ".cart-item-list",
              ".checkout-subtotal-container__dynamic",
            ];
            var $newDom = $("<div>" + data + "</div>");

            // remove any transitions
            $newDom.find(".fade-in").removeClass("fade-in");
            $newDom.find("[data-cc-animate]").removeAttr("data-cc-animate");

            for (var i = 0; i < toReplace.length; i++) {
              this.replacingContent = true; // to avoid triggering change events when focus is lifted before DOM replacement
              var $toReplace = this.$container.find(toReplace[i]),
                $replaceWith = $newDom.find(toReplace[i]);
              // preserve loaded images
              $replaceWith.find(".cart-item__image").each(function () {
                var $match = $toReplace.find("#" + this.id);
                if ($match.length) {
                  $(this).replaceWith($match.clone());
                }
              });
              $toReplace.replaceWith($replaceWith);
              this.replacingContent = false;
            }

            //ech0
            if (typeof window.aa_freegift !== "undefined") {
              console.log("Reload aa_freegift when update cart - 1");
              var aaFreeGiftElementShow = $("body").attr(
                "data-aafreegiftelementshow",
              );
              var aaFreeGiftCart = window.aa_freegift.getCart();
              var aaFreeGiftProductList =
                window.aa_freegift.getProductList(aaFreeGiftCart);
              window.aa_freegift.checkGiftInCartData(aaFreeGiftCart);
              if (aaFreeGiftElementShow == "1") {
                console.log("Reload aa_freegift when update cart - 2");
                window.aa_freegift.cartRemoveGift(
                  aaFreeGiftCart,
                  aaFreeGiftProductList,
                  false,
                );
                window.aa_freegift.checkoutLastCheck(aaFreeGiftCart);
                window.aa_freegift.cartFreeGiftItems(aaFreeGiftProductList);
                window.aa_freegift.getProductCartSwiperInit();
                window.aa_freegift.notice_render(
                  aaFreeGiftElementShow,
                  aaFreeGiftCart,
                );
                window.aa_freegift.modal_foot_button(aaFreeGiftCart);
              } else {
                console.log("Reload aa_freegift when update cart - 3");
                window.aa_freegift.cartRemoveGift(
                  aaFreeGiftCart,
                  aaFreeGiftProductList,
                  true,
                );
              }
              if (
                typeof window.aa_freegift.apiCollections_urls !== "undefined" &&
                window.aa_freegift.apiCollections_urls != ""
              ) {
                $(".aa-freegift-cart .aa-head .aa-freegift-notice").attr(
                  "data-link",
                  window.aa_freegift.apiCollections_urls,
                );
              }
            }
            //ech0
          }.bind(this),
          error: function error(data) {
            if (data.statusText != "abort") {
              console.log("Error refreshing page");
              console.log(data);
            }
          },
          complete: function () {
            this.cartRefreshXhr = null;
          }.bind(this),
        });
      },

      updateCart: function updateCart(params, successCallback) {
        if (this.cartXhr) {
          this.cartXhr.abort();
        }
        if (this.cartRefreshXhr) {
          this.cartRefreshXhr.abort();
        }
        this.cartXhr = $.ajax({
          type: "POST",
          url: theme.routes.cart_change_url + ".js",
          data: params,
          dataType: "json",
          success: function success(data) {
            document.documentElement.dispatchEvent(
              new CustomEvent("theme:cartchanged", {
                bubbles: true,
                cancelable: false,
                detail: data,
              }),
            );

            successCallback();
          },
          error: function error(data) {
            if (data.statusText != "abort") {
              console.log("Error processing update");
              console.log(data);
            }
          },
          complete: function () {
            this.cartXhr = null;
          }.bind(this),
        });
      },
    };

    this.onSectionUnload = function (container) {
      $(document).off(".cartTemplateSection");
      $(container).off(".cartTemplateSection");
      theme.cartNoteMonitor.unload(
        $('.checkout-note [name="note"]', container),
      );
    };
  })();

  theme.CollectionTemplateSection = new (function () {
    this.onSectionLoad = function (container) {
      this.namespace = theme.namespaceFromSection(container);
      this.$container = $(container);

      this.filterer = new theme.LoadFilterer(this);

      // button subcollection link hide/reveal
      $(window).on(
        "debouncedresize" + this.namespace,
        this.functions.truncateButtonSubcollections.bind(this),
      );
      this.functions.truncateButtonSubcollections.call(this);
      // 处理 linkfirstoid 参数重新排序商品
      theme.handleLinkFirstOidSorting(this.$container[0], ".product-list");

      // 处理移动端逻辑 商品列表-移动端-悬浮购物车
      if (window.innerWidth < 768) {
        theme.loadCollectionTemplateListMobile.onSectionLoad(container);
      }

      // gallery subcollection carousel
      var $subcollectionGallery = $(
        ".subcollection-links--gallery .gallery",
        container,
      );
      $subcollectionGallery
        .on("init", function () {
          $(".lazyload--manual", this)
            .removeClass("lazyload--manual")
            .addClass("lazyload");
        })
        .slick({
          autoplay: false,
          fade: false,
          infinite: false,
          swipeToSlide: true,
          slidesToShow: Math.min(
            4,
            $(".subcollection-links--gallery .gallery__item", container).length,
          ),
          slidesToScroll: 1,
          useTransform: true,
          arrows: true,
          dots: false,
          prevArrow:
            '<button type="button" class="image-page-button image-page-button--previous ltr-icon" aria-label="' +
            theme.strings.previous +
            '">' +
            theme.icons.chevronLeft +
            "</button>",
          nextArrow:
            '<button type="button" class="image-page-button image-page-button--next ltr-icon" aria-label="' +
            theme.strings.next +
            '">' +
            theme.icons.chevronRight +
            "</button>",
          rtl: document.querySelector("html[dir=rtl]") ? true : false,
          responsive: [
            {
              breakpoint: 1000,
              settings: {
                slidesToShow: Math.min(
                  3,
                  $(".subcollection-links--gallery .gallery__item", container)
                    .length,
                ),
              },
            },

            {
              breakpoint: 768,
              settings:
                $subcollectionGallery.data("mobile-item-count") == "hide"
                  ? "unslick"
                  : {
                      slidesToShow:
                        $subcollectionGallery.data("mobile-item-count"),
                    },
            },
          ],
        });
    };

    this.onSectionUnload = function (container) {
      this.filterer.destroy();
      $(".subcollection-links__expander", this.$container).off("click");
      $(".slick-slider", container).slick("unslick").off("init");
      $(window).off(this.namespace);
    };

    this.functions = {
      truncateButtonSubcollections: function truncateButtonSubcollections() {
        var $subcollections = $(
          ".subcollection-links--buttons",
          this.$container,
        );
        if ($subcollections.css("display") == "flex") {
          var limit = 4;
          var $btns = $subcollections.find(".btn");
          if (
            $btns.length > limit &&
            $subcollections.find(".subcollection-links__expander").length === 0
          ) {
            $btns.slice(limit - 1).hide();
            $(
              '<a href="#" class="btn btn--tertiary subcollection-links__expander">',
            )
              .text(theme.strings.collections_general_see_all_subcollections)
              .appendTo($subcollections)
              .on("click", function (evt) {
                evt.preventDefault();
                $(this).siblings().show();
                $(this).remove();
              });
          }
        } else if (
          $subcollections.find(".subcollection-links__expander").length
        ) {
          $subcollections
            .find(".subcollection-links__expander")
            .siblings()
            .show();
          $subcollections.find(".subcollection-links__expander").remove();
        }
      },
    };
  })();

  theme.CustomRowSection = new (function () {
    this.onSectionLoad = function (container) {
      theme.VideoManager.onSectionLoad(container);
    };

    this.onSectionUnload = function (container) {
      theme.VideoManager.onSectionUnload(container);
    };
  })();

  theme.FeaturedCollectionSection = new (function () {
    let countdownListArrNew = {};
    function runCountdownListNew(container) {
      var self = this;
      var $countdownContainer = $(container);
      if ($countdownContainer.hasClass("countdown-container")) {
        $countdownContainer.find(".owl-item .block-inner").each(function (e) {
          if ($(this).find(".countdown-speed").length == 0) {
            var productId = $(this).parent().attr("data-product-id");
            if (countdownListArrNew[productId]) {
              $(this).append(
                '<div class="countdown-speed" style="width: 100%; margin-top: 14px; height: 15px; background: #FFF1C6; border-radius: 10px;"><div style="color: #000; font-size: 12px; line-height: 15px; white-space: pre; width: ' +
                  countdownListArrNew[productId] +
                  '; height: 15px; background: #C4D606; border-radius: 10px; text-align: left; padding-left: 10px;">' +
                  countdownListArrNew[productId] +
                  " Sold</div></div>",
              );
            }
          }
        });
        setTimeout(function () {
          runCountdownListNew(self);
        }, 500);
      }
    }
    function runCountdownContainerNew(container) {
      if ($(container).hasClass("countdown-container")) {
        var $target = $(container);
        if (window.innerWidth > 758) {
          $target
            .find(".js-featured-collection-slider")
            .css("position", "relative");
          $target
            .find(".js-featured-collection-slider .flash-sale-header-new")
            .append(
              '<div class="flash-sale-header-new-countdown"><div class="flash-sale-text">END IN</div><div class="countdown-time"></div></div>',
            );
        } else {
          $target.find(".page-header").css("position", "relative");
          $target.css("position", "relative");
          $target
            .find(
              ".js-featured-collection-slider .flash-sale-header-new .flash-sale-header-new-countdown",
            )
            .html(
              '<div class="flash-sale-text">END IN</div><div class="countdown-time"></div>',
            );
          if ($target.find(".view-all").length == 0) {
            $target.find(".countdown-div").css("top", "50px");
          }
        }
        runFlashSaleCountdown(
          $target.find(".countdown-time"),
          $target.attr("end_time"),
        );

        var labelList = $target.find(
          ".product-block .product-label-container-new .product-label-new--sale",
        );
        for (var idx = 0; idx < labelList.length; idx++) {
          var spanstr = labelList.eq(idx).html();
          var sale_amount = labelList.eq(idx).attr("data-amount");
          labelList.eq(idx).css("background", "#092F18");
          labelList.eq(idx).css("font-size", "12px");
          labelList.eq(idx).css("color", "#fff");
          labelList.eq(idx).css("display", "flex");
          labelList.eq(idx).css("justify-content", "center");
          labelList.eq(idx).css("align-items", "center");
          if (window.innerWidth > 758) {
            labelList.eq(idx).css("width", "62px");
          } else {
            labelList.eq(idx).css("width", "55px");
          }
          spanstr =
            '<svg style="width: 12px;height: 12px;" xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none"><path d="M2 6.70312L3.68421 0H7.78947L6.10526 3.96094H10L2.21053 13L4.84211 6.70312H2Z" fill="white"/></svg>' +
            "<span>-" +
            sale_amount +
            "</span>";
          labelList.eq(idx).html(spanstr);
        }
        if (window.location.pathname != "/pages/homepage") {
          //$target.find(".product-block__title").css("color", "#000");
          //$target.find(".product-block__title").css("font-weight", "500");
          $target.find(".product-price").css("color", "#000");
        }
      }
    }
    function handleQuickbuy(container) {
      var self = this;
      var url =
        dtc_url +
        "api/activity/flashSale?shop_id=3&activity_site=us&current=" +
        (Math.random() + "").substr(2);
      $.ajax({
        url: url,
        timeout: dtc_time_out, // 设置超时时间为 3 秒
        success: function (result) {
          if (result.end_in) {
            container.attributes.class.value =
              container.attributes.class.value + " countdown-container";
            container.setAttribute("end_time", result.end_in);
            runCountdownContainerNew(container);
            var $countdownContainer = $(container);
            if ($countdownContainer.hasClass("countdown-container")) {
              if (window.innerWidth > 758) {
                $countdownContainer
                  .find(".product-block .block-inner")
                  .each(function (e) {
                    if (result.inv_obj[e]) {
                      var productId = $(this).parent().attr("data-product-id");
                      countdownListArrNew[productId] = result.inv_obj[e];
                      $(this).append(
                        '<div class="countdown-speed" style="width: 100%; margin-top: 14px; height: 16px; background: #EEEEEE; border-radius: 10px;"><div style="color: #000; font-size: 12px; line-height: 16px; white-space: pre; width: ' +
                          result.inv_obj[e] +
                          '; height: 16px; background: #C4D606; border-radius: 10px; text-align: left; padding-left: 10px;font-family: Roboto;">Only ' +
                          result.inv_obj[e] +
                          " left</div></div>",
                      );
                    }
                  });
              }
              if (window.innerWidth <= 758) {
                $countdownContainer
                  .find(".product-block .block-inner")
                  .each(function (e) {
                    if (result.inv_obj[e]) {
                      var productId = $(this).parent().attr("data-product-id");
                      countdownListArrNew[productId] = result.inv_obj[e];
                      $(this).append(
                        '<div class="countdown-speed" style="margin-top: 14px;width: 100%; height: 12px; background: #EEEEEE; border-radius: 10px;"><div style="color: #000; font-size: 10px; line-height: 12px; white-space: pre; width: ' +
                          result.inv_obj[e] +
                          '; height: 12px; background: #C4D606; border-radius: 10px; text-align: left; padding-left: 6px;font-family: Roboto;">Only ' +
                          result.inv_obj[e] +
                          " left</div></div>",
                      );
                    }
                  });
              }
              runCountdownListNew(container);
            }
          }
        },
        error: function (xhr, status, error) {},
      });
    }
    function updateButtonText(container, viewMoreNode, isMobile) {
      if (!viewMoreNode) return;
      const productListNode = container.querySelector(
        ".js-featured-collection-slider .featured-collection__product-list",
      );

      if (!productListNode) return;
      const hiddenClass = isMobile ? "hidden-mobile" : "hidden-pc";

      const hiddenProductBlocks = productListNode.querySelectorAll(
        `.product-block.${hiddenClass}`,
      );

      if (hiddenProductBlocks.length === 0) {
        // 没有更多商品，显示 "Less"
        viewMoreNode.textContent = "Less";
      } else {
        // 还有隐藏商品，显示 "More"
        viewMoreNode.textContent = "More";
      }
    }
    function handleBuyNow(container) {
      var self = this;
      var $buyNowButton = $(container).find(".js-product-block-buy-now");
      if ($buyNowButton.length > 0) {
        $buyNowButton.on("click", function (e) {
          e.preventDefault();
          var $button = $(this);
          var $productBlock = $button.closest(".product-block");
          var pageWidth = $(window).width();

          // PC端：触发 quickbuy-toggle 按钮
          if (pageWidth >= 768) {
            var $quickbuyToggle = $productBlock.find(".quickbuy-toggle");
            if ($quickbuyToggle.length > 0) {
              $quickbuyToggle.first().trigger("click");
            }
          }
          // 移动端：触发 image-add-to-cart-button 按钮
          else {
            var $imageAddToCartButton = $productBlock.find(
              ".image-add-to-cart-button",
            );
            // 如果按钮不存在（可能因为 enable_buy_now 被隐藏），创建一个临时的
            if ($imageAddToCartButton.length === 0) {
              var productUrl = $button.data("href");
              if (productUrl) {
                $imageAddToCartButton = $("<div>")
                  .addClass("image-add-to-cart-button")
                  .attr("data-product-id", $button.data("product-id"))
                  .attr("data-href", productUrl)
                  .css({ display: "none" })
                  .appendTo($productBlock.find(".image-cont"));
              }
            }
            if ($imageAddToCartButton.length > 0) {
              $imageAddToCartButton.first().trigger("click");
            }
          }
        });
      }
    }
    function handleMoreMode(container, moreModeNode) {
      const isMobile = moreModeNode.includes("mobile");
      const hiddenClass = isMobile ? "hidden-mobile" : "hidden-pc";
      const handlerKey = "data-more-mode-handler-" + moreModeNode;
      if (container.hasAttribute(handlerKey)) {
        const viewMoreNode = container.querySelector(
          ".featured-collection_view-more",
        );
        if (viewMoreNode) {
          updateButtonText(container, viewMoreNode, isMobile);
        }
        return;
      }
      container.setAttribute(handlerKey, "true");
      const loadMoreCountAttr = moreModeNode.includes("mobile")
        ? "data-load-more-count-mobile"
        : "data-load-more-count-pc";
      const loadMoreCount = parseInt(
        container.getAttribute(loadMoreCountAttr) ||
          container.getAttribute("data-load-more-count") ||
          "4",
        10,
      );
      const viewMoreNode = container.querySelector(
        ".featured-collection_view-more",
      );
      if (viewMoreNode) {
        updateButtonText(container, viewMoreNode, isMobile);
      }
      container.addEventListener("click", function (e) {
        const target = e.target;
        const clickedViewMore = target.closest(
          ".featured-collection_view-more",
        );

        if (!clickedViewMore) return;

        e.preventDefault();
        e.stopPropagation();
        const currentViewMoreNode = container.querySelector(
          ".featured-collection_view-more",
        );
        if (!currentViewMoreNode) return;
        const productListNode = container.querySelector(
          ".js-featured-collection-slider .featured-collection__product-list",
        );

        if (!productListNode) return;
        const hiddenProductBlocks = productListNode.querySelectorAll(
          `.product-block.${hiddenClass}`,
        );
        const allProductBlocks =
          productListNode.querySelectorAll(".product-block");

        if (hiddenProductBlocks.length === 0) {
          // 没有隐藏商品，点击 "Less" 收回所有商品
          allProductBlocks.forEach((block, index) => {
            if (index >= loadMoreCount) {
              block.classList.add(hiddenClass);
            }
          });
          currentViewMoreNode.textContent = "More";
          container.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        } else {
          // 显示下一批商品
          const countToShow = Math.min(
            loadMoreCount,
            hiddenProductBlocks.length,
          );
          for (let i = 0; i < countToShow; i++) {
            hiddenProductBlocks[i].classList.remove("hidden");
          }
          // 更新按钮文本
          updateButtonText(container, currentViewMoreNode, isMobile);
        }
      });
    }
    /** PC / 移动端共用同一套 Embla 视口与控件（slidesToScroll 按视口区分） */
    function handleFeaturedEmblaSlider(container, isMobileViewport) {
      const emblaNode = container.querySelector(".featured-collection_embla");
      if (!emblaNode) return;

      const viewportNode = emblaNode.querySelector(
        ".featured-collection_embla__viewport",
      );
      const prevBtnNode = emblaNode.querySelector(
        ".featured-collection_embla__button--prev",
      );
      const nextBtnNode = emblaNode.querySelector(
        ".featured-collection_embla__button--next",
      );
      const progressNode = emblaNode.querySelector(
        ".featured-collection_progress__bar_js",
      );

      if (!viewportNode) return;

      const OPTIONS = {
        slidesToScroll: isMobileViewport ? 1 : 4,
      };
      const emblaApi = EmblaCarousel(viewportNode, OPTIONS);

      $(
        '.product-block__image--primary .lazyload--manual, .product-block__image--secondary[data-image-index="1"] .lazyload--manual, .product-block-options__item.lazyload--manual',
        emblaNode,
      )
        .removeClass("lazyload--manual")
        .addClass("lazyload");

      theme.ProductBlockManager.loadImages(container);

      if (prevBtnNode && nextBtnNode) {
        const removePrevNextBtnsClickHandlers =
          window.addPrevNextBtnsClickHandlers(
            emblaApi,
            prevBtnNode,
            nextBtnNode,
          );
        emblaApi.on("destroy", removePrevNextBtnsClickHandlers);
      }

      if (progressNode) {
        const { applyProgress, removeProgress } = window.setupProgressBar(
          emblaApi,
          progressNode,
        );

        emblaApi.on("init", () => {
          applyProgress();
          emblaApi.reInit();
        });

        emblaApi
          .on("init", applyProgress)
          .on("select", applyProgress)
          .on("slideFocus", applyProgress)
          .on("destroy", removeProgress);

        applyProgress();
      }
    }
    this.onSectionLoad = function (container) {
      const isMobile = $(window).width() < 768;
      console.log("[featured-collection] section load", {
        isMobile,
        enableCarouselPc: container.getAttribute("data-enable-carousel-pc"),
        enableCarouselMobile: container.getAttribute(
          "data-enable-carousel-mobile",
        ),
      });
      // 处理闪购逻辑
      const enableQuickbuy = container.getAttribute("data-enable-quickbuy");
      if (enableQuickbuy == "true" || enableQuickbuy == true) {
        handleQuickbuy(container);
      }
      const enableCarouselPc = container.getAttribute(
        "data-enable-carousel-pc",
      );
      const enableMoreModePc = container.getAttribute(
        "data-enable-more-mode-pc",
      );
      const enableCarouselMobile = container.getAttribute(
        "data-enable-carousel-mobile",
      );
      const enableMoreModeMobile = container.getAttribute(
        "data-enable-more-mode-mobile",
      );
      if (isMobile) {
        theme.loadMobileQuickbuy.onSectionLoad(container);
        if (enableCarouselMobile == "true" || enableCarouselMobile == true) {
          handleFeaturedEmblaSlider(container, true);
        } else if (
          enableMoreModeMobile == "true" ||
          enableMoreModeMobile == true
        ) {
          handleMoreMode(container, ".js-featured-collection-slider-mobile");
        }
      } else {
        if (enableCarouselPc == "true" || enableCarouselPc == true) {
          handleFeaturedEmblaSlider(container, false);
        } else {
          theme.ProductBlockManager.loadImages(container);
        }
        // 处理More Mode逻辑
        if (enableMoreModePc == "true" || enableMoreModePc == true) {
          handleMoreMode(container, ".js-featured-collection-slider");
        }
      }
      // 处理 linkfirstoid 参数重新排序商品
      theme.handleLinkFirstOidSorting(
        container,
        ".featured-collection__product-list",
      );
      // 处理Buy Now逻辑
      handleBuyNow(container);
    };

    this.onSectionUnload = function (container) {
      theme.ProductBlockManager.unloadImages(container);
      theme.unloadCarousels(container);
    };
  })();

  theme.CommonCarouselsSection = new (function () {
    this.onSectionLoad = function (container) {
      var $carousels = theme.loadCarousels(container);
      if ($carousels.length === 0) {
        theme.ProductBlockManager.loadImages(container);
      }
    };

    this.onSectionUnload = function (container) {
      theme.ProductBlockManager.unloadImages(container);
      theme.unloadCarousels(container);
    };
  })();

  theme.FeaturedCollectionsSection = new (function () {
    this.onSectionLoad = function (container) {
      var $carousels = theme.loadCarousels(container);
      // carousels load blocks after init
      if ($carousels.length === 0) {
        theme.ProductBlockManager.loadImages(container);
      }
    };

    this.onSectionUnload = function (container) {
      theme.ProductBlockManager.unloadImages(container);
      theme.unloadCarousels(container);
    };
  })();

  theme.FeaturedProductSection = new (function () {
    this.onSectionLoad = function (container) {
      // init gallery (before product form - so it can respond to variant images)
      theme.initProductGallery(container);

      // init product form
      $(".product-form", container).trigger("load-product-form");

      theme.ProductBlockManager.loadImages(container);
    };

    this.onSectionUnload = function (container) {
      theme.ProductBlockManager.unloadImages(container);
      theme.destroyProductGallery(container);
      $(".product-form", container).trigger("unload-product-form");
      $(".slideshow", container).slick("unslick");
    };
  })();

  theme.FooterSection = new (function () {
    this.onSectionLoad = function (container) {
      document
        .querySelector(".footer-newsletter.signup-form .signup-form__button")
        ?.addEventListener("click", function () {
          ptengine && ptengine.track("email-sign-up-footer");
        });
      $(".disclosure", container).each(function () {
        $(this).data("disclosure", new theme.Disclosure($(this)));
      });
      // 处理移动端逻辑
      if (window.innerWidth < 768) {
        $(".footer-menu-mobile_item .footer-menu-mobile__icon").on(
          "click",
          function (e) {
            e.preventDefault();
            var $item = $(this).closest(".footer-menu-mobile_item");
            var $ul = $item.find("ul");
            var $icon = $(this);

            // 切换active类
            $item.toggleClass("active");

            // 切换ul的显示状态
            if ($item.hasClass("active")) {
              $ul.slideDown(300);
              // 隐藏footer-menu-mobile_item_row1的下边框
              $item
                .find(".footer-menu-mobile_item_row1")
                .css("border-bottom", "none");
            } else {
              $ul.slideUp(300);
              $item
                .find(".footer-menu-mobile_item_row1")
                .css("border-bottom", "1px solid #ffffff");
            }
          },
        );
      }
    };

    this.onSectionUnload = function (container) {
      $(".disclosure", container).each(function () {
        $(this).data("disclosure").unload();
      });
    };
  })();

  theme.GallerySection = new (function () {
    this.onSectionLoad = function (container) {
      var $carouselGallery = $(".gallery--mobile-carousel", container);
      if ($carouselGallery.length) {
        var assessCarouselFunction = function assessCarouselFunction() {
          var isCarousel = $carouselGallery.hasClass("slick-slider"),
            shouldShowCarousel = $(window).width() < 768;

          if (!shouldShowCarousel) {
            $(".lazyload--manual", $carouselGallery)
              .removeClass("lazyload--manual")
              .addClass("lazyload");
          }

          if (isCarousel && !shouldShowCarousel) {
            // Destroy carousel

            // - unload slick
            $carouselGallery.slick("unslick").off("init");
            $carouselGallery
              .find("a, .gallery__item")
              .removeAttr("tabindex")
              .removeAttr("role");

            // - re-row items
            var rowLimit = $carouselGallery.data("grid");
            var $currentRow = null;
            $carouselGallery.find(".gallery__item").each(function (index) {
              if (index % rowLimit === 0) {
                $currentRow = $('<div class="gallery__row">').appendTo(
                  $carouselGallery,
                );
              }
              $(this).appendTo($currentRow);
            });
          } else if (!isCarousel && shouldShowCarousel) {
            // Create carousel

            // - de-row items
            $carouselGallery.find(".gallery__item").appendTo($carouselGallery);
            $carouselGallery.find(".gallery__row").remove();

            // - init carousel
            $carouselGallery
              .on("init", function () {
                $(".lazyload--manual", this)
                  .removeClass("lazyload--manual")
                  .addClass("lazyload");
              })
              .slick({
                autoplay: false,
                fade: false,
                infinite: true,
                useTransform: true,
                arrows: false,
                dots: true,
                customPaging: function customPaging(slider, i) {
                  return (
                    '<button class="custom-dot" type="button" data-role="none" role="button" tabindex="0">' +
                    '<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 30 30" xml:space="preserve">' +
                    '<circle class="circle-one" cx="15" cy="15" r="13" />' +
                    '<circle class="circle-two" cx="15" cy="15" r="13" />' +
                    "</svg>" +
                    "</button>"
                  );
                },
                rtl: document.querySelector("html[dir=rtl]") ? true : false,
              });
          }
        };

        assessCarouselFunction();
        $(window).on(
          "debouncedresize.themeSection" + container.id,
          assessCarouselFunction,
        );
      }

      // Tidier typography
      $(".overlay-text__title, .overlay-text__rte", container).each(
        function () {
          theme.avoidUnecessaryOrphans(this);
        },
      );
    };

    this.onSectionUnload = function (container) {
      $(window).off(".themeSection" + container.id);
      $(".slick-slider", container).each(function () {
        $(this).slick("unslick").off("init");
      });
    };

    this.onBlockSelect = function (block) {
      var blockSlideIndex = $(block).data("slick-index");
      $(block)
        .closest(".slick-slider")
        .each(function () {
          $(this).slick("slickGoTo", blockSlideIndex);
        });
    };
  })();

  theme.HeaderSection = new (function () {
    this.onSectionLoad = function (container) {
      // block focus events targeted at the social icons
      $(container).on(
        "focusin.headerSection focusout.headerSection",
        ".social-links",
        function (e) {
          return false;
        },
      );

      // asses focus, and handle transitioning between child elements with a timeout
      var searchFocusOutTimeoutId = -1;
      $(container).on(
        "focusin.headerSection focusout.headerSection",
        ".search-box",
        function (e) {
          if (e.type == "focusin") {
            clearTimeout(searchFocusOutTimeoutId);
            $(this).closest(".search-box").addClass("focus");
          } else {
            clearTimeout(searchFocusOutTimeoutId);
            searchFocusOutTimeoutId = setTimeout(
              function () {
                $(this).closest(".search-box").removeClass("focus");
              }.bind(this),
              200,
            );
          }
        },
      );

      // Toggle search
      $(container).on(
        "click.headerSection",
        ".show-search-link, .main-search__close",
        function (e) {
          if ($("body").toggleClass("show-search").hasClass("show-search")) {
            setTimeout(function () {
              $(".main-search__input:first").focus();
            }, 500);
            $(".main-search__suggestions .lazyload--manual")
              .removeClass("lazyload--manual")
              .addClass("lazyload");
          } else {
            $(".show-search-link:first").focus();
          }
          return false;
        },
      );

      // Close search on escape
      $(container).on(
        "keyup.headerSection",
        ".main-search__input",
        function (e) {
          if (e.keyCode == 27) {
            $(".main-search__close").click();
          }
        },
      );

      /// Live search
      var $liveSearchContainer = $(
        '.main-search[data-live-search="true"]',
        container,
      );
      if ($liveSearchContainer.length) {
        var searchTimeoutThrottle = 500,
          searchTimeoutID = -1,
          currReqObj = null,
          resultLimit = 8,
          showPrice = $liveSearchContainer.data("live-search-price"),
          showVendor = $liveSearchContainer.data("live-search-vendor"),
          includeMeta = $liveSearchContainer.data("live-search-meta"),
          perRowMob = $liveSearchContainer.data("per-row-mob");

        $(container).on(
          "keyup.headerSection change.headerSection",
          ".main-search__input",
          function () {
            var $searchContainer = $(".main-search"),
              $resultsBox = $searchContainer.find(".main-search__results"),
              valueToSearch = $(this).val();

            //Only search if search string longer than 2, and it has changed
            if (
              valueToSearch.length > 2 &&
              valueToSearch != $(this).data("oldval")
            ) {
              //Reset previous value
              $(this).data("oldval", valueToSearch);

              // Kill outstanding ajax request
              if (currReqObj != null) {
                currReqObj.abort();
              }

              // Kill previous search
              clearTimeout(searchTimeoutID);

              // Create URL for full search results
              var $form = $(this).closest("form");
              var linkURL =
                $form.attr("action") +
                ($form.attr("action").indexOf("?") > -1 ? "&" : "?") +
                $form.serialize();

              //Show loading
              $searchContainer
                .removeClass(
                  "main-search--has-results main-search--results-on-multiple-lines main-search--no-results",
                )
                .addClass("main-search--loading");
              if ($(".main-search__results-spinner").length === 0) {
                $resultsBox.html(
                  '<div class="main-search__results-spinner"><div class="loading-spinner"></div></div>',
                );
              }

              // 搜索集合页时，搜索结果中只显示包含这些关键字的集合页
              const collectionFilterKeyword = $form
                .find('input[name="options[filter_search_keyword]"]')
                .val();

              // Do next search (in X milliseconds)
              searchTimeoutID = setTimeout(function () {
                var ajaxUrl, ajaxData;
                if (theme.Shopify.features.predictiveSearch) {
                  // use the API
                  ajaxUrl = theme.routes.predictive_search_url;
                  ajaxData = {
                    q: valueToSearch,
                    section_id: "predictive-search",
                    resources: {
                      type: $form.find('input[name="type"]').val(),
                      limit: resultLimit,
                      options: {
                        unavailable_products: "last",
                        fields: includeMeta
                          ? "title,product_type,variants.title,vendor,tag,variants.sku"
                          : "title,product_type,variants.title,vendor",
                      },
                    },
                  };
                } else {
                  // use the theme template fallback
                  ajaxUrl = linkURL;
                  ajaxData = {
                    section_id: "main-search",
                  };
                }
                //Ajax hit on search page
                currReqObj = $.ajax({
                  url: ajaxUrl,
                  data: ajaxData,
                  dataType: "html",
                  success: function success(response) {
                    var $resultsList = null;
                    if (!theme.Shopify.features.predictiveSearch) {
                      $resultsList = $("<div>" + response + "</div>").find(
                        '[data-section-type="search-template"] .product-list',
                      );
                    } else {
                      $resultsList = $(response).find(".product-list");
                    }
                    // reset previous contents
                    currReqObj = null;
                    theme.ProductBlockManager.unloadImages($resultsBox);
                    $searchContainer.removeClass(
                      "main-search--has-results main-search--results-on-multiple-lines main-search--no-results",
                    );
                    $resultsBox.empty();

                    var $resultsProducts = $(
                      '<div class="main-search__results__products collection-listing"><div></div></div>',
                    );
                    var $resultsPages = $(
                      '<div class="main-search__results__pages">',
                    );

                    $resultsProducts.children()[0].className =
                      $resultsList[0].className;

                    $resultsList
                      .find(
                        ".product-block:not(.collection-block):not(.page-block)",
                      )
                      .slice(0, resultLimit)
                      .addClass("main-search-result")
                      .each(function () {
                        $(this).find(".btn.quickbuy-toggle").remove();
                        $(this)
                          .find(".quickbuy-toggle")
                          .removeClass("quickbuy-toggle");
                        if (!showPrice) {
                          $(this).find(".product-price").remove();
                        }
                        if (!showVendor) {
                          $(this).find(".vendor").remove();
                        }
                      })
                      .appendTo($resultsProducts.children());

                    $resultsList
                      .find(".product-block.page-block")
                      .each(function () {
                        var $item = $(
                          '<a class="main-search-result main-search-result--page">',
                        ).attr("href", $(this).find("a:first").attr("href"));
                        $('<div class="main-search-result__text">')
                          .text($(this).find(".page-block__title").text())
                          .appendTo($item);
                        $resultsPages.append($item);
                      });

                    $resultsList
                      .find(".product-block.collection-block")
                      .slice(0, resultLimit)
                      .addClass("main-search-result")
                      .each(function () {
                        var $block = $(this);
                        var title = $block
                          .find(".product-block__title")
                          .text()
                          .trim();
                        if (
                          collectionFilterKeyword !== "" &&
                          collectionFilterKeyword.includes(title)
                        ) {
                          $block.addClass("main-search-result");
                          $block.find(".btn.quickbuy-toggle").remove();
                          $block
                            .find(".quickbuy-toggle")
                            .removeClass("quickbuy-toggle");
                          if (!showPrice) {
                            $block.find(".product-price").remove();
                          }
                          if (!showVendor) {
                            $block.find(".vendor").remove();
                          }
                          $block.appendTo($resultsProducts.children());
                        }
                      });

                    $searchContainer.removeClass("main-search--loading");

                    var areProducts =
                        $resultsProducts.find(".main-search-result:first")
                          .length > 0,
                      arePages =
                        $resultsPages.find(".main-search-result:first").length >
                        0;
                    if (areProducts || arePages) {
                      // Numerous results
                      $searchContainer.addClass("main-search--has-results");
                      $searchContainer.toggleClass(
                        "main-search--results-on-multiple-lines",
                        $resultsProducts.find(".product-block").length > 4,
                      );
                      if (areProducts) {
                        $resultsBox.append($resultsProducts);
                        theme.ProductBlockManager.loadImages($resultsProducts);
                      }
                      if (arePages) {
                        $('<h6 class="main-search-result__heading">')
                          .html(theme.strings.general_quick_search_pages)
                          .prependTo($resultsPages);
                        $resultsBox.append($resultsPages);
                      }
                      $(
                        '<a class="main-search__results-all-link button altcolour">',
                      )
                        .attr("href", linkURL)
                        .html(theme.strings.layout_live_search_see_all)
                        .appendTo($resultsBox);
                      // 要对那些包含一下关键词的产品进行过滤，即包含这些关键词，不能被搜索出来
                      if (window.theme.settings?.filter_search_keyword) {
                        try {
                          const searchResultEl = document.querySelectorAll(
                            ".main-search__results .product-block.main-search-result",
                          );
                          searchResultEl.forEach((item) => {
                            const title = item
                              .querySelector(".product-block__title")
                              ?.innerText.toLocaleLowerCase();
                            const filterSearchKeywords =
                              window.theme.settings.filter_search_keyword
                                .trim()
                                .toLocaleLowerCase()
                                .split(",");
                            for (
                              let i = 0;
                              i < filterSearchKeywords.length;
                              i++
                            ) {
                              const target = filterSearchKeywords[i].trim();
                              if (title.includes(target)) {
                                item.style.display = "none";
                                break;
                              }
                            }
                          });
                        } catch (error) {
                          console.warn("Error! filter search keyword :", error);
                        }
                      }

                      theme.initAnimateOnScroll();
                    } else {
                      // No results - show nothing
                      $searchContainer.addClass("main-search--no-results");
                      $('<div class="main-search__empty-message">')
                        .html(theme.strings.general_quick_search_no_results)
                        .appendTo($resultsBox);
                    }
                  },
                  error: function error(response) {
                    console.log("Error fetching results");
                  },
                });
              }, searchTimeoutThrottle);
            } else if ($(this).val().length <= 2) {
              // Deleted text? Abandon search-in-progress
              $(this).data("oldval", valueToSearch);
              if (currReqObj != null) {
                currReqObj.abort();
              }
              clearTimeout(searchTimeoutID);

              // Clear results
              $searchContainer.removeClass(
                "main-search--has-results main-search--results-on-multiple-lines main-search--loading",
              );
              $resultsBox.empty();
            }
          },
        );
      }

      // nav
      theme.Navigation.init({
        nav: $(".navigation--main", container),
        mobileNavHtml: $(
          ".mobile-navigation-drawer-template",
          container,
        ).html(),
        proxyTier1Nav: $(".navigation--left", container),
      });

      if (theme.inlineNavigationCheck) {
        theme.inlineNavigationCheck();
        $(window).on(
          "debouncedresize.headerSection",
          theme.inlineNavigationCheck,
        );
      } else if (document.querySelector("#InlineNavigationCheckScript")) {
        // if just enabled in theme editor but not evaluated
        eval(document.querySelector("#InlineNavigationCheckScript").innerHTML);
      }

      // set anything that alters based on contents/viewport/scroll, etc
      this.section = document.querySelector(".section-header");
      this.transparentPageheader = document.querySelector(
        ".pageheader--transparent-permitted",
      );

      this.functions.setSticky.call(this);
      this.functions.setTransparency.call(this);
      this.functions.setHeaderHeightProperty.call(this);

      $(window).on(
        "scroll.headerSection",
        this.functions.afterScroll.bind(this),
      );
      $(window).on(
        "pageshow.headerSection",
        this.functions.afterScroll.bind(this),
      );
      $(window).on(
        "debouncedresize.headerSection",
        this.functions.afterResize.bind(this),
      );

      // account / localization (after mobile nav initialises)
      $(".disclosure", container).each(function () {
        $(this).data("disclosure", new theme.Disclosure($(this)));
      });

      $(".mobile-navigation-drawer .disclosure").each(function () {
        $(this).data("disclosure", new theme.Disclosure($(this)));
        // set up slide-down transition
        var $list = $(".disclosure-list", this),
          listHeight = 0;
        $list.children().each(function () {
          listHeight += $(this).height();
        });
        $(".disclosure-list", this).css("height", "".concat(listHeight, "px"));
      });

      // listen to cart changes
      $(document).on("theme:cartchanged.headerSection", function () {
        $.getJSON(location.origin + "?sections=header", function (data) {
          var cartSummarySelectors = ["#pageheader .logo-area__right__inner"];
          for (var i = 0; i < cartSummarySelectors.length; i++) {
            var $newCartObj = $("<div>" + data.header + "</div>")
              .find(cartSummarySelectors[i])
              .first();
            var $currCart = $(cartSummarySelectors[i]);
            $currCart.html($newCartObj.html());
          }
        });
      });

      // init mobile nav again if it's open and this is a reload
      if (Shopify.designMode && $("body").hasClass("reveal-mobile-nav")) {
        // theme.openMobileNav();
      }
    };

    this.onSectionUnload = function (container) {
      $(container).off(".headerSection");
      $(document).off(".headerSection");
      $(window).off(".headerSection");
      $(window).off("pageshow.headerSection");
      $(".disclosure", container).each(function () {
        $(this).data("disclosure").unload();
      });
      $(".mobile-navigation-drawer .disclosure").each(function () {
        $(this).data("disclosure").unload();
      });
      theme.Navigation.destroy(
        $(".navigation", container),
        $(".navigation--left", container),
      );
    };

    this.functions = {
      afterScroll: function afterScroll() {
        this.functions.setTransparency.call(this);
      },

      afterResize: function afterResize() {
        this.functions.setSticky.call(this);
        this.functions.setHeaderHeightProperty.call(this);
        this.functions.setTransparency.call(this);
      },

      setTransparency: function setTransparency() {
        if (this.transparentPageheader) {
          var bar = document.querySelector(".section-announcement-bar"),
            scrollThreshold = bar ? bar.offsetTop + bar.clientHeight : 0;
          if (!this.isSticky || window.scrollY <= scrollThreshold) {
            this.transparentPageheader.classList.add("pageheader--transparent");
            this.transparentPageheader.classList.remove("offset-header");
          } else {
            // this.transparentPageheader.classList.remove(
            //   "pageheader--transparent",
            // );
            this.transparentPageheader.classList.add("offset-header");
          }
        }
      },

      setSticky: function setSticky() {
        this.isSticky =
          getComputedStyle(this.section).position === "sticky" ||
          getComputedStyle(this.section).position === "-webkit-sticky";
      },

      setHeaderHeightProperty: function setHeaderHeightProperty() {
        var headerHeight = 0,
          stickyHeaderHeight = 0;
        if (this.section) {
          headerHeight = Math.ceil(this.section.clientHeight);
          if (this.isSticky) {
            stickyHeaderHeight = headerHeight;
          }
        }
        document.documentElement.style.setProperty(
          "--theme-header-height",
          headerHeight + "px",
        );
        document.documentElement.style.setProperty(
          "--theme-sticky-header-height",
          stickyHeaderHeight + "px",
        );
      },
    };
  })();

  theme.ImageWithTextOverlaySection = new (function () {
    var _ = this;

    _.checkForHeaderHeightSubtraction = function () {
      $(
        ".section-image-with-text-overlay .height--full-minus-header-height",
      ).each(function () {
        var height = $(window).height();
        // transparent header & top section? slightly different calculation
        if (
          document.querySelector(".pageheader--transparent-permitted") &&
          !this.closest(".shopify-section").previousElementSibling
        ) {
          document
            .querySelectorAll(
              ".section-store-messages, .section-announcement-bar",
            )
            .forEach((el) => {
              height -= el.clientHeight;
            });
        } else {
          height -= document.querySelector(".section-header").clientHeight;
        }
        $(".rimage-outer-wrapper, .placeholder-image", this).height(height);
      });
    };

    this.onSectionLoad = function (container) {
      $(".height--full", container).each(function () {
        if ($(this).closest(".section-image-with-text-overlay").index() == 0) {
          $(this).addClass("height--full-minus-header-height");
          _.checkForHeaderHeightSubtraction();
          $(window)
            .off("debouncedresize.imageWithTextOverlaySection")
            .on(
              "debouncedresize.imageWithTextOverlaySection",
              _.checkForHeaderHeightSubtraction,
            );
        }
      });

      // Tidier typography
      $(".overlay-text__title, .overlay-text__rte", container).each(
        function () {
          theme.avoidUnecessaryOrphans(this);
        },
      );
    };

    this.onSectionUnload = function (container) {
      $(window).off(".imageWithTextOverlaySection");
    };
  })();

  theme.ListCollectionsTemplateSection = new (function () {
    this.onSectionLoad = function (container) {
      theme.ProductBlockManager.loadImages(container);
    };

    this.onSectionUnload = function (container) {
      theme.ProductBlockManager.unloadImages(container);
    };
  })();

  theme.ProductTemplateSection = new (function () {
    this.onSectionLoad = function (container) {
      /// Init store availability if applicable
      if ($("[data-store-availability-container]", container).length) {
        this.storeAvailability = new theme.StoreAvailability(
          $("[data-store-availability-container]", container)[0],
        );
      }
      theme.initProductSlick(container);
      // init gallery (before product form - so it can respond to variant images)
      theme.initProductGallery(container);

      // init product form
      $(".product-form", container).trigger("load-product-form");
      $(".product-column-float-mobile .product-form").trigger(
        "load-product-form",
      );
      $(".product-column-float-pc .product-form").trigger("load-product-form");

      theme.ProductBlockManager.loadImages(container);

      // click review rating under title
      $(".theme-product-reviews", container).on("click", "a", function () {
        $("html,body").animate(
          {
            scrollTop: $($(this).attr("href")).offset().top,
          },
          1000,
        );
        return false;
      });

      $(".product-column-float-mobile ").on(
        "click",
        ".close-icon a",
        function (event) {
          event.preventDefault();
          $(".product-column-float-mobile").fadeOut(500);
          $("body").css("overflow", "auto");
        },
      );

      $(".product-column-float-mobile ").on("click", ".overlay", function () {
        $(".product-column-float-mobile").fadeOut(500);
        $("body").css("overflow", "auto");
      });
    };

    this.onSectionUnload = function (container) {
      theme.ProductBlockManager.unloadImages(container);
      theme.destroyProductGallery(container);
      $(".product-form", container).trigger("unload-product-form");
      $(".theme-product-reviews", container).off("click");
      if (this.storeAvailability) {
        this.storeAvailability.onSectionUnload();
      }
    };
  })();

  theme.SearchTemplateSection = new (function () {
    this.onSectionLoad = function (container) {
      this.namespace = theme.namespaceFromSection(container);
      this.$container = $(container);

      this.filterer = new theme.LoadFilterer(this);
    };

    this.onSectionUnload = function () {
      this.filterer.destroy();
    };
  })();

  theme.SlideshowSection = new (function () {
    var _ = this;

    _.checkForHeaderHeightSubtraction = function () {
      $(".section-slideshow .height--full-minus-header-height").each(
        function () {
          var height = $(window).height();
          // transparent header & top section? slightly different calculation
          if (
            document.querySelector(".pageheader--transparent-permitted") &&
            !this.closest(".shopify-section").previousElementSibling
          ) {
            document
              .querySelectorAll(
                ".section-store-messages, .section-announcement-bar",
              )
              .forEach((el) => {
                height -= el.clientHeight;
              });
          } else {
            height -= document.querySelector(".section-header").clientHeight;
          }
          $(".rimage-outer-wrapper, .placeholder-image", this).height(height);
        },
      );
    };

    this.onSectionLoad = function (container) {
      $(".slideshow", container).each(function () {
        var slideshowSpeed = $(this).data("transition") === "instant" ? 0 : 800;
        var autoplaySpeed = $(this).data("autoplay-speed") * 1000;

        if (
          $(this).find(".height--full").length &&
          $(this).closest(".section-slideshow").index() == 0
        ) {
          $(this).addClass("height--full-minus-header-height");
          _.checkForHeaderHeightSubtraction();
          $(window)
            .off("debouncedresize.slideshowSection")
            .on(
              "debouncedresize.slideshowSection",
              _.checkForHeaderHeightSubtraction,
            );
        }
        $(this)
          .on("init", function () {
            $(".lazyload--manual", this)
              .removeClass("lazyload--manual")
              .addClass("lazyload");
          })
          .slick({
            autoplay: $(this).data("autoplay"),
            fade: $(this).data("transition") !== "slide",
            speed: slideshowSpeed,
            autoplaySpeed: autoplaySpeed,
            arrows: $(this).data("navigation") === "arrows",
            dots: $(this).data("navigation") === "dots",
            pauseOnHover: false,
            infinite: true,
            useTransform: true,
            prevArrow:
              '<button type="button" class="slick-prev" aria-label="' +
              theme.strings.previous +
              '">' +
              theme.icons.chevronLeft +
              "</button>",
            nextArrow:
              '<button type="button" class="slick-next" aria-label="' +
              theme.strings.next +
              '">' +
              theme.icons.chevronRight +
              "</button>",
            customPaging: function customPaging(slider, i) {
              return (
                '<button class="custom-dot" type="button" data-role="none" role="button" tabindex="0">' +
                '<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 30 30" xml:space="preserve">' +
                '<circle class="circle-one" cx="15" cy="15" r="13" />' +
                '<circle class="circle-two" cx="15" cy="15" r="13" style="animation-duration: '.concat(
                  autoplaySpeed + slideshowSpeed,
                  'ms" />',
                ) +
                "</svg>" +
                "</button>"
              );
            },
            rtl: document.querySelector("html[dir=rtl]") ? true : false,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  arrows: false,
                  dots: $(this).data("navigation") !== "none",
                },
              },
            ],
          })
          .on("beforeChange", function (event, slick, currentSlide) {
            if (
              $(this).data("transition") === "slide_fade" ||
              $(this).data("transition") === "zoom"
            ) {
              var $outgoingSlide = $(slick.$slides.get(currentSlide));
              $outgoingSlide.addClass("slick--leaving");
            }
          })
          .on("afterChange", function (event, slick) {
            $(slick.$slides)
              .filter(".slick--leaving")
              .removeClass("slick--leaving");
          });
      });

      // Tidier typography
      $(".overlay-text__title, .overlay-text__rte", container).each(
        function () {
          theme.avoidUnecessaryOrphans(this);
        },
      );
    };

    this.onSectionUnload = function (container) {
      $(".slick-slider", container).slick("unslick").off("init");
      $(window).off(".slideshowSection");
    };

    this.onBlockSelect = function (container) {
      $(container)
        .closest(".slick-slider")
        .slick("slickGoTo", $(container).data("slick-index"))
        .slick("slickPause");
    };

    this.onBlockDeselect = function (container) {
      $(container).closest(".slick-slider").slick("slickPlay");
    };
  })();

  theme.TestimonialsSection = new (function () {
    this.onSectionLoad = function (container) {
      this.namespace = theme.namespaceFromSection(container);
      this.$testimonialContainer = $(".testimonial-list", container);

      this.$testimonialContainer
        .find(".testimonial-list__inner")
        .on("init", function () {
          $(".lazyload--manual", this)
            .removeClass("lazyload--manual")
            .addClass("lazyload");
        })
        .slick({
          fade: this.$testimonialContainer.hasClass(
            "testimonial-list--with-images",
          ),
          slidesToShow: this.$testimonialContainer.hasClass(
            "testimonial-list--without-images",
          )
            ? 2
            : 1,
          autoplay: this.$testimonialContainer.data("autoplay"),
          autoplaySpeed: this.$testimonialContainer.data("autoplay-speed"),
          dots: false,
          arrows: true,
          appendArrows: this.$testimonialContainer.find(
            ".testimonial-list__controls",
          ),
          prevArrow:
            '<button type="button" class="slick-prev" aria-label="' +
            theme.strings.previous +
            '">' +
            theme.icons.chevronLeft +
            "</button>",
          nextArrow:
            '<button type="button" class="slick-next" aria-label="' +
            theme.strings.next +
            '">' +
            theme.icons.chevronRight +
            "</button>",
          rtl: document.querySelector("html[dir=rtl]") ? true : false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                fade: false,
                slidesToShow: 1,
              },
            },
          ],
        });
    };

    this.onSectionUnload = function (container) {
      $(".slick-slider", container).each(function () {
        $(this).slick("unslick").off("init");
      });
    };

    this.onBlockSelect = function (block) {
      var blockSlideIndex = $(block).data("slick-index");
      $(block)
        .closest(".slick-slider")
        .each(function () {
          $(this).slick("slickGoTo", blockSlideIndex);
        });
    };
  })();
  theme.ProductBundleSection = new (function () {
    this.onSectionLoad = function (container) {
      this.namespace = theme.namespaceFromSection(container);
      this.$container = $(container);
      this.$container
        .find(".js-product-bundle-tabs")
        .on("click", "li", (event) => {
          var index = $(event.target).index();

          $(event.target).addClass("active");
          $(event.target).siblings().removeClass("active");

          this.$container
            .find(".js-tab-item-box")
            .eq(index)
            .addClass("active")
            .siblings()
            .removeClass("active");
        });

      //弹窗逻辑
      this.$container.find(".js-add-cart-dialog").on("click", (event) => {
        const index = $(event.target).data("index");
        this.$container.find(".js-product-bundle-dialog").removeClass("hide");
        this.$container
          .find(".js-product-cont")
          .eq(index)
          .removeClass("hide")
          .siblings()
          .addClass("hide");
        document.body.style.overflow = "hidden"; // 禁止滚动
      });

      //关闭弹窗逻辑
      this.$container
        .find(".js-product-bundle-close-dialog")
        .on("click", () => {
          this.$container.find(".js-product-bundle-dialog").addClass("hide");
          document.body.style.overflow = ""; // 恢复滚动
        });

      //加入购物车逻辑
      this.$container.find(".js-add-to-cart-btn").on("click", async (event) => {
        theme.removeAddedCartDrawer();
        const toCartBtn = $(event.target);
        const discountCode = toCartBtn.data("discount-code");
        const form = toCartBtn.closest(".js-product-cont").find("form");
        if (form.length > 0) {
          const items = form.serializeArray();
          const formattedItems = [];

          for (let i = 0; i < items.length; i += 2) {
            if (items[i].name === "id" && items[i + 1]?.name === "quantity") {
              formattedItems.push({
                id: items[i].value,
                quantity: parseInt(items[i + 1].value, 10), // 将 quantity 转换为整数
                sections: "cart-drawer",
              });
            }
          }

          const formData = {
            items: formattedItems,
            sections: "cart-drawer",
          };
          var shopifyAjaxAddURL = theme.routes.cart_add_url;
          try {
            const addToCartResponse = await $.ajax({
              url: shopifyAjaxAddURL,
              method: "POST",
              contentType: "application/json",
              data: JSON.stringify(formData),
            });
            if (discountCode) {
              const discountResponse = await fetch(
                `/discount/${discountCode}`,
                {
                  method: "GET",
                },
              );
            }
            //刷新购物车页面的 section 数据
            const sectionsResponse = await $.get("/?sections=cart-drawer");
            const { items } = JSON.parse(addToCartResponse);
            const keys = items.map((item) => {
              return item.id;
            });

            theme.addedToCartHandler.call(form, {
              sections: sectionsResponse,
              key: keys,
            });
          } catch (data) {
            if (
              typeof data !== "undefined" &&
              typeof data.status !== "undefined"
            ) {
              var jsonRes = $.parseJSON(data.responseText);
              theme.showQuickPopup(jsonRes.description, toCartBtn);
            }
          }
        }
      });

      //改变变体的时候计算价格
      const setTotalPrice = function () {
        const contEl = $(".js-product-cont").not(".hide");
        const ul = contEl.find(".js-dialog-product-list");
        const li = ul.find("li");
        const compareEle = contEl.find(".js-total-compare-price");
        const discountEle = contEl.find(".js-total-curr-price");
        const type = discountEle.data("discount-amount").includes("%") ? 1 : 2;
        const discountAmount = parseFloat(
          (discountEle.data("discount-amount") || "0")
            .toString()
            .replace(/[$💲%]/g, ""),
        );
        let totalCompPrice = 0;

        //计算总价格
        li.each((index, item) => {
          const select = $(item).find('select[name="id"]:not(:disabled)');
          const selectedOption = select.find("option:selected");
          const quantity = Number($(item).find('input[name="quantity"]').val());
          const price =
            (parseFloat(selectedOption.data("price")) || 0) * quantity;
          totalCompPrice += price;
        });
        //原价
        compareEle.html(`$${totalCompPrice / 100}`);
        //折扣后的价格
        const discountAmountHtml =
          type === 1
            ? (totalCompPrice * (1 - discountAmount / 100)) / 100
            : (totalCompPrice - discountAmount * 100) / 100;
        const roundedDiscountAmount = parseFloat(discountAmountHtml.toFixed(2));
        discountEle.html(`$${roundedDiscountAmount}`);
      };

      //变体改变的时候
      this.$container.find(".original-selector").on("change", (event) => {
        const select = $(event.target);
        const selectedOption = select.find("option:selected");
        const priceText = selectedOption.data("price-text");
        select
          .siblings(".product-price")
          .find(".js-curr-price")
          .html(priceText);
        setTotalPrice();
      });

      //数量改变的时候
      this.$container.find('input[name="quantity"]').on("change", (event) => {
        setTotalPrice();
      });

      //滚动的时候隐藏加车弹窗
      $(window)
        .off(".ajaxAddScroll")
        .on("scroll.ajaxAddScroll", function () {
          // Hide notifications on scroll
          theme.removeAddedCartDrawer();
        });
    };
  })();

  theme.KKCategoriesSection = new (function () {
    this.onSectionLoad = function (container) {
      const emblaNodes = container.querySelectorAll(".kk-categories_embla");
      emblaNodes.forEach((emblaNode) => {
        const viewportNode = emblaNode.querySelector(
          ".kk-categories_embla__viewport",
        );
        if (!viewportNode) return;

        // 统一按钮
        const prevBtnNode = emblaNode.querySelector(
          ".kk-categories_embla__button--prev",
        );
        const nextBtnNode = emblaNode.querySelector(
          ".kk-categories_embla__button--next",
        );
        const progressNode = emblaNode.querySelector(
          ".kk-categories_progress__bar_js",
        );

        let OPTIONS = {};
        if (window.innerWidth < 768) {
          OPTIONS = { slidesToScroll: 1 };
        } else {
          OPTIONS = { slidesToScroll: 4 };
        }

        const emblaApi = EmblaCarousel(viewportNode, OPTIONS);

        // 统一按钮事件
        if (prevBtnNode && nextBtnNode) {
          const removePrevNextBtnsClickHandlers =
            window.addPrevNextBtnsClickHandlers(
              emblaApi,
              prevBtnNode,
              nextBtnNode,
            );
          emblaApi.on("destroy", removePrevNextBtnsClickHandlers);
        }

        // 统一进度条
        if (progressNode) {
          const { applyProgress, removeProgress } = window.setupProgressBar(
            emblaApi,
            progressNode,
          );

          emblaApi.on("init", () => {
            applyProgress();
            emblaApi.reInit();
          });

          emblaApi
            .on("init", applyProgress)
            .on("select", applyProgress)
            .on("slideFocus", applyProgress)
            .on("destroy", removeProgress);

          applyProgress();
        }
      });
    };
  })();

  theme.ChooseBlindSection = new (function () {
    this.onSectionLoad = function (container) {
      if (window.innerWidth < 768) {
        const emblaNodes = container.querySelectorAll(
          ".choose-blind-container-right-mobile_embla",
        );
        emblaNodes.forEach((emblaNode) => {
          const viewportNode = emblaNode.querySelector(
            ".choose-blind-container-right-mobile_embla__viewport",
          );
          // 移动端按钮
          const mobilePrevBtn = emblaNode.querySelector(
            ".choose-blind-container-right-mobile_embla__nav__button--prev",
          );
          const mobileNextBtn = emblaNode.querySelector(
            ".choose-blind-container-right-mobile_embla__nav__button--next",
          );
          const snapDisplayNode = emblaNode.querySelector(
            ".choose-blind-container-right-mobile_embla__controls_embla__selected-snap-display",
          );
          const progressNode = emblaNode.querySelector(
            ".choose-blind-container-right-mobile_embla__progress__bar",
          );

          const OPTIONS = { slidesToScroll: 1 };
          const emblaApi = EmblaCarousel(viewportNode, OPTIONS);

          // 设置进度条
          const { applyProgress, removeProgress } = window.setupProgressBar(
            emblaApi,
            progressNode,
          );

          // 初始化后立即应用进度
          emblaApi.on("init", () => {
            applyProgress(); // 立即计算并显示正确的进度
            emblaApi.reInit();
          });

          // 添加移动端按钮事件
          if (mobilePrevBtn && mobileNextBtn) {
            const removePrevNextBtnsClickHandlersMobile =
              window.addPrevNextBtnsClickHandlers(
                emblaApi,
                mobilePrevBtn,
                mobileNextBtn,
              );
            window.updateSelectedSnapDisplay(emblaApi, snapDisplayNode);

            emblaApi
              .on("init", applyProgress)
              //.on("reInit", applyProgress)
              .on("select", applyProgress)
              .on("slideFocus", applyProgress)
              .on("destroy", removeProgress)
              .on("destroy", removePrevNextBtnsClickHandlersMobile);

            // 立即应用初始进度
            applyProgress();
          }
        });
      }
    };
  })();

  theme.HomePageBannerWithTextSection = new (function () {
    this.onSectionLoad = function (container) {
      const autoPlayInterval = container.getAttribute(
        "data-auto-play-interval",
      );
      const emblaNodes = container.querySelectorAll(".banner-with-text_embla");
      emblaNodes.forEach((emblaNode) => {
        const viewportNode = emblaNode.querySelector(
          ".banner-with-text_embla__viewport",
        );
        const dotsNode = emblaNode.querySelector(
          ".banner-with-text_embla__dots",
        );
        const OPTIONS = { loop: true };
        const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [
          EmblaCarouselAutoplay({
            playOnInit: true,
            delay: autoPlayInterval * 1000,
          }),
        ]);
        emblaApi.plugins().autoplay?.play();
        // 添加初始化后的重新计算
        emblaApi.on("init", () => {
          emblaApi.reInit();
        });

        const removeDotBtnsAndClickHandlers = window.addDotBtnsAndClickHandlers(
          emblaApi,
          dotsNode,
        );
        emblaApi.on("destroy", removeDotBtnsAndClickHandlers);
      });
    };
  })();

  theme.SlideTextWithImgSection = new (function () {
    this.onSectionLoad = function (container) {
      const styleStr = container.dataset.style;
      console.log("debug: ", styleStr);
      const emblaNodes = container.querySelectorAll(
        ".slide-text-with-img_embla",
      );
      emblaNodes.forEach((emblaNode) => {
        const viewportNode = emblaNode.querySelector(
          ".slide-text-with-img_embla__viewport",
        );
        // PC端按钮
        const prevBtnNode = emblaNode.querySelector(
          ".slide-text-with-img_embla__button--prev",
        );
        const nextBtnNode = emblaNode.querySelector(
          ".slide-text-with-img_embla__button--next",
        );
        // 移动端按钮
        const mobilePrevBtn = emblaNode.querySelector(
          ".slide-text-with-img_embla__mobile__button--prev",
        );
        const mobileNextBtn = emblaNode.querySelector(
          ".slide-text-with-img_embla__mobile__button--next",
        );
        const snapDisplayNode = emblaNode.querySelector(
          ".slide-text-with-img_embla__mobile__selected-snap-display",
        );
        const progressNode = emblaNode.querySelector(
          ".slide-text-with-img_embla__progress__bar",
        );

        let OPTIONS = {};
        if (styleStr === "style1") {
          if (window.innerWidth < 768) {
            OPTIONS = { slidesToScroll: 2 };
          } else {
            OPTIONS = { slidesToScroll: 4 };
          }
        } else if (styleStr === "style2" || styleStr === "style3") {
          if (window.innerWidth < 768) {
            OPTIONS = { slidesToScroll: 1 };
          } else {
            OPTIONS = { slidesToScroll: 2 };
          }
        }

        const emblaApi = EmblaCarousel(viewportNode, OPTIONS);

        // 添加PC端按钮事件
        if (prevBtnNode && nextBtnNode) {
          const removePrevNextBtnsClickHandlersPC =
            window.addPrevNextBtnsClickHandlers(
              emblaApi,
              prevBtnNode,
              nextBtnNode,
            );
          emblaApi.on("destroy", removePrevNextBtnsClickHandlersPC);
        }

        // 添加移动端按钮事件
        if (mobilePrevBtn && mobileNextBtn) {
          const removePrevNextBtnsClickHandlersMobile =
            window.addPrevNextBtnsClickHandlers(
              emblaApi,
              mobilePrevBtn,
              mobileNextBtn,
            );
          window.updateSelectedSnapDisplay(emblaApi, snapDisplayNode);

          const { applyProgress, removeProgress } = window.setupProgressBar(
            emblaApi,
            progressNode,
          );

          // 添加初始化后的重新计算
          emblaApi.on("init", () => {
            applyProgress(); // 立即计算并显示正确的进度
            emblaApi.reInit();
          });

          emblaApi
            .on("init", applyProgress)
            //.on("reInit", applyProgress)
            .on("select", applyProgress)
            .on("slideFocus", applyProgress)
            .on("destroy", removeProgress)
            .on("destroy", removePrevNextBtnsClickHandlersMobile);

          // 立即应用初始进度
          applyProgress();
        }
      });
    };
  })();

  theme.CustomizeTimeBannerSection = new (function () {
    this.onSectionLoad = function (container) {
      const endTimeStr = container.dataset.endTime;
      const timeNode = container.querySelector(".js-countdown-time");
      const showCountdown = container.dataset.showCountdown;
      if (showCountdown === "false") {
        return;
      }
      var nowTime = new Date();
      var endTime = new Date(endTimeStr);
      var lefttime = endTime.getTime() - nowTime.getTime();
      if (endTime && timeNode && lefttime > 0) {
        container.style.display = "block";
        runProductDetailsCountdown($(timeNode), endTimeStr, 1);
      } else {
        container.style.display = "none";
      }
    };
  })();

  theme.SceneSlideSection = new (function () {
    this.onSectionLoad = function (container) {
      const OPTIONS = { loop: true };
      const viewportNode = container.querySelector(".scene-slide_viewport");
      const emblaApi = EmblaCarousel(viewportNode, OPTIONS);
      const prevBtnNode = viewportNode.querySelector(
        ".scene-slide-button_prev",
      );
      const nextBtnNode = viewportNode.querySelector(
        ".scene-slide-button_next",
      );
      const removePrevNextBtnsClickHandlers =
        window.addPrevNextBtnsClickHandlers(emblaApi, prevBtnNode, nextBtnNode);
      emblaApi.on("destroy", removePrevNextBtnsClickHandlers);
    };

    this.onSectionUnload = function (container) {
      const emblaApi = EmblaCarousel(
        container.querySelector(".scene-slide_viewport"),
        OPTIONS,
      );
      emblaApi.destroy();
    };
  })();

  theme.EmblasInstances = [];

  // dom ready
  $(function ($) {
    var $ = $; // keep this ref local

    $(document).on("keyup.themeTabCheck", function (evt) {
      if (evt.keyCode === 9) {
        $("body").addClass("tab-used");
        $(document).off("keyup.themeTabCheck");
      }
    });

    $(document).on(
      "click",
      "#add-to-cart-3d-float-mobile-show",
      function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        // evt.stopImmediatePropagation();
        var $standaloneFloat = $(".product-column-float-mobile").filter(
          function () {
            return $(this).closest(".quickbuy-content-mobile").length === 0;
          },
        );
        if ($standaloneFloat.length) {
          $standaloneFloat.fadeIn(500);
          $("body").css("overflow", "hidden");
          //埋点添加
          ptengine && ptengine.track("detail-m-addToCart-dialog");
        }
      },
    );

    /// Reusable function to expand/contract a div
    $(document).on("click", "a[data-toggle-target]", function (e) {
      e.preventDefault();
      var $toggler = $(this),
        $target = $($(this).data("toggle-target")),
        $transCont = $target.find(".toggle-target-container"),
        doCollapse = !$target.hasClass("toggle-target--hidden");
      var transitionDuration =
        $target.css("transition-duration").indexOf("ms") >= 0
          ? parseInt($target.css("transition-duration"))
          : parseFloat($target.css("transition-duration")) * 1000;
      if (!$target.hasClass("toggle-target--in-transition")) {
        if (doCollapse) {
          $toggler.addClass("toggle-target-toggler--is-hidden");
          $target
            .addClass("toggle-target--in-transition toggle-target--hiding")
            .css({
              height: $transCont.outerHeight() + "px",
              opacity: 1,
            });

          setTimeout(function () {
            $target.css({
              height: 0,
              opacity: 0,
            });

            setTimeout(function () {
              $target
                .addClass("toggle-target--hidden")
                .removeClass(
                  "toggle-target--in-transition toggle-target--hiding",
                );
              $target.css({
                height: "",
                opacity: "",
              });
            }, transitionDuration);
          }, 10);
        } else {
          $toggler.removeClass("toggle-target-toggler--is-hidden");
          $target
            .addClass("toggle-target--in-transition toggle-target--revealing")
            .css({
              height: 0,
              opacity: 0,
              display: "block",
            });

          setTimeout(function () {
            $target.css({
              height: $transCont.outerHeight() + "px",
              opacity: 1,
            });

            setTimeout(function () {
              $target.removeClass(
                "toggle-target--hidden toggle-target--in-transition toggle-target--revealing",
              );
              $target.css({
                height: "",
                opacity: "",
                display: "",
              });
            }, transitionDuration);
          }, 10);
        }
      }
    });

    //Redirect dropdowns
    $(document).on("change", "select.navdrop", function () {
      window.location = $(this).val();
    });

    /// Mobile nav
    $(document).on("click", ".mobile-nav-toggle", function (e) {
      e.preventDefault();
      if ($("body").hasClass("enable-mobile-nav-transition")) {
        // hide nav
        $("body").removeClass("reveal-mobile-nav reveal-mobile-nav--revealed");
        setTimeout(function () {
          $("body").removeClass("enable-mobile-nav-transition");
        }, 750);
      } else {
        // show nav
        // theme.openMobileNav();
      }
    });

    theme.openMobileNav = function () {
      $("body").addClass("enable-mobile-nav-transition");
      setTimeout(function () {
        $("body").addClass("reveal-mobile-nav");

        // on reveal, set up internal transition values
        $(".mobile-navigation-drawer .disclosure").each(function () {
          var $list = $(".disclosure-list", this),
            listHeight = 0;
          $list.children().each(function () {
            listHeight += $(this).height();
          });
          $(".disclosure-list", this).css("height", listHeight + "px");
        });

        // on reveal, lazy load images
        $(".mobile-navigation-drawer .lazyload--manual")
          .removeClass("lazyload--manual")
          .addClass("lazyload");

        // on reveal, load product carousel
        $(".mobile-navigation-drawer .product-list").each(function () {
          theme.ProductBlockManager.loadImages($(this));
        });

        // after reveal, add class
        var de = $(
          ".mobile-navigation-drawer .navigation__tier-1 > .navigation__item > .navigation__link:first",
        ).css("transition-delay");
        var du = $(
          ".mobile-navigation-drawer .navigation__tier-1 > .navigation__item > .navigation__link:first",
        ).css("transition-duration");
        var delayS =
          parseFloat(de.split(",")[0]) + parseFloat(du.split(",")[0]);
        setTimeout(function () {
          $("body").addClass("reveal-mobile-nav--revealed");
        }, delayS * 1000);
      }, 10);
    };

    /// General window shade
    // $(
    //   '<a href="#" class="page-shade" aria-label="' +
    //     theme.strings.general_navigation_menu_toggle_aria_label +
    //     '"></a>'
    // )
    //   .on("click", function () {
    //     $("body").removeClass("reveal-mobile-nav show-search");
    //     setTimeout(function () {
    //       $("body").removeClass("enable-mobile-nav-transition");
    //     }, 750);
    //     return false;
    //   })
    //   .appendTo("body");

    if (theme.settings.quickbuy_style != "off") {
      theme.loadQuickbuy();
    }
    /// Event for initialising options
    $(document).on("load-product-form", ".product-form", function (e) {
      if ($(this).data("product-id") === "") {
        return;
      }

      var $productFormContainer = $(this),
        $productDetail = $(this).closest(".product-detail");

      // events on variant change

      $(this).on("variantChanged", function (evt, variant, product) {
        // change variant status classes
        var $labelCont = $productDetail.find(".product-label-list");
        $labelCont.find(".product-label-container").remove();
        if (variant) {
          $labelCont.append(
            $(
              "#variant-label-".concat(product.id, "-").concat(variant.id),
            ).html(),
          );
        } else {
          $labelCont.append(
            $("#variant-label-".concat(product.id, "-none")).html(),
          );
        }

        const filteredMedias = theme.utils.getSkuImageFillterByAlt(
          variant,
          product,
        );

        // 加购切换套图，
        if (evt && $(evt.target).data("is-quick-buy-form")) {
          theme.hiddenProductsSlick(function (media) {
            return filteredMedias.some((ele) => ele.id == media.id);
          }, product.id);

          // const slick = $(evt.target).find(".slider-for.slick-initialized");
          // if (!slick.length) return;
          // slick.slick("slickUnfilter"); // 先复原
          // slick.slick("slickFilter", function () {
          //   return filteredMedias.some(
          //     (ele) => ele.id == $(this).data("media-id")
          //   );
          // }); // 过滤
          // slick.slick("slickGoTo", 0);
          // initSlickClick();
          // $(evt.target)
          //   .find(".carousel-thumbnails")
          //   .empty()
          //   .removeClass()
          //   .addClass("carousel-thumbnails");

          // const $carouselNav = $(evt.target).find(".carousel-thumbnails");
          // $.each(filteredMedias, function (index, item) {
          //   const $newDiv = $("<div></div").html(
          //     '<img src="' +
          //       item.preview_image.src +
          //       '&width=150" alt="' +
          //       item.alt +
          //       '"><div class="green-line"></div>'
          //   );
          //   $carouselNav.append($newDiv);
          // });
          return;
        }

        // console.log("debug: ", { variant, product });
        // instate DPBs - requires a variant ID, and may be loaded in quick buy
        if (variant) {
          var buyNowEl = document.querySelector("[data-buy-now]");
          var threeDEl = document.getElementById("add-to-cart-3d");
          if (!variant.available) {
            if (buyNowEl) buyNowEl.style.display = "none";
          } else {
            if (
              document.querySelector(".pre-order-btn")?.style?.display ===
              "none"
            ) {
              if (threeDEl && threeDEl.disabled) {
                if (buyNowEl) buyNowEl.style.display = "none";
              } else {
                if (buyNowEl) buyNowEl.style.display = "block";
              }
            } else {
              if (buyNowEl) buyNowEl.style.display = "none";
            }
            $("#dynamic-payment-div")?.hide();
          }
          $productDetail
            .find(".dynamic-payment-button-template")
            .each(function () {
              $(this).after($(this).html()).remove();

              if (Shopify.PaymentButton) {
                // resize after loading extra payment buttons
                var _f = null;
                _f = function f() {
                  document.removeEventListener(
                    "shopify:payment_button:loaded",
                    _f,
                  );
                  $productDetail
                    .closest(".quickbuy-container")
                    .trigger("changedsize");
                };
                document.addEventListener("shopify:payment_button:loaded", _f);

                Shopify.PaymentButton.init();
              }
            });
          try {
            const isProductPage = document.querySelector(
              ".section-product-main",
            );
            const isFloatMobileForm = $(this).data("is-float-mobile-form")
              ? true
              : false;
            if (product.media?.length) {
              // 精准匹配SKU套图
              const getMatchAll = (alt_str) => {
                const datas = alt_str
                  .replace("{", "")
                  .replace("}", "")
                  .split("?");
                const public_title = variant.public_title
                  .toLowerCase()
                  .split("/");
                let flag = true;
                for (let i = 0; i < datas.length; i++) {
                  const str = datas[i].trim().toLowerCase();
                  const result = public_title?.find(
                    (item) => item.trim() === str,
                  );
                  if (!result) flag = false;
                }
                return flag;
              };

              // 切换SKU切换套图

              if (!$(this).data("is-float-pc-form")) {
                for (let i = 0; i < product.media.length; i++) {
                  let is_show = false;
                  const media = product.media[i];
                  //判断是获取移动端弹窗套图还是移动端套图
                  const target = isFloatMobileForm
                    ? $(this).find(`.media[data-media-id='${media.id}']`)
                    : document.querySelector(
                        `.slide[data-media-id='${media.id}']`,
                      );
                  const is_sku_v = media.alt
                    ? media.alt.trim().toLowerCase().includes("v,")
                    : false;

                  if ((isProductPage || isFloatMobileForm) && is_sku_v) {
                    // const slickIndex = Number(target.dataset.slickIndex ?? "0");
                    const public_title = variant.public_title
                      .trim()
                      .toLowerCase()
                      .split(" / ");

                    let main_next_value = null;
                    let is_main_image = false;

                    if (target && media.alt) {
                      const image_alt_text = media.alt
                        .trim()
                        .toLowerCase()
                        .split(",");
                      if (image_alt_text.length === 1) {
                        is_show = true;
                        for (const v of product.variants) {
                          const variant_title = v.title
                            .trim()
                            .toLowerCase()
                            .split(" / ");
                          for (const alt of image_alt_text) {
                            if (variant_title.includes(alt.trim()))
                              is_show = false;
                          }
                        }
                      }
                      for (let j = 0; j < image_alt_text.length; j++) {
                        const alt_str = image_alt_text[j].trim().toLowerCase();
                        if (alt_str === "main") {
                          if (image_alt_text[j + 1])
                            main_next_value = image_alt_text[j + 1]
                              .trim()
                              .toLowerCase();
                          is_main_image = true;
                        }
                        if (
                          alt_str !== "main" &&
                          alt_str.includes("{") &&
                          alt_str.includes("}") &&
                          !is_show
                        ) {
                          is_show = getMatchAll(alt_str);
                          // console.log('debug: ', { image_alt_text, alt_str, is_show, public_title, media_id: media.id })
                        } else {
                          if (
                            alt_str !== "main" &&
                            !is_show &&
                            (alt_str === "all" ||
                              public_title.includes(alt_str))
                          ) {
                            is_show = true;
                          }
                        }
                      }
                      // console.log('debug: ', { image_alt_text, is_main_image, is_show, public_title, main_next_value })
                    } else {
                      if (!media.alt) is_show = true; // 不配置alt就直接显示
                    }

                    if (is_main_image) {
                      // console.log('debug: ', { main_next_value, is_show, public_title })
                      if (main_next_value === "all") {
                        is_show = true;
                      } else {
                        if (
                          !!main_next_value &&
                          main_next_value?.includes("{") &&
                          main_next_value?.includes("}") &&
                          !is_show
                        ) {
                          is_show = getMatchAll(main_next_value);
                        } else {
                          if (!is_show)
                            is_show = main_next_value
                              ? public_title.includes(main_next_value)
                              : true;
                        }
                      }
                    }
                    $(target).toggle(is_show);
                  }
                }
              }
              //悬浮购物车PC端口切换变体主题
              if ($(this).data("is-float-pc-form")) {
                const updateMediaImage = (src) => {
                  $(this)
                    .find(".product-column-float-pc-media img")
                    .attr(
                      "srcset",
                      `${src}&width=120 120w,${src}&width=160 160w`,
                    )
                    .attr("src", src);
                };
                const mainMedia = product?.media?.filter((item) =>
                  item.alt?.toLowerCase()?.includes("main"),
                );
                mainMedia.map?.((media) => {
                  const { alt, src, media_type } = media;
                  // 判断 alt 是否包含 JSON 格式
                  if (alt?.includes("{")) {
                    const op = variant.options.join("?").toLowerCase();
                    if (
                      alt.toLowerCase().includes(op) &&
                      media_type === "image"
                    ) {
                      updateMediaImage(src);
                    }
                  } else {
                    variant.options.forEach((option) => {
                      const op = option
                        .replace(/[:\s]+/g, "")
                        .replace(/[&%'’]/g, "_")
                        .toLowerCase();
                      if (
                        alt
                          ?.split(",")
                          .map((item) =>
                            item
                              .replace(/[:\s]+/g, "")
                              .replace(/[&%'’]/g, "_")
                              .toLowerCase(),
                          )
                          .includes(op) &&
                        media_type === "image"
                      ) {
                        updateMediaImage(src);
                      }
                    });
                  }
                });
              }
              // const nodeList =
              //   document.querySelectorAll(".slideshow .slide") ?? [];
              // let is_add_class = false; // 是否已经添加过“slide--custom-initial”，保证这个样式名唯一
              // for (const item of nodeList) {
              //   if (item.style.display === "block" && !is_add_class) {
              //     item.classList.add("slide--custom-initial");
              //     is_add_class = true;
              //   } else {
              //     item.classList.remove("slide--custom-initial");
              //   }
              // }

              // 移动端切换变体时图片位移对应
              // var pageWidth = $(window).width();
              // if (pageWidth <= 758) {
              //   const blockList = document.querySelectorAll(
              //     ".slick-track .slide[style*='display: block;']"
              //   );
              //   const el = document.querySelector(".slick-track");
              //   // console.log('debug: ', { blockList, length: blockList.length, el, featured_media: variant.featured_media })
              //   if (blockList.length === 1) {
              //     setTimeout(() => {
              //       el.style.transform = "translate3d(0px, 0px, 0px)";
              //     }, 3500);
              //   } else {
              //     for (let b = 0; b < blockList.length; b++) {
              //       const item = blockList[b];
              //       const mediaId = item.dataset.mediaId;
              //       if (variant.featured_media.id == mediaId && el) {
              //         setTimeout(() => {
              //           el.style.transform =
              //             "translate3d(-" + b * pageWidth + "px, 0px, 0px)";
              //         }, 2500);
              //         break;
              //       }
              //     }
              //   }
              // }

              const sourceList = document.querySelectorAll(
                ".product-detail .swiper-hide-on-mobile .slide",
              );
              const hiddenIndexs = [];
              sourceList.forEach((item, index) => {
                if (item.style.display === "none") hiddenIndexs.push(index);
              });
              theme.hiddenProductsSlick(function (item, index) {
                return !hiddenIndexs.includes(index);
              });
            }
          } catch (error) {
            console.warn("切换SKU切换套图 error: ", error);
          }
        }
      });

      // icon-style variant picker to show option beside label
      var $iconOptionContainers = $productDetail.find(
        ".option-selector--swatch",
      );
      if (
        $iconOptionContainers.length &&
        $("body.swatch-style-icon_circle, body.swatch-style-icon_square").length
      ) {
        $iconOptionContainers
          .find(".label")
          .append('<span class="label__value">');
        $(this).on("variantChanged", function (evt, variant) {
          $iconOptionContainers.each(function () {
            var optionIndex = $(this).data("option-index");
            if (variant) {
              var optionValue = variant.options[optionIndex];
              $(this).find(".label__value").text(optionValue);
            } else {
              var selectedOption = this.querySelector(".opt-btn:checked");
              if (selectedOption) {
                $(this).find(".label__value").text(selectedOption.value);
              }
            }
          });
        });
      }

      // Add a disabled-state to options that have no valid variants, in a descending selection order
      var $availabilityDependentOptions = $productDetail.find(
        '.option-selectors[data-disable-unavailable="true"]',
      );
      if ($availabilityDependentOptions.length) {
        $(this).on("variantChanged", function (evt, variant) {
          var _this2 = this;
          var productData = theme.OptionManager.getProductData($(this));
          var optionStatusMap = [];
          var currentSelectedOptionValues = [];

          $(
            '.option-selectors[data-disable-unavailable="true"] .option-selector',
            this,
          ).each(function (index) {
            var checkedInput = $(this).find("input:checked");
            var selectedOption = $(this).find(
              '.cc-select__option[aria-selected="true"]',
            );
            var value = checkedInput.length
              ? checkedInput.val()
              : selectedOption
                ? selectedOption.data("value")
                : null;
            currentSelectedOptionValues.push(value);
          });

          // build map of options
          for (
            var optionIndex = 0;
            optionIndex < productData.options.length;
            optionIndex++
          ) {
            var optionName = productData.options[optionIndex];
            var values = {};
            for (var i = 0; i < productData.variants.length; i++) {
              var v = productData.variants[i];
              if (!values[v.options[optionIndex]]) {
                values[v.options[optionIndex]] = false;
              }
            }
            optionStatusMap.push({
              name: optionName,
              values: values,
            });
          }

          // go through each option, assume previous option's values are locked in, if any further choices are possible show as available
          var _loop2 = function _loop2(_optionIndex) {
            var optionName = productData.options[_optionIndex];
            // for this option, find if any variants are available
            var fixedOptions = [];
            for (
              var _i2 = 0;
              _i2 < currentSelectedOptionValues.length && _i2 < _optionIndex;
              _i2++
            ) {
              fixedOptions.push(currentSelectedOptionValues[_i2]);
            }

            // go through each option value
            Object.keys(optionStatusMap[_optionIndex].values).forEach(
              (optionValue) => {
                var fixedOptionsForValue = fixedOptions.map((x) => x);
                fixedOptionsForValue.push(optionValue);

                // go through all variants
                var availableVariantExists = false;
                for (var _i3 = 0; _i3 < productData.variants.length; _i3++) {
                  var _v = productData.variants[_i3];
                  // does this variant comply with fixedOptionsForValue? (A blank value means it could be fine.)
                  var variantComplies = true;
                  for (var j = 0; j < fixedOptionsForValue.length; j++) {
                    if (
                      fixedOptionsForValue[j] &&
                      fixedOptionsForValue[j] != _v.options[j]
                    ) {
                      // note typeless compare - can encounter (16 == '16') here
                      variantComplies = false;
                    }
                  }
                  if (variantComplies && _v.available) {
                    availableVariantExists = true;
                  }
                }
                optionStatusMap[_optionIndex].values[optionValue] =
                  availableVariantExists;
              },
            );
          };
          for (
            var _optionIndex = 0;
            _optionIndex < productData.options.length;
            _optionIndex++
          ) {
            _loop2(_optionIndex);
          }

          for (var _i = 0; _i < optionStatusMap.length; _i++) {
            var _loop3 = function _loop3(optionValue) {
              $(
                '.option-selector[data-selector-type="listed"][data-option-index="'.concat(
                  _i,
                  '"] .opt-btn',
                ),
                _this2,
              )
                .filter(function () {
                  return this.value === optionValue;
                })
                .toggleClass(
                  "is-unavailable",
                  !optionStatusMap[_i].values[optionValue],
                );
              $(
                '.option-selector[data-selector-type="dropdown"][data-option-index="'.concat(
                  _i,
                  '"] .cc-select__option',
                ),
                _this2,
              )
                .filter(function () {
                  return this.dataset.value === optionValue;
                })
                .toggleClass(
                  "is-unavailable",
                  !optionStatusMap[_i].values[optionValue],
                );
            };
            for (var optionValue in optionStatusMap[_i].values) {
              _loop3(optionValue);
            }
          }

          try {
            if (currentSelectedOptionValues.length) {
              //获取出发变体改变的当前表单外框，就是变体点击的时候当前表单外框
              const productFormBox = evt.target;
              const optionBtns =
                productFormBox.querySelectorAll(".opt-btn[data-label-index]") ??
                [];
              const lastIndex = currentSelectedOptionValues.length - 1; //获取最后一排变体的下标
              //获取当前选中变体的属性，去掉最后一个属性，拼接的字符串
              const selectStr = currentSelectedOptionValues
                .slice(0, lastIndex)
                .join("~");

              //获取最后一排的属性dom元素
              let lastOptionBtn = Array.from(optionBtns).filter((item) => {
                const labelIndex = Number(item.dataset?.labelIndex ?? 0);
                if (labelIndex !== 0) {
                  item.classList.remove("hidden-btn");
                  item.classList.add("normal");
                }
                return labelIndex !== 0 && labelIndex === lastIndex;
              });
              //筛选出当前选中属性（最后一个属性排除）组成的所有变体
              let selectedGroupOption = productData.variants.filter(
                (variant) => {
                  const options = variant.options;
                  const optionsStr = options.slice(0, lastIndex).join("~");
                  return selectStr === optionsStr;
                },
              );

              //排除最后一个属性，把当前选中属性组成的所有变体遍历，然后把变体的最后一个属性新组成一个数组
              let lastAttrs = selectedGroupOption.map((variant) => {
                return variant.options[lastIndex];
              });

              //判断最后一组属性是有多个还是一个，如果只有一个的话，对第二组的属性进行隐藏和显示处理
              if (lastOptionBtn.length == 1) {
                const option1 = currentSelectedOptionValues[0];
                //获取第二组的所有属性dom元素
                lastOptionBtn = Array.from(optionBtns).filter((item) => {
                  const labelIndex = Number(item.dataset?.labelIndex ?? 0);
                  return labelIndex == 1;
                });
                //筛选出当前选中属性开头组成的所有的属性
                selectedGroupOption = productData.variants.filter((variant) => {
                  const selectOption1 = variant.option1;
                  return selectOption1 === option1;
                });
                //把当前选中属性组成的所有变体遍历，然后把变体的第二组属性新组成一个数组
                lastAttrs = selectedGroupOption.map((variant) => {
                  return variant.options[1];
                });
              }
              //根据变体匹配属性，处理最后一排的属性dom是隐藏还是显示
              lastOptionBtn?.map((item) => {
                const optionValue = item.dataset.optionValue;

                //判断最后一个属性是否在这些选中属性可能组成的变体属性里面，存在就证明有这个变体，不要隐藏，不存在就没有这个变体需要隐藏最后一个属性
                if (lastAttrs.length && !lastAttrs.includes(optionValue)) {
                  item.classList.add("hidden-btn");
                  item.classList.remove("normal");
                }
              });
              //对当前操作的变体的表单进行处理
              productFormBox
                .querySelectorAll(".option-selector__btns")
                .forEach((wrap) => {
                  const btns = wrap.querySelectorAll(".opt-btn.normal");
                  let hasChecked = false;
                  btns.forEach((btn) => {
                    if (btn.checked) hasChecked = true;
                  });
                  // 如果当前属性变体都没有一个勾选中的，就默认勾选第一个
                  if (!hasChecked) btns[0].click();
                });
            }
          } catch (error) {
            console.warn("不可用SKU Error: ", error);
          }

          // product form may have changed height (e.g. variants customised to disappear). If in quick buy, resize container
          $(this).closest(".quickbuy-container").trigger("changedsize");
        });
      }

      // when option selector changes, update validation state, but only after first validation called
      $productFormContainer.on("change", ".option-selector", function () {
        if (
          $productFormContainer.hasClass("product-form--validation-started")
        ) {
          theme.validateProductForm($productFormContainer);
        }
      });

      // initialise options
      theme.OptionManager.initProductOptions($(this));
    });

    $(document).on("unload-product-form", ".product-form", function () {
      $(this).off("variantChanged change");
      theme.OptionManager.unloadProductOptions($(this));
    });

    /// Galleries (inc. product page)

    // when variant changes, and the variant has an image
    $(document).on(
      "variantImageSelected",
      ".gallery",
      function (e, data, isFirstRun) {
        var $gallery = $(this);
        var $galleryCollageContainer = $gallery
          .filter(
            ".gallery--layout-columns-1, .gallery--layout-columns-2, .gallery--layout-collage-1, .gallery--layout-collage-2",
          )
          .find(".product-slideshow:not(.slick-slider)");
        var collageGroupedImagesChanged = false;
        var $slideshow = null;

        if ($gallery.attr("data-variant-image-grouping-option-index") !== "") {
          // when images are grouped, we use options instead of variants
          var pivotOptionIndex = $gallery.attr(
            "data-variant-image-grouping-option-index",
          );
          var selectedGroupOption = data.options[pivotOptionIndex];
          var $thumbnails = $gallery.find(".thumbnails");
          $slideshow = $gallery.find(".slideshow");

          // slideshow - filter
          if ($slideshow.hasClass("slick-slider")) {
            // is variant image visible?
            var currentIsVisible = !!$slideshow.find(
              '.slide[data-media-id="'.concat(data.featured_media.id, '"]'),
            ).length;
            // filter (By option name: standard. By media id: when multiple variants have same media)
            $slideshow
              .slick("slickUnfilter")
              .slick(
                "slickFilter",
                '.slide[data-media-id="'
                  .concat(
                    data.featured_media.id,
                    '"], [data-variant-image-group="',
                  )
                  .concat(
                    selectedGroupOption
                      .replace('"', "&quot;")
                      .replace(/<>/g, ""),
                    '"]',
                  ),
              );
            // weird hack required for Slick
            $slideshow.find(".slide").css({
              position: "",
              left: "",
              top: "",
              zIndex: "",
              opacity: "",
            });
            // jump to correct slide immediately after filtering
            if (!currentIsVisible) {
              $slideshow.slick("slickGoTo", 0, true); // reset - hack for a bug
              $slideshow.slick(
                "slickGoTo",
                $slideshow
                  .find(
                    '.slide[data-media-id="'.concat(
                      data.featured_media.id,
                      '"]',
                    ),
                  )
                  .data("slick-index"),
                true,
              );
            }
          }

          // carousel - add/remove as required
          if ($thumbnails.hasClass("owl-carousel")) {
            var $hiddenThumbnails = $gallery.find(".hidden-thumbnails");
            if (!$hiddenThumbnails.length) {
              $hiddenThumbnails = $(
                '<div class="hidden-thumbnails hidden">',
              ).insertAfter($thumbnails);
            }

            // move to hidden thumbnails container (and show() in case hide() called prior)
            $thumbnails
              .find(".thumbnail")
              .show()
              .each(function () {
                if (
                  $(this).attr("data-variant-image-group") !=
                    selectedGroupOption &&
                  $(this).attr("data-media-id") != data.featured_media.id
                ) {
                  var index = $(this).parent().index();
                  $(this).appendTo($hiddenThumbnails);
                  $thumbnails.trigger("remove.owl.carousel", [index]);
                }
              });

            // add from hidden thumbnails container
            $hiddenThumbnails.find(".thumbnail").each(function () {
              if (
                $(this).attr("data-variant-image-group") ==
                  selectedGroupOption ||
                $(this).attr("data-media-id") == data.featured_media.id
              ) {
                $(this).show();
                $thumbnails.trigger("add.owl.carousel", [this]);
              }
            });
            $thumbnails.trigger("refresh.owl.carousel");
          } else {
            // show/hide elements
            $thumbnails.find(".thumbnail").each(function () {
              if (
                $(this).attr("data-variant-image-group") ==
                  selectedGroupOption ||
                $(this).attr("data-media-id") == data.featured_media.id
              ) {
                $(this).show();
              } else {
                $(this).hide();
              }
            });
          }

          // carousel - visibility by class & moving visible to top (for nth-child styling)
          if ($galleryCollageContainer.length) {
            $galleryCollageContainer.find(".slide").each(function () {
              if (
                $(this).attr("data-variant-image-group") ==
                  selectedGroupOption ||
                $(this).attr("data-media-id") == data.featured_media.id
              ) {
                if ($(this).hasClass("slide--inactive-option")) {
                  collageGroupedImagesChanged = true;
                }
                $(this).removeClass("slide--inactive-option");
              } else {
                if (!$(this).hasClass("slide--inactive-option")) {
                  collageGroupedImagesChanged = true;
                }
                $(this).addClass("slide--inactive-option");
              }
            });
            $galleryCollageContainer
              .find(".slide--inactive-option")
              .appendTo($galleryCollageContainer);
          }
        }

        // select matching thumbnail
        $gallery
          .find(
            '.thumbnails a[data-media-id="' +
              data.featured_media.id +
              '"]:first',
          )
          .trigger("select");

        // collage - highlight selected, if not first run
        if ($galleryCollageContainer.length) {
          var $active = $gallery.find(
            '.slide[data-media-id="' + data.featured_media.id + '"]:first',
          );
          if ($active.length) {
            if (isFirstRun && !collageGroupedImagesChanged) {
              // only scroll on first run, no visual highlight
              // theme.scrollToRevealElement($active[0], true);
            } else if (collageGroupedImagesChanged) {
              // assume first image is highlighted by the change
              $gallery
                .find(".slide--was-highlighted")
                .removeClass("slide--was-highlighted");
              $active.addClass("slide--was-highlighted");
            } else if (!$active.hasClass("slide--was-highlighted")) {
              // reset
              clearTimeout(theme.variantImageFadeTimeout);
              $gallery
                .find(".slide--highlight-on")
                .removeClass("slide--highlight-on");
              $gallery
                .find(".slide--highlight-off")
                .removeClass("slide--highlight-off");
              $gallery
                .find(".slide--was-highlighted")
                .removeClass("slide--was-highlighted");

              // highlight
              $active
                .addClass("slide--highlight-on slide--was-highlighted")
                .siblings()
                .addClass("slide--highlight-off");
              theme.variantImageFadeTimeout = setTimeout(function () {
                $gallery
                  .find(".slide--highlight-on")
                  .removeClass("slide--highlight-on");
                $gallery
                  .find(".slide--highlight-off")
                  .removeClass("slide--highlight-off");
              }, 1200);

              // scroll if needed
              // theme.scrollToRevealElement($active[0]);
            }
          }
        }
      },
    );

    // click main product image (launch gallery)
    $(document).on(
      "click",
      ".product-detail .gallery .main-image a.show-gallery",
      function () {
        var images = [],
          clickedHref = $(this).attr("href"),
          $imgs = $(this)
            .closest(".product-slideshow")
            .find(".slide")
            .filter(function () {
              return $(this).css("display") !== "none";
            })
            .find(".show-gallery");
        // console.log('debug: ', { $imgs })

        if ($imgs.length) {
          $imgs.each(function () {
            var $imgThumb = $(this).find(".rimage-outer-wrapper").clone();
            // $imgThumb
            //   .find(".lazyloaded")
            //   .removeClass("lazyloaded")
            //   .addClass("lazyload")
            //   .parent()
            //   .addClass("lazyload--placeholder");
            images.push({
              thumbTag: $imgThumb,
              zoomUrl: $(this).attr("href"),
            });
          });
        } else {
          var $img = $(this).find(".rimage-outer-wrapper").clone();
          // $img
          //   .find(".lazyloaded")
          //   .removeClass("lazyloaded")
          //   .addClass("lazyload")
          //   .parent()
          //   .addClass("lazyload--placeholder");
          images.push({
            thumbTag: $img,
            zoomUrl: $(this).attr("href"),
          });
        }

        theme.buildGalleryViewer({
          images: images,
          currentImage: clickedHref,
          prev: theme.icons.chevronLeft,
          next: theme.icons.chevronRight,
          close: theme.icons.close,
        });

        return false;
      },
    );

    // load any images that aren't inside a section
    var $nonSectionedProductLists = $(
      ".product-list, .collection-listing",
    ).filter(function () {
      return $(this).closest("[data-section-type]").length == 0;
    });
    if ($nonSectionedProductLists.length) {
      theme.ProductBlockManager.loadImages($nonSectionedProductLists);
    }
    $(window).on("debouncedresize", function () {
      setTimeout(function () {
        theme.ProductBlockManager.afterImagesResized(); // empty param req
      }, 100); // after third party stuff
    });

    // forms don't all have correct label attributes
    $("#template label").each(function () {
      var $sibinputs = $(this).siblings('input:not([type="submit"]), textarea');
      if ($sibinputs.length == 1 && $sibinputs.attr("id").length > 0) {
        $(this).attr("for", $sibinputs.attr("id"));
      }
    });

    $(document).on("click", ".quantity-wrapper [data-quantity]", function () {
      var adj = $(this).data("quantity") == "up" ? 1 : -1;
      var $qty = $(this).closest(".quantity-wrapper").find("[name=quantity]");
      if ($qty.attr("step")) {
        adj *= parseInt($qty.attr("step"));
      }
      $qty.val(Math.max(1, parseInt($qty.val()) + adj)).trigger("change");
      return false;
    });

    /// Responsive tables
    $(".responsive-table").on(
      "click",
      ".responsive-table__cell-head",
      function () {
        if ($(window).width() < 768) {
          $(this).closest("tr").toggleClass("expanded");
          return false;
        }
      },
    );

    // Enhance video sections for overlays
    if (typeof cc !== "undefined" && cc.sections) {
      for (var sectionKey in cc.sections) {
        var ccSection = cc.sections[sectionKey];
        if (ccSection.name === "video") {
          var t = ccSection.section.onSectionLoad;
          ccSection.section.onSectionLoad = function (container) {
            // Tidier typography
            $(".overlay-text__title, .overlay-text__rte", container).each(
              function () {
                theme.avoidUnecessaryOrphans(this);
              },
            );
            t.call(this, container);
          };
        }
      }
    }

    // close cart summary overlay card
    $(document).on(
      "click",
      "#shopify-section-cart-drawer .cart-summary-overlay .close-icon a",
      function (event) {
        event.preventDefault();
        theme.removeAddedCartDrawer();
      },
    );

    $(document).on("input change", 'input[name="quantity"]', function () {
      let value = $(this).val();

      // 只允许输入数字
      if (!/^\d+$/.test(value)) {
        $(this).val(1); // 如果输入非数字，将值重置为1
        return;
      }

      // 转换为整数
      value = parseInt(value);

      // 限定值的范围在1到999之间
      if (value < 1) {
        $(this).val(1);
      } else if (value > 999) {
        $(this).val(999);
      }
    });

    /// Register all sections
    theme.Sections.init();
    theme.Sections.register("header", theme.HeaderSection, {
      deferredLoad: false,
    });
    theme.Sections.register("announcement-bar", theme.AnnouncementBarSection, {
      deferredLoad: false,
    });
    theme.Sections.register("footer", theme.FooterSection);
    theme.Sections.register("slideshow", theme.SlideshowSection);
    theme.Sections.register("gallery", theme.GallerySection);
    theme.Sections.register("testimonials", theme.TestimonialsSection);
    theme.Sections.register(
      "image-with-text-overlay",
      theme.ImageWithTextOverlaySection,
    );
    theme.Sections.register(
      "featured-collection",
      theme.FeaturedCollectionSection,
      {
        deferredLoad: false,
      },
    );
    theme.Sections.register("common-carousels", theme.CommonCarouselsSection);
    theme.Sections.register(
      "featured-collections",
      theme.FeaturedCollectionsSection,
    );
    theme.Sections.register("product-bundle-group", theme.ProductBundleSection);
    theme.Sections.register("map", theme.MapSection);
    theme.Sections.register("background-video", theme.VideoManager, {
      deferredLoadViewportExcess: 800,
    });
    theme.Sections.register("custom-row", theme.CustomRowSection);
    theme.Sections.register("featured-product", theme.FeaturedProductSection);
    theme.Sections.register("main-product", theme.ProductTemplateSection, {
      deferredLoad: false,
    });
    theme.Sections.register(
      "collection-template",
      theme.CollectionTemplateSection,
      { deferredLoad: false },
    );
    theme.Sections.register("search-template", theme.SearchTemplateSection, {
      deferredLoad: false,
    });
    theme.Sections.register("blog-template", theme.BlogTemplateSection, {
      deferredLoad: false,
    });
    theme.Sections.register("cart-template", theme.CartTemplateSection, {
      deferredLoad: false,
    });
    theme.Sections.register(
      "list-collections-template",
      theme.ListCollectionsTemplateSection,
      { deferredLoad: false },
    );
    theme.Sections.register("active-free-discount", theme.ActiveFreeDiscount, {
      deferredLoad: false,
    });
    theme.Sections.register(
      "page-list-collections-template",
      theme.ListCollectionsTemplateSection,
      { deferredLoad: false },
    );
    theme.Sections.register("contact", new (function () {})());
    theme.Sections.register(
      "cart-tiered-discounts",
      theme.CartTieredDiscounts,
      {
        deferredLoad: false,
      },
    );
    theme.Sections.register("faceted-filters", theme.FacetedFilters, {
      deferredLoad: false,
    });
    theme.Sections.register("kk-categories", theme.KKCategoriesSection, {
      deferredLoad: false,
    });
    theme.Sections.register("choose-blind", theme.ChooseBlindSection, {
      deferredLoad: false,
    });
    theme.Sections.register(
      "home-page-banner-with-text",
      theme.HomePageBannerWithTextSection,
      {
        deferredLoad: false,
      },
    );
    theme.Sections.register(
      "slide-text-with-img",
      theme.SlideTextWithImgSection,
      {
        deferredLoad: false,
      },
    );
    theme.Sections.register(
      "customize-time-banner",
      theme.CustomizeTimeBannerSection,
      {
        deferredLoad: false,
      },
    );
    theme.Sections.register("scene-slide", theme.SceneSlideSection, {
      deferredLoad: false,
    });
  });

  //Register dynamically pulled in sections
  $(function ($) {
    $(".pre-order-btn").click(function () {
      // $(".shopify-payment-button__more-options").click();
      document.querySelector("[data-buy-now]").click();
    });
    if (cc.sections.length) {
      cc.sections.forEach((section) => {
        try {
          var data = {};
          if (typeof section.deferredLoad !== "undefined") {
            data.deferredLoad = section.deferredLoad;
          }
          if (typeof section.deferredLoadViewportExcess !== "undefined") {
            data.deferredLoadViewportExcess =
              section.deferredLoadViewportExcess;
          }
          theme.Sections.register(section.name, section.section, data);
        } catch (err) {
          console.error(
            "Unable to register section ".concat(section.name, "."),
            err,
          );
        }
      });
    } else {
      console.warn("Barry: No common sections have been registered.");
    }
  });

  window.toast = function (content, duration) {
    try {
      if (content) {
        document.querySelector(
          ".toast-wrapper .toast-content__text",
        ).innerText = content;
        document.querySelector(".toast-wrapper").classList.add("open");
        const s = duration ? duration * 1000 : 3000;
        setTimeout(() => {
          document.querySelector(".toast-wrapper").classList.remove("open");
          document.querySelector(
            ".toast-wrapper .toast-content__text",
          ).innerText = "";
        }, s);
      }
    } catch (error) {}
  };
  // 打开轮播图预览
  function openPreviewProduct(currentIndex) {
    // 判断是否渲染过预览的轮播图
    if (!$(".slider-for-overlay").hasClass("slick-initialized")) {
      // 如果没有被初始化，进行初始化
      $(".slider-for-overlay").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        // asNavFor: ".slider-nav-overlay",
        infinite: false,
        speed: 300,
        autoplay: false,
      });

      // 是否执行过套图过滤
      if (theme.preViewData.length > 0) {
        preViewSkuFilter();
      }

      // 绑定事件
      // 1.滚动事件，改变缩略图样式
      initPreSlideEvent();

      // 2.缩略图点击事件
      initPreThumbnailsClick();

      const totalSlides = $(".slider-for-overlay").slick("getSlick").slideCount;
      $("#current-slide").text(currentIndex + 1);
      $("#total-slides").text(totalSlides);

      // 滚动到指定的位置
      $(".slider-for-overlay").slick("slickGoTo", currentIndex);

      // 同步修改缩略图的位置
      showPreThumbnailsActive(currentIndex);

      $("#swiper-prev").on("click", function () {
        theme.pauseAllMedia();
        $(".slider-for-overlay").slick("slickPrev");
      });

      $("#swiper-next").on("click", function () {
        theme.pauseAllMedia();
        $(".slider-for-overlay").slick("slickNext");
      });
    } else {
      console.log("Slick 已经被初始化");
      // 是否执行过套图过滤
      if (theme.preViewData.length > 0) {
        preViewSkuFilter();
      }

      initPreThumbnailsClick();

      const totalSlides = $(".slider-for-overlay").slick("getSlick").slideCount;
      $("#current-slide").text(currentIndex + 1);
      $("#total-slides").text(totalSlides);

      // 滚动到指定的位置
      $(".slider-for-overlay").slick("slickGoTo", currentIndex);

      // 同步修改缩略图的位置
      showPreThumbnailsActive(currentIndex);
    }
  }
  // 预览轮播图的套图过滤
  function preViewSkuFilter() {
    // 清除之前的过滤
    $(".slider-for-overlay").slick("slickUnfilter");

    // 过滤符合条件的项
    $(".slider-for-overlay").slick("slickFilter", function () {
      // 如果 filterProductData 是一个数组，使用数组的 some 方法来检查
      return theme.preViewData.some(
        (ele) => $(this).data("media-id") == ele.id,
      );
    });

    // 缩略图需要重置，才能保存索引一致
    $(".carousel-thumbnails-overlay")
      .empty()
      .removeClass()
      .addClass("carousel-thumbnails-overlay");

    const $carouselNav = $(".carousel-thumbnails-overlay");
    $.each(theme.preViewData, function (index, item) {
      const $newDiv = $("<div></div").html(
        '<img src="' +
          item.preview_image.src +
          '" alt="' +
          item.alt +
          '"><div class="green-line"></div>',
      );
      $carouselNav.append($newDiv);
    });
  }
  // 初始化轮播图的点击事件
  function initSlickClick() {
    // 为所有.slider-for下的.slick-slide绑定点击事件
    $(".slider-for .slick-slide").on("click", function () {
      const $currentSlide = $(this);
      const $sliderFor = $currentSlide.closest(".slider-for"); // 获取当前所属的.slider-for容器
      const mediaType = $currentSlide.data("meida-type");
      // 输出当前点击信息（包含容器标识以便调试）
      console.log("轮播图点击事件", mediaType);
      console.log("当前slide索引：", $currentSlide.data("slick-index"));
      // 视频类型不执行后续操作
      if (mediaType === "video" || mediaType === "external_video") {
        return;
      }
      // if ( theme.isMobile()) {
      // }
      // 淡入遮罩层
      $("#swiper-overlay").fadeIn();
      // 隐藏相关容器
      const smileUiContainer = $("#smile-ui-container");
      if (smileUiContainer.length) {
        smileUiContainer.hide();
      }
      // 禁止页面滚动
      $("body").css("overflow", "hidden");
      // 获取当前slide在所属轮播容器中的索引
      const currentIndex = $sliderFor.find(".slick-slide").index($currentSlide);
      console.log("当前容器内的索引值：", currentIndex);
      // 打开预览轮播图（传入当前容器标识，确保预览对应容器）
      openPreviewProduct(currentIndex, $sliderFor);
    });
  }
  // 初始化缩略图的点击事件
  function initThumbnails() {
    // 为所有carousel-thumbnails下的直接子div绑定点击事件
    $(".carousel-thumbnails > div").on("click", function () {
      const $this = $(this);
      // 获取当前点击元素在父容器中的索引
      const index = $this.index();
      // 获取当前所在的carousel-thumbnails容器
      const $carousel = $this.closest(".carousel-thumbnails");
      theme.pauseAllMedia();
      // 定位到当前缩略图所在的轮播容器对应的.slider-for并切换
      $carousel
        .closest(".swiper-container")
        .find(".slider-for")
        .slick("slickGoTo", index);
      // 处理当前容器内的green-line激活状态
      $carousel.find(".green-line").each(function (i) {
        if (i === index) {
          $(this).addClass("slider-nav-line-active");
        } else {
          $(this).removeClass("slider-nav-line-active");
        }
      });
      console.log("缩略图点击了：", index);
    });
    // 初始化时为每个carousel-thumbnails的第一个green-line添加激活类
    $(".carousel-thumbnails").each(function () {
      $(this).find(".green-line").eq(0).addClass("slider-nav-line-active");
    });
  }
  // 初始化预览轮播图的滚动事件
  function initPreSlideEvent() {
    $(".slider-for-overlay")
      .off("beforeChange")
      .on("beforeChange", function (event, slick, currentSlide, nextIndex) {
        $("#current-slide").text(nextIndex + 1);
        $(".slider-nav-overlay").slick("slickGoTo", nextIndex);

        showPreThumbnailsActive(nextIndex);
        if (nextIndex > currentSlide) {
          movePreCarousel("next", nextIndex);
        } else {
          movePreCarousel("prev", nextIndex);
        }

        currentSlide = nextIndex;
      });
  }
  // 初始化预览轮播图的缩略图的点击事件
  function initPreThumbnailsClick() {
    $(".carousel-thumbnails-overlay > div").each(function (index) {
      $(this)
        .off("click")
        .on("click", function () {
          // 执行点击事件的操作
          theme.pauseAllMedia();
          $(".slider-for-overlay").slick("slickGoTo", index);
        });
    });

    // showPreThumbnailsActive(currentIndex);
  }
  function showThumbnailsActive(currentSlide) {
    $(".carousel-container .carousel-thumbnails .green-line").each(
      function (index) {
        if (index === currentSlide) {
          $(this).addClass("slider-nav-line-active");
        } else {
          $(this).removeClass("slider-nav-line-active");
        }
      },
    );
  }
  function showPreThumbnailsActive(currentSlide) {
    $(
      ".carousel-container-overlay .carousel-thumbnails-overlay .green-line",
    ).each(function (index) {
      if (index === currentSlide) {
        $(this).addClass("slider-nav-line-active");
      } else {
        $(this).removeClass("slider-nav-line-active");
      }
    });

    $(".carousel-thumbnails-overlay > div").each(function (index) {
      if (index === currentSlide) {
        $(this).removeClass("slider-nav-overlay-bg");
      } else {
        $(this).addClass("slider-nav-overlay-bg");
      }
    });
  }
  function moveCarousel(direction, slideIndex) {
    var carousel = $(".carousel-container");
    var carouselItems = $(".carousel-thumbnails div");
    var itemWidth = carouselItems.width() + 10;

    // 偏移块数
    var offsetDiv = carousel.scrollLeft() / itemWidth + 4;
    var absoluteDifference = Math.abs(slideIndex - offsetDiv);
    if (absoluteDifference > 3) {
      // 如果差值大于3，则需要矫正
      carousel.scrollLeft((slideIndex - 1) * itemWidth);
    }

    if (direction === "next" && slideIndex > 3) {
      carousel.scrollLeft(carousel.scrollLeft() + itemWidth);
    } else if (direction === "prev") {
      carousel.scrollLeft(carousel.scrollLeft() - itemWidth);
    }
  }
  function movePreCarousel(direction, slideIndex) {
    var carousel = $(".carousel-container-overlay");
    var carouselItems = $(".carousel-thumbnails-overlay div");
    var itemWidth = carouselItems.width() + 10;

    var offsetDiv = carousel.scrollLeft() / itemWidth + 4;
    var absoluteDifference = Math.abs(slideIndex - offsetDiv);
    if (absoluteDifference > 2.5) {
      // 如果差值大于3，则需要矫正
      carousel.scrollLeft((slideIndex - 1) * itemWidth);
    }

    if (direction === "next" && slideIndex > 3) {
      carousel.scrollLeft(carousel.scrollLeft() + itemWidth);
    } else if (direction === "prev") {
      carousel.scrollLeft(carousel.scrollLeft() - itemWidth);
    }
  }

  // 用于active-001 营销活动页轮播图
  function addTogglePrevNextBtnsActive(emblaApi, prevBtn, nextBtn) {
    const togglePrevNextBtnsState = () => {
      if (emblaApi.canGoToPrev()) prevBtn.removeAttribute("disabled");
      else prevBtn.setAttribute("disabled", "disabled");

      if (emblaApi.canGoToNext()) nextBtn.removeAttribute("disabled");
      else nextBtn.setAttribute("disabled", "disabled");
    };

    emblaApi
      .on("select", togglePrevNextBtnsState)
      .on("init", togglePrevNextBtnsState)
      .on("reInit", togglePrevNextBtnsState);

    return () => {
      prevBtn.removeAttribute("disabled");
      nextBtn.removeAttribute("disabled");
    };
  }

  function addPrevNextBtnsClickHandlers(emblaApi, prevBtn, nextBtn) {
    const scrollPrev = () => {
      emblaApi.goToPrev();
    };
    const scrollNext = () => {
      emblaApi.goToNext();
    };
    prevBtn.addEventListener("click", scrollPrev, false);
    nextBtn.addEventListener("click", scrollNext, false);

    const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(
      emblaApi,
      prevBtn,
      nextBtn,
    );

    return () => {
      removeTogglePrevNextBtnsActive();
      prevBtn.removeEventListener("click", scrollPrev, false);
      nextBtn.removeEventListener("click", scrollNext, false);
    };
  }

  function addDotBtnsAndClickHandlers(emblaApi, dotsNode) {
    let dotNodes = [];

    const addDotBtnsWithClickHandlers = () => {
      if (!dotsNode) return;

      dotsNode.innerHTML = emblaApi
        .snapList()
        .map(() => '<button class="embla__dot" type="button"></button>')
        .join("");

      const scrollTo = (index) => {
        emblaApi.goTo(index);
      };

      dotNodes = Array.from(dotsNode.querySelectorAll(".embla__dot"));
      dotNodes.forEach((dotNode, index) => {
        dotNode.addEventListener("click", () => scrollTo(index), false);
      });
    };

    const toggleDotBtnsActive = () => {
      const previous = emblaApi.previousSnap();
      const selected = emblaApi.selectedSnap();
      dotNodes[previous]?.classList.remove("embla__dot--selected");
      dotNodes[selected]?.classList.add("embla__dot--selected");
    };

    emblaApi
      .on("init", addDotBtnsWithClickHandlers)
      .on("reInit", addDotBtnsWithClickHandlers)
      .on("init", toggleDotBtnsActive)
      .on("reInit", toggleDotBtnsActive)
      .on("select", toggleDotBtnsActive);

    return () => {
      dotsNode.innerHTML = "";
    };
  }

  function updateSelectedSnapDisplay(emblaApi, snapDisplay) {
    const updateSnapDisplay = (emblaApi) => {
      const selectedSnap = emblaApi.selectedSnap();
      const snapCount = emblaApi.snapList().length;
      snapDisplay.innerHTML = `${selectedSnap + 1} / ${snapCount}`;
    };

    emblaApi.on("select", updateSnapDisplay).on("reInit", updateSnapDisplay);

    updateSnapDisplay(emblaApi);
  }

  function setupProgressBar(emblaApi, progressNode) {
    const applyProgress = () => {
      const currentIndex = emblaApi.selectedSnap();
      const totalSlides = emblaApi.snapList().length;
      const progress = totalSlides > 1 ? (currentIndex + 1) / totalSlides : 1;
      progressNode.style.transform = `translate3d(${progress * 100}%,0px,0px)`;
    };

    const removeProgress = () => {
      progressNode.removeAttribute("style");
    };

    return {
      applyProgress,
      removeProgress,
    };
  }
  // 绑定到window对象
  window.addTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive;
  window.addPrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers;
  window.addDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers;
  window.updateSelectedSnapDisplay = updateSelectedSnapDisplay;
  window.setupProgressBar = setupProgressBar;
})(theme.jQuery);
